// src/hogwashSets.js
// 365 puzzle sets; each has 10 items, exactly 3 hogwash (fake).
// All hogwash items are VERIFIED to not exist but sound completely plausible.
//
// HOGWASH_SCHEDULE controls the day-by-day play order.
// Rules for editing:
//   • Add new sets: append their id to the END of HOGWASH_SCHEDULE.
//     This leaves all existing day assignments untouched.
//   • Remove a bad set: delete its id from HOGWASH_SCHEDULE (and its object below).
//     Only that one slot disappears; days shift minimally only within the
//     current cycle. Past days recorded in the DB are unaffected.
//   • Never reorder existing entries — that would reassign past/future days.

export const HOGWASH_SCHEDULE = [
  "mcdonalds", "cocktails", "pasta", "cheese", "sushi_types",
  "bread", "coffee", "tea", "beer_styles", "beef_cuts",
  "wine_grapes", "herbs_spices", "kitchen_tools", "cooking_methods", "mushrooms",
  "soups", "chocolate", "asian_noodles", "dumplings", "vinegar",
  "sausage", "cake", "whiskey", "seafood", "ice_cream",
  "baking", "candy_bars", "pizza_styles", "condiments", "spice_blends",
  "french_desserts", "fermented_foods", "wine_regions", "street_food", "sandwiches",
  "nuts", "countries", "dogs", "elements", "clouds",
  "rocks", "dinosaurs", "instruments", "music_terms", "music_genres",
  "opera_terms", "music_notes", "guitar_chords", "classical_composers", "art_movements",
  "drawing_concepts", "color_theory", "typography", "photography", "architecture",
  "arch_elements", "electrician", "plumbing", "carpentry", "welding",
  "automotive", "woodworking_tools", "hvac", "anatomy", "brain_parts",
  "physics_concepts", "astronomy", "genetics", "chemistry_lab", "trees",
  "ocean_zones", "constellations", "biomes", "chess_openings", "golf_terms",
  "swimming_strokes", "martial_arts", "cycling", "poker_hands", "monopoly",
  "ancient_wonders", "african_capitals", "us_states_capitals", "mountain_ranges", "rivers",
  "programming", "networking", "database", "design_patterns", "crypto",
  "medical_terms", "surgical_tools", "vitamins", "literary_terms", "greek_mythology",
  "shakespeare_plays", "languages_world", "logical_fallacies", "film_genres", "oscar_categories",
  "video_game_genres", "board_games", "finance", "legal_terms", "fashion",
  "fabric", "gemstones", "psychology_terms", "phobias", "love_languages",
  "cat_breeds", "bird_species", "horses", "deep_sea_creatures", "insects",
  "flowers", "snakes", "primates", "olympic_events", "soccer_terms",
  "running", "yoga_poses", "skiing_terms", "rock_climbing", "ancient_civilizations",
  "wars", "us_presidents", "explorers", "revolutions", "philosophy_concepts",
  "world_religions", "philosophers", "planets_moons", "space_missions", "quantum_physics",
  "telescopes", "knitting", "gardening", "photography_genres", "chess_pieces",
  "cocktail_techniques", "sewing", "stamp_collecting", "camping", "typography2",
  "economic_systems", "card_games", "knots", "printing", "astronomy2",
  "dances", "fonts_concepts", "military_ranks", "sailing", "astronomy_instruments",
  "tattoo_styles", "bridges", "renaissance_artists", "economics_indicators", "cloud_computing",
  "poetry_forms", "logic_gates", "vaccines", "theater_terms", "motorcycles",
  "economics_schools", "meditation_types", "currencies", "brain_disorders", "election_terms",
  "optical_illusions", "hurricanes", "film_techniques", "jazz_terms", "cheese2",
  "cloud_types2", "ballet_terms", "olympic_sports2", "sea_navigation", "whisky_brands",
  "bird_calls", "math_concepts", "weather_instruments", "soil_types", "grammar_terms",
  "map_projections", "interior_design", "gemology", "cocktail_glasses", "color_names",
  "logical_operators", "table_tennis", "architecture2", "marketing_terms", "music_scales",
  "soccer_positions", "greek_letters", "insurance", "anatomy2", "tattoo_techniques",
  "ancient_rome", "economics_markets", "sea_creatures2", "festivals", "pigments",
  "anime_genres", "law_courts", "horse_racing", "dentistry", "ancient_egypt",
  "renewable_energy", "architecture3", "board_game_mechanics", "fashion_eras", "clouds2",
  "wine_faults", "fabric2", "tea_ceremony", "circus_arts", "wine_aromas",
  "paper_arts", "cheeses3", "horror_subgenres", "architecture_details", "wine_service",
  "pottery", "math_shapes", "sleep", "poetry2", "woodwind",
  "biking", "pottery2", "fungi", "cheese4", "brain2",
  "surfing", "economics2", "animation_styles", "astronomy3", "gemstones2",
  "knives", "currencies2", "color_mixing", "furniture_styles", "astronomy4",
  "language_families", "bread2", "card_magic", "cooking_fats", "clouds3",
  "economics3", "cooking2", "painting_techniques", "boat_types", "ancient_greece",
  "cheese5", "architecture4", "sewing2", "boxing", "botany",
  "hockey", "roman_mythology", "cocktail3", "typography3", "bridges2",
  "aquarium", "economics4", "math2", "ancient_weapons", "genetics2",
  "painting3", "theater2", "crypto2", "horses2", "pottery3",
  "grammar2", "cooking3", "surfing2", "mythology2", "tilepatterns",
  "music3", "clouds4", "economics5", "architecture5", "athletics",
  "logic2", "cooking4", "swords", "beer2", "literature2",
  "cooking5", "insects2", "dance2", "space2", "architecture6",
  "cooking6", "birds2", "martial2", "coins", "cheese6",
  "drama", "music4", "materials", "ancient_art", "running2",
  "ecology", "social_media", "lacrosse", "cloud5", "sailing2",
  "typography4", "music5", "camping2", "mythology3", "baking2",
  "film2", "medicine2", "finance2", "animals2", "architecture7",
  "fabric3", "astronomy5", "cocktail4", "anatomy3", "art2",
  "greek2", "cooking7", "construction", "chess2", "languages2",
  "aviation", "economics6", "astronomy6", "cooking8", "animals3",
  "science2", "medicine3", "sports2", "music6", "trees2",
  "law2", "cooking9", "photography2", "marine", "cars2",
  "plants", "economics7", "architecture8", "sports3", "books",
  "cheese7", "ocean2", "music7", "astronomy7", "economics8",
  "sports4", "design2", "astronomy8", "cooking10", "tech2",
  "tools2", "literature3", "medicine4", "animals4", "history2",
  // batch 4
  "nfl_positions", "nba_terms", "baseball_terms", "tennis_terms", "cricket_terms",
  "olympic_swimming", "fencing_terms", "bowling_terms", "darts_terms", "snooker_terms",
  "roman_numerals", "periodic_groups", "math_theorems", "logic_symbols", "set_theory",
  "literary_genres", "narrative_structures", "rhetorical_devices2", "writing_styles", "journalism_terms",
  "interior_plants", "succulents", "orchid_types", "bonsai_terms", "hydroponics",
  "dog_commands", "horse_gaits", "bird_songs", "aquatic_mammals", "nocturnal_animals",
  "ancient_tools", "stone_age_terms", "bronze_age", "iron_age", "medieval_terms",
  "renaissance_terms", "industrial_revolution", "cold_war_terms", "space_race", "digital_age",
  "cocktail_garnishes", "mocktail_styles", "tea_ceremonies2", "coffee_brewing", "fermentation2",
  "sushi_fish", "ramen_types", "dim_sum", "tapas_dishes", "mezze_dishes",
  "knitting2", "embroidery_stitches", "lace_making", "macrame_terms", "weaving_terms",
  "stained_glass", "mosaic_terms", "glass_blowing", "ceramics2", "jewelry_making",
  "podcast_genres", "documentary_styles", "podcast_terms", "radio_formats", "broadcast_terms",
  "philosophy_schools", "ethics_theories", "metaphysics_terms", "epistemology2", "aesthetics_terms",
  "geology_eras", "fossil_types", "paleontology", "mineralogy2", "crystallography",
  "weather_fronts", "meteorology2", "climate_science", "oceanography2", "hydrology",
  "immune_system", "cell_types", "organ_systems", "endocrine_terms", "cardiovascular",
  "guitar_techniques", "piano_terms", "drum_rudiments", "vocal_techniques", "music_production2",
  "map_symbols", "cartography", "surveying_terms", "gis_terms", "remote_sensing",
  // ── Append new set IDs below this line ──────────────────────────────────────
  // ── BATCH 5 (sets 461-560) ───────────────────────────────────────────────
  "architecture_styles", "fashion_terms", "interior_design_b5", "photography_terms", "film_techniques_b5",
  "theater_terms_b5", "dance_styles", "ballet_terms_b5", "art_movements_b5", "painting_styles",
  "printmaking", "sculpture_terms", "graphic_design", "animation_terms", "chess_terms",
  "poker_terms", "board_game_mechanics_b5", "video_game_genres_b5", "esports_terms", "coding_concepts",
  "database_terms", "networking2", "cybersecurity", "cloud_computing_b5", "ux_design",
  "agile_terms", "devops_terms", "ai_terms", "legal_terms_b5", "economics_terms",
  "stock_market", "real_estate", "accounting_terms", "marketing_terms_b5", "psychology_terms_b5",
  "therapy_types", "quantum_physics_b5", "chemistry_reactions", "genetics_terms", "ecology_terms",
  "deep_sea", "rainforest_animals", "desert_animals", "insect_types", "mushroom_types",
  "baking_terms", "bbq_techniques", "wine_regions_b5", "beer_styles_b5", "cheese_types",
  "bread_types", "knife_techniques", "yoga_poses_b5", "martial_arts_b5", "olympic_track",
  "soccer_terms_b5", "rugby_terms", "hockey_terms", "volleyball_terms", "swimming_strokes_b5",
  "cycling_terms", "gymnastics_terms", "winter_sports", "extreme_sports", "water_sports",
  "greek_mythology_b5", "norse_mythology", "world_religions_b5", "ancient_civilizations_b5", "constellations2",
  "solar_system2", "space_exploration", "astronomy_terms", "physics_terms", "medical_specialties",
  "surgical_terms", "pharmacy_terms", "nutrition_terms", "fitness_terms", "mental_health_terms",
  "linguistics_terms", "grammar_terms_b5", "mythology_creatures", "tree_types", "flower_types",
  "herb_spice", "vegetable_varieties", "fruit_varieties", "bird_types", "ocean_zones_b5",
  "weather_phenomena", "rock_types", "biome_types", "geology_features", "climate_zones",
  "sign_language", "forensic_science", "urban_planning", "diplomacy", "cognitive_science",
];

export const HOGWASH_COPY = {
    instruction: "Find the hogwash.",
    helper: "Select the 3 items that are hogwash.",
    brand: "HOGWASH",
  };

  export const HOGWASH_SETS = [

    // ── FOOD & DRINK ──────────────────────────────────────────────────────────

    {
      id: "mcdonalds",
      themeLabel: "McDonald's Menu",
      items: [
        { id: "r1", text: "Big Mac", hogwash: false },
        { id: "r2", text: "Quarter Pounder", hogwash: false },
        { id: "r3", text: "McFlurry", hogwash: false },
        { id: "r4", text: "Chicken McNuggets", hogwash: false },
        { id: "r5", text: "Filet-O-Fish", hogwash: false },
        { id: "r6", text: "McGriddles", hogwash: false },
        { id: "r7", text: "Egg McMuffin", hogwash: false },
        { id: "h1", text: "McStack", hogwash: true },
        { id: "h2", text: "Chicken McCrisp", hogwash: true },
        { id: "h3", text: "Triple Deluxe", hogwash: true },
      ],
    },
    {
      id: "cocktails",
      themeLabel: "Classic Cocktails",
      items: [
        { id: "r1", text: "Old Fashioned", hogwash: false },
        { id: "r2", text: "Manhattan", hogwash: false },
        { id: "r3", text: "Negroni", hogwash: false },
        { id: "r4", text: "Sazerac", hogwash: false },
        { id: "r5", text: "Aperol Spritz", hogwash: false },
        { id: "r6", text: "Boulevardier", hogwash: false },
        { id: "r7", text: "Gimlet", hogwash: false },
        { id: "h1", text: "Venetian Mule", hogwash: true },
        { id: "h2", text: "Charleston Sling", hogwash: true },
        { id: "h3", text: "Brooklyn Fizz", hogwash: true },
      ],
    },
    {
      id: "pasta",
      themeLabel: "Types of Pasta",
      items: [
        { id: "r1", text: "Orecchiette", hogwash: false },
        { id: "r2", text: "Bucatini", hogwash: false },
        { id: "r3", text: "Cavatelli", hogwash: false },
        { id: "r4", text: "Pappardelle", hogwash: false },
        { id: "r5", text: "Gemelli", hogwash: false },
        { id: "r6", text: "Radiatore", hogwash: false },
        { id: "r7", text: "Campanelle", hogwash: false },
        { id: "h1", text: "Fiorentini", hogwash: true },
        { id: "h2", text: "Cascatelle", hogwash: true },
        { id: "h3", text: "Margherite", hogwash: true },
      ],
    },
    {
      id: "cheese",
      themeLabel: "Types of Cheese",
      items: [
        { id: "r1", text: "Manchego", hogwash: false },
        { id: "r2", text: "Gruyère", hogwash: false },
        { id: "r3", text: "Halloumi", hogwash: false },
        { id: "r4", text: "Burrata", hogwash: false },
        { id: "r5", text: "Taleggio", hogwash: false },
        { id: "r6", text: "Époisses", hogwash: false },
        { id: "r7", text: "Comté", hogwash: false },
        { id: "h1", text: "Crémoise", hogwash: true },
        { id: "h2", text: "Tometto", hogwash: true },
        { id: "h3", text: "Valdorino", hogwash: true },
      ],
    },
    {
      id: "sushi_types",
      themeLabel: "Types of Sushi",
      items: [
        { id: "r1", text: "Nigiri", hogwash: false },
        { id: "r2", text: "Maki", hogwash: false },
        { id: "r3", text: "Temaki", hogwash: false },
        { id: "r4", text: "Uramaki", hogwash: false },
        { id: "r5", text: "Gunkan", hogwash: false },
        { id: "r6", text: "Chirashi", hogwash: false },
        { id: "r7", text: "Inari", hogwash: false },
        { id: "h1", text: "Kakuori", hogwash: true },
        { id: "h2", text: "Tobashi", hogwash: true },
        { id: "h3", text: "Hozenaki", hogwash: true },
      ],
    },
    {
      id: "bread",
      themeLabel: "Types of Bread",
      items: [
        { id: "r1", text: "Sourdough", hogwash: false },
        { id: "r2", text: "Brioche", hogwash: false },
        { id: "r3", text: "Ciabatta", hogwash: false },
        { id: "r4", text: "Focaccia", hogwash: false },
        { id: "r5", text: "Pumpernickel", hogwash: false },
        { id: "r6", text: "Challah", hogwash: false },
        { id: "r7", text: "Pita", hogwash: false },
        { id: "h1", text: "Crestan", hogwash: true },
        { id: "h2", text: "Veraloise", hogwash: true },
        { id: "h3", text: "Altano", hogwash: true },
      ],
    },
    {
      id: "coffee",
      themeLabel: "Coffee Drinks",
      items: [
        { id: "r1", text: "Espresso", hogwash: false },
        { id: "r2", text: "Cappuccino", hogwash: false },
        { id: "r3", text: "Americano", hogwash: false },
        { id: "r4", text: "Macchiato", hogwash: false },
        { id: "r5", text: "Cortado", hogwash: false },
        { id: "r6", text: "Ristretto", hogwash: false },
        { id: "r7", text: "Affogato", hogwash: false },
        { id: "h1", text: "Cremando", hogwash: true },
        { id: "h2", text: "Nordaletto", hogwash: true },
        { id: "h3", text: "Castelcaffè", hogwash: true },
      ],
    },
    {
      id: "tea",
      themeLabel: "Tea Varieties",
      items: [
        { id: "r1", text: "Darjeeling", hogwash: false },
        { id: "r2", text: "Earl Grey", hogwash: false },
        { id: "r3", text: "Oolong", hogwash: false },
        { id: "r4", text: "Pu-erh", hogwash: false },
        { id: "r5", text: "Gyokuro", hogwash: false },
        { id: "r6", text: "Rooibos", hogwash: false },
        { id: "r7", text: "Matcha", hogwash: false },
        { id: "h1", text: "Crimson Oolong", hogwash: true },
        { id: "h2", text: "Nordmont White", hogwash: true },
        { id: "h3", text: "Valdoria Estate", hogwash: true },
      ],
    },
    {
      id: "beer_styles",
      themeLabel: "Beer Styles",
      items: [
        { id: "r1", text: "IPA", hogwash: false },
        { id: "r2", text: "Stout", hogwash: false },
        { id: "r3", text: "Hefeweizen", hogwash: false },
        { id: "r4", text: "Saison", hogwash: false },
        { id: "r5", text: "Bock", hogwash: false },
        { id: "r6", text: "Gose", hogwash: false },
        { id: "r7", text: "Märzen", hogwash: false },
        { id: "h1", text: "Heldenbock", hogwash: true },
        { id: "h2", text: "Nordalter", hogwash: true },
        { id: "h3", text: "Schwabenweiss", hogwash: true },
      ],
    },
    {
      id: "beef_cuts",
      themeLabel: "Cuts of Beef",
      items: [
        { id: "r1", text: "Ribeye", hogwash: false },
        { id: "r2", text: "Brisket", hogwash: false },
        { id: "r3", text: "Sirloin", hogwash: false },
        { id: "r4", text: "Flank", hogwash: false },
        { id: "r5", text: "Tenderloin", hogwash: false },
        { id: "r6", text: "Chuck", hogwash: false },
        { id: "r7", text: "Skirt", hogwash: false },
        { id: "h1", text: "Bretton Strip", hogwash: true },
        { id: "h2", text: "Dorsal Loin", hogwash: true },
        { id: "h3", text: "Shoulder Rondelle", hogwash: true },
      ],
    },
    {
      id: "wine_grapes",
      themeLabel: "Wine Grape Varieties",
      items: [
        { id: "r1", text: "Tempranillo", hogwash: false },
        { id: "r2", text: "Grenache", hogwash: false },
        { id: "r3", text: "Viognier", hogwash: false },
        { id: "r4", text: "Mourvèdre", hogwash: false },
        { id: "r5", text: "Grüner Veltliner", hogwash: false },
        { id: "r6", text: "Assyrtiko", hogwash: false },
        { id: "r7", text: "Nero d'Avola", hogwash: false },
        { id: "h1", text: "Valdorino", hogwash: true },
        { id: "h2", text: "Castelmare Nero", hogwash: true },
        { id: "h3", text: "Crémaux Blanc", hogwash: true },
      ],
    },
    {
      id: "herbs_spices",
      themeLabel: "Herbs & Spices",
      items: [
        { id: "r1", text: "Turmeric", hogwash: false },
        { id: "r2", text: "Cardamom", hogwash: false },
        { id: "r3", text: "Fenugreek", hogwash: false },
        { id: "r4", text: "Sumac", hogwash: false },
        { id: "r5", text: "Tarragon", hogwash: false },
        { id: "r6", text: "Chervil", hogwash: false },
        { id: "r7", text: "Asafoetida", hogwash: false },
        { id: "h1", text: "Weldwort", hogwash: true },
        { id: "h2", text: "Fenbloom", hogwash: true },
        { id: "h3", text: "Cortmint", hogwash: true },
      ],
    },
    {
      id: "kitchen_tools",
      themeLabel: "Professional Kitchen Tools",
      items: [
        { id: "r1", text: "Mandoline", hogwash: false },
        { id: "r2", text: "Chinois", hogwash: false },
        { id: "r3", text: "Tamis", hogwash: false },
        { id: "r4", text: "Mezzaluna", hogwash: false },
        { id: "r5", text: "Rondeau", hogwash: false },
        { id: "r6", text: "Mouli", hogwash: false },
        { id: "r7", text: "Bain-Marie", hogwash: false },
        { id: "h1", text: "Cantelette", hogwash: true },
        { id: "h2", text: "Rivoire", hogwash: true },
        { id: "h3", text: "Valdeau", hogwash: true },
      ],
    },
    {
      id: "cooking_methods",
      themeLabel: "Cooking Techniques",
      items: [
        { id: "r1", text: "Confit", hogwash: false },
        { id: "r2", text: "Sous Vide", hogwash: false },
        { id: "r3", text: "Braise", hogwash: false },
        { id: "r4", text: "Flambé", hogwash: false },
        { id: "r5", text: "En Papillote", hogwash: false },
        { id: "r6", text: "Blanch", hogwash: false },
        { id: "r7", text: "Deglaze", hogwash: false },
        { id: "h1", text: "Ardoise", hogwash: true },
        { id: "h2", text: "Veldure", hogwash: true },
        { id: "h3", text: "Fritole", hogwash: true },
      ],
    },
    {
      id: "mushrooms",
      themeLabel: "Edible Mushrooms",
      items: [
        { id: "r1", text: "Chanterelle", hogwash: false },
        { id: "r2", text: "Morel", hogwash: false },
        { id: "r3", text: "Porcini", hogwash: false },
        { id: "r4", text: "Shiitake", hogwash: false },
        { id: "r5", text: "Oyster", hogwash: false },
        { id: "r6", text: "King Trumpet", hogwash: false },
        { id: "r7", text: "Maitake", hogwash: false },
        { id: "h1", text: "Silken Cap", hogwash: true },
        { id: "h2", text: "Brindlecap", hogwash: true },
        { id: "h3", text: "Nordfoot", hogwash: true },
      ],
    },
    {
      id: "soups",
      themeLabel: "Soups of the World",
      items: [
        { id: "r1", text: "Bouillabaisse", hogwash: false },
        { id: "r2", text: "Vichyssoise", hogwash: false },
        { id: "r3", text: "Gazpacho", hogwash: false },
        { id: "r4", text: "Borscht", hogwash: false },
        { id: "r5", text: "Pho", hogwash: false },
        { id: "r6", text: "Tom Yum", hogwash: false },
        { id: "r7", text: "Minestrone", hogwash: false },
        { id: "h1", text: "Verdoisse", hogwash: true },
        { id: "h2", text: "Castelaine", hogwash: true },
        { id: "h3", text: "Brenhol", hogwash: true },
      ],
    },
    {
      id: "chocolate",
      themeLabel: "Chocolate Preparations",
      items: [
        { id: "r1", text: "Couverture", hogwash: false },
        { id: "r2", text: "Gianduja", hogwash: false },
        { id: "r3", text: "Praline", hogwash: false },
        { id: "r4", text: "Ganache", hogwash: false },
        { id: "r5", text: "Crémeux", hogwash: false },
        { id: "r6", text: "Pâte de Cacao", hogwash: false },
        { id: "r7", text: "Ruby Chocolate", hogwash: false },
        { id: "h1", text: "Velour Noir", hogwash: true },
        { id: "h2", text: "Castelchoc", hogwash: true },
        { id: "h3", text: "Nordcreme", hogwash: true },
      ],
    },
    {
      id: "asian_noodles",
      themeLabel: "Asian Noodle Types",
      items: [
        { id: "r1", text: "Soba", hogwash: false },
        { id: "r2", text: "Udon", hogwash: false },
        { id: "r3", text: "Somen", hogwash: false },
        { id: "r4", text: "Shirataki", hogwash: false },
        { id: "r5", text: "Misua", hogwash: false },
        { id: "r6", text: "Harusame", hogwash: false },
        { id: "r7", text: "Naengmyeon", hogwash: false },
        { id: "h1", text: "Kanzori", hogwash: true },
        { id: "h2", text: "Tobashi", hogwash: true },
        { id: "h3", text: "Murashime", hogwash: true },
      ],
    },
    {
      id: "dumplings",
      themeLabel: "Types of Dumpling",
      items: [
        { id: "r1", text: "Pierogi", hogwash: false },
        { id: "r2", text: "Gyoza", hogwash: false },
        { id: "r3", text: "Momo", hogwash: false },
        { id: "r4", text: "Manti", hogwash: false },
        { id: "r5", text: "Xiaolongbao", hogwash: false },
        { id: "r6", text: "Knödel", hogwash: false },
        { id: "r7", text: "Pelmeni", hogwash: false },
        { id: "h1", text: "Valdori", hogwash: true },
        { id: "h2", text: "Crestano", hogwash: true },
        { id: "h3", text: "Boronak", hogwash: true },
      ],
    },
    {
      id: "vinegar",
      themeLabel: "Types of Vinegar",
      items: [
        { id: "r1", text: "Balsamic Vinegar", hogwash: false },
        { id: "r2", text: "Sherry Vinegar", hogwash: false },
        { id: "r3", text: "Rice Vinegar", hogwash: false },
        { id: "r4", text: "Champagne Vinegar", hogwash: false },
        { id: "r5", text: "Malt Vinegar", hogwash: false },
        { id: "r6", text: "Tarragon Vinegar", hogwash: false },
        { id: "r7", text: "Cider Vinegar", hogwash: false },
        { id: "h1", text: "Noirette Vinegar", hogwash: true },
        { id: "h2", text: "Castelaine Vinegar", hogwash: true },
        { id: "h3", text: "Verdura Vinegar", hogwash: true },
      ],
    },
    {
      id: "sausage",
      themeLabel: "Types of Sausage",
      items: [
        { id: "r1", text: "Chorizo", hogwash: false },
        { id: "r2", text: "Bratwurst", hogwash: false },
        { id: "r3", text: "Andouille", hogwash: false },
        { id: "r4", text: "Kielbasa", hogwash: false },
        { id: "r5", text: "Merguez", hogwash: false },
        { id: "r6", text: "Boudin Blanc", hogwash: false },
        { id: "r7", text: "Cotechino", hogwash: false },
        { id: "h1", text: "Nordwurst", hogwash: true },
        { id: "h2", text: "Castelino", hogwash: true },
        { id: "h3", text: "Crestbraut", hogwash: true },
      ],
    },
    {
      id: "cake",
      themeLabel: "Types of Cake",
      items: [
        { id: "r1", text: "Opera Cake", hogwash: false },
        { id: "r2", text: "Dobos Torte", hogwash: false },
        { id: "r3", text: "Charlotte Royale", hogwash: false },
        { id: "r4", text: "Black Forest Cake", hogwash: false },
        { id: "r5", text: "Financier", hogwash: false },
        { id: "r6", text: "Battenberg", hogwash: false },
        { id: "r7", text: "Baumkuchen", hogwash: false },
        { id: "h1", text: "Valdorte", hogwash: true },
        { id: "h2", text: "Cremolinne", hogwash: true },
        { id: "h3", text: "Ardoise Gâteau", hogwash: true },
      ],
    },
    {
      id: "whiskey",
      themeLabel: "Whiskey Styles",
      items: [
        { id: "r1", text: "Speyside", hogwash: false },
        { id: "r2", text: "Islay", hogwash: false },
        { id: "r3", text: "Highland", hogwash: false },
        { id: "r4", text: "Lowland", hogwash: false },
        { id: "r5", text: "Campbeltown", hogwash: false },
        { id: "r6", text: "Bourbon", hogwash: false },
        { id: "r7", text: "Irish", hogwash: false },
        { id: "h1", text: "Nordenvale", hogwash: true },
        { id: "h2", text: "Crestmoor", hogwash: true },
        { id: "h3", text: "Valdorshire", hogwash: true },
      ],
    },
    {
      id: "seafood",
      themeLabel: "Types of Seafood",
      items: [
        { id: "r1", text: "Halibut", hogwash: false },
        { id: "r2", text: "Monkfish", hogwash: false },
        { id: "r3", text: "Dover Sole", hogwash: false },
        { id: "r4", text: "Branzino", hogwash: false },
        { id: "r5", text: "Geoduck", hogwash: false },
        { id: "r6", text: "Uni", hogwash: false },
        { id: "r7", text: "Razor Clam", hogwash: false },
        { id: "h1", text: "Velvet Sculpin", hogwash: true },
        { id: "h2", text: "Nordic Dace", hogwash: true },
        { id: "h3", text: "Castel Bream", hogwash: true },
      ],
    },
    {
      id: "ice_cream",
      themeLabel: "Ice Cream Flavors",
      items: [
        { id: "r1", text: "Spumoni", hogwash: false },
        { id: "r2", text: "Rocky Road", hogwash: false },
        { id: "r3", text: "Rum Raisin", hogwash: false },
        { id: "r4", text: "Pralines & Cream", hogwash: false },
        { id: "r5", text: "Butter Pecan", hogwash: false },
        { id: "r6", text: "Toasted Almond", hogwash: false },
        { id: "r7", text: "Neapolitan", hogwash: false },
        { id: "h1", text: "Maple Crisp", hogwash: true },
        { id: "h2", text: "Velvet Fudge", hogwash: true },
        { id: "h3", text: "Caramel Surrender", hogwash: true },
      ],
    },
    {
      id: "baking",
      themeLabel: "Baking Ingredients",
      items: [
        { id: "r1", text: "Xanthan Gum", hogwash: false },
        { id: "r2", text: "Pectin", hogwash: false },
        { id: "r3", text: "Cream of Tartar", hogwash: false },
        { id: "r4", text: "Bread Flour", hogwash: false },
        { id: "r5", text: "Almond Paste", hogwash: false },
        { id: "r6", text: "Malt Powder", hogwash: false },
        { id: "r7", text: "Invert Sugar", hogwash: false },
        { id: "h1", text: "Frost Starch", hogwash: true },
        { id: "h2", text: "Valdogum", hogwash: true },
        { id: "h3", text: "Creston Extract", hogwash: true },
      ],
    },
    {
      id: "candy_bars",
      themeLabel: "Candy Bars",
      items: [
        { id: "r1", text: "Toblerone", hogwash: false },
        { id: "r2", text: "Crunchie", hogwash: false },
        { id: "r3", text: "Bounty", hogwash: false },
        { id: "r4", text: "Butterfinger", hogwash: false },
        { id: "r5", text: "Mounds", hogwash: false },
        { id: "r6", text: "Almond Joy", hogwash: false },
        { id: "r7", text: "Zero Bar", hogwash: false },
        { id: "h1", text: "Pralino", hogwash: true },
        { id: "h2", text: "Fudgewick", hogwash: true },
        { id: "h3", text: "Creston Bar", hogwash: true },
      ],
    },
    {
      id: "pizza_styles",
      themeLabel: "Pizza Styles",
      items: [
        { id: "r1", text: "Neapolitan", hogwash: false },
        { id: "r2", text: "Roman", hogwash: false },
        { id: "r3", text: "Sicilian", hogwash: false },
        { id: "r4", text: "Detroit-Style", hogwash: false },
        { id: "r5", text: "New Haven", hogwash: false },
        { id: "r6", text: "St. Louis-Style", hogwash: false },
        { id: "r7", text: "California-Style", hogwash: false },
        { id: "h1", text: "Lombardian-Style", hogwash: true },
        { id: "h2", text: "Bolognese-Style", hogwash: true },
        { id: "h3", text: "Piedmontese-Style", hogwash: true },
      ],
    },
    {
      id: "condiments",
      themeLabel: "Condiments",
      items: [
        { id: "r1", text: "Harissa", hogwash: false },
        { id: "r2", text: "Gochujang", hogwash: false },
        { id: "r3", text: "Worcestershire", hogwash: false },
        { id: "r4", text: "Tahini", hogwash: false },
        { id: "r5", text: "Sriracha", hogwash: false },
        { id: "r6", text: "Chimichurri", hogwash: false },
        { id: "r7", text: "Aioli", hogwash: false },
        { id: "h1", text: "Valdoso", hogwash: true },
        { id: "h2", text: "Crémoise Sauce", hogwash: true },
        { id: "h3", text: "Nordivo", hogwash: true },
      ],
    },
    {
      id: "spice_blends",
      themeLabel: "Spice Blends",
      items: [
        { id: "r1", text: "Garam Masala", hogwash: false },
        { id: "r2", text: "Ras El Hanout", hogwash: false },
        { id: "r3", text: "Herbes de Provence", hogwash: false },
        { id: "r4", text: "Baharat", hogwash: false },
        { id: "r5", text: "Dukkah", hogwash: false },
        { id: "r6", text: "Shichimi Togarashi", hogwash: false },
        { id: "r7", text: "Berbere", hogwash: false },
        { id: "h1", text: "Caldani Blend", hogwash: true },
        { id: "h2", text: "Veldori Masala", hogwash: true },
        { id: "h3", text: "Creston Spice", hogwash: true },
      ],
    },
    {
      id: "french_desserts",
      themeLabel: "Classic French Desserts",
      items: [
        { id: "r1", text: "Crème Brûlée", hogwash: false },
        { id: "r2", text: "Île Flottante", hogwash: false },
        { id: "r3", text: "Baba au Rhum", hogwash: false },
        { id: "r4", text: "Profiterole", hogwash: false },
        { id: "r5", text: "Mille-Feuille", hogwash: false },
        { id: "r6", text: "Paris-Brest", hogwash: false },
        { id: "r7", text: "Tarte Tatin", hogwash: false },
        { id: "h1", text: "Veloutine", hogwash: true },
        { id: "h2", text: "Crémondine", hogwash: true },
        { id: "h3", text: "Valdino", hogwash: true },
      ],
    },
    {
      id: "fermented_foods",
      themeLabel: "Fermented Foods",
      items: [
        { id: "r1", text: "Kimchi", hogwash: false },
        { id: "r2", text: "Kefir", hogwash: false },
        { id: "r3", text: "Miso", hogwash: false },
        { id: "r4", text: "Tempeh", hogwash: false },
        { id: "r5", text: "Kvass", hogwash: false },
        { id: "r6", text: "Injera", hogwash: false },
        { id: "r7", text: "Tepache", hogwash: false },
        { id: "h1", text: "Kalochi", hogwash: true },
        { id: "h2", text: "Brenval", hogwash: true },
        { id: "h3", text: "Nordomi", hogwash: true },
      ],
    },
    {
      id: "wine_regions",
      themeLabel: "Wine Regions",
      items: [
        { id: "r1", text: "Bordeaux", hogwash: false },
        { id: "r2", text: "Burgundy", hogwash: false },
        { id: "r3", text: "Barossa Valley", hogwash: false },
        { id: "r4", text: "Rioja", hogwash: false },
        { id: "r5", text: "Tuscany", hogwash: false },
        { id: "r6", text: "Willamette Valley", hogwash: false },
        { id: "r7", text: "Douro", hogwash: false },
        { id: "h1", text: "Valdorino Valley", hogwash: true },
        { id: "h2", text: "Creston Hills", hogwash: true },
        { id: "h3", text: "Nördenvale", hogwash: true },
      ],
    },
    {
      id: "street_food",
      themeLabel: "Global Street Foods",
      items: [
        { id: "r1", text: "Banh Mi", hogwash: false },
        { id: "r2", text: "Arepas", hogwash: false },
        { id: "r3", text: "Takoyaki", hogwash: false },
        { id: "r4", text: "Çiğ Köfte", hogwash: false },
        { id: "r5", text: "Bao Buns", hogwash: false },
        { id: "r6", text: "Empanadas", hogwash: false },
        { id: "r7", text: "Jerk Chicken", hogwash: false },
        { id: "h1", text: "Maputo Roll", hogwash: true },
        { id: "h2", text: "Crestano Fry", hogwash: true },
        { id: "h3", text: "Nord Skewer", hogwash: true },
      ],
    },
    {
      id: "sandwiches",
      themeLabel: "Classic Sandwiches",
      items: [
        { id: "r1", text: "Po' Boy", hogwash: false },
        { id: "r2", text: "Croque-Monsieur", hogwash: false },
        { id: "r3", text: "Cemita", hogwash: false },
        { id: "r4", text: "Torta", hogwash: false },
        { id: "r5", text: "Cubano", hogwash: false },
        { id: "r6", text: "Bocadillo", hogwash: false },
        { id: "r7", text: "Choripán", hogwash: false },
        { id: "h1", text: "Valdoro", hogwash: true },
        { id: "h2", text: "Crestino Press", hogwash: true },
        { id: "h3", text: "Nordic Grille", hogwash: true },
      ],
    },
    {
      id: "nuts",
      themeLabel: "Types of Nuts",
      items: [
        { id: "r1", text: "Macadamia", hogwash: false },
        { id: "r2", text: "Pistachio", hogwash: false },
        { id: "r3", text: "Brazil Nut", hogwash: false },
        { id: "r4", text: "Pecan", hogwash: false },
        { id: "r5", text: "Hazelnut", hogwash: false },
        { id: "r6", text: "Pine Nut", hogwash: false },
        { id: "r7", text: "Chestnut", hogwash: false },
        { id: "h1", text: "Alpine Kernel", hogwash: true },
        { id: "h2", text: "Brindlenut", hogwash: true },
        { id: "h3", text: "Nordova Nut", hogwash: true },
      ],
    },

    // ── ANIMALS, SCIENCE & NATURE ─────────────────────────────────────────────

    {
      id: "countries",
      themeLabel: "Countries",
      items: [
        { id: "r1", text: "Uruguay", hogwash: false },
        { id: "r2", text: "Namibia", hogwash: false },
        { id: "r3", text: "Slovenia", hogwash: false },
        { id: "r4", text: "Laos", hogwash: false },
        { id: "r5", text: "Ecuador", hogwash: false },
        { id: "r6", text: "Tunisia", hogwash: false },
        { id: "r7", text: "Cambodia", hogwash: false },
        { id: "h1", text: "Montavia", hogwash: true },
        { id: "h2", text: "Cordellia", hogwash: true },
        { id: "h3", text: "Valdoria", hogwash: true },
      ],
    },
    {
      id: "dogs",
      themeLabel: "Dog Breeds",
      items: [
        { id: "r1", text: "Shiba Inu", hogwash: false },
        { id: "r2", text: "Vizsla", hogwash: false },
        { id: "r3", text: "Basenji", hogwash: false },
        { id: "r4", text: "Weimaraner", hogwash: false },
        { id: "r5", text: "Samoyed", hogwash: false },
        { id: "r6", text: "Rhodesian Ridgeback", hogwash: false },
        { id: "r7", text: "Saluki", hogwash: false },
        { id: "h1", text: "Norwegian Foxhound", hogwash: true },
        { id: "h2", text: "Alpine Shepherd", hogwash: true },
        { id: "h3", text: "Belgian Pointer", hogwash: true },
      ],
    },
    {
      id: "elements",
      themeLabel: "Chemical Elements",
      items: [
        { id: "r1", text: "Bismuth", hogwash: false },
        { id: "r2", text: "Ytterbium", hogwash: false },
        { id: "r3", text: "Tellurium", hogwash: false },
        { id: "r4", text: "Hafnium", hogwash: false },
        { id: "r5", text: "Osmium", hogwash: false },
        { id: "r6", text: "Praseodymium", hogwash: false },
        { id: "r7", text: "Xenon", hogwash: false },
        { id: "h1", text: "Valdorium", hogwash: true },
        { id: "h2", text: "Crestanium", hogwash: true },
        { id: "h3", text: "Nordovium", hogwash: true },
      ],
    },
    {
      id: "clouds",
      themeLabel: "Cloud Types",
      items: [
        { id: "r1", text: "Cirrus", hogwash: false },
        { id: "r2", text: "Altostratus", hogwash: false },
        { id: "r3", text: "Nimbostratus", hogwash: false },
        { id: "r4", text: "Stratocumulus", hogwash: false },
        { id: "r5", text: "Cumulonimbus", hogwash: false },
        { id: "r6", text: "Altocumulus", hogwash: false },
        { id: "r7", text: "Cirrocumulus", hogwash: false },
        { id: "h1", text: "Cumuloveil", hogwash: true },
        { id: "h2", text: "Stratomedius", hogwash: true },
        { id: "h3", text: "Cirroflexus", hogwash: true },
      ],
    },
    {
      id: "rocks",
      themeLabel: "Rocks & Minerals",
      items: [
        { id: "r1", text: "Obsidian", hogwash: false },
        { id: "r2", text: "Pumice", hogwash: false },
        { id: "r3", text: "Schist", hogwash: false },
        { id: "r4", text: "Gneiss", hogwash: false },
        { id: "r5", text: "Hornblende", hogwash: false },
        { id: "r6", text: "Travertine", hogwash: false },
        { id: "r7", text: "Andesite", hogwash: false },
        { id: "h1", text: "Valdorite", hogwash: true },
        { id: "h2", text: "Crestanite", hogwash: true },
        { id: "h3", text: "Brindlestone", hogwash: true },
      ],
    },
    {
      id: "dinosaurs",
      themeLabel: "Dinosaur Species",
      items: [
        { id: "r1", text: "Deinonychus", hogwash: false },
        { id: "r2", text: "Pachycephalosaurus", hogwash: false },
        { id: "r3", text: "Parasaurolophus", hogwash: false },
        { id: "r4", text: "Iguanodon", hogwash: false },
        { id: "r5", text: "Carnotaurus", hogwash: false },
        { id: "r6", text: "Baryonyx", hogwash: false },
        { id: "r7", text: "Spinosaurus", hogwash: false },
        { id: "h1", text: "Crestosaurus", hogwash: true },
        { id: "h2", text: "Nordovex", hogwash: true },
        { id: "h3", text: "Casteldon", hogwash: true },
      ],
    },

    // ── MUSIC ─────────────────────────────────────────────────────────────────

    {
      id: "instruments",
      themeLabel: "Musical Instruments",
      items: [
        { id: "r1", text: "Oboe", hogwash: false },
        { id: "r2", text: "Bassoon", hogwash: false },
        { id: "r3", text: "Viola", hogwash: false },
        { id: "r4", text: "Clarinet", hogwash: false },
        { id: "r5", text: "French Horn", hogwash: false },
        { id: "r6", text: "Timpani", hogwash: false },
        { id: "r7", text: "Vibraphone", hogwash: false },
        { id: "h1", text: "Soprano Fife", hogwash: true },
        { id: "h2", text: "Mellotone", hogwash: true },
        { id: "h3", text: "Concertino", hogwash: true },
      ],
    },
    {
      id: "music_terms",
      themeLabel: "Music Theory Terms",
      items: [
        { id: "r1", text: "Cadence", hogwash: false },
        { id: "r2", text: "Ostinato", hogwash: false },
        { id: "r3", text: "Tessitura", hogwash: false },
        { id: "r4", text: "Sforzando", hogwash: false },
        { id: "r5", text: "Melisma", hogwash: false },
        { id: "r6", text: "Leitmotif", hogwash: false },
        { id: "r7", text: "Counterpoint", hogwash: false },
        { id: "h1", text: "Florendo", hogwash: true },
        { id: "h2", text: "Subretto", hogwash: true },
        { id: "h3", text: "Cresdenza", hogwash: true },
      ],
    },
    {
      id: "music_genres",
      themeLabel: "Music Genres",
      items: [
        { id: "r1", text: "Bossa Nova", hogwash: false },
        { id: "r2", text: "Zydeco", hogwash: false },
        { id: "r3", text: "Cumbia", hogwash: false },
        { id: "r4", text: "Afrobeat", hogwash: false },
        { id: "r5", text: "Bluegrass", hogwash: false },
        { id: "r6", text: "Shoegaze", hogwash: false },
        { id: "r7", text: "Grime", hogwash: false },
        { id: "h1", text: "Darkwave Fusion", hogwash: true },
        { id: "h2", text: "Nordcore", hogwash: true },
        { id: "h3", text: "Creston Soul", hogwash: true },
      ],
    },
    {
      id: "opera_terms",
      themeLabel: "Opera Terms",
      items: [
        { id: "r1", text: "Libretto", hogwash: false },
        { id: "r2", text: "Bel Canto", hogwash: false },
        { id: "r3", text: "Coloratura", hogwash: false },
        { id: "r4", text: "Recitative", hogwash: false },
        { id: "r5", text: "Aria", hogwash: false },
        { id: "r6", text: "Castrato", hogwash: false },
        { id: "r7", text: "Soubrette", hogwash: false },
        { id: "h1", text: "Valdrina", hogwash: true },
        { id: "h2", text: "Crestalto", hogwash: true },
        { id: "h3", text: "Nordaltura", hogwash: true },
      ],
    },
    {
      id: "music_notes",
      themeLabel: "Musical Notation & Symbols",
      items: [
        { id: "r1", text: "Fermata", hogwash: false },
        { id: "r2", text: "Staccato", hogwash: false },
        { id: "r3", text: "Tenuto", hogwash: false },
        { id: "r4", text: "Trill", hogwash: false },
        { id: "r5", text: "Mordent", hogwash: false },
        { id: "r6", text: "Glissando", hogwash: false },
        { id: "r7", text: "Coda", hogwash: false },
        { id: "h1", text: "Floretto", hogwash: true },
        { id: "h2", text: "Cresdenzato", hogwash: true },
        { id: "h3", text: "Nordino", hogwash: true },
      ],
    },
    {
      id: "guitar_chords",
      themeLabel: "Guitar Chord Types",
      items: [
        { id: "r1", text: "Dominant 7th", hogwash: false },
        { id: "r2", text: "Diminished", hogwash: false },
        { id: "r3", text: "Augmented", hogwash: false },
        { id: "r4", text: "Sus2", hogwash: false },
        { id: "r5", text: "Sus4", hogwash: false },
        { id: "r6", text: "Major 9th", hogwash: false },
        { id: "r7", text: "Half-Diminished", hogwash: false },
        { id: "h1", text: "Flat 11th Open", hogwash: true },
        { id: "h2", text: "Raised 6th Minor", hogwash: true },
        { id: "h3", text: "Double Suspended", hogwash: true },
      ],
    },
    {
      id: "classical_composers",
      themeLabel: "Classical Composers",
      items: [
        { id: "r1", text: "Telemann", hogwash: false },
        { id: "r2", text: "Scarlatti", hogwash: false },
        { id: "r3", text: "Buxtehude", hogwash: false },
        { id: "r4", text: "Corelli", hogwash: false },
        { id: "r5", text: "Rameau", hogwash: false },
        { id: "r6", text: "Vivaldi", hogwash: false },
        { id: "r7", text: "Purcell", hogwash: false },
        { id: "h1", text: "Aldenvere", hogwash: true },
        { id: "h2", text: "Nordbeck", hogwash: true },
        { id: "h3", text: "Castellini", hogwash: true },
      ],
    },

    // ── ART & DESIGN ──────────────────────────────────────────────────────────

    {
      id: "art_movements",
      themeLabel: "Art Movements",
      items: [
        { id: "r1", text: "Fauvism", hogwash: false },
        { id: "r2", text: "De Stijl", hogwash: false },
        { id: "r3", text: "Suprematism", hogwash: false },
        { id: "r4", text: "Constructivism", hogwash: false },
        { id: "r5", text: "Orphism", hogwash: false },
        { id: "r6", text: "Vorticism", hogwash: false },
        { id: "r7", text: "Precisionism", hogwash: false },
        { id: "h1", text: "Valdorism", hogwash: true },
        { id: "h2", text: "Crestalism", hogwash: true },
        { id: "h3", text: "Nordovism", hogwash: true },
      ],
    },
    {
      id: "drawing_concepts",
      themeLabel: "Drawing Concepts",
      items: [
        { id: "r1", text: "Foreshortening", hogwash: false },
        { id: "r2", text: "Chiaroscuro", hogwash: false },
        { id: "r3", text: "Cross-Hatching", hogwash: false },
        { id: "r4", text: "Sgraffito", hogwash: false },
        { id: "r5", text: "Contour Line", hogwash: false },
        { id: "r6", text: "Sfumato", hogwash: false },
        { id: "r7", text: "Impasto", hogwash: false },
        { id: "h1", text: "Veldurine", hogwash: true },
        { id: "h2", text: "Crestamento", hogwash: true },
        { id: "h3", text: "Nordshading", hogwash: true },
      ],
    },
    {
      id: "color_theory",
      themeLabel: "Color Theory Terms",
      items: [
        { id: "r1", text: "Hue", hogwash: false },
        { id: "r2", text: "Saturation", hogwash: false },
        { id: "r3", text: "Luminance", hogwash: false },
        { id: "r4", text: "Complementary", hogwash: false },
        { id: "r5", text: "Analogous", hogwash: false },
        { id: "r6", text: "Triadic", hogwash: false },
        { id: "r7", text: "Split-Complementary", hogwash: false },
        { id: "h1", text: "Proximate Tone", hogwash: true },
        { id: "h2", text: "Reflective Hue Shift", hogwash: true },
        { id: "h3", text: "Tetradic Contrast", hogwash: true },
      ],
    },
    {
      id: "typography",
      themeLabel: "Typography Terms",
      items: [
        { id: "r1", text: "Kerning", hogwash: false },
        { id: "r2", text: "Leading", hogwash: false },
        { id: "r3", text: "Tracking", hogwash: false },
        { id: "r4", text: "Ligature", hogwash: false },
        { id: "r5", text: "Ascender", hogwash: false },
        { id: "r6", text: "Descender", hogwash: false },
        { id: "r7", text: "Glyph", hogwash: false },
        { id: "h1", text: "Floatline", hogwash: true },
        { id: "h2", text: "Nordspacing", hogwash: true },
        { id: "h3", text: "Crestmark", hogwash: true },
      ],
    },
    {
      id: "photography",
      themeLabel: "Photography Terms",
      items: [
        { id: "r1", text: "Bokeh", hogwash: false },
        { id: "r2", text: "Exposure", hogwash: false },
        { id: "r3", text: "Aperture", hogwash: false },
        { id: "r4", text: "ISO", hogwash: false },
        { id: "r5", text: "Shutter Speed", hogwash: false },
        { id: "r6", text: "Vignette", hogwash: false },
        { id: "r7", text: "Parallax", hogwash: false },
        { id: "h1", text: "Creston Lag", hogwash: true },
        { id: "h2", text: "Valdepth", hogwash: true },
        { id: "h3", text: "Nordframe", hogwash: true },
      ],
    },
    {
      id: "architecture",
      themeLabel: "Architecture Styles",
      items: [
        { id: "r1", text: "Brutalism", hogwash: false },
        { id: "r2", text: "Deconstructivism", hogwash: false },
        { id: "r3", text: "Beaux-Arts", hogwash: false },
        { id: "r4", text: "Palladian", hogwash: false },
        { id: "r5", text: "Romanesque", hogwash: false },
        { id: "r6", text: "Art Nouveau", hogwash: false },
        { id: "r7", text: "Metabolist", hogwash: false },
        { id: "h1", text: "Valdoric", hogwash: true },
        { id: "h2", text: "Crestanist", hogwash: true },
        { id: "h3", text: "Nordalite", hogwash: true },
      ],
    },
    {
      id: "arch_elements",
      themeLabel: "Architectural Elements",
      items: [
        { id: "r1", text: "Clerestory", hogwash: false },
        { id: "r2", text: "Buttress", hogwash: false },
        { id: "r3", text: "Fenestration", hogwash: false },
        { id: "r4", text: "Entablature", hogwash: false },
        { id: "r5", text: "Quoin", hogwash: false },
        { id: "r6", text: "Spandrel", hogwash: false },
        { id: "r7", text: "Rustication", hogwash: false },
        { id: "h1", text: "Veldcourse", hogwash: true },
        { id: "h2", text: "Nordcornice", hogwash: true },
        { id: "h3", text: "Crestpillar", hogwash: true },
      ],
    },

    // ── TRADES & TECHNICAL ────────────────────────────────────────────────────

    {
      id: "electrician",
      themeLabel: "Electrician Terms",
      items: [
        { id: "r1", text: "Conduit", hogwash: false },
        { id: "r2", text: "GFCI", hogwash: false },
        { id: "r3", text: "Ampacity", hogwash: false },
        { id: "r4", text: "Bonding", hogwash: false },
        { id: "r5", text: "Overcurrent", hogwash: false },
        { id: "r6", text: "Raceway", hogwash: false },
        { id: "r7", text: "Pigtail", hogwash: false },
        { id: "h1", text: "Gridlock Tap", hogwash: true },
        { id: "h2", text: "Neutral Bonding Loop", hogwash: true },
        { id: "h3", text: "Arc Float", hogwash: true },
      ],
    },
    {
      id: "plumbing",
      themeLabel: "Plumbing Terms",
      items: [
        { id: "r1", text: "P-Trap", hogwash: false },
        { id: "r2", text: "Backflow Preventer", hogwash: false },
        { id: "r3", text: "Shutoff Valve", hogwash: false },
        { id: "r4", text: "Wax Ring", hogwash: false },
        { id: "r5", text: "Escutcheon", hogwash: false },
        { id: "r6", text: "Solder Flux", hogwash: false },
        { id: "r7", text: "Cleanout", hogwash: false },
        { id: "h1", text: "Reverse S-Trap", hogwash: true },
        { id: "h2", text: "Pressure Float Seal", hogwash: true },
        { id: "h3", text: "Dual Backcheck", hogwash: true },
      ],
    },
    {
      id: "carpentry",
      themeLabel: "Carpentry Joints",
      items: [
        { id: "r1", text: "Dovetail Joint", hogwash: false },
        { id: "r2", text: "Mortise & Tenon", hogwash: false },
        { id: "r3", text: "Rabbet Joint", hogwash: false },
        { id: "r4", text: "Biscuit Joint", hogwash: false },
        { id: "r5", text: "Finger Joint", hogwash: false },
        { id: "r6", text: "Box Joint", hogwash: false },
        { id: "r7", text: "Dado Joint", hogwash: false },
        { id: "h1", text: "Creston Lock Joint", hogwash: true },
        { id: "h2", text: "Nordic Scarf", hogwash: true },
        { id: "h3", text: "Valdwood Splice", hogwash: true },
      ],
    },
    {
      id: "welding",
      themeLabel: "Welding Terms",
      items: [
        { id: "r1", text: "MIG Welding", hogwash: false },
        { id: "r2", text: "TIG Welding", hogwash: false },
        { id: "r3", text: "Arc Welding", hogwash: false },
        { id: "r4", text: "Flux Core", hogwash: false },
        { id: "r5", text: "Spatter", hogwash: false },
        { id: "r6", text: "Undercut", hogwash: false },
        { id: "r7", text: "Porosity", hogwash: false },
        { id: "h1", text: "Cold Lap Fusion", hogwash: true },
        { id: "h2", text: "Submerged Bead", hogwash: true },
        { id: "h3", text: "Nordweld Pass", hogwash: true },
      ],
    },
    {
      id: "automotive",
      themeLabel: "Car Engine Parts",
      items: [
        { id: "r1", text: "Camshaft", hogwash: false },
        { id: "r2", text: "Crankshaft", hogwash: false },
        { id: "r3", text: "Throttle Body", hogwash: false },
        { id: "r4", text: "Timing Belt", hogwash: false },
        { id: "r5", text: "Rocker Arm", hogwash: false },
        { id: "r6", text: "Piston Ring", hogwash: false },
        { id: "r7", text: "Lifter", hogwash: false },
        { id: "h1", text: "Compression Rod", hogwash: true },
        { id: "h2", text: "Intake Float Valve", hogwash: true },
        { id: "h3", text: "Nordcam Adjuster", hogwash: true },
      ],
    },
    {
      id: "woodworking_tools",
      themeLabel: "Woodworking Tools",
      items: [
        { id: "r1", text: "Spokeshave", hogwash: false },
        { id: "r2", text: "Rabbet Plane", hogwash: false },
        { id: "r3", text: "Mortiser", hogwash: false },
        { id: "r4", text: "Drawknife", hogwash: false },
        { id: "r5", text: "Card Scraper", hogwash: false },
        { id: "r6", text: "Froe", hogwash: false },
        { id: "r7", text: "Biscuit Joiner", hogwash: false },
        { id: "h1", text: "Crestplane", hogwash: true },
        { id: "h2", text: "Nordic Skew", hogwash: true },
        { id: "h3", text: "Valdscraper", hogwash: true },
      ],
    },
    {
      id: "hvac",
      themeLabel: "HVAC Terms",
      items: [
        { id: "r1", text: "Plenum", hogwash: false },
        { id: "r2", text: "Damper", hogwash: false },
        { id: "r3", text: "Refrigerant", hogwash: false },
        { id: "r4", text: "Economizer", hogwash: false },
        { id: "r5", text: "Enthalpy", hogwash: false },
        { id: "r6", text: "Subcooling", hogwash: false },
        { id: "r7", text: "Superheat", hogwash: false },
        { id: "h1", text: "Bleed Float", hogwash: true },
        { id: "h2", text: "Nordflow Damper", hogwash: true },
        { id: "h3", text: "Creston Coil", hogwash: true },
      ],
    },

    // ── SCIENCE ───────────────────────────────────────────────────────────────

    {
      id: "anatomy",
      themeLabel: "Bones of the Human Body",
      items: [
        { id: "r1", text: "Clavicle", hogwash: false },
        { id: "r2", text: "Scapula", hogwash: false },
        { id: "r3", text: "Fibula", hogwash: false },
        { id: "r4", text: "Sternum", hogwash: false },
        { id: "r5", text: "Patella", hogwash: false },
        { id: "r6", text: "Phalanges", hogwash: false },
        { id: "r7", text: "Talus", hogwash: false },
        { id: "h1", text: "Sulcular Bone", hogwash: true },
        { id: "h2", text: "Intercorvum", hogwash: true },
        { id: "h3", text: "Valdosseum", hogwash: true },
      ],
    },
    {
      id: "brain_parts",
      themeLabel: "Parts of the Brain",
      items: [
        { id: "r1", text: "Amygdala", hogwash: false },
        { id: "r2", text: "Hippocampus", hogwash: false },
        { id: "r3", text: "Cerebellum", hogwash: false },
        { id: "r4", text: "Thalamus", hogwash: false },
        { id: "r5", text: "Pons", hogwash: false },
        { id: "r6", text: "Medulla Oblongata", hogwash: false },
        { id: "r7", text: "Cingulate Cortex", hogwash: false },
        { id: "h1", text: "Valdencephalon", hogwash: true },
        { id: "h2", text: "Crestex Lobe", hogwash: true },
        { id: "h3", text: "Nordulary Body", hogwash: true },
      ],
    },
    {
      id: "physics_concepts",
      themeLabel: "Physics Concepts",
      items: [
        { id: "r1", text: "Entropy", hogwash: false },
        { id: "r2", text: "Torque", hogwash: false },
        { id: "r3", text: "Diffraction", hogwash: false },
        { id: "r4", text: "Refraction", hogwash: false },
        { id: "r5", text: "Magnetic Flux", hogwash: false },
        { id: "r6", text: "Wave Function", hogwash: false },
        { id: "r7", text: "Resonance", hogwash: false },
        { id: "h1", text: "Valdonic Field", hogwash: true },
        { id: "h2", text: "Crestonian Force", hogwash: true },
        { id: "h3", text: "Nordaltic Decay", hogwash: true },
      ],
    },
    {
      id: "astronomy",
      themeLabel: "Astronomy Terms",
      items: [
        { id: "r1", text: "Aphelion", hogwash: false },
        { id: "r2", text: "Barycenter", hogwash: false },
        { id: "r3", text: "Albedo", hogwash: false },
        { id: "r4", text: "Syzygy", hogwash: false },
        { id: "r5", text: "Parallax", hogwash: false },
        { id: "r6", text: "Ecliptic", hogwash: false },
        { id: "r7", text: "Periapsis", hogwash: false },
        { id: "h1", text: "Crestapsis", hogwash: true },
        { id: "h2", text: "Valdovoid", hogwash: true },
        { id: "h3", text: "Nordhelion", hogwash: true },
      ],
    },
    {
      id: "genetics",
      themeLabel: "Genetics Terms",
      items: [
        { id: "r1", text: "Phenotype", hogwash: false },
        { id: "r2", text: "Allele", hogwash: false },
        { id: "r3", text: "Codon", hogwash: false },
        { id: "r4", text: "Epistasis", hogwash: false },
        { id: "r5", text: "Intron", hogwash: false },
        { id: "r6", text: "Plasmid", hogwash: false },
        { id: "r7", text: "Telomere", hogwash: false },
        { id: "h1", text: "Valdomer", hogwash: true },
        { id: "h2", text: "Crestron", hogwash: true },
        { id: "h3", text: "Nordodon", hogwash: true },
      ],
    },
    {
      id: "chemistry_lab",
      themeLabel: "Chemistry Lab Equipment",
      items: [
        { id: "r1", text: "Burette", hogwash: false },
        { id: "r2", text: "Crucible", hogwash: false },
        { id: "r3", text: "Desiccator", hogwash: false },
        { id: "r4", text: "Rotary Evaporator", hogwash: false },
        { id: "r5", text: "Separatory Funnel", hogwash: false },
        { id: "r6", text: "Condenser Coil", hogwash: false },
        { id: "r7", text: "Pipette", hogwash: false },
        { id: "h1", text: "Valdoscope", hogwash: true },
        { id: "h2", text: "Crestameter", hogwash: true },
        { id: "h3", text: "Norddenser", hogwash: true },
      ],
    },
    {
      id: "trees",
      themeLabel: "Types of Trees",
      items: [
        { id: "r1", text: "Larch", hogwash: false },
        { id: "r2", text: "Tupelo", hogwash: false },
        { id: "r3", text: "Catalpa", hogwash: false },
        { id: "r4", text: "Persimmon", hogwash: false },
        { id: "r5", text: "Pawpaw", hogwash: false },
        { id: "r6", text: "Basswood", hogwash: false },
        { id: "r7", text: "Osage Orange", hogwash: false },
        { id: "h1", text: "Creston Elm", hogwash: true },
        { id: "h2", text: "Nordpine", hogwash: true },
        { id: "h3", text: "Valdoak", hogwash: true },
      ],
    },
    {
      id: "ocean_zones",
      themeLabel: "Ocean Zones",
      items: [
        { id: "r1", text: "Epipelagic", hogwash: false },
        { id: "r2", text: "Mesopelagic", hogwash: false },
        { id: "r3", text: "Bathypelagic", hogwash: false },
        { id: "r4", text: "Abyssopelagic", hogwash: false },
        { id: "r5", text: "Hadalpelagic", hogwash: false },
        { id: "r6", text: "Photic Zone", hogwash: false },
        { id: "r7", text: "Benthic Zone", hogwash: false },
        { id: "h1", text: "Nordopelagic", hogwash: true },
        { id: "h2", text: "Crestypelagic", hogwash: true },
        { id: "h3", text: "Valdzone", hogwash: true },
      ],
    },
    {
      id: "constellations",
      themeLabel: "Constellations",
      items: [
        { id: "r1", text: "Orion", hogwash: false },
        { id: "r2", text: "Cassiopeia", hogwash: false },
        { id: "r3", text: "Cygnus", hogwash: false },
        { id: "r4", text: "Lupus", hogwash: false },
        { id: "r5", text: "Cepheus", hogwash: false },
        { id: "r6", text: "Vela", hogwash: false },
        { id: "r7", text: "Andromeda", hogwash: false },
        { id: "h1", text: "Corvinus", hogwash: true },
        { id: "h2", text: "Stellara", hogwash: true },
        { id: "h3", text: "Aquilon", hogwash: true },
      ],
    },
    {
      id: "biomes",
      themeLabel: "Biomes",
      items: [
        { id: "r1", text: "Taiga", hogwash: false },
        { id: "r2", text: "Chaparral", hogwash: false },
        { id: "r3", text: "Savanna", hogwash: false },
        { id: "r4", text: "Tundra", hogwash: false },
        { id: "r5", text: "Riparian", hogwash: false },
        { id: "r6", text: "Mangrove", hogwash: false },
        { id: "r7", text: "Boreal Forest", hogwash: false },
        { id: "h1", text: "Veldsteppe", hogwash: true },
        { id: "h2", text: "Crestmoor", hogwash: true },
        { id: "h3", text: "Nordwild", hogwash: true },
      ],
    },

    // ── SPORTS & GAMES ────────────────────────────────────────────────────────

    {
      id: "chess_openings",
      themeLabel: "Chess Openings",
      items: [
        { id: "r1", text: "Sicilian Defense", hogwash: false },
        { id: "r2", text: "Queen's Gambit", hogwash: false },
        { id: "r3", text: "Ruy López", hogwash: false },
        { id: "r4", text: "French Defense", hogwash: false },
        { id: "r5", text: "Nimzo-Indian Defense", hogwash: false },
        { id: "r6", text: "Grünfeld Defense", hogwash: false },
        { id: "r7", text: "King's Indian Defense", hogwash: false },
        { id: "h1", text: "Venetian Counter", hogwash: true },
        { id: "h2", text: "Nordic Flank", hogwash: true },
        { id: "h3", text: "Dresden Opening", hogwash: true },
      ],
    },
    {
      id: "golf_terms",
      themeLabel: "Golf Terms",
      items: [
        { id: "r1", text: "Albatross", hogwash: false },
        { id: "r2", text: "Stymie", hogwash: false },
        { id: "r3", text: "Dormie", hogwash: false },
        { id: "r4", text: "Gimme", hogwash: false },
        { id: "r5", text: "Flop Shot", hogwash: false },
        { id: "r6", text: "Fade", hogwash: false },
        { id: "r7", text: "Draw", hogwash: false },
        { id: "h1", text: "Creston Lie", hogwash: true },
        { id: "h2", text: "Nordic Chip", hogwash: true },
        { id: "h3", text: "Valdputt", hogwash: true },
      ],
    },
    {
      id: "swimming_strokes",
      themeLabel: "Swimming Strokes & Techniques",
      items: [
        { id: "r1", text: "Butterfly", hogwash: false },
        { id: "r2", text: "Breaststroke", hogwash: false },
        { id: "r3", text: "Backstroke", hogwash: false },
        { id: "r4", text: "Freestyle", hogwash: false },
        { id: "r5", text: "Sidestroke", hogwash: false },
        { id: "r6", text: "Trudgen", hogwash: false },
        { id: "r7", text: "Elementary Backstroke", hogwash: false },
        { id: "h1", text: "Creston Glide", hogwash: true },
        { id: "h2", text: "Nordstroke", hogwash: true },
        { id: "h3", text: "Valdkick", hogwash: true },
      ],
    },
    {
      id: "martial_arts",
      themeLabel: "Martial Arts Styles",
      items: [
        { id: "r1", text: "Muay Thai", hogwash: false },
        { id: "r2", text: "Krav Maga", hogwash: false },
        { id: "r3", text: "Capoeira", hogwash: false },
        { id: "r4", text: "Hapkido", hogwash: false },
        { id: "r5", text: "Silat", hogwash: false },
        { id: "r6", text: "Lethwei", hogwash: false },
        { id: "r7", text: "Savate", hogwash: false },
        { id: "h1", text: "Valdori Do", hogwash: true },
        { id: "h2", text: "Creston Ryu", hogwash: true },
        { id: "h3", text: "Nordiken", hogwash: true },
      ],
    },
    {
      id: "cycling",
      themeLabel: "Cycling Race Types",
      items: [
        { id: "r1", text: "Criterium", hogwash: false },
        { id: "r2", text: "Gran Fondo", hogwash: false },
        { id: "r3", text: "Cyclocross", hogwash: false },
        { id: "r4", text: "Time Trial", hogwash: false },
        { id: "r5", text: "Omnium", hogwash: false },
        { id: "r6", text: "Prologue Stage", hogwash: false },
        { id: "r7", text: "Team Sprint", hogwash: false },
        { id: "h1", text: "Nordval Stage", hogwash: true },
        { id: "h2", text: "Creston Circuit", hogwash: true },
        { id: "h3", text: "Valdofondo", hogwash: true },
      ],
    },
    {
      id: "poker_hands",
      themeLabel: "Poker Hands",
      items: [
        { id: "r1", text: "Royal Flush", hogwash: false },
        { id: "r2", text: "Straight Flush", hogwash: false },
        { id: "r3", text: "Four of a Kind", hogwash: false },
        { id: "r4", text: "Full House", hogwash: false },
        { id: "r5", text: "Flush", hogwash: false },
        { id: "r6", text: "Straight", hogwash: false },
        { id: "r7", text: "Three of a Kind", hogwash: false },
        { id: "h1", text: "Double Pair Plus", hogwash: true },
        { id: "h2", text: "Running Flush", hogwash: true },
        { id: "h3", text: "Iron Straight", hogwash: true },
      ],
    },

    // ── HISTORY & GEOGRAPHY ───────────────────────────────────────────────────

    {
      id: "monopoly",
      themeLabel: "Monopoly Properties",
      items: [
        { id: "r1", text: "Boardwalk", hogwash: false },
        { id: "r2", text: "Park Place", hogwash: false },
        { id: "r3", text: "Marvin Gardens", hogwash: false },
        { id: "r4", text: "Atlantic Avenue", hogwash: false },
        { id: "r5", text: "St. Charles Place", hogwash: false },
        { id: "r6", text: "Connecticut Avenue", hogwash: false },
        { id: "r7", text: "Ventnor Avenue", hogwash: false },
        { id: "h1", text: "Berkshire Place", hogwash: true },
        { id: "h2", text: "Harbor Drive", hogwash: true },
        { id: "h3", text: "Richmond Boulevard", hogwash: true },
      ],
    },
    {
      id: "ancient_wonders",
      themeLabel: "Ancient Wonders & Landmarks",
      items: [
        { id: "r1", text: "Colosseum", hogwash: false },
        { id: "r2", text: "Hagia Sophia", hogwash: false },
        { id: "r3", text: "Angkor Wat", hogwash: false },
        { id: "r4", text: "Chichen Itza", hogwash: false },
        { id: "r5", text: "Petra", hogwash: false },
        { id: "r6", text: "Teotihuacan", hogwash: false },
        { id: "r7", text: "Persepolis", hogwash: false },
        { id: "h1", text: "Valdoria Gate", hogwash: true },
        { id: "h2", text: "Temple of Crestanos", hogwash: true },
        { id: "h3", text: "Ruins of Nordavar", hogwash: true },
      ],
    },
    {
      id: "african_capitals",
      themeLabel: "African Capital Cities",
      items: [
        { id: "r1", text: "Ouagadougou", hogwash: false },
        { id: "r2", text: "Antananarivo", hogwash: false },
        { id: "r3", text: "Yamoussoukro", hogwash: false },
        { id: "r4", text: "Libreville", hogwash: false },
        { id: "r5", text: "Ndjamena", hogwash: false },
        { id: "r6", text: "Lilongwe", hogwash: false },
        { id: "r7", text: "Niamey", hogwash: false },
        { id: "h1", text: "Valdora", hogwash: true },
        { id: "h2", text: "Crestonbi", hogwash: true },
        { id: "h3", text: "Nordavi", hogwash: true },
      ],
    },
    {
      id: "us_states_capitals",
      themeLabel: "U.S. State Capitals",
      items: [
        { id: "r1", text: "Montpelier", hogwash: false },
        { id: "r2", text: "Frankfort", hogwash: false },
        { id: "r3", text: "Juneau", hogwash: false },
        { id: "r4", text: "Pierre", hogwash: false },
        { id: "r5", text: "Bismarck", hogwash: false },
        { id: "r6", text: "Cheyenne", hogwash: false },
        { id: "r7", text: "Concord", hogwash: false },
        { id: "h1", text: "Valdmont", hogwash: true },
        { id: "h2", text: "Creston City", hogwash: true },
        { id: "h3", text: "Nordwell", hogwash: true },
      ],
    },
    {
      id: "mountain_ranges",
      themeLabel: "Mountain Ranges",
      items: [
        { id: "r1", text: "Andes", hogwash: false },
        { id: "r2", text: "Caucasus", hogwash: false },
        { id: "r3", text: "Zagros", hogwash: false },
        { id: "r4", text: "Drakensberg", hogwash: false },
        { id: "r5", text: "Urals", hogwash: false },
        { id: "r6", text: "Altai", hogwash: false },
        { id: "r7", text: "Kunlun", hogwash: false },
        { id: "h1", text: "Valdoran Range", hogwash: true },
        { id: "h2", text: "Crestonide Mountains", hogwash: true },
        { id: "h3", text: "Nordavar Ridge", hogwash: true },
      ],
    },
    {
      id: "rivers",
      themeLabel: "Rivers of the World",
      items: [
        { id: "r1", text: "Zambezi", hogwash: false },
        { id: "r2", text: "Mekong", hogwash: false },
        { id: "r3", text: "Orinoco", hogwash: false },
        { id: "r4", text: "Lena", hogwash: false },
        { id: "r5", text: "Irrawaddy", hogwash: false },
        { id: "r6", text: "Volga", hogwash: false },
        { id: "r7", text: "Murray", hogwash: false },
        { id: "h1", text: "Valdora River", hogwash: true },
        { id: "h2", text: "Crestine River", hogwash: true },
        { id: "h3", text: "Nordavian River", hogwash: true },
      ],
    },

    // ── TECHNOLOGY & PROGRAMMING ──────────────────────────────────────────────

    {
      id: "programming",
      themeLabel: "Programming Languages",
      items: [
        { id: "r1", text: "Python", hogwash: false },
        { id: "r2", text: "Rust", hogwash: false },
        { id: "r3", text: "Go", hogwash: false },
        { id: "r4", text: "Kotlin", hogwash: false },
        { id: "r5", text: "Swift", hogwash: false },
        { id: "r6", text: "Elixir", hogwash: false },
        { id: "r7", text: "Scala", hogwash: false },
        { id: "h1", text: "Velocity", hogwash: true },
        { id: "h2", text: "Fusion", hogwash: true },
        { id: "h3", text: "Prism", hogwash: true },
      ],
    },
    {
      id: "networking",
      themeLabel: "Networking Terms",
      items: [
        { id: "r1", text: "DNS", hogwash: false },
        { id: "r2", text: "DHCP", hogwash: false },
        { id: "r3", text: "Subnet Mask", hogwash: false },
        { id: "r4", text: "BGP", hogwash: false },
        { id: "r5", text: "VPN Tunnel", hogwash: false },
        { id: "r6", text: "NAT", hogwash: false },
        { id: "r7", text: "VLAN", hogwash: false },
        { id: "h1", text: "Frame Resolver", hogwash: true },
        { id: "h2", text: "Packet Conduit", hogwash: true },
        { id: "h3", text: "Creston Protocol", hogwash: true },
      ],
    },
    {
      id: "database",
      themeLabel: "Database Concepts",
      items: [
        { id: "r1", text: "Normalization", hogwash: false },
        { id: "r2", text: "Sharding", hogwash: false },
        { id: "r3", text: "Indexing", hogwash: false },
        { id: "r4", text: "ACID", hogwash: false },
        { id: "r5", text: "Denormalization", hogwash: false },
        { id: "r6", text: "CAP Theorem", hogwash: false },
        { id: "r7", text: "Materialized View", hogwash: false },
        { id: "h1", text: "Creston Cache Layer", hogwash: true },
        { id: "h2", text: "Valdorow Store", hogwash: true },
        { id: "h3", text: "Nordic Replica Set", hogwash: true },
      ],
    },
    {
      id: "design_patterns",
      themeLabel: "Software Design Patterns",
      items: [
        { id: "r1", text: "Singleton", hogwash: false },
        { id: "r2", text: "Observer", hogwash: false },
        { id: "r3", text: "Decorator", hogwash: false },
        { id: "r4", text: "Facade", hogwash: false },
        { id: "r5", text: "Proxy", hogwash: false },
        { id: "r6", text: "Command", hogwash: false },
        { id: "r7", text: "Mediator", hogwash: false },
        { id: "h1", text: "Creston Bridge", hogwash: true },
        { id: "h2", text: "Valdorator", hogwash: true },
        { id: "h3", text: "Nordic Relay", hogwash: true },
      ],
    },
    {
      id: "crypto",
      themeLabel: "Cryptocurrency Terms",
      items: [
        { id: "r1", text: "Proof of Work", hogwash: false },
        { id: "r2", text: "Smart Contract", hogwash: false },
        { id: "r3", text: "Mempool", hogwash: false },
        { id: "r4", text: "Gas Fee", hogwash: false },
        { id: "r5", text: "Cold Wallet", hogwash: false },
        { id: "r6", text: "Hash Rate", hogwash: false },
        { id: "r7", text: "Staking", hogwash: false },
        { id: "h1", text: "Fluid Ledger", hogwash: true },
        { id: "h2", text: "Creston Chain", hogwash: true },
        { id: "h3", text: "Proof of Stake Relay", hogwash: true },
      ],
    },

    // ── MEDICINE & HEALTH ─────────────────────────────────────────────────────

    {
      id: "medical_terms",
      themeLabel: "Medical Terms",
      items: [
        { id: "r1", text: "Tachycardia", hogwash: false },
        { id: "r2", text: "Epistaxis", hogwash: false },
        { id: "r3", text: "Dysphagia", hogwash: false },
        { id: "r4", text: "Diaphoresis", hogwash: false },
        { id: "r5", text: "Pruritus", hogwash: false },
        { id: "r6", text: "Syncope", hogwash: false },
        { id: "r7", text: "Edema", hogwash: false },
        { id: "h1", text: "Valdorrhea", hogwash: true },
        { id: "h2", text: "Crestopenia", hogwash: true },
        { id: "h3", text: "Nordalgia", hogwash: true },
      ],
    },
    {
      id: "surgical_tools",
      themeLabel: "Surgical Instruments",
      items: [
        { id: "r1", text: "Retractor", hogwash: false },
        { id: "r2", text: "Trocar", hogwash: false },
        { id: "r3", text: "Hemostat", hogwash: false },
        { id: "r4", text: "Curette", hogwash: false },
        { id: "r5", text: "Cannula", hogwash: false },
        { id: "r6", text: "Scalpel", hogwash: false },
        { id: "r7", text: "Speculum", hogwash: false },
        { id: "h1", text: "Valdoscope", hogwash: true },
        { id: "h2", text: "Crestotome", hogwash: true },
        { id: "h3", text: "Nordclasp", hogwash: true },
      ],
    },
    {
      id: "vitamins",
      themeLabel: "Vitamins & Nutrients",
      items: [
        { id: "r1", text: "Riboflavin", hogwash: false },
        { id: "r2", text: "Niacin", hogwash: false },
        { id: "r3", text: "Folate", hogwash: false },
        { id: "r4", text: "Biotin", hogwash: false },
        { id: "r5", text: "Thiamine", hogwash: false },
        { id: "r6", text: "Pantothenic Acid", hogwash: false },
        { id: "r7", text: "Cobalamin", hogwash: false },
        { id: "h1", text: "Valdoflavin", hogwash: true },
        { id: "h2", text: "Crestomin", hogwash: true },
        { id: "h3", text: "Nordobin", hogwash: true },
      ],
    },

    // ── LANGUAGE & LITERATURE ─────────────────────────────────────────────────

    {
      id: "literary_terms",
      themeLabel: "Literary Devices",
      items: [
        { id: "r1", text: "Synecdoche", hogwash: false },
        { id: "r2", text: "Chiasmus", hogwash: false },
        { id: "r3", text: "Anaphora", hogwash: false },
        { id: "r4", text: "Zeugma", hogwash: false },
        { id: "r5", text: "Polysyndeton", hogwash: false },
        { id: "r6", text: "Apophasis", hogwash: false },
        { id: "r7", text: "Litotes", hogwash: false },
        { id: "h1", text: "Valdotaxis", hogwash: true },
        { id: "h2", text: "Crestophora", hogwash: true },
        { id: "h3", text: "Nordismus", hogwash: true },
      ],
    },
    {
      id: "greek_mythology",
      themeLabel: "Greek Mythology Figures",
      items: [
        { id: "r1", text: "Persephone", hogwash: false },
        { id: "r2", text: "Hephaestus", hogwash: false },
        { id: "r3", text: "Morpheus", hogwash: false },
        { id: "r4", text: "Aeolus", hogwash: false },
        { id: "r5", text: "Nemesis", hogwash: false },
        { id: "r6", text: "Tyche", hogwash: false },
        { id: "r7", text: "Charon", hogwash: false },
        { id: "h1", text: "Valdoros", hogwash: true },
        { id: "h2", text: "Crestania", hogwash: true },
        { id: "h3", text: "Nordovus", hogwash: true },
      ],
    },
    {
      id: "shakespeare_plays",
      themeLabel: "Shakespeare Plays",
      items: [
        { id: "r1", text: "Coriolanus", hogwash: false },
        { id: "r2", text: "Cymbeline", hogwash: false },
        { id: "r3", text: "Pericles", hogwash: false },
        { id: "r4", text: "Timon of Athens", hogwash: false },
        { id: "r5", text: "The Winter's Tale", hogwash: false },
        { id: "r6", text: "Measure for Measure", hogwash: false },
        { id: "r7", text: "All's Well That Ends Well", hogwash: false },
        { id: "h1", text: "The Duke of Valdoria", hogwash: true },
        { id: "h2", text: "Crestano's Lament", hogwash: true },
        { id: "h3", text: "The Nordic Earl", hogwash: true },
      ],
    },
    {
      id: "languages_world",
      themeLabel: "World Languages",
      items: [
        { id: "r1", text: "Tagalog", hogwash: false },
        { id: "r2", text: "Swahili", hogwash: false },
        { id: "r3", text: "Amharic", hogwash: false },
        { id: "r4", text: "Catalan", hogwash: false },
        { id: "r5", text: "Hausa", hogwash: false },
        { id: "r6", text: "Telugu", hogwash: false },
        { id: "r7", text: "Punjabi", hogwash: false },
        { id: "h1", text: "Valdorian", hogwash: true },
        { id: "h2", text: "Crestani", hogwash: true },
        { id: "h3", text: "Nordavic", hogwash: true },
      ],
    },
    {
      id: "logical_fallacies",
      themeLabel: "Logical Fallacies",
      items: [
        { id: "r1", text: "Ad Hominem", hogwash: false },
        { id: "r2", text: "Straw Man", hogwash: false },
        { id: "r3", text: "False Dichotomy", hogwash: false },
        { id: "r4", text: "Slippery Slope", hogwash: false },
        { id: "r5", text: "Appeal to Authority", hogwash: false },
        { id: "r6", text: "Hasty Generalization", hogwash: false },
        { id: "r7", text: "Circular Reasoning", hogwash: false },
        { id: "h1", text: "Creston's Paradox", hogwash: true },
        { id: "h2", text: "Valdoric Leap", hogwash: true },
        { id: "h3", text: "Nordic Regression", hogwash: true },
      ],
    },

    // ── FILM, TV & POP CULTURE ────────────────────────────────────────────────

    {
      id: "film_genres",
      themeLabel: "Film Genres",
      items: [
        { id: "r1", text: "Giallo", hogwash: false },
        { id: "r2", text: "Mumblecore", hogwash: false },
        { id: "r3", text: "Wuxia", hogwash: false },
        { id: "r4", text: "Dogme 95", hogwash: false },
        { id: "r5", text: "Spaghetti Western", hogwash: false },
        { id: "r6", text: "Peplum", hogwash: false },
        { id: "r7", text: "Jidaigeki", hogwash: false },
        { id: "h1", text: "Nordwave", hogwash: true },
        { id: "h2", text: "Crestanismo", hogwash: true },
        { id: "h3", text: "Valdocore", hogwash: true },
      ],
    },
    {
      id: "oscar_categories",
      themeLabel: "Academy Award Categories",
      items: [
        { id: "r1", text: "Best Cinematography", hogwash: false },
        { id: "r2", text: "Best Film Editing", hogwash: false },
        { id: "r3", text: "Best Production Design", hogwash: false },
        { id: "r4", text: "Best Costume Design", hogwash: false },
        { id: "r5", text: "Best Original Score", hogwash: false },
        { id: "r6", text: "Best Animated Feature", hogwash: false },
        { id: "r7", text: "Best International Feature Film", hogwash: false },
        { id: "h1", text: "Best Visual Composition", hogwash: true },
        { id: "h2", text: "Best Narrative Direction", hogwash: true },
        { id: "h3", text: "Best Dramatic Ensemble", hogwash: true },
      ],
    },
    {
      id: "video_game_genres",
      themeLabel: "Video Game Genres",
      items: [
        { id: "r1", text: "Roguelike", hogwash: false },
        { id: "r2", text: "Metroidvania", hogwash: false },
        { id: "r3", text: "Soulslike", hogwash: false },
        { id: "r4", text: "Visual Novel", hogwash: false },
        { id: "r5", text: "Battle Royale", hogwash: false },
        { id: "r6", text: "Auto-Battler", hogwash: false },
        { id: "r7", text: "Tower Defense", hogwash: false },
        { id: "h1", text: "Narrative Shooter", hogwash: true },
        { id: "h2", text: "Creston RPG", hogwash: true },
        { id: "h3", text: "Valdovania", hogwash: true },
      ],
    },
    {
      id: "board_games",
      themeLabel: "Board Games",
      items: [
        { id: "r1", text: "Agricola", hogwash: false },
        { id: "r2", text: "Pandemic", hogwash: false },
        { id: "r3", text: "Terraforming Mars", hogwash: false },
        { id: "r4", text: "Wingspan", hogwash: false },
        { id: "r5", text: "Twilight Imperium", hogwash: false },
        { id: "r6", text: "Everdell", hogwash: false },
        { id: "r7", text: "Spirit Island", hogwash: false },
        { id: "h1", text: "Valdora Rising", hogwash: true },
        { id: "h2", text: "Creston Conquest", hogwash: true },
        { id: "h3", text: "Nordhold", hogwash: true },
      ],
    },

    // ── FINANCE & LAW ─────────────────────────────────────────────────────────

    {
      id: "finance",
      themeLabel: "Finance Terms",
      items: [
        { id: "r1", text: "Amortization", hogwash: false },
        { id: "r2", text: "Arbitrage", hogwash: false },
        { id: "r3", text: "Hedge Fund", hogwash: false },
        { id: "r4", text: "Liquidity", hogwash: false },
        { id: "r5", text: "Yield Curve", hogwash: false },
        { id: "r6", text: "Short Selling", hogwash: false },
        { id: "r7", text: "Margin Call", hogwash: false },
        { id: "h1", text: "Creston Spread", hogwash: true },
        { id: "h2", text: "Valdoric Position", hogwash: true },
        { id: "h3", text: "Nordic Float", hogwash: true },
      ],
    },
    {
      id: "legal_terms",
      themeLabel: "Legal Terms",
      items: [
        { id: "r1", text: "Habeas Corpus", hogwash: false },
        { id: "r2", text: "Voir Dire", hogwash: false },
        { id: "r3", text: "Mens Rea", hogwash: false },
        { id: "r4", text: "Subrogation", hogwash: false },
        { id: "r5", text: "Tortfeasor", hogwash: false },
        { id: "r6", text: "Estoppel", hogwash: false },
        { id: "r7", text: "Indemnification", hogwash: false },
        { id: "h1", text: "Valdoric Standing", hogwash: true },
        { id: "h2", text: "Crestonian Remedy", hogwash: true },
        { id: "h3", text: "Nordic Pleading", hogwash: true },
      ],
    },

    // ── FASHION & TEXTILES ────────────────────────────────────────────────────

    {
      id: "fashion",
      themeLabel: "Fashion Terms",
      items: [
        { id: "r1", text: "Ruching", hogwash: false },
        { id: "r2", text: "Boucle", hogwash: false },
        { id: "r3", text: "Peplum", hogwash: false },
        { id: "r4", text: "Toile", hogwash: false },
        { id: "r5", text: "Jacquard", hogwash: false },
        { id: "r6", text: "Grosgrain", hogwash: false },
        { id: "r7", text: "Organza", hogwash: false },
        { id: "h1", text: "Veldreau", hogwash: true },
        { id: "h2", text: "Crestaine", hogwash: true },
        { id: "h3", text: "Nordweave", hogwash: true },
      ],
    },
    {
      id: "fabric",
      themeLabel: "Types of Fabric",
      items: [
        { id: "r1", text: "Cambric", hogwash: false },
        { id: "r2", text: "Muslin", hogwash: false },
        { id: "r3", text: "Chenille", hogwash: false },
        { id: "r4", text: "Damask", hogwash: false },
        { id: "r5", text: "Twill", hogwash: false },
        { id: "r6", text: "Herringbone", hogwash: false },
        { id: "r7", text: "Brocade", hogwash: false },
        { id: "h1", text: "Valdweave", hogwash: true },
        { id: "h2", text: "Crestlinen", hogwash: true },
        { id: "h3", text: "Nordsatin", hogwash: true },
      ],
    },
    {
      id: "gemstones",
      themeLabel: "Gemstones",
      items: [
        { id: "r1", text: "Tanzanite", hogwash: false },
        { id: "r2", text: "Alexandrite", hogwash: false },
        { id: "r3", text: "Peridot", hogwash: false },
        { id: "r4", text: "Tourmaline", hogwash: false },
        { id: "r5", text: "Citrine", hogwash: false },
        { id: "r6", text: "Labradorite", hogwash: false },
        { id: "r7", text: "Moonstone", hogwash: false },
        { id: "h1", text: "Valdorite", hogwash: true },
        { id: "h2", text: "Crestanine", hogwash: true },
        { id: "h3", text: "Nordonyx", hogwash: true },
      ],
    },

    // ── PSYCHOLOGY & BEHAVIOR ─────────────────────────────────────────────────

    {
      id: "psychology_terms",
      themeLabel: "Psychology Terms",
      items: [
        { id: "r1", text: "Cognitive Dissonance", hogwash: false },
        { id: "r2", text: "Gaslighting", hogwash: false },
        { id: "r3", text: "Projection", hogwash: false },
        { id: "r4", text: "Attachment Theory", hogwash: false },
        { id: "r5", text: "Locus of Control", hogwash: false },
        { id: "r6", text: "Priming", hogwash: false },
        { id: "r7", text: "Confirmation Bias", hogwash: false },
        { id: "h1", text: "Valdoric Reflex", hogwash: true },
        { id: "h2", text: "Creston Loop", hogwash: true },
        { id: "h3", text: "Nordic Displacement", hogwash: true },
      ],
    },
    {
      id: "phobias",
      themeLabel: "Types of Phobia",
      items: [
        { id: "r1", text: "Arachnophobia", hogwash: false },
        { id: "r2", text: "Claustrophobia", hogwash: false },
        { id: "r3", text: "Xenophobia", hogwash: false },
        { id: "r4", text: "Trypophobia", hogwash: false },
        { id: "r5", text: "Nyctophobia", hogwash: false },
        { id: "r6", text: "Glossophobia", hogwash: false },
        { id: "r7", text: "Emetophobia", hogwash: false },
        { id: "h1", text: "Valdophobia", hogwash: true },
        { id: "h2", text: "Crestophobia", hogwash: true },
        { id: "h3", text: "Nordophobia", hogwash: true },
      ],
    },
    {
      id: "love_languages",
      themeLabel: "Concepts from Psychology & Self-Help",
      items: [
        { id: "r1", text: "Growth Mindset", hogwash: false },
        { id: "r2", text: "Emotional Intelligence", hogwash: false },
        { id: "r3", text: "Imposter Syndrome", hogwash: false },
        { id: "r4", text: "Flow State", hogwash: false },
        { id: "r5", text: "Dopamine Loop", hogwash: false },
        { id: "r6", text: "Neuroplasticity", hogwash: false },
        { id: "r7", text: "Intrinsic Motivation", hogwash: false },
        { id: "h1", text: "Creston Drive", hogwash: true },
        { id: "h2", text: "Valdoric Cycle", hogwash: true },
        { id: "h3", text: "Nordic Resonance Factor", hogwash: true },
      ],
    },

    // ── ADDITIONAL NATURE & ANIMALS ───────────────────────────────────────────

    {
      id: "cat_breeds",
      themeLabel: "Cat Breeds",
      items: [
        { id: "r1", text: "Abyssinian", hogwash: false },
        { id: "r2", text: "Ragamuffin", hogwash: false },
        { id: "r3", text: "Burmilla", hogwash: false },
        { id: "r4", text: "Chartreux", hogwash: false },
        { id: "r5", text: "Tonkinese", hogwash: false },
        { id: "r6", text: "Sokoke", hogwash: false },
        { id: "r7", text: "Havana Brown", hogwash: false },
        { id: "h1", text: "Nordovan Curl", hogwash: true },
        { id: "h2", text: "Crestshire Blue", hogwash: true },
        { id: "h3", text: "Valdomere Longhair", hogwash: true },
      ],
    },
    {
      id: "bird_species",
      themeLabel: "Bird Species",
      items: [
        { id: "r1", text: "Hoatzin", hogwash: false },
        { id: "r2", text: "Shoebill", hogwash: false },
        { id: "r3", text: "Resplendent Quetzal", hogwash: false },
        { id: "r4", text: "Kookaburra", hogwash: false },
        { id: "r5", text: "Kakapo", hogwash: false },
        { id: "r6", text: "Sunbittern", hogwash: false },
        { id: "r7", text: "Lyrebird", hogwash: false },
        { id: "h1", text: "Creston Finch", hogwash: true },
        { id: "h2", text: "Nordic Tanager", hogwash: true },
        { id: "h3", text: "Valdora Wren", hogwash: true },
      ],
    },
    {
      id: "horses",
      themeLabel: "Horse Breeds",
      items: [
        { id: "r1", text: "Appaloosa", hogwash: false },
        { id: "r2", text: "Friesian", hogwash: false },
        { id: "r3", text: "Lipizzaner", hogwash: false },
        { id: "r4", text: "Akhal-Teke", hogwash: false },
        { id: "r5", text: "Andalusian", hogwash: false },
        { id: "r6", text: "Haflinger", hogwash: false },
        { id: "r7", text: "Marwari", hogwash: false },
        { id: "h1", text: "Crestonian Trotter", hogwash: true },
        { id: "h2", text: "Nordvale Stallion", hogwash: true },
        { id: "h3", text: "Valdoran Gray", hogwash: true },
      ],
    },
    {
      id: "deep_sea_creatures",
      themeLabel: "Deep Sea Creatures",
      items: [
        { id: "r1", text: "Anglerfish", hogwash: false },
        { id: "r2", text: "Vampire Squid", hogwash: false },
        { id: "r3", text: "Dumbo Octopus", hogwash: false },
        { id: "r4", text: "Barreleye Fish", hogwash: false },
        { id: "r5", text: "Goblin Shark", hogwash: false },
        { id: "r6", text: "Frilled Shark", hogwash: false },
        { id: "r7", text: "Bioluminescent Jellyfish", hogwash: false },
        { id: "h1", text: "Creston Lanternfish", hogwash: true },
        { id: "h2", text: "Nordic Spinefish", hogwash: true },
        { id: "h3", text: "Valdoran Gulper", hogwash: true },
      ],
    },
    {
      id: "insects",
      themeLabel: "Insects",
      items: [
        { id: "r1", text: "Harlequin Bug", hogwash: false },
        { id: "r2", text: "Assassin Bug", hogwash: false },
        { id: "r3", text: "Leafcutter Ant", hogwash: false },
        { id: "r4", text: "Bombardier Beetle", hogwash: false },
        { id: "r5", text: "Titan Beetle", hogwash: false },
        { id: "r6", text: "Walking Stick", hogwash: false },
        { id: "r7", text: "Dobsonfly", hogwash: false },
        { id: "h1", text: "Creston Moth", hogwash: true },
        { id: "h2", text: "Nordic Bore Beetle", hogwash: true },
        { id: "h3", text: "Valdoran Lacewing", hogwash: true },
      ],
    },
    {
      id: "flowers",
      themeLabel: "Flowers",
      items: [
        { id: "r1", text: "Fritillaria", hogwash: false },
        { id: "r2", text: "Hellebore", hogwash: false },
        { id: "r3", text: "Agapanthus", hogwash: false },
        { id: "r4", text: "Echinacea", hogwash: false },
        { id: "r5", text: "Bleeding Heart", hogwash: false },
        { id: "r6", text: "Foxglove", hogwash: false },
        { id: "r7", text: "Yarrow", hogwash: false },
        { id: "h1", text: "Creston Bloom", hogwash: true },
        { id: "h2", text: "Nordvale Petal", hogwash: true },
        { id: "h3", text: "Valdorise", hogwash: true },
      ],
    },
    {
      id: "snakes",
      themeLabel: "Snake Species",
      items: [
        { id: "r1", text: "Gaboon Viper", hogwash: false },
        { id: "r2", text: "King Cobra", hogwash: false },
        { id: "r3", text: "Boomslang", hogwash: false },
        { id: "r4", text: "Sidewinder", hogwash: false },
        { id: "r5", text: "Inland Taipan", hogwash: false },
        { id: "r6", text: "Tentacled Snake", hogwash: false },
        { id: "r7", text: "Copperhead", hogwash: false },
        { id: "h1", text: "Valdoran Racer", hogwash: true },
        { id: "h2", text: "Crestine Mamba", hogwash: true },
        { id: "h3", text: "Nordic Ground Boa", hogwash: true },
      ],
    },
    {
      id: "primates",
      themeLabel: "Primates",
      items: [
        { id: "r1", text: "Mandrill", hogwash: false },
        { id: "r2", text: "Aye-aye", hogwash: false },
        { id: "r3", text: "Tarsier", hogwash: false },
        { id: "r4", text: "Gelada", hogwash: false },
        { id: "r5", text: "Proboscis Monkey", hogwash: false },
        { id: "r6", text: "Siamang", hogwash: false },
        { id: "r7", text: "Indri", hogwash: false },
        { id: "h1", text: "Crestonian Lemur", hogwash: true },
        { id: "h2", text: "Nordoran Gibbon", hogwash: true },
        { id: "h3", text: "Valdovian Capuchin", hogwash: true },
      ],
    },

    // ── SPORTS (CONTINUED) ────────────────────────────────────────────────────

    {
      id: "olympic_events",
      themeLabel: "Olympic Events",
      items: [
        { id: "r1", text: "Biathlon", hogwash: false },
        { id: "r2", text: "Skeleton", hogwash: false },
        { id: "r3", text: "Equestrian Dressage", hogwash: false },
        { id: "r4", text: "Rhythmic Gymnastics", hogwash: false },
        { id: "r5", text: "Modern Pentathlon", hogwash: false },
        { id: "r6", text: "Synchronized Swimming", hogwash: false },
        { id: "r7", text: "Canoe Slalom", hogwash: false },
        { id: "h1", text: "Nordic Relay Dash", hogwash: true },
        { id: "h2", text: "Creston Sprint Rowing", hogwash: true },
        { id: "h3", text: "Valdoran Parallel Jump", hogwash: true },
      ],
    },
    {
      id: "soccer_terms",
      themeLabel: "Soccer Terms",
      items: [
        { id: "r1", text: "Nutmeg", hogwash: false },
        { id: "r2", text: "Panenka", hogwash: false },
        { id: "r3", text: "Rabona", hogwash: false },
        { id: "r4", text: "Sweeper", hogwash: false },
        { id: "r5", text: "Offside Trap", hogwash: false },
        { id: "r6", text: "Tiki-Taka", hogwash: false },
        { id: "r7", text: "Box-to-Box", hogwash: false },
        { id: "h1", text: "Crestada", hogwash: true },
        { id: "h2", text: "Nordic Flick", hogwash: true },
        { id: "h3", text: "Valdora Chip", hogwash: true },
      ],
    },
    {
      id: "running",
      themeLabel: "Running Terms",
      items: [
        { id: "r1", text: "Negative Split", hogwash: false },
        { id: "r2", text: "Fartlek", hogwash: false },
        { id: "r3", text: "Tempo Run", hogwash: false },
        { id: "r4", text: "Cadence", hogwash: false },
        { id: "r5", text: "Pronation", hogwash: false },
        { id: "r6", text: "VO2 Max", hogwash: false },
        { id: "r7", text: "Lactate Threshold", hogwash: false },
        { id: "h1", text: "Creston Surge", hogwash: true },
        { id: "h2", text: "Valdoric Pace", hogwash: true },
        { id: "h3", text: "Nordic Heel Float", hogwash: true },
      ],
    },
    {
      id: "yoga_poses",
      themeLabel: "Yoga Poses",
      items: [
        { id: "r1", text: "Warrior II", hogwash: false },
        { id: "r2", text: "Crow Pose", hogwash: false },
        { id: "r3", text: "Pigeon Pose", hogwash: false },
        { id: "r4", text: "Camel Pose", hogwash: false },
        { id: "r5", text: "Eagle Pose", hogwash: false },
        { id: "r6", text: "Boat Pose", hogwash: false },
        { id: "r7", text: "Triangle Pose", hogwash: false },
        { id: "h1", text: "Nordic Fold", hogwash: true },
        { id: "h2", text: "Creston Stretch", hogwash: true },
        { id: "h3", text: "Valdora Flow", hogwash: true },
      ],
    },
    {
      id: "skiing_terms",
      themeLabel: "Skiing Terms",
      items: [
        { id: "r1", text: "Moguls", hogwash: false },
        { id: "r2", text: "Schuss", hogwash: false },
        { id: "r3", text: "Carving", hogwash: false },
        { id: "r4", text: "Couloir", hogwash: false },
        { id: "r5", text: "Powder", hogwash: false },
        { id: "r6", text: "Telemark", hogwash: false },
        { id: "r7", text: "Slalom Gate", hogwash: false },
        { id: "h1", text: "Creston Traverse", hogwash: true },
        { id: "h2", text: "Nordpiste", hogwash: true },
        { id: "h3", text: "Valdline", hogwash: true },
      ],
    },
    {
      id: "rock_climbing",
      themeLabel: "Rock Climbing Terms",
      items: [
        { id: "r1", text: "Belay", hogwash: false },
        { id: "r2", text: "Crimp", hogwash: false },
        { id: "r3", text: "Dyno", hogwash: false },
        { id: "r4", text: "Rappel", hogwash: false },
        { id: "r5", text: "Smear", hogwash: false },
        { id: "r6", text: "Heel Hook", hogwash: false },
        { id: "r7", text: "Layback", hogwash: false },
        { id: "h1", text: "Creston Flag", hogwash: true },
        { id: "h2", text: "Nordic Crimp", hogwash: true },
        { id: "h3", text: "Valdoran Mantle", hogwash: true },
      ],
    },

    // ── HISTORY ───────────────────────────────────────────────────────────────

    {
      id: "ancient_civilizations",
      themeLabel: "Ancient Civilizations",
      items: [
        { id: "r1", text: "Akkadian Empire", hogwash: false },
        { id: "r2", text: "Minoan Civilization", hogwash: false },
        { id: "r3", text: "Carthage", hogwash: false },
        { id: "r4", text: "Maurya Empire", hogwash: false },
        { id: "r5", text: "Nubian Kingdom", hogwash: false },
        { id: "r6", text: "Indus Valley", hogwash: false },
        { id: "r7", text: "Phoenicia", hogwash: false },
        { id: "h1", text: "Valdorian Republic", hogwash: true },
        { id: "h2", text: "Crestonian Empire", hogwash: true },
        { id: "h3", text: "Nordic Dominion", hogwash: true },
      ],
    },
    {
      id: "wars",
      themeLabel: "Historical Wars & Conflicts",
      items: [
        { id: "r1", text: "Peloponnesian War", hogwash: false },
        { id: "r2", text: "Thirty Years' War", hogwash: false },
        { id: "r3", text: "Crimean War", hogwash: false },
        { id: "r4", text: "Boer War", hogwash: false },
        { id: "r5", text: "Punic Wars", hogwash: false },
        { id: "r6", text: "Opium Wars", hogwash: false },
        { id: "r7", text: "Mexican-American War", hogwash: false },
        { id: "h1", text: "Valdoran Conflict", hogwash: true },
        { id: "h2", text: "Creston War", hogwash: true },
        { id: "h3", text: "Nordic Siege", hogwash: true },
      ],
    },
    {
      id: "us_presidents",
      themeLabel: "U.S. Presidents",
      items: [
        { id: "r1", text: "Millard Fillmore", hogwash: false },
        { id: "r2", text: "Chester Arthur", hogwash: false },
        { id: "r3", text: "Franklin Pierce", hogwash: false },
        { id: "r4", text: "Rutherford Hayes", hogwash: false },
        { id: "r5", text: "James Buchanan", hogwash: false },
        { id: "r6", text: "William Henry Harrison", hogwash: false },
        { id: "r7", text: "Martin Van Buren", hogwash: false },
        { id: "h1", text: "Harold Creston", hogwash: true },
        { id: "h2", text: "James Valdor", hogwash: true },
        { id: "h3", text: "Frederick Nordwell", hogwash: true },
      ],
    },
    {
      id: "explorers",
      themeLabel: "Historical Explorers",
      items: [
        { id: "r1", text: "Vasco da Gama", hogwash: false },
        { id: "r2", text: "Ferdinand Magellan", hogwash: false },
        { id: "r3", text: "Zheng He", hogwash: false },
        { id: "r4", text: "Roald Amundsen", hogwash: false },
        { id: "r5", text: "Ibn Battuta", hogwash: false },
        { id: "r6", text: "Henry Hudson", hogwash: false },
        { id: "r7", text: "Ernest Shackleton", hogwash: false },
        { id: "h1", text: "Aldric Nordvane", hogwash: true },
        { id: "h2", text: "Pietro Crestano", hogwash: true },
        { id: "h3", text: "Edmund Valdore", hogwash: true },
      ],
    },
    {
      id: "revolutions",
      themeLabel: "Historical Revolutions",
      items: [
        { id: "r1", text: "French Revolution", hogwash: false },
        { id: "r2", text: "American Revolution", hogwash: false },
        { id: "r3", text: "Haitian Revolution", hogwash: false },
        { id: "r4", text: "Glorious Revolution", hogwash: false },
        { id: "r5", text: "Meiji Restoration", hogwash: false },
        { id: "r6", text: "Cuban Revolution", hogwash: false },
        { id: "r7", text: "Velvet Revolution", hogwash: false },
        { id: "h1", text: "Valdoran Uprising", hogwash: true },
        { id: "h2", text: "Crestonian Revolution", hogwash: true },
        { id: "h3", text: "Nordic Reformation", hogwash: true },
      ],
    },

    // ── RELIGION & PHILOSOPHY ─────────────────────────────────────────────────

    {
      id: "philosophy_concepts",
      themeLabel: "Philosophy Concepts",
      items: [
        { id: "r1", text: "Categorical Imperative", hogwash: false },
        { id: "r2", text: "Dialectic", hogwash: false },
        { id: "r3", text: "Phenomenology", hogwash: false },
        { id: "r4", text: "Solipsism", hogwash: false },
        { id: "r5", text: "Utilitarianism", hogwash: false },
        { id: "r6", text: "Epistemology", hogwash: false },
        { id: "r7", text: "Ontology", hogwash: false },
        { id: "h1", text: "Crestonian Duality", hogwash: true },
        { id: "h2", text: "Valdoric Realism", hogwash: true },
        { id: "h3", text: "Nordic Formalism", hogwash: true },
      ],
    },
    {
      id: "world_religions",
      themeLabel: "World Religions & Belief Systems",
      items: [
        { id: "r1", text: "Jainism", hogwash: false },
        { id: "r2", text: "Zoroastrianism", hogwash: false },
        { id: "r3", text: "Baha'i Faith", hogwash: false },
        { id: "r4", text: "Shinto", hogwash: false },
        { id: "r5", text: "Yazidism", hogwash: false },
        { id: "r6", text: "Cao Dai", hogwash: false },
        { id: "r7", text: "Tenrikyo", hogwash: false },
        { id: "h1", text: "Valdorism", hogwash: true },
        { id: "h2", text: "Crestanism", hogwash: true },
        { id: "h3", text: "Nordavism", hogwash: true },
      ],
    },
    {
      id: "philosophers",
      themeLabel: "Famous Philosophers",
      items: [
        { id: "r1", text: "Epictetus", hogwash: false },
        { id: "r2", text: "Heraclitus", hogwash: false },
        { id: "r3", text: "Maimonides", hogwash: false },
        { id: "r4", text: "Averroes", hogwash: false },
        { id: "r5", text: "Kierkegaard", hogwash: false },
        { id: "r6", text: "Schopenhauer", hogwash: false },
        { id: "r7", text: "Wittgenstein", hogwash: false },
        { id: "h1", text: "Aldric Nordvane", hogwash: true },
        { id: "h2", text: "Pietro Crestano", hogwash: true },
        { id: "h3", text: "Valdorus of Athens", hogwash: true },
      ],
    },

    // ── SPACE & PHYSICS ───────────────────────────────────────────────────────

    {
      id: "planets_moons",
      themeLabel: "Moons of the Solar System",
      items: [
        { id: "r1", text: "Titan", hogwash: false },
        { id: "r2", text: "Europa", hogwash: false },
        { id: "r3", text: "Ganymede", hogwash: false },
        { id: "r4", text: "Callisto", hogwash: false },
        { id: "r5", text: "Enceladus", hogwash: false },
        { id: "r6", text: "Triton", hogwash: false },
        { id: "r7", text: "Oberon", hogwash: false },
        { id: "h1", text: "Valdora IV", hogwash: true },
        { id: "h2", text: "Crestonis", hogwash: true },
        { id: "h3", text: "Nordavus", hogwash: true },
      ],
    },
    {
      id: "space_missions",
      themeLabel: "Space Missions",
      items: [
        { id: "r1", text: "Voyager 1", hogwash: false },
        { id: "r2", text: "Cassini-Huygens", hogwash: false },
        { id: "r3", text: "New Horizons", hogwash: false },
        { id: "r4", text: "MESSENGER", hogwash: false },
        { id: "r5", text: "Mars Pathfinder", hogwash: false },
        { id: "r6", text: "Juno", hogwash: false },
        { id: "r7", text: "Dawn", hogwash: false },
        { id: "h1", text: "Creston Deep Probe", hogwash: true },
        { id: "h2", text: "Nordic Orbiter", hogwash: true },
        { id: "h3", text: "Valdoran Explorer", hogwash: true },
      ],
    },
    {
      id: "quantum_physics",
      themeLabel: "Quantum Physics Concepts",
      items: [
        { id: "r1", text: "Superposition", hogwash: false },
        { id: "r2", text: "Entanglement", hogwash: false },
        { id: "r3", text: "Wave Collapse", hogwash: false },
        { id: "r4", text: "Spin", hogwash: false },
        { id: "r5", text: "Decoherence", hogwash: false },
        { id: "r6", text: "Uncertainty Principle", hogwash: false },
        { id: "r7", text: "Tunneling", hogwash: false },
        { id: "h1", text: "Creston Effect", hogwash: true },
        { id: "h2", text: "Valdoric Collapse", hogwash: true },
        { id: "h3", text: "Nordic Resonance Field", hogwash: true },
      ],
    },
    {
      id: "telescopes",
      themeLabel: "Space Telescopes & Observatories",
      items: [
        { id: "r1", text: "Hubble Space Telescope", hogwash: false },
        { id: "r2", text: "James Webb Space Telescope", hogwash: false },
        { id: "r3", text: "Chandra X-ray Observatory", hogwash: false },
        { id: "r4", text: "Spitzer Space Telescope", hogwash: false },
        { id: "r5", text: "Kepler Space Telescope", hogwash: false },
        { id: "r6", text: "XMM-Newton", hogwash: false },
        { id: "r7", text: "TESS", hogwash: false },
        { id: "h1", text: "Valdoran Deep-Field Array", hogwash: true },
        { id: "h2", text: "Creston Infrared Scope", hogwash: true },
        { id: "h3", text: "Nordic Orbital Observer", hogwash: true },
      ],
    },

    // ── HOBBIES & EVERYDAY LIFE ───────────────────────────────────────────────

    {
      id: "knitting",
      themeLabel: "Knitting & Crochet Terms",
      items: [
        { id: "r1", text: "Stockinette", hogwash: false },
        { id: "r2", text: "Frogging", hogwash: false },
        { id: "r3", text: "Yarn Over", hogwash: false },
        { id: "r4", text: "Crochet Hook", hogwash: false },
        { id: "r5", text: "Ribbing", hogwash: false },
        { id: "r6", text: "Magic Loop", hogwash: false },
        { id: "r7", text: "Provisional Cast-On", hogwash: false },
        { id: "h1", text: "Creston Bind", hogwash: true },
        { id: "h2", text: "Valdoran Purl", hogwash: true },
        { id: "h3", text: "Nordic Tuck Stitch", hogwash: true },
      ],
    },
    {
      id: "gardening",
      themeLabel: "Gardening Techniques",
      items: [
        { id: "r1", text: "Deadheading", hogwash: false },
        { id: "r2", text: "Espalier", hogwash: false },
        { id: "r3", text: "Scarification", hogwash: false },
        { id: "r4", text: "Companion Planting", hogwash: false },
        { id: "r5", text: "Mulching", hogwash: false },
        { id: "r6", text: "Grafting", hogwash: false },
        { id: "r7", text: "Pinching Out", hogwash: false },
        { id: "h1", text: "Creston Pruning", hogwash: true },
        { id: "h2", text: "Nordic Side Graft", hogwash: true },
        { id: "h3", text: "Valdoran Thinning", hogwash: true },
      ],
    },
    {
      id: "photography_genres",
      themeLabel: "Photography Genres",
      items: [
        { id: "r1", text: "Cinemagraph", hogwash: false },
        { id: "r2", text: "Lomography", hogwash: false },
        { id: "r3", text: "Long Exposure", hogwash: false },
        { id: "r4", text: "Double Exposure", hogwash: false },
        { id: "r5", text: "High-Key", hogwash: false },
        { id: "r6", text: "Low-Key", hogwash: false },
        { id: "r7", text: "Tilt-Shift", hogwash: false },
        { id: "h1", text: "Creston Blur", hogwash: true },
        { id: "h2", text: "Nordic Depth Shot", hogwash: true },
        { id: "h3", text: "Valdoran Frame", hogwash: true },
      ],
    },
    {
      id: "chess_pieces",
      themeLabel: "Chess Piece Movements",
      items: [
        { id: "r1", text: "Knight Fork", hogwash: false },
        { id: "r2", text: "Pin", hogwash: false },
        { id: "r3", text: "Skewer", hogwash: false },
        { id: "r4", text: "Discovered Check", hogwash: false },
        { id: "r5", text: "Zwischenzug", hogwash: false },
        { id: "r6", text: "Zugzwang", hogwash: false },
        { id: "r7", text: "En Passant", hogwash: false },
        { id: "h1", text: "Valdoran Sacrifice", hogwash: true },
        { id: "h2", text: "Creston Gambit", hogwash: true },
        { id: "h3", text: "Nordic Opposition", hogwash: true },
      ],
    },
    {
      id: "cocktail_techniques",
      themeLabel: "Bartending Techniques",
      items: [
        { id: "r1", text: "Dry Shake", hogwash: false },
        { id: "r2", text: "Fat Washing", hogwash: false },
        { id: "r3", text: "Clarification", hogwash: false },
        { id: "r4", text: "Rinsing", hogwash: false },
        { id: "r5", text: "Muddling", hogwash: false },
        { id: "r6", text: "Flaming Zest", hogwash: false },
        { id: "r7", text: "Demerara Syrup", hogwash: false },
        { id: "h1", text: "Creston Press", hogwash: true },
        { id: "h2", text: "Valdoran Float", hogwash: true },
        { id: "h3", text: "Nordic Smoke Roll", hogwash: true },
      ],
    },
    {
      id: "sewing",
      themeLabel: "Sewing Terms",
      items: [
        { id: "r1", text: "Seam Allowance", hogwash: false },
        { id: "r2", text: "Basting", hogwash: false },
        { id: "r3", text: "Topstitch", hogwash: false },
        { id: "r4", text: "Interfacing", hogwash: false },
        { id: "r5", text: "Notching", hogwash: false },
        { id: "r6", text: "French Seam", hogwash: false },
        { id: "r7", text: "Bias Tape", hogwash: false },
        { id: "h1", text: "Crestline Stitch", hogwash: true },
        { id: "h2", text: "Valdoran Fold", hogwash: true },
        { id: "h3", text: "Nordic Hem", hogwash: true },
      ],
    },
    {
      id: "stamp_collecting",
      themeLabel: "Philately (Stamp Collecting) Terms",
      items: [
        { id: "r1", text: "Perforation", hogwash: false },
        { id: "r2", text: "Watermark", hogwash: false },
        { id: "r3", text: "Gutter Pair", hogwash: false },
        { id: "r4", text: "Overprint", hogwash: false },
        { id: "r5", text: "Definitive", hogwash: false },
        { id: "r6", text: "Cachet", hogwash: false },
        { id: "r7", text: "Coil Stamp", hogwash: false },
        { id: "h1", text: "Creston Proof", hogwash: true },
        { id: "h2", text: "Valdoran Block", hogwash: true },
        { id: "h3", text: "Nordic Imperforate", hogwash: true },
      ],
    },
    {
      id: "camping",
      themeLabel: "Camping & Outdoor Survival Terms",
      items: [
        { id: "r1", text: "Tinder Bundle", hogwash: false },
        { id: "r2", text: "Bear Hang", hogwash: false },
        { id: "r3", text: "Dead Reckoning", hogwash: false },
        { id: "r4", text: "Lean-To", hogwash: false },
        { id: "r5", text: "Blazing a Trail", hogwash: false },
        { id: "r6", text: "Leave No Trace", hogwash: false },
        { id: "r7", text: "Bivouac", hogwash: false },
        { id: "h1", text: "Creston Lash", hogwash: true },
        { id: "h2", text: "Nordic Shelter Pack", hogwash: true },
        { id: "h3", text: "Valdoran Cache", hogwash: true },
      ],
    },

    // ── MISCELLANEOUS ─────────────────────────────────────────────────────────

    {
      id: "typography2",
      themeLabel: "Font Families & Typefaces",
      items: [
        { id: "r1", text: "Helvetica", hogwash: false },
        { id: "r2", text: "Garamond", hogwash: false },
        { id: "r3", text: "Futura", hogwash: false },
        { id: "r4", text: "Bodoni", hogwash: false },
        { id: "r5", text: "Caslon", hogwash: false },
        { id: "r6", text: "Gill Sans", hogwash: false },
        { id: "r7", text: "Univers", hogwash: false },
        { id: "h1", text: "Nordvale Sans", hogwash: true },
        { id: "h2", text: "Creston Serif", hogwash: true },
        { id: "h3", text: "Valdoric Display", hogwash: true },
      ],
    },
    {
      id: "economic_systems",
      themeLabel: "Economic Systems & Theories",
      items: [
        { id: "r1", text: "Keynesian", hogwash: false },
        { id: "r2", text: "Mercantilism", hogwash: false },
        { id: "r3", text: "Monetarism", hogwash: false },
        { id: "r4", text: "Physiocracy", hogwash: false },
        { id: "r5", text: "Marxism", hogwash: false },
        { id: "r6", text: "Austerian", hogwash: false },
        { id: "r7", text: "Supply-Side Economics", hogwash: false },
        { id: "h1", text: "Valdorism", hogwash: true },
        { id: "h2", text: "Creston Theory", hogwash: true },
        { id: "h3", text: "Nordic Equilibrium", hogwash: true },
      ],
    },
    {
      id: "card_games",
      themeLabel: "Card Games",
      items: [
        { id: "r1", text: "Canasta", hogwash: false },
        { id: "r2", text: "Pinochle", hogwash: false },
        { id: "r3", text: "Cribbage", hogwash: false },
        { id: "r4", text: "Bezique", hogwash: false },
        { id: "r5", text: "Piquet", hogwash: false },
        { id: "r6", text: "Euchre", hogwash: false },
        { id: "r7", text: "Whist", hogwash: false },
        { id: "h1", text: "Valdoran Aces", hogwash: true },
        { id: "h2", text: "Creston Trick", hogwash: true },
        { id: "h3", text: "Nordic Draw", hogwash: true },
      ],
    },
    {
      id: "knots",
      themeLabel: "Types of Knots",
      items: [
        { id: "r1", text: "Bowline", hogwash: false },
        { id: "r2", text: "Clove Hitch", hogwash: false },
        { id: "r3", text: "Sheet Bend", hogwash: false },
        { id: "r4", text: "Prusik", hogwash: false },
        { id: "r5", text: "Trucker's Hitch", hogwash: false },
        { id: "r6", text: "Monkey's Fist", hogwash: false },
        { id: "r7", text: "Alpine Butterfly", hogwash: false },
        { id: "h1", text: "Creston Loop", hogwash: true },
        { id: "h2", text: "Valdoran Hitch", hogwash: true },
        { id: "h3", text: "Nordic Splice", hogwash: true },
      ],
    },
    {
      id: "printing",
      themeLabel: "Printing Techniques",
      items: [
        { id: "r1", text: "Lithography", hogwash: false },
        { id: "r2", text: "Etching", hogwash: false },
        { id: "r3", text: "Aquatint", hogwash: false },
        { id: "r4", text: "Mezzotint", hogwash: false },
        { id: "r5", text: "Screen Printing", hogwash: false },
        { id: "r6", text: "Letterpress", hogwash: false },
        { id: "r7", text: "Linocut", hogwash: false },
        { id: "h1", text: "Crestotype", hogwash: true },
        { id: "h2", text: "Nordengraving", hogwash: true },
        { id: "h3", text: "Valdoprint", hogwash: true },
      ],
    },
    {
      id: "astronomy2",
      themeLabel: "Types of Stars",
      items: [
        { id: "r1", text: "Red Giant", hogwash: false },
        { id: "r2", text: "White Dwarf", hogwash: false },
        { id: "r3", text: "Neutron Star", hogwash: false },
        { id: "r4", text: "Magnetar", hogwash: false },
        { id: "r5", text: "Brown Dwarf", hogwash: false },
        { id: "r6", text: "T Tauri Star", hogwash: false },
        { id: "r7", text: "Wolf-Rayet Star", hogwash: false },
        { id: "h1", text: "Creston Pulsar", hogwash: true },
        { id: "h2", text: "Valdoran Dwarf", hogwash: true },
        { id: "h3", text: "Nordic Subgiant", hogwash: true },
      ],
    },
    {
      id: "dances",
      themeLabel: "Dance Styles",
      items: [
        { id: "r1", text: "Foxtrot", hogwash: false },
        { id: "r2", text: "Lindy Hop", hogwash: false },
        { id: "r3", text: "Paso Doble", hogwash: false },
        { id: "r4", text: "Viennese Waltz", hogwash: false },
        { id: "r5", text: "Quickstep", hogwash: false },
        { id: "r6", text: "West Coast Swing", hogwash: false },
        { id: "r7", text: "Bolero", hogwash: false },
        { id: "h1", text: "Crestano", hogwash: true },
        { id: "h2", text: "Nordic Slide", hogwash: true },
        { id: "h3", text: "Valdorant", hogwash: true },
      ],
    },
    {
      id: "fonts_concepts",
      themeLabel: "Graphic Design Concepts",
      items: [
        { id: "r1", text: "Negative Space", hogwash: false },
        { id: "r2", text: "Visual Hierarchy", hogwash: false },
        { id: "r3", text: "Gestalt Principles", hogwash: false },
        { id: "r4", text: "Bleed", hogwash: false },
        { id: "r5", text: "Crop Marks", hogwash: false },
        { id: "r6", text: "Rasterization", hogwash: false },
        { id: "r7", text: "Bezier Curve", hogwash: false },
        { id: "h1", text: "Creston Grid", hogwash: true },
        { id: "h2", text: "Valdoran Contrast", hogwash: true },
        { id: "h3", text: "Nordic Flow Path", hogwash: true },
      ],
    },
    {
      id: "military_ranks",
      themeLabel: "Military Ranks",
      items: [
        { id: "r1", text: "Corporal", hogwash: false },
        { id: "r2", text: "Warrant Officer", hogwash: false },
        { id: "r3", text: "Brigadier General", hogwash: false },
        { id: "r4", text: "Ensign", hogwash: false },
        { id: "r5", text: "Petty Officer", hogwash: false },
        { id: "r6", text: "Master Sergeant", hogwash: false },
        { id: "r7", text: "Chief of Staff", hogwash: false },
        { id: "h1", text: "Creston Commander", hogwash: true },
        { id: "h2", text: "Nordic Field Adjutant", hogwash: true },
        { id: "h3", text: "Valdoran Centurion", hogwash: true },
      ],
    },
    {
      id: "sailing",
      themeLabel: "Sailing Terms",
      items: [
        { id: "r1", text: "Tacking", hogwash: false },
        { id: "r2", text: "Jibing", hogwash: false },
        { id: "r3", text: "Cleat", hogwash: false },
        { id: "r4", text: "Luff", hogwash: false },
        { id: "r5", text: "Keel", hogwash: false },
        { id: "r6", text: "Batten", hogwash: false },
        { id: "r7", text: "Spinnaker", hogwash: false },
        { id: "h1", text: "Creston Reach", hogwash: true },
        { id: "h2", text: "Valdoran Trim", hogwash: true },
        { id: "h3", text: "Nordic Run", hogwash: true },
      ],
    },
    {
      id: "astronomy_instruments",
      themeLabel: "Scientific Instruments",
      items: [
        { id: "r1", text: "Spectrophotometer", hogwash: false },
        { id: "r2", text: "Oscilloscope", hogwash: false },
        { id: "r3", text: "Calorimeter", hogwash: false },
        { id: "r4", text: "Gravimeter", hogwash: false },
        { id: "r5", text: "Magnetometer", hogwash: false },
        { id: "r6", text: "Refractometer", hogwash: false },
        { id: "r7", text: "Bolometer", hogwash: false },
        { id: "h1", text: "Crestometer", hogwash: true },
        { id: "h2", text: "Valdoscope", hogwash: true },
        { id: "h3", text: "Nordalyzer", hogwash: true },
      ],
    },
    {
      id: "tattoo_styles",
      themeLabel: "Tattoo Styles",
      items: [
        { id: "r1", text: "Blackwork", hogwash: false },
        { id: "r2", text: "Neo-Traditional", hogwash: false },
        { id: "r3", text: "Irezumi", hogwash: false },
        { id: "r4", text: "Dotwork", hogwash: false },
        { id: "r5", text: "Trash Polka", hogwash: false },
        { id: "r6", text: "Watercolor", hogwash: false },
        { id: "r7", text: "Fine Line", hogwash: false },
        { id: "h1", text: "Creston Shade", hogwash: true },
        { id: "h2", text: "Valdoran Flash", hogwash: true },
        { id: "h3", text: "Nordic Folk Art", hogwash: true },
      ],
    },
    {
      id: "bridges",
      themeLabel: "Types of Bridges",
      items: [
        { id: "r1", text: "Suspension Bridge", hogwash: false },
        { id: "r2", text: "Cable-Stayed Bridge", hogwash: false },
        { id: "r3", text: "Truss Bridge", hogwash: false },
        { id: "r4", text: "Arch Bridge", hogwash: false },
        { id: "r5", text: "Cantilever Bridge", hogwash: false },
        { id: "r6", text: "Beam Bridge", hogwash: false },
        { id: "r7", text: "Bascule Bridge", hogwash: false },
        { id: "h1", text: "Creston Float Bridge", hogwash: true },
        { id: "h2", text: "Valdoran Span", hogwash: true },
        { id: "h3", text: "Nordic Tied Arch", hogwash: true },
      ],
    },
    {
      id: "renaissance_artists",
      themeLabel: "Renaissance Artists",
      items: [
        { id: "r1", text: "Raphael", hogwash: false },
        { id: "r2", text: "Donatello", hogwash: false },
        { id: "r3", text: "Botticelli", hogwash: false },
        { id: "r4", text: "Titian", hogwash: false },
        { id: "r5", text: "Caravaggio", hogwash: false },
        { id: "r6", text: "Tintoretto", hogwash: false },
        { id: "r7", text: "Mantegna", hogwash: false },
        { id: "h1", text: "Valdoro di Cresti", hogwash: true },
        { id: "h2", text: "Nordavini", hogwash: true },
        { id: "h3", text: "Crestano di Valda", hogwash: true },
      ],
    },
    {
      id: "economics_indicators",
      themeLabel: "Economic Indicators",
      items: [
        { id: "r1", text: "GDP", hogwash: false },
        { id: "r2", text: "CPI", hogwash: false },
        { id: "r3", text: "Purchasing Power Parity", hogwash: false },
        { id: "r4", text: "Gini Coefficient", hogwash: false },
        { id: "r5", text: "M2 Money Supply", hogwash: false },
        { id: "r6", text: "Balance of Trade", hogwash: false },
        { id: "r7", text: "Unemployment Rate", hogwash: false },
        { id: "h1", text: "Creston Index", hogwash: true },
        { id: "h2", text: "Valdoran Velocity", hogwash: true },
        { id: "h3", text: "Nordic Demand Ratio", hogwash: true },
      ],
    },
    {
      id: "cloud_computing",
      themeLabel: "Cloud Computing Terms",
      items: [
        { id: "r1", text: "Serverless", hogwash: false },
        { id: "r2", text: "Kubernetes", hogwash: false },
        { id: "r3", text: "Microservices", hogwash: false },
        { id: "r4", text: "Load Balancer", hogwash: false },
        { id: "r5", text: "Autoscaling", hogwash: false },
        { id: "r6", text: "CDN", hogwash: false },
        { id: "r7", text: "Edge Computing", hogwash: false },
        { id: "h1", text: "Creston Mesh", hogwash: true },
        { id: "h2", text: "Valdoran Gateway", hogwash: true },
        { id: "h3", text: "Nordic Cluster Node", hogwash: true },
      ],
    },
    {
      id: "poetry_forms",
      themeLabel: "Poetry Forms",
      items: [
        { id: "r1", text: "Villanelle", hogwash: false },
        { id: "r2", text: "Sestina", hogwash: false },
        { id: "r3", text: "Pantoum", hogwash: false },
        { id: "r4", text: "Ghazal", hogwash: false },
        { id: "r5", text: "Terza Rima", hogwash: false },
        { id: "r6", text: "Rondeau", hogwash: false },
        { id: "r7", text: "Triolet", hogwash: false },
        { id: "h1", text: "Valdorine", hogwash: true },
        { id: "h2", text: "Crestola", hogwash: true },
        { id: "h3", text: "Nordic Verse", hogwash: true },
      ],
    },
    {
      id: "logic_gates",
      themeLabel: "Logic Gates",
      items: [
        { id: "r1", text: "AND Gate", hogwash: false },
        { id: "r2", text: "OR Gate", hogwash: false },
        { id: "r3", text: "NAND Gate", hogwash: false },
        { id: "r4", text: "NOR Gate", hogwash: false },
        { id: "r5", text: "XOR Gate", hogwash: false },
        { id: "r6", text: "XNOR Gate", hogwash: false },
        { id: "r7", text: "NOT Gate", hogwash: false },
        { id: "h1", text: "CRESTON Gate", hogwash: true },
        { id: "h2", text: "VALDOR Gate", hogwash: true },
        { id: "h3", text: "NORDIC Gate", hogwash: true },
      ],
    },
    {
      id: "vaccines",
      themeLabel: "Types of Vaccines",
      items: [
        { id: "r1", text: "mRNA Vaccine", hogwash: false },
        { id: "r2", text: "Live Attenuated", hogwash: false },
        { id: "r3", text: "Inactivated", hogwash: false },
        { id: "r4", text: "Subunit", hogwash: false },
        { id: "r5", text: "Toxoid", hogwash: false },
        { id: "r6", text: "Viral Vector", hogwash: false },
        { id: "r7", text: "Conjugate", hogwash: false },
        { id: "h1", text: "Creston Adjuvant", hogwash: true },
        { id: "h2", text: "Valdoric Peptide", hogwash: true },
        { id: "h3", text: "Nordic Lipid Shell", hogwash: true },
      ],
    },
    {
      id: "theater_terms",
      themeLabel: "Theater Terms",
      items: [
        { id: "r1", text: "Apron Stage", hogwash: false },
        { id: "r2", text: "Thrust Stage", hogwash: false },
        { id: "r3", text: "Proscenium", hogwash: false },
        { id: "r4", text: "Blocking", hogwash: false },
        { id: "r5", text: "Fourth Wall", hogwash: false },
        { id: "r6", text: "Green Room", hogwash: false },
        { id: "r7", text: "Wings", hogwash: false },
        { id: "h1", text: "Crestonian Stage", hogwash: true },
        { id: "h2", text: "Valdoric Pit", hogwash: true },
        { id: "h3", text: "Nordic Arc", hogwash: true },
      ],
    },
    {
      id: "motorcycles",
      themeLabel: "Motorcycle Types",
      items: [
        { id: "r1", text: "Cafe Racer", hogwash: false },
        { id: "r2", text: "Scrambler", hogwash: false },
        { id: "r3", text: "Enduro", hogwash: false },
        { id: "r4", text: "Bobber", hogwash: false },
        { id: "r5", text: "Chopper", hogwash: false },
        { id: "r6", text: "Faired Sportbike", hogwash: false },
        { id: "r7", text: "Adventure Tourer", hogwash: false },
        { id: "h1", text: "Creston Tracker", hogwash: true },
        { id: "h2", text: "Valdoran Flat-Track", hogwash: true },
        { id: "h3", text: "Nordic Cruiser", hogwash: true },
      ],
    },
    {
      id: "economics_schools",
      themeLabel: "Schools of Economic Thought",
      items: [
        { id: "r1", text: "Austrian School", hogwash: false },
        { id: "r2", text: "Chicago School", hogwash: false },
        { id: "r3", text: "Cambridge School", hogwash: false },
        { id: "r4", text: "Post-Keynesian", hogwash: false },
        { id: "r5", text: "Institutionalism", hogwash: false },
        { id: "r6", text: "Behavioral Economics", hogwash: false },
        { id: "r7", text: "Classical Economics", hogwash: false },
        { id: "h1", text: "Crestonian School", hogwash: true },
        { id: "h2", text: "Valdoran Theory", hogwash: true },
        { id: "h3", text: "Nordic Rationalism", hogwash: true },
      ],
    },
    {
      id: "meditation_types",
      themeLabel: "Types of Meditation",
      items: [
        { id: "r1", text: "Vipassana", hogwash: false },
        { id: "r2", text: "Loving-Kindness", hogwash: false },
        { id: "r3", text: "Body Scan", hogwash: false },
        { id: "r4", text: "Transcendental", hogwash: false },
        { id: "r5", text: "Zazen", hogwash: false },
        { id: "r6", text: "Kundalini", hogwash: false },
        { id: "r7", text: "Nada Yoga", hogwash: false },
        { id: "h1", text: "Creston Stillness", hogwash: true },
        { id: "h2", text: "Valdoran Centering", hogwash: true },
        { id: "h3", text: "Nordic Focus Technique", hogwash: true },
      ],
    },
    {
      id: "currencies",
      themeLabel: "World Currencies",
      items: [
        { id: "r1", text: "Zloty", hogwash: false },
        { id: "r2", text: "Dirham", hogwash: false },
        { id: "r3", text: "Ringgit", hogwash: false },
        { id: "r4", text: "Forint", hogwash: false },
        { id: "r5", text: "Lira", hogwash: false },
        { id: "r6", text: "Baht", hogwash: false },
        { id: "r7", text: "Krona", hogwash: false },
        { id: "h1", text: "Valdor", hogwash: true },
        { id: "h2", text: "Crestanek", hogwash: true },
        { id: "h3", text: "Nordmark", hogwash: true },
      ],
    },
    {
      id: "brain_disorders",
      themeLabel: "Neurological Conditions",
      items: [
        { id: "r1", text: "Aphasia", hogwash: false },
        { id: "r2", text: "Agnosia", hogwash: false },
        { id: "r3", text: "Dystonia", hogwash: false },
        { id: "r4", text: "Ataxia", hogwash: false },
        { id: "r5", text: "Narcolepsy", hogwash: false },
        { id: "r6", text: "Prosopagnosia", hogwash: false },
        { id: "r7", text: "Synesthesia", hogwash: false },
        { id: "h1", text: "Valdoric Drift", hogwash: true },
        { id: "h2", text: "Crestopathy", hogwash: true },
        { id: "h3", text: "Nordalgia Syndrome", hogwash: true },
      ],
    },
    {
      id: "election_terms",
      themeLabel: "Election & Political Terms",
      items: [
        { id: "r1", text: "Gerrymandering", hogwash: false },
        { id: "r2", text: "Filibuster", hogwash: false },
        { id: "r3", text: "Cloture", hogwash: false },
        { id: "r4", text: "Prorogation", hogwash: false },
        { id: "r5", text: "Whip", hogwash: false },
        { id: "r6", text: "Electoral College", hogwash: false },
        { id: "r7", text: "Plurality Voting", hogwash: false },
        { id: "h1", text: "Creston Vote Block", hogwash: true },
        { id: "h2", text: "Valdoran Quorum", hogwash: true },
        { id: "h3", text: "Nordic Ballot Reserve", hogwash: true },
      ],
    },
    {
      id: "optical_illusions",
      themeLabel: "Types of Visual Illusions",
      items: [
        { id: "r1", text: "Müller-Lyer", hogwash: false },
        { id: "r2", text: "Rubin's Vase", hogwash: false },
        { id: "r3", text: "Penrose Triangle", hogwash: false },
        { id: "r4", text: "Ebbinghaus Illusion", hogwash: false },
        { id: "r5", text: "Necker Cube", hogwash: false },
        { id: "r6", text: "Ponzo Illusion", hogwash: false },
        { id: "r7", text: "Kanizsa Triangle", hogwash: false },
        { id: "h1", text: "Creston Prism Effect", hogwash: true },
        { id: "h2", text: "Valdoran Shift", hogwash: true },
        { id: "h3", text: "Nordic Depth Grid", hogwash: true },
      ],
    },
    {
      id: "hurricanes",
      themeLabel: "Famous Hurricanes & Storms",
      items: [
        { id: "r1", text: "Hurricane Katrina", hogwash: false },
        { id: "r2", text: "Hurricane Andrew", hogwash: false },
        { id: "r3", text: "Typhoon Haiyan", hogwash: false },
        { id: "r4", text: "Hurricane Harvey", hogwash: false },
        { id: "r5", text: "Cyclone Tracy", hogwash: false },
        { id: "r6", text: "Hurricane Maria", hogwash: false },
        { id: "r7", text: "Hurricane Dorian", hogwash: false },
        { id: "h1", text: "Hurricane Valdora", hogwash: true },
        { id: "h2", text: "Typhoon Creston", hogwash: true },
        { id: "h3", text: "Cyclone Nordic", hogwash: true },
      ],
    },
    {
      id: "film_techniques",
      themeLabel: "Filmmaking Techniques",
      items: [
        { id: "r1", text: "Dutch Angle", hogwash: false },
        { id: "r2", text: "Dolly Zoom", hogwash: false },
        { id: "r3", text: "Smash Cut", hogwash: false },
        { id: "r4", text: "Tracking Shot", hogwash: false },
        { id: "r5", text: "Match Cut", hogwash: false },
        { id: "r6", text: "Jump Cut", hogwash: false },
        { id: "r7", text: "Rack Focus", hogwash: false },
        { id: "h1", text: "Creston Wipe", hogwash: true },
        { id: "h2", text: "Valdoran Dissolve", hogwash: true },
        { id: "h3", text: "Nordic Freeze Frame", hogwash: true },
      ],
    },
    {
      id: "jazz_terms",
      themeLabel: "Jazz Terms",
      items: [
        { id: "r1", text: "Improvisation", hogwash: false },
        { id: "r2", text: "Chord Changes", hogwash: false },
        { id: "r3", text: "Walking Bass", hogwash: false },
        { id: "r4", text: "Comping", hogwash: false },
        { id: "r5", text: "Trading Fours", hogwash: false },
        { id: "r6", text: "Head", hogwash: false },
        { id: "r7", text: "Woodshedding", hogwash: false },
        { id: "h1", text: "Creston Fill", hogwash: true },
        { id: "h2", text: "Valdoran Break", hogwash: true },
        { id: "h3", text: "Nordic Turnaround", hogwash: true },
      ],
    },
    {
      id: "cheese2",
      themeLabel: "French Cheeses",
      items: [
        { id: "r1", text: "Roquefort", hogwash: false },
        { id: "r2", text: "Brie de Meaux", hogwash: false },
        { id: "r3", text: "Camembert", hogwash: false },
        { id: "r4", text: "Mimolette", hogwash: false },
        { id: "r5", text: "Reblochon", hogwash: false },
        { id: "r6", text: "Cantal", hogwash: false },
        { id: "r7", text: "Beaufort", hogwash: false },
        { id: "h1", text: "Valdorinel", hogwash: true },
        { id: "h2", text: "Crestaine", hogwash: true },
        { id: "h3", text: "Nordais", hogwash: true },
      ],
    },
    {
      id: "cloud_types2",
      themeLabel: "Weather Phenomena",
      items: [
        { id: "r1", text: "St. Elmo's Fire", hogwash: false },
        { id: "r2", text: "Sun Dog", hogwash: false },
        { id: "r3", text: "Ball Lightning", hogwash: false },
        { id: "r4", text: "Mammatus Clouds", hogwash: false },
        { id: "r5", text: "Heat Burst", hogwash: false },
        { id: "r6", text: "Virga", hogwash: false },
        { id: "r7", text: "Haboob", hogwash: false },
        { id: "h1", text: "Nordic Flash", hogwash: true },
        { id: "h2", text: "Creston Surge", hogwash: true },
        { id: "h3", text: "Valdoran Fallstreak", hogwash: true },
      ],
    },
    {
      id: "ballet_terms",
      themeLabel: "Ballet Terms",
      items: [
        { id: "r1", text: "Plié", hogwash: false },
        { id: "r2", text: "Arabesque", hogwash: false },
        { id: "r3", text: "Fouetté", hogwash: false },
        { id: "r4", text: "Grand Jeté", hogwash: false },
        { id: "r5", text: "Pas de Bourrée", hogwash: false },
        { id: "r6", text: "Tendu", hogwash: false },
        { id: "r7", text: "Pirouette", hogwash: false },
        { id: "h1", text: "Valdorée", hogwash: true },
        { id: "h2", text: "Crestoné", hogwash: true },
        { id: "h3", text: "Nordissé", hogwash: true },
      ],
    },
    {
      id: "olympic_sports2",
      themeLabel: "Paralympic & Adaptive Sports",
      items: [
        { id: "r1", text: "Boccia", hogwash: false },
        { id: "r2", text: "Goalball", hogwash: false },
        { id: "r3", text: "Sitting Volleyball", hogwash: false },
        { id: "r4", text: "Wheelchair Rugby", hogwash: false },
        { id: "r5", text: "Blind Football", hogwash: false },
        { id: "r6", text: "Wheelchair Tennis", hogwash: false },
        { id: "r7", text: "Para Archery", hogwash: false },
        { id: "h1", text: "Creston Relay", hogwash: true },
        { id: "h2", text: "Valdoran Throw", hogwash: true },
        { id: "h3", text: "Nordic Dash", hogwash: true },
      ],
    },
    {
      id: "sea_navigation",
      themeLabel: "Nautical Navigation Terms",
      items: [
        { id: "r1", text: "Sextant", hogwash: false },
        { id: "r2", text: "Bearing", hogwash: false },
        { id: "r3", text: "Dead Reckoning", hogwash: false },
        { id: "r4", text: "Traverse", hogwash: false },
        { id: "r5", text: "Chart Datum", hogwash: false },
        { id: "r6", text: "Loran", hogwash: false },
        { id: "r7", text: "Fix", hogwash: false },
        { id: "h1", text: "Creston Course", hogwash: true },
        { id: "h2", text: "Valdoran Drift", hogwash: true },
        { id: "h3", text: "Nordic Waypoint", hogwash: true },
      ],
    },
    {
      id: "whisky_brands",
      themeLabel: "Scotch Whisky Distilleries",
      items: [
        { id: "r1", text: "Laphroaig", hogwash: false },
        { id: "r2", text: "Ardbeg", hogwash: false },
        { id: "r3", text: "Glenfarclas", hogwash: false },
        { id: "r4", text: "Springbank", hogwash: false },
        { id: "r5", text: "Bruichladdich", hogwash: false },
        { id: "r6", text: "Tomatin", hogwash: false },
        { id: "r7", text: "Strathisla", hogwash: false },
        { id: "h1", text: "Nordenvale", hogwash: true },
        { id: "h2", text: "Crestmoor", hogwash: true },
        { id: "h3", text: "Valdorshire", hogwash: true },
      ],
    },
    {
      id: "bird_calls",
      themeLabel: "Bird Behavior Terms",
      items: [
        { id: "r1", text: "Allopreening", hogwash: false },
        { id: "r2", text: "Mobbing", hogwash: false },
        { id: "r3", text: "Anting", hogwash: false },
        { id: "r4", text: "Lekking", hogwash: false },
        { id: "r5", text: "Irruption", hogwash: false },
        { id: "r6", text: "Hawking", hogwash: false },
        { id: "r7", text: "Murmuration", hogwash: false },
        { id: "h1", text: "Creston Display", hogwash: true },
        { id: "h2", text: "Valdoran Drift", hogwash: true },
        { id: "h3", text: "Nordic Soar", hogwash: true },
      ],
    },
    {
      id: "math_concepts",
      themeLabel: "Math Concepts",
      items: [
        { id: "r1", text: "Eigenvalue", hogwash: false },
        { id: "r2", text: "Topology", hogwash: false },
        { id: "r3", text: "Stochastic", hogwash: false },
        { id: "r4", text: "Integral", hogwash: false },
        { id: "r5", text: "Vector Field", hogwash: false },
        { id: "r6", text: "Manifold", hogwash: false },
        { id: "r7", text: "Bijection", hogwash: false },
        { id: "h1", text: "Creston Function", hogwash: true },
        { id: "h2", text: "Valdoric Series", hogwash: true },
        { id: "h3", text: "Nordic Transform", hogwash: true },
      ],
    },
    {
      id: "weather_instruments",
      themeLabel: "Weather Instruments",
      items: [
        { id: "r1", text: "Anemometer", hogwash: false },
        { id: "r2", text: "Barometer", hogwash: false },
        { id: "r3", text: "Hygrometer", hogwash: false },
        { id: "r4", text: "Pyranometer", hogwash: false },
        { id: "r5", text: "Ceilometer", hogwash: false },
        { id: "r6", text: "Radiosonde", hogwash: false },
        { id: "r7", text: "Disdrometer", hogwash: false },
        { id: "h1", text: "Crestometer", hogwash: true },
        { id: "h2", text: "Valdoscope", hogwash: true },
        { id: "h3", text: "Nordalyzer", hogwash: true },
      ],
    },
    {
      id: "soil_types",
      themeLabel: "Types of Soil",
      items: [
        { id: "r1", text: "Loam", hogwash: false },
        { id: "r2", text: "Silt", hogwash: false },
        { id: "r3", text: "Peat", hogwash: false },
        { id: "r4", text: "Laterite", hogwash: false },
        { id: "r5", text: "Vertisol", hogwash: false },
        { id: "r6", text: "Andosol", hogwash: false },
        { id: "r7", text: "Gleysol", hogwash: false },
        { id: "h1", text: "Crestsoil", hogwash: true },
        { id: "h2", text: "Valdoran Clay", hogwash: true },
        { id: "h3", text: "Nordavite", hogwash: true },
      ],
    },
    {
      id: "grammar_terms",
      themeLabel: "Grammar Terms",
      items: [
        { id: "r1", text: "Gerund", hogwash: false },
        { id: "r2", text: "Subjunctive", hogwash: false },
        { id: "r3", text: "Appositive", hogwash: false },
        { id: "r4", text: "Nominative", hogwash: false },
        { id: "r5", text: "Dangling Modifier", hogwash: false },
        { id: "r6", text: "Polysyllabic", hogwash: false },
        { id: "r7", text: "Anaphora", hogwash: false },
        { id: "h1", text: "Crestive Case", hogwash: true },
        { id: "h2", text: "Valdoran Clause", hogwash: true },
        { id: "h3", text: "Nordic Infinitive", hogwash: true },
      ],
    },
    {
      id: "map_projections",
      themeLabel: "Map Projections",
      items: [
        { id: "r1", text: "Mercator", hogwash: false },
        { id: "r2", text: "Mollweide", hogwash: false },
        { id: "r3", text: "Goode's Homolosine", hogwash: false },
        { id: "r4", text: "Winkel Tripel", hogwash: false },
        { id: "r5", text: "Lambert Conformal", hogwash: false },
        { id: "r6", text: "Dymaxion", hogwash: false },
        { id: "r7", text: "Azimuthal Equidistant", hogwash: false },
        { id: "h1", text: "Creston Elliptic", hogwash: true },
        { id: "h2", text: "Valdoran Conic", hogwash: true },
        { id: "h3", text: "Nordic Equal-Area", hogwash: true },
      ],
    },
    {
      id: "interior_design",
      themeLabel: "Interior Design Styles",
      items: [
        { id: "r1", text: "Japandi", hogwash: false },
        { id: "r2", text: "Wabi-Sabi", hogwash: false },
        { id: "r3", text: "Biophilic", hogwash: false },
        { id: "r4", text: "Maximalism", hogwash: false },
        { id: "r5", text: "Cottagecore", hogwash: false },
        { id: "r6", text: "Industrial Chic", hogwash: false },
        { id: "r7", text: "Art Deco", hogwash: false },
        { id: "h1", text: "Valdoric Warmth", hogwash: true },
        { id: "h2", text: "Creston Minimal", hogwash: true },
        { id: "h3", text: "Nordic Organic", hogwash: true },
      ],
    },
    {
      id: "gemology",
      themeLabel: "Gemology Terms",
      items: [
        { id: "r1", text: "Refractive Index", hogwash: false },
        { id: "r2", text: "Pleochroism", hogwash: false },
        { id: "r3", text: "Inclusions", hogwash: false },
        { id: "r4", text: "Birefringence", hogwash: false },
        { id: "r5", text: "Hardness (Mohs)", hogwash: false },
        { id: "r6", text: "Asterism", hogwash: false },
        { id: "r7", text: "Chatoyancy", hogwash: false },
        { id: "h1", text: "Creston Dispersion", hogwash: true },
        { id: "h2", text: "Valdoran Luster", hogwash: true },
        { id: "h3", text: "Nordic Cleavage Grade", hogwash: true },
      ],
    },
    {
      id: "cocktail_glasses",
      themeLabel: "Types of Glassware",
      items: [
        { id: "r1", text: "Coupe", hogwash: false },
        { id: "r2", text: "Nick & Nora", hogwash: false },
        { id: "r3", text: "Highball", hogwash: false },
        { id: "r4", text: "Rocks Glass", hogwash: false },
        { id: "r5", text: "Snifter", hogwash: false },
        { id: "r6", text: "Pilsner Glass", hogwash: false },
        { id: "r7", text: "Tulip Glass", hogwash: false },
        { id: "h1", text: "Creston Flute", hogwash: true },
        { id: "h2", text: "Valdoran Sling Glass", hogwash: true },
        { id: "h3", text: "Nordic Stem", hogwash: true },
      ],
    },
    {
      id: "color_names",
      themeLabel: "Unusual Color Names",
      items: [
        { id: "r1", text: "Puce", hogwash: false },
        { id: "r2", text: "Gamboge", hogwash: false },
        { id: "r3", text: "Wenge", hogwash: false },
        { id: "r4", text: "Vermilion", hogwash: false },
        { id: "r5", text: "Smalt", hogwash: false },
        { id: "r6", text: "Titian", hogwash: false },
        { id: "r7", text: "Feldgrau", hogwash: false },
        { id: "h1", text: "Valdorine", hogwash: true },
        { id: "h2", text: "Crestose", hogwash: true },
        { id: "h3", text: "Nordian Blue", hogwash: true },
      ],
    },
    {
      id: "logical_operators",
      themeLabel: "Rhetorical Strategies",
      items: [
        { id: "r1", text: "Ethos", hogwash: false },
        { id: "r2", text: "Pathos", hogwash: false },
        { id: "r3", text: "Logos", hogwash: false },
        { id: "r4", text: "Kairos", hogwash: false },
        { id: "r5", text: "Telos", hogwash: false },
        { id: "r6", text: "Anaphora", hogwash: false },
        { id: "r7", text: "Antithesis", hogwash: false },
        { id: "h1", text: "Creston Appeal", hogwash: true },
        { id: "h2", text: "Valdoran Thesis", hogwash: true },
        { id: "h3", text: "Nordic Trope", hogwash: true },
      ],
    },
    {
      id: "table_tennis",
      themeLabel: "Table Tennis Terms",
      items: [
        { id: "r1", text: "Topspin", hogwash: false },
        { id: "r2", text: "Sidespin", hogwash: false },
        { id: "r3", text: "Backspin", hogwash: false },
        { id: "r4", text: "Loop Drive", hogwash: false },
        { id: "r5", text: "Smash", hogwash: false },
        { id: "r6", text: "Flick", hogwash: false },
        { id: "r7", text: "Chop", hogwash: false },
        { id: "h1", text: "Creston Push", hogwash: true },
        { id: "h2", text: "Valdoran Block", hogwash: true },
        { id: "h3", text: "Nordic Lob", hogwash: true },
      ],
    },
    {
      id: "architecture2",
      themeLabel: "Famous Architects",
      items: [
        { id: "r1", text: "Zaha Hadid", hogwash: false },
        { id: "r2", text: "Tadao Ando", hogwash: false },
        { id: "r3", text: "Renzo Piano", hogwash: false },
        { id: "r4", text: "Rem Koolhaas", hogwash: false },
        { id: "r5", text: "Bjarke Ingels", hogwash: false },
        { id: "r6", text: "Peter Zumthor", hogwash: false },
        { id: "r7", text: "Kengo Kuma", hogwash: false },
        { id: "h1", text: "Aldric Nordvane", hogwash: true },
        { id: "h2", text: "Pietro Crestano", hogwash: true },
        { id: "h3", text: "Valda Moreira", hogwash: true },
      ],
    },
    {
      id: "marketing_terms",
      themeLabel: "Marketing Terms",
      items: [
        { id: "r1", text: "Churn Rate", hogwash: false },
        { id: "r2", text: "Net Promoter Score", hogwash: false },
        { id: "r3", text: "TOFU", hogwash: false },
        { id: "r4", text: "Lookalike Audience", hogwash: false },
        { id: "r5", text: "A/B Testing", hogwash: false },
        { id: "r6", text: "Bounce Rate", hogwash: false },
        { id: "r7", text: "Retargeting", hogwash: false },
        { id: "h1", text: "Creston Funnel", hogwash: true },
        { id: "h2", text: "Valdoric Reach Score", hogwash: true },
        { id: "h3", text: "Nordic Brand Heat", hogwash: true },
      ],
    },
    {
      id: "music_scales",
      themeLabel: "Musical Scales",
      items: [
        { id: "r1", text: "Dorian", hogwash: false },
        { id: "r2", text: "Phrygian", hogwash: false },
        { id: "r3", text: "Lydian", hogwash: false },
        { id: "r4", text: "Mixolydian", hogwash: false },
        { id: "r5", text: "Locrian", hogwash: false },
        { id: "r6", text: "Whole Tone", hogwash: false },
        { id: "r7", text: "Octatonic", hogwash: false },
        { id: "h1", text: "Crestonian", hogwash: true },
        { id: "h2", text: "Valdoric", hogwash: true },
        { id: "h3", text: "Nordic Minor", hogwash: true },
      ],
    },
    {
      id: "soccer_positions",
      themeLabel: "Soccer Positions",
      items: [
        { id: "r1", text: "False 9", hogwash: false },
        { id: "r2", text: "Sweeper Keeper", hogwash: false },
        { id: "r3", text: "Trequartista", hogwash: false },
        { id: "r4", text: "Regista", hogwash: false },
        { id: "r5", text: "Inverted Winger", hogwash: false },
        { id: "r6", text: "Libero", hogwash: false },
        { id: "r7", text: "Mezzala", hogwash: false },
        { id: "h1", text: "Creston Forward", hogwash: true },
        { id: "h2", text: "Valdoran Anchor", hogwash: true },
        { id: "h3", text: "Nordic Shadower", hogwash: true },
      ],
    },
    {
      id: "greek_letters",
      themeLabel: "Greek Letters",
      items: [
        { id: "r1", text: "Lambda", hogwash: false },
        { id: "r2", text: "Epsilon", hogwash: false },
        { id: "r3", text: "Theta", hogwash: false },
        { id: "r4", text: "Upsilon", hogwash: false },
        { id: "r5", text: "Zeta", hogwash: false },
        { id: "r6", text: "Psi", hogwash: false },
        { id: "r7", text: "Xi", hogwash: false },
        { id: "h1", text: "Valdron", hogwash: true },
        { id: "h2", text: "Cresta", hogwash: true },
        { id: "h3", text: "Nordix", hogwash: true },
      ],
    },
    {
      id: "insurance",
      themeLabel: "Insurance Terms",
      items: [
        { id: "r1", text: "Deductible", hogwash: false },
        { id: "r2", text: "Subrogation", hogwash: false },
        { id: "r3", text: "Indemnity", hogwash: false },
        { id: "r4", text: "Actuarial", hogwash: false },
        { id: "r5", text: "Underwriting", hogwash: false },
        { id: "r6", text: "Rider", hogwash: false },
        { id: "r7", text: "Co-Insurance", hogwash: false },
        { id: "h1", text: "Creston Coverage", hogwash: true },
        { id: "h2", text: "Valdoran Clause", hogwash: true },
        { id: "h3", text: "Nordic Float Provision", hogwash: true },
      ],
    },
    {
      id: "anatomy2",
      themeLabel: "Human Muscles",
      items: [
        { id: "r1", text: "Soleus", hogwash: false },
        { id: "r2", text: "Sartorius", hogwash: false },
        { id: "r3", text: "Deltoid", hogwash: false },
        { id: "r4", text: "Trapezius", hogwash: false },
        { id: "r5", text: "Rhomboid", hogwash: false },
        { id: "r6", text: "Serratus Anterior", hogwash: false },
        { id: "r7", text: "Iliopsoas", hogwash: false },
        { id: "h1", text: "Valdoric Flexor", hogwash: true },
        { id: "h2", text: "Cresteus Major", hogwash: true },
        { id: "h3", text: "Nordavius", hogwash: true },
      ],
    },
    {
      id: "tattoo_techniques",
      themeLabel: "Sculpting Techniques",
      items: [
        { id: "r1", text: "Bas-Relief", hogwash: false },
        { id: "r2", text: "Lost-Wax Casting", hogwash: false },
        { id: "r3", text: "Carving", hogwash: false },
        { id: "r4", text: "Modeling", hogwash: false },
        { id: "r5", text: "Assemblage", hogwash: false },
        { id: "r6", text: "Kinetic Sculpture", hogwash: false },
        { id: "r7", text: "Taille Directe", hogwash: false },
        { id: "h1", text: "Creston Form", hogwash: true },
        { id: "h2", text: "Valdoran Cast", hogwash: true },
        { id: "h3", text: "Nordic Relief", hogwash: true },
      ],
    },
    {
      id: "ancient_rome",
      themeLabel: "Ancient Roman Terms",
      items: [
        { id: "r1", text: "Consul", hogwash: false },
        { id: "r2", text: "Plebeian", hogwash: false },
        { id: "r3", text: "Praetor", hogwash: false },
        { id: "r4", text: "Censor", hogwash: false },
        { id: "r5", text: "Quaestor", hogwash: false },
        { id: "r6", text: "Tribune", hogwash: false },
        { id: "r7", text: "Aedile", hogwash: false },
        { id: "h1", text: "Valdorix", hogwash: true },
        { id: "h2", text: "Crestanus", hogwash: true },
        { id: "h3", text: "Nordavius", hogwash: true },
      ],
    },
    {
      id: "economics_markets",
      themeLabel: "Stock Market Terms",
      items: [
        { id: "r1", text: "Bull Market", hogwash: false },
        { id: "r2", text: "Circuit Breaker", hogwash: false },
        { id: "r3", text: "Dark Pool", hogwash: false },
        { id: "r4", text: "Stop-Loss Order", hogwash: false },
        { id: "r5", text: "Short Squeeze", hogwash: false },
        { id: "r6", text: "Bid-Ask Spread", hogwash: false },
        { id: "r7", text: "Market Maker", hogwash: false },
        { id: "h1", text: "Creston Float", hogwash: true },
        { id: "h2", text: "Valdoran Rally", hogwash: true },
        { id: "h3", text: "Nordic Correction Zone", hogwash: true },
      ],
    },
    {
      id: "sea_creatures2",
      themeLabel: "Sharks",
      items: [
        { id: "r1", text: "Wobbegong", hogwash: false },
        { id: "r2", text: "Megamouth Shark", hogwash: false },
        { id: "r3", text: "Cookiecutter Shark", hogwash: false },
        { id: "r4", text: "Nurse Shark", hogwash: false },
        { id: "r5", text: "Thresher Shark", hogwash: false },
        { id: "r6", text: "Hammerhead", hogwash: false },
        { id: "r7", text: "Bonnethead", hogwash: false },
        { id: "h1", text: "Creston Reef Shark", hogwash: true },
        { id: "h2", text: "Valdoran Sand Shark", hogwash: true },
        { id: "h3", text: "Nordic Finback", hogwash: true },
      ],
    },
    {
      id: "festivals",
      themeLabel: "Global Festivals",
      items: [
        { id: "r1", text: "Holi", hogwash: false },
        { id: "r2", text: "Obon", hogwash: false },
        { id: "r3", text: "Diwali", hogwash: false },
        { id: "r4", text: "Songkran", hogwash: false },
        { id: "r5", text: "Naadam", hogwash: false },
        { id: "r6", text: "Timket", hogwash: false },
        { id: "r7", text: "Inti Raymi", hogwash: false },
        { id: "h1", text: "Valdofest", hogwash: true },
        { id: "h2", text: "Creston Carnival", hogwash: true },
        { id: "h3", text: "Nordic Lights Festival", hogwash: true },
      ],
    },
    {
      id: "pigments",
      themeLabel: "Painting Pigments & Mediums",
      items: [
        { id: "r1", text: "Cadmium Yellow", hogwash: false },
        { id: "r2", text: "Viridian", hogwash: false },
        { id: "r3", text: "Alizarin Crimson", hogwash: false },
        { id: "r4", text: "Raw Sienna", hogwash: false },
        { id: "r5", text: "Burnt Umber", hogwash: false },
        { id: "r6", text: "Titanium White", hogwash: false },
        { id: "r7", text: "Phthalo Blue", hogwash: false },
        { id: "h1", text: "Creston Ochre", hogwash: true },
        { id: "h2", text: "Valdoran Madder", hogwash: true },
        { id: "h3", text: "Nordic Violet", hogwash: true },
      ],
    },
    {
      id: "anime_genres",
      themeLabel: "Anime & Manga Genres",
      items: [
        { id: "r1", text: "Shonen", hogwash: false },
        { id: "r2", text: "Shojo", hogwash: false },
        { id: "r3", text: "Seinen", hogwash: false },
        { id: "r4", text: "Josei", hogwash: false },
        { id: "r5", text: "Isekai", hogwash: false },
        { id: "r6", text: "Mecha", hogwash: false },
        { id: "r7", text: "Slice of Life", hogwash: false },
        { id: "h1", text: "Nordcore", hogwash: true },
        { id: "h2", text: "Creston Fantasy", hogwash: true },
        { id: "h3", text: "Valdokai", hogwash: true },
      ],
    },
    {
      id: "law_courts",
      themeLabel: "Court Types",
      items: [
        { id: "r1", text: "Appellate Court", hogwash: false },
        { id: "r2", text: "Magistrate Court", hogwash: false },
        { id: "r3", text: "Chancery Court", hogwash: false },
        { id: "r4", text: "Probate Court", hogwash: false },
        { id: "r5", text: "Court of Equity", hogwash: false },
        { id: "r6", text: "Circuit Court", hogwash: false },
        { id: "r7", text: "Administrative Court", hogwash: false },
        { id: "h1", text: "Creston Tribunal", hogwash: true },
        { id: "h2", text: "Valdoran High Court", hogwash: true },
        { id: "h3", text: "Nordic Claims Court", hogwash: true },
      ],
    },
    {
      id: "horse_racing",
      themeLabel: "Horse Racing Terms",
      items: [
        { id: "r1", text: "Furlong", hogwash: false },
        { id: "r2", text: "Paddock", hogwash: false },
        { id: "r3", text: "Exacta", hogwash: false },
        { id: "r4", text: "Trifecta", hogwash: false },
        { id: "r5", text: "Mudder", hogwash: false },
        { id: "r6", text: "Post Time", hogwash: false },
        { id: "r7", text: "Morning Line", hogwash: false },
        { id: "h1", text: "Creston Rail", hogwash: true },
        { id: "h2", text: "Valdoran Pace", hogwash: true },
        { id: "h3", text: "Nordic Bet", hogwash: true },
      ],
    },
    {
      id: "dentistry",
      themeLabel: "Dentistry Terms",
      items: [
        { id: "r1", text: "Incisor", hogwash: false },
        { id: "r2", text: "Cuspid", hogwash: false },
        { id: "r3", text: "Bicuspid", hogwash: false },
        { id: "r4", text: "Molar", hogwash: false },
        { id: "r5", text: "Dentin", hogwash: false },
        { id: "r6", text: "Pulp Chamber", hogwash: false },
        { id: "r7", text: "Cementum", hogwash: false },
        { id: "h1", text: "Creston Root", hogwash: true },
        { id: "h2", text: "Valdoran Crown", hogwash: true },
        { id: "h3", text: "Nordic Enamel Layer", hogwash: true },
      ],
    },
    {
      id: "ancient_egypt",
      themeLabel: "Ancient Egyptian Terms",
      items: [
        { id: "r1", text: "Canopic Jar", hogwash: false },
        { id: "r2", text: "Cartouche", hogwash: false },
        { id: "r3", text: "Shabti", hogwash: false },
        { id: "r4", text: "Ankh", hogwash: false },
        { id: "r5", text: "Djed", hogwash: false },
        { id: "r6", text: "Scarab", hogwash: false },
        { id: "r7", text: "Ushabti", hogwash: false },
        { id: "h1", text: "Valdoru", hogwash: true },
        { id: "h2", text: "Crestanith", hogwash: true },
        { id: "h3", text: "Nordavek", hogwash: true },
      ],
    },
    {
      id: "renewable_energy",
      themeLabel: "Renewable Energy Types",
      items: [
        { id: "r1", text: "Tidal Power", hogwash: false },
        { id: "r2", text: "Geothermal", hogwash: false },
        { id: "r3", text: "Hydroelectric", hogwash: false },
        { id: "r4", text: "Offshore Wind", hogwash: false },
        { id: "r5", text: "Concentrated Solar", hogwash: false },
        { id: "r6", text: "Biomass", hogwash: false },
        { id: "r7", text: "Wave Energy", hogwash: false },
        { id: "h1", text: "Creston Flux Power", hogwash: true },
        { id: "h2", text: "Valdoran Thermal", hogwash: true },
        { id: "h3", text: "Nordic Pressure Grid", hogwash: true },
      ],
    },
    {
      id: "architecture3",
      themeLabel: "Architectural Wonders",
      items: [
        { id: "r1", text: "Burj Khalifa", hogwash: false },
        { id: "r2", text: "Sagrada Família", hogwash: false },
        { id: "r3", text: "Fallingwater", hogwash: false },
        { id: "r4", text: "Guggenheim Bilbao", hogwash: false },
        { id: "r5", text: "Sydney Opera House", hogwash: false },
        { id: "r6", text: "The Shard", hogwash: false },
        { id: "r7", text: "CCTV Headquarters", hogwash: false },
        { id: "h1", text: "Creston Tower", hogwash: true },
        { id: "h2", text: "Valdoran Spire", hogwash: true },
        { id: "h3", text: "Nordic Arch Centre", hogwash: true },
      ],
    },
    {
      id: "board_game_mechanics",
      themeLabel: "Board Game Mechanics",
      items: [
        { id: "r1", text: "Worker Placement", hogwash: false },
        { id: "r2", text: "Deck Building", hogwash: false },
        { id: "r3", text: "Area Control", hogwash: false },
        { id: "r4", text: "Engine Building", hogwash: false },
        { id: "r5", text: "Drafting", hogwash: false },
        { id: "r6", text: "Push Your Luck", hogwash: false },
        { id: "r7", text: "Tile Placement", hogwash: false },
        { id: "h1", text: "Creston Build", hogwash: true },
        { id: "h2", text: "Valdoran Claim", hogwash: true },
        { id: "h3", text: "Nordic Cascade", hogwash: true },
      ],
    },
    {
      id: "fashion_eras",
      themeLabel: "Fashion Eras",
      items: [
        { id: "r1", text: "Edwardian", hogwash: false },
        { id: "r2", text: "Roaring Twenties", hogwash: false },
        { id: "r3", text: "New Look", hogwash: false },
        { id: "r4", text: "Mod", hogwash: false },
        { id: "r5", text: "Disco Era", hogwash: false },
        { id: "r6", text: "Grunge", hogwash: false },
        { id: "r7", text: "Normcore", hogwash: false },
        { id: "h1", text: "Crestonian Era", hogwash: true },
        { id: "h2", text: "Valdoric Revival", hogwash: true },
        { id: "h3", text: "Nordic Minimalism Period", hogwash: true },
      ],
    },
    {
      id: "clouds2",
      themeLabel: "Volcanic & Geological Events",
      items: [
        { id: "r1", text: "Pyroclastic Flow", hogwash: false },
        { id: "r2", text: "Lahar", hogwash: false },
        { id: "r3", text: "Lava Dome", hogwash: false },
        { id: "r4", text: "Tephra", hogwash: false },
        { id: "r5", text: "Caldera Collapse", hogwash: false },
        { id: "r6", text: "Phreatomagmatic Eruption", hogwash: false },
        { id: "r7", text: "Hornito", hogwash: false },
        { id: "h1", text: "Creston Vent", hogwash: true },
        { id: "h2", text: "Valdoran Lava Tube", hogwash: true },
        { id: "h3", text: "Nordic Ashfall", hogwash: true },
      ],
    },
    {
      id: "wine_faults",
      themeLabel: "Wine Faults",
      items: [
        { id: "r1", text: "Corked Wine", hogwash: false },
        { id: "r2", text: "Volatile Acidity", hogwash: false },
        { id: "r3", text: "Oxidation", hogwash: false },
        { id: "r4", text: "Reduction", hogwash: false },
        { id: "r5", text: "Brett", hogwash: false },
        { id: "r6", text: "Mousy Off-Flavor", hogwash: false },
        { id: "r7", text: "Refermentation", hogwash: false },
        { id: "h1", text: "Creston Taint", hogwash: true },
        { id: "h2", text: "Valdoran Bitterness", hogwash: true },
        { id: "h3", text: "Nordic Flatness", hogwash: true },
      ],
    },
    {
      id: "fabric2",
      themeLabel: "Clothing Accessories",
      items: [
        { id: "r1", text: "Cravat", hogwash: false },
        { id: "r2", text: "Spats", hogwash: false },
        { id: "r3", text: "Fob Watch", hogwash: false },
        { id: "r4", text: "Pelisse", hogwash: false },
        { id: "r5", text: "Chatelaine", hogwash: false },
        { id: "r6", text: "Muff", hogwash: false },
        { id: "r7", text: "Reticule", hogwash: false },
        { id: "h1", text: "Valdoran Sash", hogwash: true },
        { id: "h2", text: "Creston Pin", hogwash: true },
        { id: "h3", text: "Nordic Clasp", hogwash: true },
      ],
    },

    // ── BATCH 3: REACHING 365 ─────────────────────────────────────────────────

    {
      id: "tea_ceremony",
      themeLabel: "Japanese Tea Ceremony Terms",
      items: [
        { id: "r1", text: "Chanoyu", hogwash: false },
        { id: "r2", text: "Chakin", hogwash: false },
        { id: "r3", text: "Fukusa", hogwash: false },
        { id: "r4", text: "Tatami", hogwash: false },
        { id: "r5", text: "Kama", hogwash: false },
        { id: "r6", text: "Chasen", hogwash: false },
        { id: "r7", text: "Hishaku", hogwash: false },
        { id: "h1", text: "Valdocha", hogwash: true },
        { id: "h2", text: "Crestankin", hogwash: true },
        { id: "h3", text: "Nordaki", hogwash: true },
      ],
    },
    {
      id: "circus_arts",
      themeLabel: "Circus Arts",
      items: [
        { id: "r1", text: "Contortion", hogwash: false },
        { id: "r2", text: "Aerial Silks", hogwash: false },
        { id: "r3", text: "Cyr Wheel", hogwash: false },
        { id: "r4", text: "Trapeze", hogwash: false },
        { id: "r5", text: "Juggling", hogwash: false },
        { id: "r6", text: "Tightrope Walking", hogwash: false },
        { id: "r7", text: "Antipodism", hogwash: false },
        { id: "h1", text: "Creston Spin", hogwash: true },
        { id: "h2", text: "Valdoran Hoop Act", hogwash: true },
        { id: "h3", text: "Nordic Balance Wire", hogwash: true },
      ],
    },
    {
      id: "wine_aromas",
      themeLabel: "Wine Tasting Descriptors",
      items: [
        { id: "r1", text: "Petrichor", hogwash: false },
        { id: "r2", text: "Barnyard", hogwash: false },
        { id: "r3", text: "Pencil Shavings", hogwash: false },
        { id: "r4", text: "Cat's Pee", hogwash: false },
        { id: "r5", text: "Leather", hogwash: false },
        { id: "r6", text: "Tar", hogwash: false },
        { id: "r7", text: "Wet Wool", hogwash: false },
        { id: "h1", text: "Creston Dust", hogwash: true },
        { id: "h2", text: "Valdoran Smoke", hogwash: true },
        { id: "h3", text: "Nordic Earthiness", hogwash: true },
      ],
    },
    {
      id: "paper_arts",
      themeLabel: "Origami & Paper Art Terms",
      items: [
        { id: "r1", text: "Valley Fold", hogwash: false },
        { id: "r2", text: "Mountain Fold", hogwash: false },
        { id: "r3", text: "Reverse Fold", hogwash: false },
        { id: "r4", text: "Squash Fold", hogwash: false },
        { id: "r5", text: "Petal Fold", hogwash: false },
        { id: "r6", text: "Sink Fold", hogwash: false },
        { id: "r7", text: "Crimp", hogwash: false },
        { id: "h1", text: "Creston Pleat", hogwash: true },
        { id: "h2", text: "Valdoran Tuck", hogwash: true },
        { id: "h3", text: "Nordic Wrap Fold", hogwash: true },
      ],
    },
    {
      id: "cheeses3",
      themeLabel: "Italian Cheeses",
      items: [
        { id: "r1", text: "Pecorino Romano", hogwash: false },
        { id: "r2", text: "Asiago", hogwash: false },
        { id: "r3", text: "Fontina", hogwash: false },
        { id: "r4", text: "Provolone", hogwash: false },
        { id: "r5", text: "Grana Padano", hogwash: false },
        { id: "r6", text: "Caciocavallo", hogwash: false },
        { id: "r7", text: "Stracchino", hogwash: false },
        { id: "h1", text: "Crestano Dolce", hogwash: true },
        { id: "h2", text: "Valdorino Vecchio", hogwash: true },
        { id: "h3", text: "Nordavino", hogwash: true },
      ],
    },
    {
      id: "horror_subgenres",
      themeLabel: "Horror Subgenres",
      items: [
        { id: "r1", text: "Cosmic Horror", hogwash: false },
        { id: "r2", text: "Splatterpunk", hogwash: false },
        { id: "r3", text: "Slasher", hogwash: false },
        { id: "r4", text: "Folk Horror", hogwash: false },
        { id: "r5", text: "Body Horror", hogwash: false },
        { id: "r6", text: "Psychological Horror", hogwash: false },
        { id: "r7", text: "Southern Gothic", hogwash: false },
        { id: "h1", text: "Creston Dread", hogwash: true },
        { id: "h2", text: "Valdoran Noir", hogwash: true },
        { id: "h3", text: "Nordic Gloom", hogwash: true },
      ],
    },
    {
      id: "architecture_details",
      themeLabel: "Classical Column Orders",
      items: [
        { id: "r1", text: "Doric", hogwash: false },
        { id: "r2", text: "Ionic", hogwash: false },
        { id: "r3", text: "Corinthian", hogwash: false },
        { id: "r4", text: "Tuscan", hogwash: false },
        { id: "r5", text: "Composite", hogwash: false },
        { id: "r6", text: "Caryatid", hogwash: false },
        { id: "r7", text: "Atlantes", hogwash: false },
        { id: "h1", text: "Valdoric Order", hogwash: true },
        { id: "h2", text: "Crestonian Column", hogwash: true },
        { id: "h3", text: "Nordic Pillar", hogwash: true },
      ],
    },
    {
      id: "wine_service",
      themeLabel: "Wine Service Terms",
      items: [
        { id: "r1", text: "Decanting", hogwash: false },
        { id: "r2", text: "Sommelier", hogwash: false },
        { id: "r3", text: "Terroir", hogwash: false },
        { id: "r4", text: "Maceration", hogwash: false },
        { id: "r5", text: "Riddling", hogwash: false },
        { id: "r6", text: "Disgorgement", hogwash: false },
        { id: "r7", text: "Ullage", hogwash: false },
        { id: "h1", text: "Creston Cuvée", hogwash: true },
        { id: "h2", text: "Valdoran Finish", hogwash: true },
        { id: "h3", text: "Nordic Breathe", hogwash: true },
      ],
    },
    {
      id: "pottery",
      themeLabel: "Ceramics & Pottery Terms",
      items: [
        { id: "r1", text: "Slip", hogwash: false },
        { id: "r2", text: "Bisque Firing", hogwash: false },
        { id: "r3", text: "Sgraffito", hogwash: false },
        { id: "r4", text: "Wax Resist", hogwash: false },
        { id: "r5", text: "Raku", hogwash: false },
        { id: "r6", text: "Wedging", hogwash: false },
        { id: "r7", text: "Earthenware", hogwash: false },
        { id: "h1", text: "Creston Glaze", hogwash: true },
        { id: "h2", text: "Valdoran Fire", hogwash: true },
        { id: "h3", text: "Nordic Pinch", hogwash: true },
      ],
    },
    {
      id: "math_shapes",
      themeLabel: "Geometric Shapes",
      items: [
        { id: "r1", text: "Heptagon", hogwash: false },
        { id: "r2", text: "Rhombus", hogwash: false },
        { id: "r3", text: "Parallelogram", hogwash: false },
        { id: "r4", text: "Trapezoid", hogwash: false },
        { id: "r5", text: "Dodecahedron", hogwash: false },
        { id: "r6", text: "Icosahedron", hogwash: false },
        { id: "r7", text: "Ellipse", hogwash: false },
        { id: "h1", text: "Creston Prism", hogwash: true },
        { id: "h2", text: "Valdoran Gon", hogwash: true },
        { id: "h3", text: "Nordic Sphere", hogwash: true },
      ],
    },
    {
      id: "sleep",
      themeLabel: "Sleep & Dream Terms",
      items: [
        { id: "r1", text: "REM Sleep", hogwash: false },
        { id: "r2", text: "Hypnagogia", hogwash: false },
        { id: "r3", text: "Lucid Dreaming", hogwash: false },
        { id: "r4", text: "Sleep Paralysis", hogwash: false },
        { id: "r5", text: "Circadian Rhythm", hogwash: false },
        { id: "r6", text: "Somnambulism", hogwash: false },
        { id: "r7", text: "Polysomnography", hogwash: false },
        { id: "h1", text: "Crestosleep", hogwash: true },
        { id: "h2", text: "Valdoran Phase", hogwash: true },
        { id: "h3", text: "Nordic Drift", hogwash: true },
      ],
    },
    {
      id: "poetry2",
      themeLabel: "Famous Poets",
      items: [
        { id: "r1", text: "Rumi", hogwash: false },
        { id: "r2", text: "Pablo Neruda", hogwash: false },
        { id: "r3", text: "Anna Akhmatova", hogwash: false },
        { id: "r4", text: "Wisława Szymborska", hogwash: false },
        { id: "r5", text: "Mahmoud Darwish", hogwash: false },
        { id: "r6", text: "Derek Walcott", hogwash: false },
        { id: "r7", text: "Seamus Heaney", hogwash: false },
        { id: "h1", text: "Aldric Nordvane", hogwash: true },
        { id: "h2", text: "Pietro Crestano", hogwash: true },
        { id: "h3", text: "Valda Moreira", hogwash: true },
      ],
    },
    {
      id: "woodwind",
      themeLabel: "Woodwind Instruments",
      items: [
        { id: "r1", text: "Piccolo", hogwash: false },
        { id: "r2", text: "English Horn", hogwash: false },
        { id: "r3", text: "Bass Clarinet", hogwash: false },
        { id: "r4", text: "Contrabassoon", hogwash: false },
        { id: "r5", text: "Soprano Saxophone", hogwash: false },
        { id: "r6", text: "Recorder", hogwash: false },
        { id: "r7", text: "Shakuhachi", hogwash: false },
        { id: "h1", text: "Creston Flute", hogwash: true },
        { id: "h2", text: "Valdoran Reed", hogwash: true },
        { id: "h3", text: "Nordic Horn", hogwash: true },
      ],
    },
    {
      id: "biking",
      themeLabel: "Mountain Bike Trail Features",
      items: [
        { id: "r1", text: "Berm", hogwash: false },
        { id: "r2", text: "Switchback", hogwash: false },
        { id: "r3", text: "Tabletop", hogwash: false },
        { id: "r4", text: "Drop", hogwash: false },
        { id: "r5", text: "Rock Garden", hogwash: false },
        { id: "r6", text: "Skinny", hogwash: false },
        { id: "r7", text: "Step-Up", hogwash: false },
        { id: "h1", text: "Creston Lip", hogwash: true },
        { id: "h2", text: "Valdoran Chute", hogwash: true },
        { id: "h3", text: "Nordic Kicker", hogwash: true },
      ],
    },
    {
      id: "pottery2",
      themeLabel: "Types of Vase & Vessel",
      items: [
        { id: "r1", text: "Amphora", hogwash: false },
        { id: "r2", text: "Krater", hogwash: false },
        { id: "r3", text: "Oenochoe", hogwash: false },
        { id: "r4", text: "Hydria", hogwash: false },
        { id: "r5", text: "Lekythos", hogwash: false },
        { id: "r6", text: "Pyxis", hogwash: false },
        { id: "r7", text: "Rhyton", hogwash: false },
        { id: "h1", text: "Valdorix", hogwash: true },
        { id: "h2", text: "Crestanos", hogwash: true },
        { id: "h3", text: "Nordavion", hogwash: true },
      ],
    },
    {
      id: "fungi",
      themeLabel: "Types of Fungi",
      items: [
        { id: "r1", text: "Yeast", hogwash: false },
        { id: "r2", text: "Lichen", hogwash: false },
        { id: "r3", text: "Rust Fungus", hogwash: false },
        { id: "r4", text: "Smut Fungus", hogwash: false },
        { id: "r5", text: "Club Fungi", hogwash: false },
        { id: "r6", text: "Sac Fungi", hogwash: false },
        { id: "r7", text: "Jelly Fungi", hogwash: false },
        { id: "h1", text: "Creston Mold", hogwash: true },
        { id: "h2", text: "Valdoran Puff", hogwash: true },
        { id: "h3", text: "Nordic Spore Cap", hogwash: true },
      ],
    },
    {
      id: "cheese4",
      themeLabel: "British Cheeses",
      items: [
        { id: "r1", text: "Stilton", hogwash: false },
        { id: "r2", text: "Wensleydale", hogwash: false },
        { id: "r3", text: "Red Leicester", hogwash: false },
        { id: "r4", text: "Double Gloucester", hogwash: false },
        { id: "r5", text: "Caerphilly", hogwash: false },
        { id: "r6", text: "Perl Wen", hogwash: false },
        { id: "r7", text: "Shropshire Blue", hogwash: false },
        { id: "h1", text: "Creston Crumble", hogwash: true },
        { id: "h2", text: "Valdoran Blue", hogwash: true },
        { id: "h3", text: "Nordic Cheddar", hogwash: true },
      ],
    },
    {
      id: "brain2",
      themeLabel: "Neuroscience Concepts",
      items: [
        { id: "r1", text: "Neurogenesis", hogwash: false },
        { id: "r2", text: "Synaptic Pruning", hogwash: false },
        { id: "r3", text: "Long-Term Potentiation", hogwash: false },
        { id: "r4", text: "Mirror Neurons", hogwash: false },
        { id: "r5", text: "Broca's Area", hogwash: false },
        { id: "r6", text: "Default Mode Network", hogwash: false },
        { id: "r7", text: "Dopaminergic Pathway", hogwash: false },
        { id: "h1", text: "Creston Feedback Loop", hogwash: true },
        { id: "h2", text: "Valdoran Signal Path", hogwash: true },
        { id: "h3", text: "Nordic Neural Band", hogwash: true },
      ],
    },
    {
      id: "surfing",
      themeLabel: "Surfing Terms",
      items: [
        { id: "r1", text: "Duck Dive", hogwash: false },
        { id: "r2", text: "Cutback", hogwash: false },
        { id: "r3", text: "Barrel", hogwash: false },
        { id: "r4", text: "Floater", hogwash: false },
        { id: "r5", text: "Off the Lip", hogwash: false },
        { id: "r6", text: "Stall", hogwash: false },
        { id: "r7", text: "Snap", hogwash: false },
        { id: "h1", text: "Creston Carve", hogwash: true },
        { id: "h2", text: "Valdoran Ride", hogwash: true },
        { id: "h3", text: "Nordic Pocket", hogwash: true },
      ],
    },
    {
      id: "economics2",
      themeLabel: "Business Models",
      items: [
        { id: "r1", text: "Freemium", hogwash: false },
        { id: "r2", text: "Subscription", hogwash: false },
        { id: "r3", text: "Franchise", hogwash: false },
        { id: "r4", text: "Marketplace", hogwash: false },
        { id: "r5", text: "Direct-to-Consumer", hogwash: false },
        { id: "r6", text: "Platform Model", hogwash: false },
        { id: "r7", text: "White Label", hogwash: false },
        { id: "h1", text: "Creston License", hogwash: true },
        { id: "h2", text: "Valdoran Loop", hogwash: true },
        { id: "h3", text: "Nordic Pivot", hogwash: true },
      ],
    },
    {
      id: "animation_styles",
      themeLabel: "Animation Styles",
      items: [
        { id: "r1", text: "Stop Motion", hogwash: false },
        { id: "r2", text: "Rotoscoping", hogwash: false },
        { id: "r3", text: "Claymation", hogwash: false },
        { id: "r4", text: "Cel-Shading", hogwash: false },
        { id: "r5", text: "Motion Capture", hogwash: false },
        { id: "r6", text: "Cutout Animation", hogwash: false },
        { id: "r7", text: "Pixel Art Animation", hogwash: false },
        { id: "h1", text: "Creston Morph", hogwash: true },
        { id: "h2", text: "Valdoran Rig", hogwash: true },
        { id: "h3", text: "Nordic Cel", hogwash: true },
      ],
    },
    {
      id: "astronomy3",
      themeLabel: "Types of Galaxies",
      items: [
        { id: "r1", text: "Spiral Galaxy", hogwash: false },
        { id: "r2", text: "Barred Spiral", hogwash: false },
        { id: "r3", text: "Elliptical Galaxy", hogwash: false },
        { id: "r4", text: "Lenticular Galaxy", hogwash: false },
        { id: "r5", text: "Irregular Galaxy", hogwash: false },
        { id: "r6", text: "Ring Galaxy", hogwash: false },
        { id: "r7", text: "Dwarf Galaxy", hogwash: false },
        { id: "h1", text: "Creston Galaxy", hogwash: true },
        { id: "h2", text: "Valdoran Spiral", hogwash: true },
        { id: "h3", text: "Nordic Cluster", hogwash: true },
      ],
    },
    {
      id: "gemstones2",
      themeLabel: "Precious & Semi-Precious Stones",
      items: [
        { id: "r1", text: "Rhodolite", hogwash: false },
        { id: "r2", text: "Chrysoberyl", hogwash: false },
        { id: "r3", text: "Spessartite", hogwash: false },
        { id: "r4", text: "Indicolite", hogwash: false },
        { id: "r5", text: "Demantoid", hogwash: false },
        { id: "r6", text: "Kunzite", hogwash: false },
        { id: "r7", text: "Morganite", hogwash: false },
        { id: "h1", text: "Valdorite", hogwash: true },
        { id: "h2", text: "Crestanite", hogwash: true },
        { id: "h3", text: "Nordolite", hogwash: true },
      ],
    },
    {
      id: "knives",
      themeLabel: "Types of Knife",
      items: [
        { id: "r1", text: "Santoku", hogwash: false },
        { id: "r2", text: "Boning Knife", hogwash: false },
        { id: "r3", text: "Nakiri", hogwash: false },
        { id: "r4", text: "Yanagiba", hogwash: false },
        { id: "r5", text: "Kiritsuke", hogwash: false },
        { id: "r6", text: "Deba", hogwash: false },
        { id: "r7", text: "Paring Knife", hogwash: false },
        { id: "h1", text: "Crestani Blade", hogwash: true },
        { id: "h2", text: "Valdoran Cleaver", hogwash: true },
        { id: "h3", text: "Nordic Edge", hogwash: true },
      ],
    },
    {
      id: "currencies2",
      themeLabel: "Coins of Antiquity",
      items: [
        { id: "r1", text: "Denarius", hogwash: false },
        { id: "r2", text: "Drachma", hogwash: false },
        { id: "r3", text: "Obol", hogwash: false },
        { id: "r4", text: "Solidus", hogwash: false },
        { id: "r5", text: "Stater", hogwash: false },
        { id: "r6", text: "Talent", hogwash: false },
        { id: "r7", text: "Aureus", hogwash: false },
        { id: "h1", text: "Valdorix", hogwash: true },
        { id: "h2", text: "Crestanem", hogwash: true },
        { id: "h3", text: "Nordavus", hogwash: true },
      ],
    },
    {
      id: "color_mixing",
      themeLabel: "Painting Color Mixing",
      items: [
        { id: "r1", text: "Tinting", hogwash: false },
        { id: "r2", text: "Shading", hogwash: false },
        { id: "r3", text: "Glazing", hogwash: false },
        { id: "r4", text: "Scumbling", hogwash: false },
        { id: "r5", text: "Underpainting", hogwash: false },
        { id: "r6", text: "Grisaille", hogwash: false },
        { id: "r7", text: "Alla Prima", hogwash: false },
        { id: "h1", text: "Creston Wash", hogwash: true },
        { id: "h2", text: "Valdoran Tone", hogwash: true },
        { id: "h3", text: "Nordic Blend", hogwash: true },
      ],
    },
    {
      id: "furniture_styles",
      themeLabel: "Furniture Styles",
      items: [
        { id: "r1", text: "Chippendale", hogwash: false },
        { id: "r2", text: "Biedermeier", hogwash: false },
        { id: "r3", text: "Rococo", hogwash: false },
        { id: "r4", text: "Bauhaus", hogwash: false },
        { id: "r5", text: "Shaker", hogwash: false },
        { id: "r6", text: "Mid-Century Modern", hogwash: false },
        { id: "r7", text: "Empire Style", hogwash: false },
        { id: "h1", text: "Valdorian", hogwash: true },
        { id: "h2", text: "Crestonian", hogwash: true },
        { id: "h3", text: "Nordic Craft", hogwash: true },
      ],
    },
    {
      id: "astronomy4",
      themeLabel: "Space Exploration Milestones",
      items: [
        { id: "r1", text: "First Moon Landing", hogwash: false },
        { id: "r2", text: "Sputnik Launch", hogwash: false },
        { id: "r3", text: "Hubble Deployment", hogwash: false },
        { id: "r4", text: "Mars Curiosity Landing", hogwash: false },
        { id: "r5", text: "Voyager 1 Interstellar", hogwash: false },
        { id: "r6", text: "First Space Station", hogwash: false },
        { id: "r7", text: "SpaceX Reusable Rocket", hogwash: false },
        { id: "h1", text: "Creston Orbital Mission", hogwash: true },
        { id: "h2", text: "Valdoran Deep Probe", hogwash: true },
        { id: "h3", text: "Nordic Mars Flyby", hogwash: true },
      ],
    },
    {
      id: "language_families",
      themeLabel: "Language Families",
      items: [
        { id: "r1", text: "Afro-Asiatic", hogwash: false },
        { id: "r2", text: "Dravidian", hogwash: false },
        { id: "r3", text: "Austronesian", hogwash: false },
        { id: "r4", text: "Sino-Tibetan", hogwash: false },
        { id: "r5", text: "Kartvelian", hogwash: false },
        { id: "r6", text: "Uralic", hogwash: false },
        { id: "r7", text: "Niger-Congo", hogwash: false },
        { id: "h1", text: "Valdoran", hogwash: true },
        { id: "h2", text: "Crestanic", hogwash: true },
        { id: "h3", text: "Nordavic", hogwash: true },
      ],
    },
    {
      id: "bread2",
      themeLabel: "Flatbreads of the World",
      items: [
        { id: "r1", text: "Lavash", hogwash: false },
        { id: "r2", text: "Injera", hogwash: false },
        { id: "r3", text: "Roti", hogwash: false },
        { id: "r4", text: "Arepa", hogwash: false },
        { id: "r5", text: "Naan", hogwash: false },
        { id: "r6", text: "Paratha", hogwash: false },
        { id: "r7", text: "Tortilla", hogwash: false },
        { id: "h1", text: "Valdoran Flatbread", hogwash: true },
        { id: "h2", text: "Crestani Bread", hogwash: true },
        { id: "h3", text: "Nordic Hardtack", hogwash: true },
      ],
    },
    {
      id: "card_magic",
      themeLabel: "Magic Trick Types",
      items: [
        { id: "r1", text: "Mentalism", hogwash: false },
        { id: "r2", text: "Escapology", hogwash: false },
        { id: "r3", text: "Sleight of Hand", hogwash: false },
        { id: "r4", text: "Illusion", hogwash: false },
        { id: "r5", text: "Prediction", hogwash: false },
        { id: "r6", text: "Transformation", hogwash: false },
        { id: "r7", text: "Restoration", hogwash: false },
        { id: "h1", text: "Creston Phase", hogwash: true },
        { id: "h2", text: "Valdoran Reveal", hogwash: true },
        { id: "h3", text: "Nordic Pass", hogwash: true },
      ],
    },
    {
      id: "cooking_fats",
      themeLabel: "Cooking Oils & Fats",
      items: [
        { id: "r1", text: "Ghee", hogwash: false },
        { id: "r2", text: "Schmaltz", hogwash: false },
        { id: "r3", text: "Lard", hogwash: false },
        { id: "r4", text: "Duck Fat", hogwash: false },
        { id: "r5", text: "Avocado Oil", hogwash: false },
        { id: "r6", text: "Coconut Oil", hogwash: false },
        { id: "r7", text: "Tallow", hogwash: false },
        { id: "h1", text: "Creston Oil", hogwash: true },
        { id: "h2", text: "Valdoran Butter", hogwash: true },
        { id: "h3", text: "Nordic Press Oil", hogwash: true },
      ],
    },
    {
      id: "clouds3",
      themeLabel: "Types of Precipitation",
      items: [
        { id: "r1", text: "Sleet", hogwash: false },
        { id: "r2", text: "Graupel", hogwash: false },
        { id: "r3", text: "Freezing Rain", hogwash: false },
        { id: "r4", text: "Drizzle", hogwash: false },
        { id: "r5", text: "Virga", hogwash: false },
        { id: "r6", text: "Diamond Dust", hogwash: false },
        { id: "r7", text: "Hail", hogwash: false },
        { id: "h1", text: "Creston Flurry", hogwash: true },
        { id: "h2", text: "Valdoran Mist", hogwash: true },
        { id: "h3", text: "Nordic Ice Needle", hogwash: true },
      ],
    },
    {
      id: "economics3",
      themeLabel: "Startup Terms",
      items: [
        { id: "r1", text: "Pivot", hogwash: false },
        { id: "r2", text: "Runway", hogwash: false },
        { id: "r3", text: "Burn Rate", hogwash: false },
        { id: "r4", text: "Unicorn", hogwash: false },
        { id: "r5", text: "Seed Round", hogwash: false },
        { id: "r6", text: "Product-Market Fit", hogwash: false },
        { id: "r7", text: "Cap Table", hogwash: false },
        { id: "h1", text: "Creston Valuation", hogwash: true },
        { id: "h2", text: "Valdoran Dilution", hogwash: true },
        { id: "h3", text: "Nordic Term Sheet", hogwash: true },
      ],
    },
    {
      id: "cooking2",
      themeLabel: "French Culinary Terms",
      items: [
        { id: "r1", text: "Mise en Place", hogwash: false },
        { id: "r2", text: "Brunoise", hogwash: false },
        { id: "r3", text: "Julienne", hogwash: false },
        { id: "r4", text: "Chiffonade", hogwash: false },
        { id: "r5", text: "Sachet d'épices", hogwash: false },
        { id: "r6", text: "Monter au Beurre", hogwash: false },
        { id: "r7", text: "Nappe", hogwash: false },
        { id: "h1", text: "Creston Taille", hogwash: true },
        { id: "h2", text: "Valdoran Tournée", hogwash: true },
        { id: "h3", text: "Nordic Fond", hogwash: true },
      ],
    },
    {
      id: "painting_techniques",
      themeLabel: "Watercolor Techniques",
      items: [
        { id: "r1", text: "Wet-on-Wet", hogwash: false },
        { id: "r2", text: "Dry Brush", hogwash: false },
        { id: "r3", text: "Lifting", hogwash: false },
        { id: "r4", text: "Blooms", hogwash: false },
        { id: "r5", text: "Granulation", hogwash: false },
        { id: "r6", text: "Masking Fluid", hogwash: false },
        { id: "r7", text: "Backrun", hogwash: false },
        { id: "h1", text: "Creston Wash", hogwash: true },
        { id: "h2", text: "Valdoran Tone", hogwash: true },
        { id: "h3", text: "Nordic Float", hogwash: true },
      ],
    },
    {
      id: "boat_types",
      themeLabel: "Types of Boats & Ships",
      items: [
        { id: "r1", text: "Catamaran", hogwash: false },
        { id: "r2", text: "Dhow", hogwash: false },
        { id: "r3", text: "Felucca", hogwash: false },
        { id: "r4", text: "Junk", hogwash: false },
        { id: "r5", text: "Galleon", hogwash: false },
        { id: "r6", text: "Brig", hogwash: false },
        { id: "r7", text: "Schooner", hogwash: false },
        { id: "h1", text: "Creston Sloop", hogwash: true },
        { id: "h2", text: "Valdoran Ketch", hogwash: true },
        { id: "h3", text: "Nordic Barque", hogwash: true },
      ],
    },
    {
      id: "ancient_greece",
      themeLabel: "Ancient Greek Terms",
      items: [
        { id: "r1", text: "Agora", hogwash: false },
        { id: "r2", text: "Stoa", hogwash: false },
        { id: "r3", text: "Symposium", hogwash: false },
        { id: "r4", text: "Polis", hogwash: false },
        { id: "r5", text: "Ephebe", hogwash: false },
        { id: "r6", text: "Xenia", hogwash: false },
        { id: "r7", text: "Ekklesia", hogwash: false },
        { id: "h1", text: "Valdorix", hogwash: true },
        { id: "h2", text: "Crestanon", hogwash: true },
        { id: "h3", text: "Nordavion", hogwash: true },
      ],
    },
    {
      id: "cheese5",
      themeLabel: "Spanish Cheeses",
      items: [
        { id: "r1", text: "Tetilla", hogwash: false },
        { id: "r2", text: "Torta del Casar", hogwash: false },
        { id: "r3", text: "Idiazabal", hogwash: false },
        { id: "r4", text: "Cabrales", hogwash: false },
        { id: "r5", text: "Mahón", hogwash: false },
        { id: "r6", text: "Queso Ibores", hogwash: false },
        { id: "r7", text: "Roncal", hogwash: false },
        { id: "h1", text: "Valdorino", hogwash: true },
        { id: "h2", text: "Crestano Viejo", hogwash: true },
        { id: "h3", text: "Nordalés", hogwash: true },
      ],
    },
    {
      id: "architecture4",
      themeLabel: "Roofing Styles",
      items: [
        { id: "r1", text: "Mansard Roof", hogwash: false },
        { id: "r2", text: "Gambrel Roof", hogwash: false },
        { id: "r3", text: "Butterfly Roof", hogwash: false },
        { id: "r4", text: "Saltbox Roof", hogwash: false },
        { id: "r5", text: "Shed Roof", hogwash: false },
        { id: "r6", text: "Jerkinhead", hogwash: false },
        { id: "r7", text: "Clerestory Roof", hogwash: false },
        { id: "h1", text: "Creston Pitch", hogwash: true },
        { id: "h2", text: "Valdoran Dormer", hogwash: true },
        { id: "h3", text: "Nordic Hip", hogwash: true },
      ],
    },
    {
      id: "sewing2",
      themeLabel: "Quilting Terms",
      items: [
        { id: "r1", text: "Batting", hogwash: false },
        { id: "r2", text: "Binding", hogwash: false },
        { id: "r3", text: "Appliqué", hogwash: false },
        { id: "r4", text: "Sashing", hogwash: false },
        { id: "r5", text: "Block", hogwash: false },
        { id: "r6", text: "Flying Geese", hogwash: false },
        { id: "r7", text: "Log Cabin", hogwash: false },
        { id: "h1", text: "Creston Star", hogwash: true },
        { id: "h2", text: "Valdoran Patch", hogwash: true },
        { id: "h3", text: "Nordic Sampler", hogwash: true },
      ],
    },
    {
      id: "boxing",
      themeLabel: "Boxing Terms",
      items: [
        { id: "r1", text: "Jab", hogwash: false },
        { id: "r2", text: "Cross", hogwash: false },
        { id: "r3", text: "Southpaw", hogwash: false },
        { id: "r4", text: "Clinch", hogwash: false },
        { id: "r5", text: "Uppercut", hogwash: false },
        { id: "r6", text: "Slip", hogwash: false },
        { id: "r7", text: "Philly Shell", hogwash: false },
        { id: "h1", text: "Creston Feint", hogwash: true },
        { id: "h2", text: "Valdoran Counterpunch", hogwash: true },
        { id: "h3", text: "Nordic Guard", hogwash: true },
      ],
    },
    {
      id: "botany",
      themeLabel: "Botany Terms",
      items: [
        { id: "r1", text: "Photosynthesis", hogwash: false },
        { id: "r2", text: "Stomata", hogwash: false },
        { id: "r3", text: "Xylem", hogwash: false },
        { id: "r4", text: "Phloem", hogwash: false },
        { id: "r5", text: "Dehiscence", hogwash: false },
        { id: "r6", text: "Tendril", hogwash: false },
        { id: "r7", text: "Petiole", hogwash: false },
        { id: "h1", text: "Creston Node", hogwash: true },
        { id: "h2", text: "Valdoran Stalk", hogwash: true },
        { id: "h3", text: "Nordic Frond", hogwash: true },
      ],
    },
    {
      id: "hockey",
      themeLabel: "Ice Hockey Terms",
      items: [
        { id: "r1", text: "Icing", hogwash: false },
        { id: "r2", text: "Offside", hogwash: false },
        { id: "r3", text: "Deke", hogwash: false },
        { id: "r4", text: "Slapshot", hogwash: false },
        { id: "r5", text: "Penalty Kill", hogwash: false },
        { id: "r6", text: "Power Play", hogwash: false },
        { id: "r7", text: "Forecheck", hogwash: false },
        { id: "h1", text: "Creston Rush", hogwash: true },
        { id: "h2", text: "Valdoran Screen", hogwash: true },
        { id: "h3", text: "Nordic Line Change", hogwash: true },
      ],
    },
    {
      id: "roman_mythology",
      themeLabel: "Roman Mythology Figures",
      items: [
        { id: "r1", text: "Janus", hogwash: false },
        { id: "r2", text: "Vulcan", hogwash: false },
        { id: "r3", text: "Pluto", hogwash: false },
        { id: "r4", text: "Fortuna", hogwash: false },
        { id: "r5", text: "Aurora", hogwash: false },
        { id: "r6", text: "Terminus", hogwash: false },
        { id: "r7", text: "Faunus", hogwash: false },
        { id: "h1", text: "Valdorus", hogwash: true },
        { id: "h2", text: "Crestanus", hogwash: true },
        { id: "h3", text: "Nordavus", hogwash: true },
      ],
    },
    {
      id: "cocktail3",
      themeLabel: "Non-Alcoholic Drinks",
      items: [
        { id: "r1", text: "Shrub", hogwash: false },
        { id: "r2", text: "Switchel", hogwash: false },
        { id: "r3", text: "Agua Fresca", hogwash: false },
        { id: "r4", text: "Tepache", hogwash: false },
        { id: "r5", text: "Kombucha", hogwash: false },
        { id: "r6", text: "Lassi", hogwash: false },
        { id: "r7", text: "Kefir Water", hogwash: false },
        { id: "h1", text: "Creston Fizz", hogwash: true },
        { id: "h2", text: "Valdoran Cooler", hogwash: true },
        { id: "h3", text: "Nordic Tonic", hogwash: true },
      ],
    },
    {
      id: "typography3",
      themeLabel: "Types of Serif Fonts",
      items: [
        { id: "r1", text: "Transitional Serif", hogwash: false },
        { id: "r2", text: "Old Style", hogwash: false },
        { id: "r3", text: "Modern Serif", hogwash: false },
        { id: "r4", text: "Slab Serif", hogwash: false },
        { id: "r5", text: "Humanist Serif", hogwash: false },
        { id: "r6", text: "Clarendon", hogwash: false },
        { id: "r7", text: "Glyphic", hogwash: false },
        { id: "h1", text: "Creston Bracket", hogwash: true },
        { id: "h2", text: "Valdoran Wedge", hogwash: true },
        { id: "h3", text: "Nordic Face", hogwash: true },
      ],
    },
    {
      id: "bridges2",
      themeLabel: "Famous Bridges",
      items: [
        { id: "r1", text: "Golden Gate Bridge", hogwash: false },
        { id: "r2", text: "Tower Bridge", hogwash: false },
        { id: "r3", text: "Millau Viaduct", hogwash: false },
        { id: "r4", text: "Rialto Bridge", hogwash: false },
        { id: "r5", text: "Akashi Kaikyō Bridge", hogwash: false },
        { id: "r6", text: "Forth Rail Bridge", hogwash: false },
        { id: "r7", text: "Sydney Harbour Bridge", hogwash: false },
        { id: "h1", text: "Creston Crossing", hogwash: true },
        { id: "h2", text: "Valdoran Span", hogwash: true },
        { id: "h3", text: "Nordic Long Bridge", hogwash: true },
      ],
    },
    {
      id: "aquarium",
      themeLabel: "Types of Freshwater Fish",
      items: [
        { id: "r1", text: "Discus", hogwash: false },
        { id: "r2", text: "Betta", hogwash: false },
        { id: "r3", text: "Killifish", hogwash: false },
        { id: "r4", text: "Peacock Cichlid", hogwash: false },
        { id: "r5", text: "Arowana", hogwash: false },
        { id: "r6", text: "Plecostomus", hogwash: false },
        { id: "r7", text: "Rainbowfish", hogwash: false },
        { id: "h1", text: "Creston Darter", hogwash: true },
        { id: "h2", text: "Valdoran Tetra", hogwash: true },
        { id: "h3", text: "Nordic Perch", hogwash: true },
      ],
    },
    {
      id: "economics4",
      themeLabel: "Real Estate Terms",
      items: [
        { id: "r1", text: "Escrow", hogwash: false },
        { id: "r2", text: "Lien", hogwash: false },
        { id: "r3", text: "Title Insurance", hogwash: false },
        { id: "r4", text: "Cap Rate", hogwash: false },
        { id: "r5", text: "Easement", hogwash: false },
        { id: "r6", text: "Contingency", hogwash: false },
        { id: "r7", text: "Quitclaim Deed", hogwash: false },
        { id: "h1", text: "Creston Lien Float", hogwash: true },
        { id: "h2", text: "Valdoran Title Hold", hogwash: true },
        { id: "h3", text: "Nordic Deed Reserve", hogwash: true },
      ],
    },
    {
      id: "math2",
      themeLabel: "Famous Mathematicians",
      items: [
        { id: "r1", text: "Ramanujan", hogwash: false },
        { id: "r2", text: "Emmy Noether", hogwash: false },
        { id: "r3", text: "Leonhard Euler", hogwash: false },
        { id: "r4", text: "Blaise Pascal", hogwash: false },
        { id: "r5", text: "John von Neumann", hogwash: false },
        { id: "r6", text: "Carl Gauss", hogwash: false },
        { id: "r7", text: "Ada Lovelace", hogwash: false },
        { id: "h1", text: "Aldric Nordvane", hogwash: true },
        { id: "h2", text: "Pietro Crestano", hogwash: true },
        { id: "h3", text: "Valda Moreira", hogwash: true },
      ],
    },
    {
      id: "ancient_weapons",
      themeLabel: "Ancient Weapons",
      items: [
        { id: "r1", text: "Halberd", hogwash: false },
        { id: "r2", text: "Crossbow", hogwash: false },
        { id: "r3", text: "Catapult", hogwash: false },
        { id: "r4", text: "Ballista", hogwash: false },
        { id: "r5", text: "Trebuchet", hogwash: false },
        { id: "r6", text: "Gladius", hogwash: false },
        { id: "r7", text: "Kopis", hogwash: false },
        { id: "h1", text: "Valdoran Blade", hogwash: true },
        { id: "h2", text: "Creston Spear", hogwash: true },
        { id: "h3", text: "Nordic Axe", hogwash: true },
      ],
    },
    {
      id: "genetics2",
      themeLabel: "Genetic Conditions",
      items: [
        { id: "r1", text: "Phenylketonuria", hogwash: false },
        { id: "r2", text: "Marfan Syndrome", hogwash: false },
        { id: "r3", text: "Achondroplasia", hogwash: false },
        { id: "r4", text: "Turner Syndrome", hogwash: false },
        { id: "r5", text: "Huntington's Disease", hogwash: false },
        { id: "r6", text: "Cystic Fibrosis", hogwash: false },
        { id: "r7", text: "Gaucher Disease", hogwash: false },
        { id: "h1", text: "Creston Syndrome", hogwash: true },
        { id: "h2", text: "Valdoran Disease", hogwash: true },
        { id: "h3", text: "Nordic Disorder", hogwash: true },
      ],
    },
    {
      id: "painting3",
      themeLabel: "Famous Paintings",
      items: [
        { id: "r1", text: "The Night Watch", hogwash: false },
        { id: "r2", text: "Girl with a Pearl Earring", hogwash: false },
        { id: "r3", text: "The Birth of Venus", hogwash: false },
        { id: "r4", text: "The Persistence of Memory", hogwash: false },
        { id: "r5", text: "Water Lilies", hogwash: false },
        { id: "r6", text: "The Hay Wain", hogwash: false },
        { id: "r7", text: "American Gothic", hogwash: false },
        { id: "h1", text: "Evening in Valdora", hogwash: true },
        { id: "h2", text: "The Creston Garden", hogwash: true },
        { id: "h3", text: "Nordic Twilight", hogwash: true },
      ],
    },
    {
      id: "theater2",
      themeLabel: "Musical Theater Shows",
      items: [
        { id: "r1", text: "Sweeney Todd", hogwash: false },
        { id: "r2", text: "Company", hogwash: false },
        { id: "r3", text: "Follies", hogwash: false },
        { id: "r4", text: "Assassins", hogwash: false },
        { id: "r5", text: "Sunday in the Park with George", hogwash: false },
        { id: "r6", text: "Into the Woods", hogwash: false },
        { id: "r7", text: "Pacific Overtures", hogwash: false },
        { id: "h1", text: "Creston Heights", hogwash: true },
        { id: "h2", text: "The Valdoran", hogwash: true },
        { id: "h3", text: "Nordic Dreams", hogwash: true },
      ],
    },
    {
      id: "crypto2",
      themeLabel: "Cybersecurity Terms",
      items: [
        { id: "r1", text: "Phishing", hogwash: false },
        { id: "r2", text: "Zero-Day", hogwash: false },
        { id: "r3", text: "SQL Injection", hogwash: false },
        { id: "r4", text: "Man-in-the-Middle", hogwash: false },
        { id: "r5", text: "Brute Force Attack", hogwash: false },
        { id: "r6", text: "Social Engineering", hogwash: false },
        { id: "r7", text: "Ransomware", hogwash: false },
        { id: "h1", text: "Creston Exploit", hogwash: true },
        { id: "h2", text: "Valdoran Worm", hogwash: true },
        { id: "h3", text: "Nordic Packet Flood", hogwash: true },
      ],
    },
    {
      id: "horses2",
      themeLabel: "Equestrian Disciplines",
      items: [
        { id: "r1", text: "Dressage", hogwash: false },
        { id: "r2", text: "Eventing", hogwash: false },
        { id: "r3", text: "Polo", hogwash: false },
        { id: "r4", text: "Barrel Racing", hogwash: false },
        { id: "r5", text: "Reining", hogwash: false },
        { id: "r6", text: "Show Jumping", hogwash: false },
        { id: "r7", text: "Endurance Riding", hogwash: false },
        { id: "h1", text: "Creston Trail", hogwash: true },
        { id: "h2", text: "Valdoran Canter", hogwash: true },
        { id: "h3", text: "Nordic Cross", hogwash: true },
      ],
    },
    {
      id: "pottery3",
      themeLabel: "Ancient Pottery Styles",
      items: [
        { id: "r1", text: "Raku Ware", hogwash: false },
        { id: "r2", text: "Majolica", hogwash: false },
        { id: "r3", text: "Faience", hogwash: false },
        { id: "r4", text: "Delftware", hogwash: false },
        { id: "r5", text: "Celadon", hogwash: false },
        { id: "r6", text: "Imari Ware", hogwash: false },
        { id: "r7", text: "Slipware", hogwash: false },
        { id: "h1", text: "Crestano Ware", hogwash: true },
        { id: "h2", text: "Valdoran Blue", hogwash: true },
        { id: "h3", text: "Nordic Gloss", hogwash: true },
      ],
    },
    {
      id: "grammar2",
      themeLabel: "Punctuation Marks",
      items: [
        { id: "r1", text: "Interrobang", hogwash: false },
        { id: "r2", text: "Pilcrow", hogwash: false },
        { id: "r3", text: "Dagger", hogwash: false },
        { id: "r4", text: "Octothorpe", hogwash: false },
        { id: "r5", text: "Caret", hogwash: false },
        { id: "r6", text: "Tilde", hogwash: false },
        { id: "r7", text: "Solidus", hogwash: false },
        { id: "h1", text: "Creston Mark", hogwash: true },
        { id: "h2", text: "Valdoran Dot", hogwash: true },
        { id: "h3", text: "Nordic Hook", hogwash: true },
      ],
    },
    {
      id: "cooking3",
      themeLabel: "Indian Cooking Terms",
      items: [
        { id: "r1", text: "Tadka", hogwash: false },
        { id: "r2", text: "Dum", hogwash: false },
        { id: "r3", text: "Bhuna", hogwash: false },
        { id: "r4", text: "Tawa", hogwash: false },
        { id: "r5", text: "Karahi", hogwash: false },
        { id: "r6", text: "Vaghar", hogwash: false },
        { id: "r7", text: "Achaar", hogwash: false },
        { id: "h1", text: "Creston Masala", hogwash: true },
        { id: "h2", text: "Valdoran Tadka", hogwash: true },
        { id: "h3", text: "Nordic Dal", hogwash: true },
      ],
    },
    {
      id: "surfing2",
      themeLabel: "Water Polo Terms",
      items: [
        { id: "r1", text: "Eggbeater", hogwash: false },
        { id: "r2", text: "Wet Pass", hogwash: false },
        { id: "r3", text: "Lob Shot", hogwash: false },
        { id: "r4", text: "Sprint", hogwash: false },
        { id: "r5", text: "Exclusion", hogwash: false },
        { id: "r6", text: "Penalty Throw", hogwash: false },
        { id: "r7", text: "Corner Throw", hogwash: false },
        { id: "h1", text: "Creston Float", hogwash: true },
        { id: "h2", text: "Valdoran Block", hogwash: true },
        { id: "h3", text: "Nordic Drop", hogwash: true },
      ],
    },
    {
      id: "mythology2",
      themeLabel: "Norse Mythology Figures",
      items: [
        { id: "r1", text: "Freyr", hogwash: false },
        { id: "r2", text: "Frigg", hogwash: false },
        { id: "r3", text: "Mimir", hogwash: false },
        { id: "r4", text: "Baldur", hogwash: false },
        { id: "r5", text: "Njord", hogwash: false },
        { id: "r6", text: "Skadi", hogwash: false },
        { id: "r7", text: "Tyr", hogwash: false },
        { id: "h1", text: "Valdoric", hogwash: true },
        { id: "h2", text: "Crestanir", hogwash: true },
        { id: "h3", text: "Nordavus", hogwash: true },
      ],
    },
    {
      id: "tilepatterns",
      themeLabel: "Decorative Tile Patterns",
      items: [
        { id: "r1", text: "Zellige", hogwash: false },
        { id: "r2", text: "Encaustic", hogwash: false },
        { id: "r3", text: "Terrazzo", hogwash: false },
        { id: "r4", text: "Arabesque", hogwash: false },
        { id: "r5", text: "Herringbone", hogwash: false },
        { id: "r6", text: "Chevron", hogwash: false },
        { id: "r7", text: "Basket Weave", hogwash: false },
        { id: "h1", text: "Creston Mosaic", hogwash: true },
        { id: "h2", text: "Valdoran Grid", hogwash: true },
        { id: "h3", text: "Nordic Lattice", hogwash: true },
      ],
    },
    {
      id: "music3",
      themeLabel: "Music Subgenres of Rock",
      items: [
        { id: "r1", text: "Krautrock", hogwash: false },
        { id: "r2", text: "Math Rock", hogwash: false },
        { id: "r3", text: "Post-Rock", hogwash: false },
        { id: "r4", text: "Space Rock", hogwash: false },
        { id: "r5", text: "Noise Rock", hogwash: false },
        { id: "r6", text: "Indie Folk", hogwash: false },
        { id: "r7", text: "Grunge", hogwash: false },
        { id: "h1", text: "Creston Rock", hogwash: true },
        { id: "h2", text: "Valdorock", hogwash: true },
        { id: "h3", text: "Nordic Wave Rock", hogwash: true },
      ],
    },
    {
      id: "clouds4",
      themeLabel: "Climate Zones",
      items: [
        { id: "r1", text: "Tropical Monsoon", hogwash: false },
        { id: "r2", text: "Humid Subtropical", hogwash: false },
        { id: "r3", text: "Subarctic", hogwash: false },
        { id: "r4", text: "Semi-Arid", hogwash: false },
        { id: "r5", text: "Oceanic", hogwash: false },
        { id: "r6", text: "Mediterranean", hogwash: false },
        { id: "r7", text: "Tundra", hogwash: false },
        { id: "h1", text: "Creston Maritime", hogwash: true },
        { id: "h2", text: "Valdoran Dry", hogwash: true },
        { id: "h3", text: "Nordic Plateau", hogwash: true },
      ],
    },
    {
      id: "economics5",
      themeLabel: "International Trade Terms",
      items: [
        { id: "r1", text: "Tariff", hogwash: false },
        { id: "r2", text: "Embargo", hogwash: false },
        { id: "r3", text: "Quota", hogwash: false },
        { id: "r4", text: "Most Favored Nation", hogwash: false },
        { id: "r5", text: "Dumping", hogwash: false },
        { id: "r6", text: "Trade Deficit", hogwash: false },
        { id: "r7", text: "Free Trade Zone", hogwash: false },
        { id: "h1", text: "Creston Levy", hogwash: true },
        { id: "h2", text: "Valdoran Trade Block", hogwash: true },
        { id: "h3", text: "Nordic Export Pact", hogwash: true },
      ],
    },
    {
      id: "architecture5",
      themeLabel: "Garden Design Styles",
      items: [
        { id: "r1", text: "Parterre", hogwash: false },
        { id: "r2", text: "Stumpery", hogwash: false },
        { id: "r3", text: "Ha-Ha", hogwash: false },
        { id: "r4", text: "Potager", hogwash: false },
        { id: "r5", text: "Bosquet", hogwash: false },
        { id: "r6", text: "Knot Garden", hogwash: false },
        { id: "r7", text: "Fernery", hogwash: false },
        { id: "h1", text: "Creston Court", hogwash: true },
        { id: "h2", text: "Valdoran Walk", hogwash: true },
        { id: "h3", text: "Nordic Bower", hogwash: true },
      ],
    },
    {
      id: "athletics",
      themeLabel: "Track & Field Events",
      items: [
        { id: "r1", text: "Discus Throw", hogwash: false },
        { id: "r2", text: "Hammer Throw", hogwash: false },
        { id: "r3", text: "Triple Jump", hogwash: false },
        { id: "r4", text: "Steeplechase", hogwash: false },
        { id: "r5", text: "Decathlon", hogwash: false },
        { id: "r6", text: "Javelin", hogwash: false },
        { id: "r7", text: "Heptathlon", hogwash: false },
        { id: "h1", text: "Creston Relay", hogwash: true },
        { id: "h2", text: "Valdoran Vault", hogwash: true },
        { id: "h3", text: "Nordic Hurdle Race", hogwash: true },
      ],
    },
    {
      id: "logic2",
      themeLabel: "Philosophy of Mind Concepts",
      items: [
        { id: "r1", text: "Qualia", hogwash: false },
        { id: "r2", text: "Functionalism", hogwash: false },
        { id: "r3", text: "Dualism", hogwash: false },
        { id: "r4", text: "Physicalism", hogwash: false },
        { id: "r5", text: "Epiphenomenalism", hogwash: false },
        { id: "r6", text: "Emergentism", hogwash: false },
        { id: "r7", text: "Intentionality", hogwash: false },
        { id: "h1", text: "Creston Monism", hogwash: true },
        { id: "h2", text: "Valdoran Idealism", hogwash: true },
        { id: "h3", text: "Nordic Holism", hogwash: true },
      ],
    },
    {
      id: "cooking4",
      themeLabel: "Types of Pastry",
      items: [
        { id: "r1", text: "Pâte Brisée", hogwash: false },
        { id: "r2", text: "Choux Pastry", hogwash: false },
        { id: "r3", text: "Filo Pastry", hogwash: false },
        { id: "r4", text: "Hot Water Crust", hogwash: false },
        { id: "r5", text: "Rough Puff", hogwash: false },
        { id: "r6", text: "Suet Pastry", hogwash: false },
        { id: "r7", text: "Kouign-Amann", hogwash: false },
        { id: "h1", text: "Creston Crust", hogwash: true },
        { id: "h2", text: "Valdoran Dough", hogwash: true },
        { id: "h3", text: "Nordic Roll", hogwash: true },
      ],
    },
    {
      id: "swords",
      themeLabel: "Types of Sword",
      items: [
        { id: "r1", text: "Scimitar", hogwash: false },
        { id: "r2", text: "Katana", hogwash: false },
        { id: "r3", text: "Rapier", hogwash: false },
        { id: "r4", text: "Falchion", hogwash: false },
        { id: "r5", text: "Claymore", hogwash: false },
        { id: "r6", text: "Estoc", hogwash: false },
        { id: "r7", text: "Sabre", hogwash: false },
        { id: "h1", text: "Creston Blade", hogwash: true },
        { id: "h2", text: "Valdoran Edge", hogwash: true },
        { id: "h3", text: "Nordic Long Sword", hogwash: true },
      ],
    },
    {
      id: "beer2",
      themeLabel: "Hops Varieties",
      items: [
        { id: "r1", text: "Citra", hogwash: false },
        { id: "r2", text: "Simcoe", hogwash: false },
        { id: "r3", text: "Mosaic", hogwash: false },
        { id: "r4", text: "Saaz", hogwash: false },
        { id: "r5", text: "Hallertau", hogwash: false },
        { id: "r6", text: "Centennial", hogwash: false },
        { id: "r7", text: "Amarillo", hogwash: false },
        { id: "h1", text: "Creston Gold", hogwash: true },
        { id: "h2", text: "Valdoran Bitter", hogwash: true },
        { id: "h3", text: "Nordic Spice", hogwash: true },
      ],
    },
    {
      id: "literature2",
      themeLabel: "Classic Novel Titles",
      items: [
        { id: "r1", text: "Middlemarch", hogwash: false },
        { id: "r2", text: "The Brothers Karamazov", hogwash: false },
        { id: "r3", text: "The Trial", hogwash: false },
        { id: "r4", text: "Buddenbrooks", hogwash: false },
        { id: "r5", text: "In Search of Lost Time", hogwash: false },
        { id: "r6", text: "The Tin Drum", hogwash: false },
        { id: "r7", text: "Nausea", hogwash: false },
        { id: "h1", text: "The Valdoran", hogwash: true },
        { id: "h2", text: "Creston's End", hogwash: true },
        { id: "h3", text: "The Nordic Path", hogwash: true },
      ],
    },
    {
      id: "cooking5",
      themeLabel: "Types of Sauce",
      items: [
        { id: "r1", text: "Velouté", hogwash: false },
        { id: "r2", text: "Hollandaise", hogwash: false },
        { id: "r3", text: "Beurre Blanc", hogwash: false },
        { id: "r4", text: "Romesco", hogwash: false },
        { id: "r5", text: "Gremolata", hogwash: false },
        { id: "r6", text: "Salsa Verde", hogwash: false },
        { id: "r7", text: "Béarnaise", hogwash: false },
        { id: "h1", text: "Creston Sauce", hogwash: true },
        { id: "h2", text: "Valdoran Jus", hogwash: true },
        { id: "h3", text: "Nordic Glaze", hogwash: true },
      ],
    },
    {
      id: "insects2",
      themeLabel: "Types of Butterfly",
      items: [
        { id: "r1", text: "Painted Lady", hogwash: false },
        { id: "r2", text: "Red Admiral", hogwash: false },
        { id: "r3", text: "Morpho", hogwash: false },
        { id: "r4", text: "Birdwing", hogwash: false },
        { id: "r5", text: "Swallowtail", hogwash: false },
        { id: "r6", text: "Skipper", hogwash: false },
        { id: "r7", text: "Glasswing", hogwash: false },
        { id: "h1", text: "Creston Copper", hogwash: true },
        { id: "h2", text: "Valdoran Blue", hogwash: true },
        { id: "h3", text: "Nordic Fritillary", hogwash: true },
      ],
    },
    {
      id: "dance2",
      themeLabel: "Latin Dances",
      items: [
        { id: "r1", text: "Cha-Cha-Cha", hogwash: false },
        { id: "r2", text: "Samba", hogwash: false },
        { id: "r3", text: "Rumba", hogwash: false },
        { id: "r4", text: "Mambo", hogwash: false },
        { id: "r5", text: "Merengue", hogwash: false },
        { id: "r6", text: "Bachata", hogwash: false },
        { id: "r7", text: "Salsa", hogwash: false },
        { id: "h1", text: "Crestano", hogwash: true },
        { id: "h2", text: "Valdorant", hogwash: true },
        { id: "h3", text: "Nordalsa", hogwash: true },
      ],
    },
    {
      id: "space2",
      themeLabel: "Rocket Engine Types",
      items: [
        { id: "r1", text: "Solid Rocket Booster", hogwash: false },
        { id: "r2", text: "Liquid-Fueled Engine", hogwash: false },
        { id: "r3", text: "Ion Thruster", hogwash: false },
        { id: "r4", text: "Hall Effect Thruster", hogwash: false },
        { id: "r5", text: "Nuclear Thermal", hogwash: false },
        { id: "r6", text: "Scramjet", hogwash: false },
        { id: "r7", text: "Aerospike", hogwash: false },
        { id: "h1", text: "Creston Pulse Drive", hogwash: true },
        { id: "h2", text: "Valdoran Gravity Engine", hogwash: true },
        { id: "h3", text: "Nordic Wave Thrust", hogwash: true },
      ],
    },
    {
      id: "architecture6",
      themeLabel: "Interior Design Elements",
      items: [
        { id: "r1", text: "Wainscoting", hogwash: false },
        { id: "r2", text: "Crown Molding", hogwash: false },
        { id: "r3", text: "Coffered Ceiling", hogwash: false },
        { id: "r4", text: "Transom Window", hogwash: false },
        { id: "r5", text: "Pediment", hogwash: false },
        { id: "r6", text: "Dado Rail", hogwash: false },
        { id: "r7", text: "Pilaster", hogwash: false },
        { id: "h1", text: "Creston Panel", hogwash: true },
        { id: "h2", text: "Valdoran Trim", hogwash: true },
        { id: "h3", text: "Nordic Frieze", hogwash: true },
      ],
    },
    {
      id: "cooking6",
      themeLabel: "BBQ & Grilling Techniques",
      items: [
        { id: "r1", text: "Low and Slow", hogwash: false },
        { id: "r2", text: "Reverse Sear", hogwash: false },
        { id: "r3", text: "Spatchcock", hogwash: false },
        { id: "r4", text: "Wet Brine", hogwash: false },
        { id: "r5", text: "Dry Rub", hogwash: false },
        { id: "r6", text: "Planking", hogwash: false },
        { id: "r7", text: "Two-Zone Fire", hogwash: false },
        { id: "h1", text: "Creston Char", hogwash: true },
        { id: "h2", text: "Valdoran Smoke", hogwash: true },
        { id: "h3", text: "Nordic Pit Method", hogwash: true },
      ],
    },
    {
      id: "birds2",
      themeLabel: "Birds of Prey",
      items: [
        { id: "r1", text: "Peregrine Falcon", hogwash: false },
        { id: "r2", text: "Harpy Eagle", hogwash: false },
        { id: "r3", text: "Lanner Falcon", hogwash: false },
        { id: "r4", text: "Osprey", hogwash: false },
        { id: "r5", text: "Martial Eagle", hogwash: false },
        { id: "r6", text: "Eurasian Hobby", hogwash: false },
        { id: "r7", text: "Merlin", hogwash: false },
        { id: "h1", text: "Creston Hawk", hogwash: true },
        { id: "h2", text: "Valdoran Kite", hogwash: true },
        { id: "h3", text: "Nordic Buzzard", hogwash: true },
      ],
    },
    {
      id: "martial2",
      themeLabel: "Brazilian Jiu-Jitsu Techniques",
      items: [
        { id: "r1", text: "Armbar", hogwash: false },
        { id: "r2", text: "Triangle Choke", hogwash: false },
        { id: "r3", text: "Rear Naked Choke", hogwash: false },
        { id: "r4", text: "De La Riva Guard", hogwash: false },
        { id: "r5", text: "Omoplata", hogwash: false },
        { id: "r6", text: "Berimbolo", hogwash: false },
        { id: "r7", text: "Kimura", hogwash: false },
        { id: "h1", text: "Creston Lock", hogwash: true },
        { id: "h2", text: "Valdoran Sweep", hogwash: true },
        { id: "h3", text: "Nordic Clinch", hogwash: true },
      ],
    },
    {
      id: "coins",
      themeLabel: "U.S. Coin Types",
      items: [
        { id: "r1", text: "Morgan Dollar", hogwash: false },
        { id: "r2", text: "Buffalo Nickel", hogwash: false },
        { id: "r3", text: "Mercury Dime", hogwash: false },
        { id: "r4", text: "Walking Liberty Half Dollar", hogwash: false },
        { id: "r5", text: "Indian Head Cent", hogwash: false },
        { id: "r6", text: "Saint-Gaudens Double Eagle", hogwash: false },
        { id: "r7", text: "Peace Dollar", hogwash: false },
        { id: "h1", text: "Creston Eagle", hogwash: true },
        { id: "h2", text: "Valdoran Quarter", hogwash: true },
        { id: "h3", text: "Nordic Half Cent", hogwash: true },
      ],
    },
    {
      id: "cheese6",
      themeLabel: "Swiss Cheeses",
      items: [
        { id: "r1", text: "Gruyère", hogwash: false },
        { id: "r2", text: "Raclette", hogwash: false },
        { id: "r3", text: "Appenzeller", hogwash: false },
        { id: "r4", text: "Tilsit", hogwash: false },
        { id: "r5", text: "Sbrinz", hogwash: false },
        { id: "r6", text: "Schabziger", hogwash: false },
        { id: "r7", text: "Vacherin Mont-d'Or", hogwash: false },
        { id: "h1", text: "Creston Alpine", hogwash: true },
        { id: "h2", text: "Valdoran Berg", hogwash: true },
        { id: "h3", text: "Nordic Käse", hogwash: true },
      ],
    },
    {
      id: "drama",
      themeLabel: "Film Directors",
      items: [
        { id: "r1", text: "Akira Kurosawa", hogwash: false },
        { id: "r2", text: "Ingmar Bergman", hogwash: false },
        { id: "r3", text: "Agnes Varda", hogwash: false },
        { id: "r4", text: "Pedro Almodóvar", hogwash: false },
        { id: "r5", text: "Wong Kar-wai", hogwash: false },
        { id: "r6", text: "Andrei Tarkovsky", hogwash: false },
        { id: "r7", text: "Lucrecia Martel", hogwash: false },
        { id: "h1", text: "Aldric Nordvane", hogwash: true },
        { id: "h2", text: "Pietro Crestano", hogwash: true },
        { id: "h3", text: "Valda Moreira", hogwash: true },
      ],
    },
    {
      id: "music4",
      themeLabel: "Hip-Hop Terms",
      items: [
        { id: "r1", text: "Breakbeat", hogwash: false },
        { id: "r2", text: "Freestyle", hogwash: false },
        { id: "r3", text: "Ciphering", hogwash: false },
        { id: "r4", text: "Sampling", hogwash: false },
        { id: "r5", text: "Chopping", hogwash: false },
        { id: "r6", text: "Layering", hogwash: false },
        { id: "r7", text: "Scratching", hogwash: false },
        { id: "h1", text: "Creston Drop", hogwash: true },
        { id: "h2", text: "Valdoran Flow", hogwash: true },
        { id: "h3", text: "Nordic Bounce", hogwash: true },
      ],
    },
    {
      id: "materials",
      themeLabel: "Materials Science Terms",
      items: [
        { id: "r1", text: "Tensile Strength", hogwash: false },
        { id: "r2", text: "Ductility", hogwash: false },
        { id: "r3", text: "Fatigue", hogwash: false },
        { id: "r4", text: "Creep", hogwash: false },
        { id: "r5", text: "Annealing", hogwash: false },
        { id: "r6", text: "Tempering", hogwash: false },
        { id: "r7", text: "Sintering", hogwash: false },
        { id: "h1", text: "Creston Hardening", hogwash: true },
        { id: "h2", text: "Valdoran Yield", hogwash: true },
        { id: "h3", text: "Nordic Stress Relief", hogwash: true },
      ],
    },
    {
      id: "ancient_art",
      themeLabel: "Ancient Art Forms",
      items: [
        { id: "r1", text: "Cave Painting", hogwash: false },
        { id: "r2", text: "Fresco", hogwash: false },
        { id: "r3", text: "Mosaic", hogwash: false },
        { id: "r4", text: "Bas-Relief", hogwash: false },
        { id: "r5", text: "Gilding", hogwash: false },
        { id: "r6", text: "Encaustic", hogwash: false },
        { id: "r7", text: "Cloisonné", hogwash: false },
        { id: "h1", text: "Valdoran Carving", hogwash: true },
        { id: "h2", text: "Creston Etching", hogwash: true },
        { id: "h3", text: "Nordic Inlay", hogwash: true },
      ],
    },
    {
      id: "running2",
      themeLabel: "Triathlon Terms",
      items: [
        { id: "r1", text: "T1 Transition", hogwash: false },
        { id: "r2", text: "T2 Transition", hogwash: false },
        { id: "r3", text: "Drafting", hogwash: false },
        { id: "r4", text: "Brick Training", hogwash: false },
        { id: "r5", text: "Aerobars", hogwash: false },
        { id: "r6", text: "Wetsuit Strippers", hogwash: false },
        { id: "r7", text: "Gel Pack", hogwash: false },
        { id: "h1", text: "Creston Split", hogwash: true },
        { id: "h2", text: "Valdoran Zone", hogwash: true },
        { id: "h3", text: "Nordic Pace Bike", hogwash: true },
      ],
    },
    {
      id: "ecology",
      themeLabel: "Ecology Terms",
      items: [
        { id: "r1", text: "Trophic Level", hogwash: false },
        { id: "r2", text: "Keystone Species", hogwash: false },
        { id: "r3", text: "Biomass", hogwash: false },
        { id: "r4", text: "Succession", hogwash: false },
        { id: "r5", text: "Niche", hogwash: false },
        { id: "r6", text: "Carrying Capacity", hogwash: false },
        { id: "r7", text: "Commensalism", hogwash: false },
        { id: "h1", text: "Creston Chain", hogwash: true },
        { id: "h2", text: "Valdoran Web", hogwash: true },
        { id: "h3", text: "Nordic Balance", hogwash: true },
      ],
    },

    // ── FINAL PUSH TO 365 ─────────────────────────────────────────────────────

    {
      id: "social_media",
      themeLabel: "Social Media Terms",
      items: [
        { id: "r1", text: "Algorithm", hogwash: false },
        { id: "r2", text: "Shadowban", hogwash: false },
        { id: "r3", text: "Doomscrolling", hogwash: false },
        { id: "r4", text: "Ratio", hogwash: false },
        { id: "r5", text: "Finsta", hogwash: false },
        { id: "r6", text: "Subtweet", hogwash: false },
        { id: "r7", text: "Story Highlight", hogwash: false },
        { id: "h1", text: "Creston Boost", hogwash: true },
        { id: "h2", text: "Valdoran Feed", hogwash: true },
        { id: "h3", text: "Nordic Reach", hogwash: true },
      ],
    },
    {
      id: "lacrosse",
      themeLabel: "Lacrosse Terms",
      items: [
        { id: "r1", text: "Cradle", hogwash: false },
        { id: "r2", text: "Face-Off", hogwash: false },
        { id: "r3", text: "Crease", hogwash: false },
        { id: "r4", text: "Fast Break", hogwash: false },
        { id: "r5", text: "Ground Ball", hogwash: false },
        { id: "r6", text: "Clear", hogwash: false },
        { id: "r7", text: "Ride", hogwash: false },
        { id: "h1", text: "Creston Check", hogwash: true },
        { id: "h2", text: "Valdoran Slash", hogwash: true },
        { id: "h3", text: "Nordic Set Play", hogwash: true },
      ],
    },
    {
      id: "cloud5",
      themeLabel: "Ocean Currents",
      items: [
        { id: "r1", text: "Gulf Stream", hogwash: false },
        { id: "r2", text: "Humboldt Current", hogwash: false },
        { id: "r3", text: "Kuroshio Current", hogwash: false },
        { id: "r4", text: "Agulhas Current", hogwash: false },
        { id: "r5", text: "Labrador Current", hogwash: false },
        { id: "r6", text: "Antarctic Circumpolar", hogwash: false },
        { id: "r7", text: "Benguela Current", hogwash: false },
        { id: "h1", text: "Creston Drift", hogwash: true },
        { id: "h2", text: "Valdoran Stream", hogwash: true },
        { id: "h3", text: "Nordic Gyre", hogwash: true },
      ],
    },
    {
      id: "sailing2",
      themeLabel: "Fishing Techniques",
      items: [
        { id: "r1", text: "Fly Fishing", hogwash: false },
        { id: "r2", text: "Trolling", hogwash: false },
        { id: "r3", text: "Bottom Fishing", hogwash: false },
        { id: "r4", text: "Ice Fishing", hogwash: false },
        { id: "r5", text: "Jigging", hogwash: false },
        { id: "r6", text: "Spearfishing", hogwash: false },
        { id: "r7", text: "Noodling", hogwash: false },
        { id: "h1", text: "Creston Cast", hogwash: true },
        { id: "h2", text: "Valdoran Line", hogwash: true },
        { id: "h3", text: "Nordic Drop", hogwash: true },
      ],
    },
    {
      id: "typography4",
      themeLabel: "Calligraphy Styles",
      items: [
        { id: "r1", text: "Copperplate", hogwash: false },
        { id: "r2", text: "Spencerian", hogwash: false },
        { id: "r3", text: "Uncial", hogwash: false },
        { id: "r4", text: "Italic", hogwash: false },
        { id: "r5", text: "Blackletter", hogwash: false },
        { id: "r6", text: "Foundational Hand", hogwash: false },
        { id: "r7", text: "Naskh", hogwash: false },
        { id: "h1", text: "Creston Script", hogwash: true },
        { id: "h2", text: "Valdoran Hand", hogwash: true },
        { id: "h3", text: "Nordic Brush", hogwash: true },
      ],
    },
    {
      id: "music5",
      themeLabel: "Music Production Terms",
      items: [
        { id: "r1", text: "Sidechain", hogwash: false },
        { id: "r2", text: "EQ", hogwash: false },
        { id: "r3", text: "Reverb", hogwash: false },
        { id: "r4", text: "Saturation", hogwash: false },
        { id: "r5", text: "Compression", hogwash: false },
        { id: "r6", text: "Bounce to Stem", hogwash: false },
        { id: "r7", text: "Parallel Processing", hogwash: false },
        { id: "h1", text: "Creston Bus", hogwash: true },
        { id: "h2", text: "Valdoran Chain", hogwash: true },
        { id: "h3", text: "Nordic Mix", hogwash: true },
      ],
    },
    {
      id: "camping2",
      themeLabel: "Backpacking Gear",
      items: [
        { id: "r1", text: "Trekking Poles", hogwash: false },
        { id: "r2", text: "Water Filter", hogwash: false },
        { id: "r3", text: "Stuff Sack", hogwash: false },
        { id: "r4", text: "Gaiters", hogwash: false },
        { id: "r5", text: "Headlamp", hogwash: false },
        { id: "r6", text: "Sleeping Pad", hogwash: false },
        { id: "r7", text: "Dry Bag", hogwash: false },
        { id: "h1", text: "Creston Pack", hogwash: true },
        { id: "h2", text: "Valdoran Shell", hogwash: true },
        { id: "h3", text: "Nordic Boot", hogwash: true },
      ],
    },
    {
      id: "mythology3",
      themeLabel: "Hindu Mythology Figures",
      items: [
        { id: "r1", text: "Hanuman", hogwash: false },
        { id: "r2", text: "Lakshmi", hogwash: false },
        { id: "r3", text: "Kali", hogwash: false },
        { id: "r4", text: "Ganesha", hogwash: false },
        { id: "r5", text: "Indra", hogwash: false },
        { id: "r6", text: "Saraswati", hogwash: false },
        { id: "r7", text: "Brahma", hogwash: false },
        { id: "h1", text: "Valdoravi", hogwash: true },
        { id: "h2", text: "Crestanesh", hogwash: true },
        { id: "h3", text: "Nordadev", hogwash: true },
      ],
    },
    {
      id: "baking2",
      themeLabel: "Artisan Bread Terms",
      items: [
        { id: "r1", text: "Autolyse", hogwash: false },
        { id: "r2", text: "Hydration", hogwash: false },
        { id: "r3", text: "Starter", hogwash: false },
        { id: "r4", text: "Windowpane Test", hogwash: false },
        { id: "r5", text: "Proofing", hogwash: false },
        { id: "r6", text: "Scoring", hogwash: false },
        { id: "r7", text: "Dutch Oven Bake", hogwash: false },
        { id: "h1", text: "Creston Rest", hogwash: true },
        { id: "h2", text: "Valdoran Rise", hogwash: true },
        { id: "h3", text: "Nordic Stretch", hogwash: true },
      ],
    },
    {
      id: "film2",
      themeLabel: "Film Movements",
      items: [
        { id: "r1", text: "French New Wave", hogwash: false },
        { id: "r2", text: "Italian Neorealism", hogwash: false },
        { id: "r3", text: "German Expressionism", hogwash: false },
        { id: "r4", text: "Dogme 95", hogwash: false },
        { id: "r5", text: "Czech New Wave", hogwash: false },
        { id: "r6", text: "Brazilian Cinema Novo", hogwash: false },
        { id: "r7", text: "British Free Cinema", hogwash: false },
        { id: "h1", text: "Creston Realism", hogwash: true },
        { id: "h2", text: "Valdoran New Wave", hogwash: true },
        { id: "h3", text: "Nordic Auteurism", hogwash: true },
      ],
    },
    {
      id: "medicine2",
      themeLabel: "Medical Specialties",
      items: [
        { id: "r1", text: "Nephrology", hogwash: false },
        { id: "r2", text: "Endocrinology", hogwash: false },
        { id: "r3", text: "Rheumatology", hogwash: false },
        { id: "r4", text: "Hematology", hogwash: false },
        { id: "r5", text: "Pulmonology", hogwash: false },
        { id: "r6", text: "Gastroenterology", hogwash: false },
        { id: "r7", text: "Otolaryngology", hogwash: false },
        { id: "h1", text: "Crestology", hogwash: true },
        { id: "h2", text: "Valdorology", hogwash: true },
        { id: "h3", text: "Nordiology", hogwash: true },
      ],
    },
    {
      id: "finance2",
      themeLabel: "Accounting Terms",
      items: [
        { id: "r1", text: "Accrual", hogwash: false },
        { id: "r2", text: "Depreciation", hogwash: false },
        { id: "r3", text: "Working Capital", hogwash: false },
        { id: "r4", text: "EBITDA", hogwash: false },
        { id: "r5", text: "Goodwill", hogwash: false },
        { id: "r6", text: "Accounts Receivable", hogwash: false },
        { id: "r7", text: "Deferred Revenue", hogwash: false },
        { id: "h1", text: "Creston Reserve", hogwash: true },
        { id: "h2", text: "Valdoran Float", hogwash: true },
        { id: "h3", text: "Nordic Accrual", hogwash: true },
      ],
    },
    {
      id: "animals2",
      themeLabel: "Marsupials",
      items: [
        { id: "r1", text: "Quokka", hogwash: false },
        { id: "r2", text: "Numbat", hogwash: false },
        { id: "r3", text: "Quoll", hogwash: false },
        { id: "r4", text: "Bilby", hogwash: false },
        { id: "r5", text: "Pademelon", hogwash: false },
        { id: "r6", text: "Dunnart", hogwash: false },
        { id: "r7", text: "Potoroo", hogwash: false },
        { id: "h1", text: "Creston Wallaby", hogwash: true },
        { id: "h2", text: "Valdoran Bandicoot", hogwash: true },
        { id: "h3", text: "Nordic Possum", hogwash: true },
      ],
    },
    {
      id: "architecture7",
      themeLabel: "Skyscraper Terms",
      items: [
        { id: "r1", text: "Curtain Wall", hogwash: false },
        { id: "r2", text: "Setback", hogwash: false },
        { id: "r3", text: "Atrium", hogwash: false },
        { id: "r4", text: "Core", hogwash: false },
        { id: "r5", text: "Damper", hogwash: false },
        { id: "r6", text: "Sky Lobby", hogwash: false },
        { id: "r7", text: "Outrigger", hogwash: false },
        { id: "h1", text: "Creston Spire", hogwash: true },
        { id: "h2", text: "Valdoran Podium", hogwash: true },
        { id: "h3", text: "Nordic Structural Belt", hogwash: true },
      ],
    },
    {
      id: "fabric3",
      themeLabel: "Textile Dyeing Techniques",
      items: [
        { id: "r1", text: "Shibori", hogwash: false },
        { id: "r2", text: "Batik", hogwash: false },
        { id: "r3", text: "Ikat", hogwash: false },
        { id: "r4", text: "Ombré", hogwash: false },
        { id: "r5", text: "Resist Dyeing", hogwash: false },
        { id: "r6", text: "Space Dyeing", hogwash: false },
        { id: "r7", text: "Indigo Vat", hogwash: false },
        { id: "h1", text: "Creston Dye", hogwash: true },
        { id: "h2", text: "Valdoran Print", hogwash: true },
        { id: "h3", text: "Nordic Stripe", hogwash: true },
      ],
    },
    {
      id: "astronomy5",
      themeLabel: "Comets & Asteroids",
      items: [
        { id: "r1", text: "Halley's Comet", hogwash: false },
        { id: "r2", text: "Comet Hale-Bopp", hogwash: false },
        { id: "r3", text: "Apophis", hogwash: false },
        { id: "r4", text: "Bennu", hogwash: false },
        { id: "r5", text: "Vesta", hogwash: false },
        { id: "r6", text: "Ceres", hogwash: false },
        { id: "r7", text: "Oumuamua", hogwash: false },
        { id: "h1", text: "Creston 2049", hogwash: true },
        { id: "h2", text: "Valdoran Comet", hogwash: true },
        { id: "h3", text: "Nordic-B", hogwash: true },
      ],
    },
    {
      id: "cocktail4",
      themeLabel: "Vermouth & Aperitifs",
      items: [
        { id: "r1", text: "Lillet Blanc", hogwash: false },
        { id: "r2", text: "Cocchi Americano", hogwash: false },
        { id: "r3", text: "Campari", hogwash: false },
        { id: "r4", text: "Chartreuse", hogwash: false },
        { id: "r5", text: "Bénédictine", hogwash: false },
        { id: "r6", text: "Amaro Nonino", hogwash: false },
        { id: "r7", text: "Suze", hogwash: false },
        { id: "h1", text: "Creston Amaro", hogwash: true },
        { id: "h2", text: "Valdoran Bitter", hogwash: true },
        { id: "h3", text: "Nordic Aperitif", hogwash: true },
      ],
    },
    {
      id: "anatomy3",
      themeLabel: "Parts of the Eye",
      items: [
        { id: "r1", text: "Cornea", hogwash: false },
        { id: "r2", text: "Iris", hogwash: false },
        { id: "r3", text: "Sclera", hogwash: false },
        { id: "r4", text: "Macula", hogwash: false },
        { id: "r5", text: "Vitreous Humor", hogwash: false },
        { id: "r6", text: "Fovea", hogwash: false },
        { id: "r7", text: "Choroid", hogwash: false },
        { id: "h1", text: "Crestana", hogwash: true },
        { id: "h2", text: "Valdoretina", hogwash: true },
        { id: "h3", text: "Nordic Lens Cap", hogwash: true },
      ],
    },
    {
      id: "art2",
      themeLabel: "Abstract Art Techniques",
      items: [
        { id: "r1", text: "Drip Painting", hogwash: false },
        { id: "r2", text: "Color Field", hogwash: false },
        { id: "r3", text: "Gestural Abstraction", hogwash: false },
        { id: "r4", text: "Hard-Edge Painting", hogwash: false },
        { id: "r5", text: "Lyrical Abstraction", hogwash: false },
        { id: "r6", text: "Monochromatic", hogwash: false },
        { id: "r7", text: "Action Painting", hogwash: false },
        { id: "h1", text: "Creston Field", hogwash: true },
        { id: "h2", text: "Valdoran Wash", hogwash: true },
        { id: "h3", text: "Nordic Smear", hogwash: true },
      ],
    },
    {
      id: "greek2",
      themeLabel: "Greek Gods & Domains",
      items: [
        { id: "r1", text: "Hestia – Hearth", hogwash: false },
        { id: "r2", text: "Demeter – Harvest", hogwash: false },
        { id: "r3", text: "Poseidon – Sea", hogwash: false },
        { id: "r4", text: "Hades – Underworld", hogwash: false },
        { id: "r5", text: "Ares – War", hogwash: false },
        { id: "r6", text: "Dionysus – Wine", hogwash: false },
        { id: "r7", text: "Hermes – Messengers", hogwash: false },
        { id: "h1", text: "Valdorix – Horizon", hogwash: true },
        { id: "h2", text: "Crestanos – Storms", hogwash: true },
        { id: "h3", text: "Nordavus – Ice", hogwash: true },
      ],
    },
    {
      id: "cooking7",
      themeLabel: "Japanese Cooking Terms",
      items: [
        { id: "r1", text: "Umami", hogwash: false },
        { id: "r2", text: "Dashi", hogwash: false },
        { id: "r3", text: "Katsuobushi", hogwash: false },
        { id: "r4", text: "Mirin", hogwash: false },
        { id: "r5", text: "Kombu", hogwash: false },
        { id: "r6", text: "Ponzu", hogwash: false },
        { id: "r7", text: "Tsuyu", hogwash: false },
        { id: "h1", text: "Creston Broth", hogwash: true },
        { id: "h2", text: "Valdoran Stock", hogwash: true },
        { id: "h3", text: "Nordic Dashi", hogwash: true },
      ],
    },
    {
      id: "construction",
      themeLabel: "Construction Terms",
      items: [
        { id: "r1", text: "Rebar", hogwash: false },
        { id: "r2", text: "Footing", hogwash: false },
        { id: "r3", text: "Soffit", hogwash: false },
        { id: "r4", text: "Fascia", hogwash: false },
        { id: "r5", text: "Sheathing", hogwash: false },
        { id: "r6", text: "Joist", hogwash: false },
        { id: "r7", text: "Cripple Wall", hogwash: false },
        { id: "h1", text: "Creston Beam", hogwash: true },
        { id: "h2", text: "Valdoran Form", hogwash: true },
        { id: "h3", text: "Nordic Load Path", hogwash: true },
      ],
    },
    {
      id: "chess2",
      themeLabel: "Famous Chess Players",
      items: [
        { id: "r1", text: "Magnus Carlsen", hogwash: false },
        { id: "r2", text: "Garry Kasparov", hogwash: false },
        { id: "r3", text: "Bobby Fischer", hogwash: false },
        { id: "r4", text: "Viswanathan Anand", hogwash: false },
        { id: "r5", text: "Mikhail Tal", hogwash: false },
        { id: "r6", text: "José Raúl Capablanca", hogwash: false },
        { id: "r7", text: "Judith Polgar", hogwash: false },
        { id: "h1", text: "Aldric Nordvane", hogwash: true },
        { id: "h2", text: "Pietro Crestano", hogwash: true },
        { id: "h3", text: "Valda Moreira", hogwash: true },
      ],
    },
    {
      id: "languages2",
      themeLabel: "Writing Systems",
      items: [
        { id: "r1", text: "Cyrillic", hogwash: false },
        { id: "r2", text: "Devanagari", hogwash: false },
        { id: "r3", text: "Hangul", hogwash: false },
        { id: "r4", text: "Ge'ez", hogwash: false },
        { id: "r5", text: "Tibetan", hogwash: false },
        { id: "r6", text: "Baybayin", hogwash: false },
        { id: "r7", text: "Sinhala", hogwash: false },
        { id: "h1", text: "Valdorian Script", hogwash: true },
        { id: "h2", text: "Creston Alphabet", hogwash: true },
        { id: "h3", text: "Nordic Rune Set", hogwash: true },
      ],
    },
    {
      id: "aviation",
      themeLabel: "Aviation Terms",
      items: [
        { id: "r1", text: "Aileron", hogwash: false },
        { id: "r2", text: "Rudder", hogwash: false },
        { id: "r3", text: "Flap", hogwash: false },
        { id: "r4", text: "Spoiler", hogwash: false },
        { id: "r5", text: "Stall", hogwash: false },
        { id: "r6", text: "VFR", hogwash: false },
        { id: "r7", text: "METAR", hogwash: false },
        { id: "h1", text: "Creston Glide", hogwash: true },
        { id: "h2", text: "Valdoran Pitch", hogwash: true },
        { id: "h3", text: "Nordic Roll Rate", hogwash: true },
      ],
    },
    {
      id: "economics6",
      themeLabel: "Behavioral Economics Concepts",
      items: [
        { id: "r1", text: "Loss Aversion", hogwash: false },
        { id: "r2", text: "Nudge Theory", hogwash: false },
        { id: "r3", text: "Anchoring", hogwash: false },
        { id: "r4", text: "Endowment Effect", hogwash: false },
        { id: "r5", text: "Sunk Cost Fallacy", hogwash: false },
        { id: "r6", text: "Hyperbolic Discounting", hogwash: false },
        { id: "r7", text: "Choice Architecture", hogwash: false },
        { id: "h1", text: "Creston Bias", hogwash: true },
        { id: "h2", text: "Valdoran Frame", hogwash: true },
        { id: "h3", text: "Nordic Default Effect", hogwash: true },
      ],
    },
    {
      id: "astronomy6",
      themeLabel: "Radio Astronomy Terms",
      items: [
        { id: "r1", text: "Pulsar", hogwash: false },
        { id: "r2", text: "Quasar", hogwash: false },
        { id: "r3", text: "Redshift", hogwash: false },
        { id: "r4", text: "Blueshift", hogwash: false },
        { id: "r5", text: "Cosmic Microwave Background", hogwash: false },
        { id: "r6", text: "Event Horizon", hogwash: false },
        { id: "r7", text: "Hawking Radiation", hogwash: false },
        { id: "h1", text: "Creston Burst", hogwash: true },
        { id: "h2", text: "Valdoran Signal", hogwash: true },
        { id: "h3", text: "Nordic Static", hogwash: true },
      ],
    },
    {
      id: "cooking8",
      themeLabel: "Mexican Cooking Terms",
      items: [
        { id: "r1", text: "Mole", hogwash: false },
        { id: "r2", text: "Achiote", hogwash: false },
        { id: "r3", text: "Epazote", hogwash: false },
        { id: "r4", text: "Sofrito", hogwash: false },
        { id: "r5", text: "Nixtamalization", hogwash: false },
        { id: "r6", text: "Comal", hogwash: false },
        { id: "r7", text: "Piloncillo", hogwash: false },
        { id: "h1", text: "Creston Salsa", hogwash: true },
        { id: "h2", text: "Valdoran Spice", hogwash: true },
        { id: "h3", text: "Nordic Masa", hogwash: true },
      ],
    },
    {
      id: "animals3",
      themeLabel: "Venomous Animals",
      items: [
        { id: "r1", text: "Box Jellyfish", hogwash: false },
        { id: "r2", text: "Blue-Ringed Octopus", hogwash: false },
        { id: "r3", text: "Stonefish", hogwash: false },
        { id: "r4", text: "Cone Snail", hogwash: false },
        { id: "r5", text: "Platypus", hogwash: false },
        { id: "r6", text: "Slow Loris", hogwash: false },
        { id: "r7", text: "Gila Monster", hogwash: false },
        { id: "h1", text: "Creston Viper", hogwash: true },
        { id: "h2", text: "Valdoran Toad", hogwash: true },
        { id: "h3", text: "Nordic Sea Worm", hogwash: true },
      ],
    },
    {
      id: "science2",
      themeLabel: "Scientific Laws",
      items: [
        { id: "r1", text: "Boyle's Law", hogwash: false },
        { id: "r2", text: "Ohm's Law", hogwash: false },
        { id: "r3", text: "Faraday's Law", hogwash: false },
        { id: "r4", text: "Hooke's Law", hogwash: false },
        { id: "r5", text: "Charles's Law", hogwash: false },
        { id: "r6", text: "Avogadro's Law", hogwash: false },
        { id: "r7", text: "Hubble's Law", hogwash: false },
        { id: "h1", text: "Creston's Law", hogwash: true },
        { id: "h2", text: "Valdoran's Principle", hogwash: true },
        { id: "h3", text: "Nordic's Constant", hogwash: true },
      ],
    },
    {
      id: "medicine3",
      themeLabel: "Vaccines by Disease",
      items: [
        { id: "r1", text: "MMR Vaccine", hogwash: false },
        { id: "r2", text: "DTaP Vaccine", hogwash: false },
        { id: "r3", text: "Hepatitis B Vaccine", hogwash: false },
        { id: "r4", text: "Varicella Vaccine", hogwash: false },
        { id: "r5", text: "Meningococcal Vaccine", hogwash: false },
        { id: "r6", text: "Rabies Vaccine", hogwash: false },
        { id: "r7", text: "Yellow Fever Vaccine", hogwash: false },
        { id: "h1", text: "Creston Immune Boost", hogwash: true },
        { id: "h2", text: "Valdoran Inoculation", hogwash: true },
        { id: "h3", text: "Nordic Shield Shot", hogwash: true },
      ],
    },
    {
      id: "sports2",
      themeLabel: "Gymnastics Terms",
      items: [
        { id: "r1", text: "Tkatchev", hogwash: false },
        { id: "r2", text: "Kip", hogwash: false },
        { id: "r3", text: "Giant Swing", hogwash: false },
        { id: "r4", text: "Layout", hogwash: false },
        { id: "r5", text: "Tuck", hogwash: false },
        { id: "r6", text: "Dismount", hogwash: false },
        { id: "r7", text: "Salto", hogwash: false },
        { id: "h1", text: "Creston Pike", hogwash: true },
        { id: "h2", text: "Valdoran Twist", hogwash: true },
        { id: "h3", text: "Nordic Release", hogwash: true },
      ],
    },
    {
      id: "music6",
      themeLabel: "Electronic Music Genres",
      items: [
        { id: "r1", text: "Techno", hogwash: false },
        { id: "r2", text: "Drum and Bass", hogwash: false },
        { id: "r3", text: "Ambient", hogwash: false },
        { id: "r4", text: "Dubstep", hogwash: false },
        { id: "r5", text: "Trance", hogwash: false },
        { id: "r6", text: "Hardcore", hogwash: false },
        { id: "r7", text: "UK Garage", hogwash: false },
        { id: "h1", text: "Creston Beat", hogwash: true },
        { id: "h2", text: "Valdoran Bass", hogwash: true },
        { id: "h3", text: "Nordic Wave", hogwash: true },
      ],
    },
    {
      id: "trees2",
      themeLabel: "Tropical Fruits",
      items: [
        { id: "r1", text: "Rambutan", hogwash: false },
        { id: "r2", text: "Durian", hogwash: false },
        { id: "r3", text: "Mangosteen", hogwash: false },
        { id: "r4", text: "Salak", hogwash: false },
        { id: "r5", text: "Jackfruit", hogwash: false },
        { id: "r6", text: "Soursop", hogwash: false },
        { id: "r7", text: "Longan", hogwash: false },
        { id: "h1", text: "Creston Fruit", hogwash: true },
        { id: "h2", text: "Valdoran Berry", hogwash: true },
        { id: "h3", text: "Nordic Drupe", hogwash: true },
      ],
    },
    {
      id: "law2",
      themeLabel: "Types of Contract",
      items: [
        { id: "r1", text: "Bilateral Contract", hogwash: false },
        { id: "r2", text: "Unilateral Contract", hogwash: false },
        { id: "r3", text: "Void Contract", hogwash: false },
        { id: "r4", text: "Voidable Contract", hogwash: false },
        { id: "r5", text: "Express Contract", hogwash: false },
        { id: "r6", text: "Implied Contract", hogwash: false },
        { id: "r7", text: "Adhesion Contract", hogwash: false },
        { id: "h1", text: "Creston Agreement", hogwash: true },
        { id: "h2", text: "Valdoran Covenant", hogwash: true },
        { id: "h3", text: "Nordic Deed", hogwash: true },
      ],
    },
    {
      id: "cooking9",
      themeLabel: "Egg Preparations",
      items: [
        { id: "r1", text: "Shirred Eggs", hogwash: false },
        { id: "r2", text: "Coddled Eggs", hogwash: false },
        { id: "r3", text: "Eggs en Cocotte", hogwash: false },
        { id: "r4", text: "Poached Egg", hogwash: false },
        { id: "r5", text: "Oeufs Mollets", hogwash: false },
        { id: "r6", text: "Basted Egg", hogwash: false },
        { id: "r7", text: "Soft Scramble", hogwash: false },
        { id: "h1", text: "Creston Fold", hogwash: true },
        { id: "h2", text: "Valdoran Fry", hogwash: true },
        { id: "h3", text: "Nordic Cure", hogwash: true },
      ],
    },
    {
      id: "photography2",
      themeLabel: "Film Camera Formats",
      items: [
        { id: "r1", text: "35mm Film", hogwash: false },
        { id: "r2", text: "Medium Format", hogwash: false },
        { id: "r3", text: "Large Format", hogwash: false },
        { id: "r4", text: "APS Film", hogwash: false },
        { id: "r5", text: "110 Cartridge", hogwash: false },
        { id: "r6", text: "120 Roll Film", hogwash: false },
        { id: "r7", text: "Disc Film", hogwash: false },
        { id: "h1", text: "Creston Slide", hogwash: true },
        { id: "h2", text: "Valdoran Frame", hogwash: true },
        { id: "h3", text: "Nordic Plate", hogwash: true },
      ],
    },
    {
      id: "marine",
      themeLabel: "Marine Biology Terms",
      items: [
        { id: "r1", text: "Bioluminescence", hogwash: false },
        { id: "r2", text: "Thermocline", hogwash: false },
        { id: "r3", text: "Symbiosis", hogwash: false },
        { id: "r4", text: "Zooplankton", hogwash: false },
        { id: "r5", text: "Benthic", hogwash: false },
        { id: "r6", text: "Pelagic", hogwash: false },
        { id: "r7", text: "Halocline", hogwash: false },
        { id: "h1", text: "Creston Zone", hogwash: true },
        { id: "h2", text: "Valdoran Layer", hogwash: true },
        { id: "h3", text: "Nordic Drift", hogwash: true },
      ],
    },
    {
      id: "cars2",
      themeLabel: "Classic Car Brands",
      items: [
        { id: "r1", text: "DeSoto", hogwash: false },
        { id: "r2", text: "Studebaker", hogwash: false },
        { id: "r3", text: "Hudson", hogwash: false },
        { id: "r4", text: "Packard", hogwash: false },
        { id: "r5", text: "Nash", hogwash: false },
        { id: "r6", text: "Kaiser", hogwash: false },
        { id: "r7", text: "Frazer", hogwash: false },
        { id: "h1", text: "Creston Motor Co.", hogwash: true },
        { id: "h2", text: "Valdoran Auto", hogwash: true },
        { id: "h3", text: "Nordic Drive", hogwash: true },
      ],
    },
    {
      id: "plants",
      themeLabel: "Carnivorous Plants",
      items: [
        { id: "r1", text: "Venus Flytrap", hogwash: false },
        { id: "r2", text: "Sundew", hogwash: false },
        { id: "r3", text: "Pitcher Plant", hogwash: false },
        { id: "r4", text: "Bladderwort", hogwash: false },
        { id: "r5", text: "Butterwort", hogwash: false },
        { id: "r6", text: "Corkscrew Plant", hogwash: false },
        { id: "r7", text: "Cobra Lily", hogwash: false },
        { id: "h1", text: "Creston Trap", hogwash: true },
        { id: "h2", text: "Valdoran Snapper", hogwash: true },
        { id: "h3", text: "Nordic Pitcher", hogwash: true },
      ],
    },
    {
      id: "economics7",
      themeLabel: "Central Banking Terms",
      items: [
        { id: "r1", text: "Quantitative Easing", hogwash: false },
        { id: "r2", text: "Federal Funds Rate", hogwash: false },
        { id: "r3", text: "Reserve Requirement", hogwash: false },
        { id: "r4", text: "Open Market Operations", hogwash: false },
        { id: "r5", text: "Inflation Target", hogwash: false },
        { id: "r6", text: "Yield Spread", hogwash: false },
        { id: "r7", text: "Discount Window", hogwash: false },
        { id: "h1", text: "Creston Rate", hogwash: true },
        { id: "h2", text: "Valdoran Bond Floor", hogwash: true },
        { id: "h3", text: "Nordic Reserve Cap", hogwash: true },
      ],
    },
    {
      id: "architecture8",
      themeLabel: "Window Styles",
      items: [
        { id: "r1", text: "Casement Window", hogwash: false },
        { id: "r2", text: "Bay Window", hogwash: false },
        { id: "r3", text: "Oriel Window", hogwash: false },
        { id: "r4", text: "Sash Window", hogwash: false },
        { id: "r5", text: "Rose Window", hogwash: false },
        { id: "r6", text: "Lancet Window", hogwash: false },
        { id: "r7", text: "Fanlight", hogwash: false },
        { id: "h1", text: "Creston Pane", hogwash: true },
        { id: "h2", text: "Valdoran Arch Window", hogwash: true },
        { id: "h3", text: "Nordic Light", hogwash: true },
      ],
    },
    {
      id: "sports3",
      themeLabel: "Volleyball Terms",
      items: [
        { id: "r1", text: "Libero", hogwash: false },
        { id: "r2", text: "Setter", hogwash: false },
        { id: "r3", text: "Dig", hogwash: false },
        { id: "r4", text: "Kill", hogwash: false },
        { id: "r5", text: "Pancake", hogwash: false },
        { id: "r6", text: "Joust", hogwash: false },
        { id: "r7", text: "Float Serve", hogwash: false },
        { id: "h1", text: "Creston Spike", hogwash: true },
        { id: "h2", text: "Valdoran Set", hogwash: true },
        { id: "h3", text: "Nordic Roll Shot", hogwash: true },
      ],
    },
    {
      id: "books",
      themeLabel: "Book Publishing Terms",
      items: [
        { id: "r1", text: "Colophon", hogwash: false },
        { id: "r2", text: "Frontispiece", hogwash: false },
        { id: "r3", text: "Galley Proof", hogwash: false },
        { id: "r4", text: "Recto", hogwash: false },
        { id: "r5", text: "Verso", hogwash: false },
        { id: "r6", text: "Endpapers", hogwash: false },
        { id: "r7", text: "Bleed", hogwash: false },
        { id: "h1", text: "Creston Folio", hogwash: true },
        { id: "h2", text: "Valdoran Proof", hogwash: true },
        { id: "h3", text: "Nordic Imprint", hogwash: true },
      ],
    },
    {
      id: "cheese7",
      themeLabel: "Blue Cheeses",
      items: [
        { id: "r1", text: "Gorgonzola", hogwash: false },
        { id: "r2", text: "Roquefort", hogwash: false },
        { id: "r3", text: "Stilton", hogwash: false },
        { id: "r4", text: "Maytag Blue", hogwash: false },
        { id: "r5", text: "Cabrales", hogwash: false },
        { id: "r6", text: "Danish Blue", hogwash: false },
        { id: "r7", text: "Bleu d'Auvergne", hogwash: false },
        { id: "h1", text: "Creston Blue", hogwash: true },
        { id: "h2", text: "Valdoran Mold", hogwash: true },
        { id: "h3", text: "Nordic Blue", hogwash: true },
      ],
    },
    {
      id: "ocean2",
      themeLabel: "Underwater Geography",
      items: [
        { id: "r1", text: "Seamount", hogwash: false },
        { id: "r2", text: "Guyot", hogwash: false },
        { id: "r3", text: "Abyssal Plain", hogwash: false },
        { id: "r4", text: "Continental Shelf", hogwash: false },
        { id: "r5", text: "Ocean Trench", hogwash: false },
        { id: "r6", text: "Mid-Ocean Ridge", hogwash: false },
        { id: "r7", text: "Atoll", hogwash: false },
        { id: "h1", text: "Creston Ridge", hogwash: true },
        { id: "h2", text: "Valdoran Deep", hogwash: true },
        { id: "h3", text: "Nordic Basin", hogwash: true },
      ],
    },
    {
      id: "music7",
      themeLabel: "Percussion Instruments",
      items: [
        { id: "r1", text: "Djembe", hogwash: false },
        { id: "r2", text: "Cajon", hogwash: false },
        { id: "r3", text: "Bongos", hogwash: false },
        { id: "r4", text: "Tabla", hogwash: false },
        { id: "r5", text: "Tambourine", hogwash: false },
        { id: "r6", text: "Marimba", hogwash: false },
        { id: "r7", text: "Steel Pan", hogwash: false },
        { id: "h1", text: "Creston Drum", hogwash: true },
        { id: "h2", text: "Valdoran Bell", hogwash: true },
        { id: "h3", text: "Nordic Gong", hogwash: true },
      ],
    },
    {
      id: "astronomy7",
      themeLabel: "Notable Nebulae",
      items: [
        { id: "r1", text: "Orion Nebula", hogwash: false },
        { id: "r2", text: "Crab Nebula", hogwash: false },
        { id: "r3", text: "Pillars of Creation", hogwash: false },
        { id: "r4", text: "Horsehead Nebula", hogwash: false },
        { id: "r5", text: "Ring Nebula", hogwash: false },
        { id: "r6", text: "Helix Nebula", hogwash: false },
        { id: "r7", text: "Lagoon Nebula", hogwash: false },
        { id: "h1", text: "Creston Cloud", hogwash: true },
        { id: "h2", text: "Valdoran Veil", hogwash: true },
        { id: "h3", text: "Nordic Dust Ring", hogwash: true },
      ],
    },
    {
      id: "economics8",
      themeLabel: "Types of Tax",
      items: [
        { id: "r1", text: "Capital Gains Tax", hogwash: false },
        { id: "r2", text: "Excise Tax", hogwash: false },
        { id: "r3", text: "Estate Tax", hogwash: false },
        { id: "r4", text: "Payroll Tax", hogwash: false },
        { id: "r5", text: "Value Added Tax", hogwash: false },
        { id: "r6", text: "Withholding Tax", hogwash: false },
        { id: "r7", text: "Pigouvian Tax", hogwash: false },
        { id: "h1", text: "Creston Levy", hogwash: true },
        { id: "h2", text: "Valdoran Surcharge", hogwash: true },
        { id: "h3", text: "Nordic Duty", hogwash: true },
      ],
    },
    {
      id: "sports4",
      themeLabel: "Archery Terms",
      items: [
        { id: "r1", text: "Nocking", hogwash: false },
        { id: "r2", text: "Draw Length", hogwash: false },
        { id: "r3", text: "Fletching", hogwash: false },
        { id: "r4", text: "Anchor Point", hogwash: false },
        { id: "r5", text: "Clicker", hogwash: false },
        { id: "r6", text: "Spine", hogwash: false },
        { id: "r7", text: "Barebow", hogwash: false },
        { id: "h1", text: "Creston Draw", hogwash: true },
        { id: "h2", text: "Valdoran Release", hogwash: true },
        { id: "h3", text: "Nordic Arrow", hogwash: true },
      ],
    },
    {
      id: "design2",
      themeLabel: "UX Design Terms",
      items: [
        { id: "r1", text: "Wireframe", hogwash: false },
        { id: "r2", text: "Affordance", hogwash: false },
        { id: "r3", text: "Fitt's Law", hogwash: false },
        { id: "r4", text: "Card Sorting", hogwash: false },
        { id: "r5", text: "Heuristic Evaluation", hogwash: false },
        { id: "r6", text: "A/B Test", hogwash: false },
        { id: "r7", text: "User Journey", hogwash: false },
        { id: "h1", text: "Creston Flow", hogwash: true },
        { id: "h2", text: "Valdoran Map", hogwash: true },
        { id: "h3", text: "Nordic Prototype", hogwash: true },
      ],
    },
    {
      id: "astronomy8",
      themeLabel: "Planetary Features",
      items: [
        { id: "r1", text: "Olympus Mons", hogwash: false },
        { id: "r2", text: "Valles Marineris", hogwash: false },
        { id: "r3", text: "Great Red Spot", hogwash: false },
        { id: "r4", text: "Caloris Basin", hogwash: false },
        { id: "r5", text: "Hellas Planitia", hogwash: false },
        { id: "r6", text: "Cassini Division", hogwash: false },
        { id: "r7", text: "Maxwell Montes", hogwash: false },
        { id: "h1", text: "Creston Crater", hogwash: true },
        { id: "h2", text: "Valdoran Rift", hogwash: true },
        { id: "h3", text: "Nordic Plateau", hogwash: true },
      ],
    },
    {
      id: "cooking10",
      themeLabel: "Street Food by Country",
      items: [
        { id: "r1", text: "Som Tam (Thailand)", hogwash: false },
        { id: "r2", text: "Jiānbǐng (China)", hogwash: false },
        { id: "r3", text: "Arepas (Colombia)", hogwash: false },
        { id: "r4", text: "Currywurst (Germany)", hogwash: false },
        { id: "r5", text: "Poutine (Canada)", hogwash: false },
        { id: "r6", text: "Arancini (Italy)", hogwash: false },
        { id: "r7", text: "Doubles (Trinidad)", hogwash: false },
        { id: "h1", text: "Creston Wrap (Valdoria)", hogwash: true },
        { id: "h2", text: "Nordfry (Nordic)", hogwash: true },
        { id: "h3", text: "Crestbun (Crestania)", hogwash: true },
      ],
    },
    {
      id: "tech2",
      themeLabel: "Machine Learning Terms",
      items: [
        { id: "r1", text: "Overfitting", hogwash: false },
        { id: "r2", text: "Gradient Descent", hogwash: false },
        { id: "r3", text: "Backpropagation", hogwash: false },
        { id: "r4", text: "Dropout", hogwash: false },
        { id: "r5", text: "Epoch", hogwash: false },
        { id: "r6", text: "Tokenization", hogwash: false },
        { id: "r7", text: "Embedding", hogwash: false },
        { id: "h1", text: "Creston Pass", hogwash: true },
        { id: "h2", text: "Valdoran Weight", hogwash: true },
        { id: "h3", text: "Nordic Layer", hogwash: true },
      ],
    },
    {
      id: "tools2",
      themeLabel: "Hand Tool Types",
      items: [
        { id: "r1", text: "Claw Hammer", hogwash: false },
        { id: "r2", text: "Torque Wrench", hogwash: false },
        { id: "r3", text: "Allen Key", hogwash: false },
        { id: "r4", text: "Jigsaw", hogwash: false },
        { id: "r5", text: "Oscillating Tool", hogwash: false },
        { id: "r6", text: "Plumb Bob", hogwash: false },
        { id: "r7", text: "Level", hogwash: false },
        { id: "h1", text: "Creston Gauge", hogwash: true },
        { id: "h2", text: "Valdoran Mallet", hogwash: true },
        { id: "h3", text: "Nordic Square", hogwash: true },
      ],
    },
    {
      id: "literature3",
      themeLabel: "Narrative Points of View",
      items: [
        { id: "r1", text: "First Person", hogwash: false },
        { id: "r2", text: "Second Person", hogwash: false },
        { id: "r3", text: "Third-Person Limited", hogwash: false },
        { id: "r4", text: "Third-Person Omniscient", hogwash: false },
        { id: "r5", text: "Unreliable Narrator", hogwash: false },
        { id: "r6", text: "Free Indirect Discourse", hogwash: false },
        { id: "r7", text: "Stream of Consciousness", hogwash: false },
        { id: "h1", text: "Creston Viewpoint", hogwash: true },
        { id: "h2", text: "Valdoran Perspective", hogwash: true },
        { id: "h3", text: "Nordic Narrative Mode", hogwash: true },
      ],
    },
    {
      id: "medicine4",
      themeLabel: "Types of Scan & Imaging",
      items: [
        { id: "r1", text: "MRI", hogwash: false },
        { id: "r2", text: "CT Scan", hogwash: false },
        { id: "r3", text: "PET Scan", hogwash: false },
        { id: "r4", text: "Ultrasound", hogwash: false },
        { id: "r5", text: "DEXA Scan", hogwash: false },
        { id: "r6", text: "Fluoroscopy", hogwash: false },
        { id: "r7", text: "Angiography", hogwash: false },
        { id: "h1", text: "Creston Imaging", hogwash: true },
        { id: "h2", text: "Valdoran Scan", hogwash: true },
        { id: "h3", text: "Nordic Neural Map", hogwash: true },
      ],
    },
    {
      id: "animals4",
      themeLabel: "Penguin Species",
      items: [
        { id: "r1", text: "Emperor Penguin", hogwash: false },
        { id: "r2", text: "Chinstrap Penguin", hogwash: false },
        { id: "r3", text: "Rockhopper Penguin", hogwash: false },
        { id: "r4", text: "Macaroni Penguin", hogwash: false },
        { id: "r5", text: "Gentoo Penguin", hogwash: false },
        { id: "r6", text: "Little Blue Penguin", hogwash: false },
        { id: "r7", text: "African Penguin", hogwash: false },
        { id: "h1", text: "Creston Penguin", hogwash: true },
        { id: "h2", text: "Valdoran Ice Penguin", hogwash: true },
        { id: "h3", text: "Nordic Snow Penguin", hogwash: true },
      ],
    },
    {
      id: "history2",
      themeLabel: "Famous Speeches",
      items: [
        { id: "r1", text: "Gettysburg Address", hogwash: false },
        { id: "r2", text: "I Have a Dream", hogwash: false },
        { id: "r3", text: "Blood, Toil, Tears and Sweat", hogwash: false },
        { id: "r4", text: "Ich bin ein Berliner", hogwash: false },
        { id: "r5", text: "We Shall Fight on the Beaches", hogwash: false },
        { id: "r6", text: "Four Freedoms", hogwash: false },
        { id: "r7", text: "Ain't I a Woman", hogwash: false },
        { id: "h1", text: "The Creston Address", hogwash: true },
        { id: "h2", text: "The Valdoran Declaration", hogwash: true },
        { id: "h3", text: "Nordic Unity Speech", hogwash: true },
      ],
    },

    // ── BATCH 4: 100 NEW SETS ─────────────────────────────────────────────────

    // ── SPORTS ───────────────────────────────────────────────────────────────
    {
      id: "nfl_positions",
      themeLabel: "NFL Football Positions",
      items: [
        { id: "r1", text: "Cornerback", hogwash: false },
        { id: "r2", text: "Free Safety", hogwash: false },
        { id: "r3", text: "Nose Tackle", hogwash: false },
        { id: "r4", text: "Tight End", hogwash: false },
        { id: "r5", text: "Fullback", hogwash: false },
        { id: "r6", text: "Left Guard", hogwash: false },
        { id: "r7", text: "Sam Linebacker", hogwash: false },
        { id: "h1", text: "Slot Tackle", hogwash: true },
        { id: "h2", text: "Creston Back", hogwash: true },
        { id: "h3", text: "Nordic Rusher", hogwash: true },
      ],
    },
    {
      id: "nba_terms",
      themeLabel: "Basketball Terms",
      items: [
        { id: "r1", text: "Pick and Roll", hogwash: false },
        { id: "r2", text: "Alley-Oop", hogwash: false },
        { id: "r3", text: "Triple-Double", hogwash: false },
        { id: "r4", text: "Eurostep", hogwash: false },
        { id: "r5", text: "Paint Touch", hogwash: false },
        { id: "r6", text: "Box Out", hogwash: false },
        { id: "r7", text: "Zone Defense", hogwash: false },
        { id: "h1", text: "Creston Cut", hogwash: true },
        { id: "h2", text: "Valdoran Screen", hogwash: true },
        { id: "h3", text: "Nordic Trap", hogwash: true },
      ],
    },
    {
      id: "baseball_terms",
      themeLabel: "Baseball Terms",
      items: [
        { id: "r1", text: "Balk", hogwash: false },
        { id: "r2", text: "Squeeze Play", hogwash: false },
        { id: "r3", text: "Shift", hogwash: false },
        { id: "r4", text: "Pickoff", hogwash: false },
        { id: "r5", text: "Passed Ball", hogwash: false },
        { id: "r6", text: "Fielder's Choice", hogwash: false },
        { id: "r7", text: "Can of Corn", hogwash: false },
        { id: "h1", text: "Creston Count", hogwash: true },
        { id: "h2", text: "Valdoran Spin", hogwash: true },
        { id: "h3", text: "Nordic Bunt", hogwash: true },
      ],
    },
    {
      id: "tennis_terms",
      themeLabel: "Tennis Terms",
      items: [
        { id: "r1", text: "Topspin", hogwash: false },
        { id: "r2", text: "Slice", hogwash: false },
        { id: "r3", text: "Volley", hogwash: false },
        { id: "r4", text: "Drop Shot", hogwash: false },
        { id: "r5", text: "Bagel", hogwash: false },
        { id: "r6", text: "Moonball", hogwash: false },
        { id: "r7", text: "Tweener", hogwash: false },
        { id: "h1", text: "Creston Serve", hogwash: true },
        { id: "h2", text: "Valdoran Lob", hogwash: true },
        { id: "h3", text: "Nordic Cross", hogwash: true },
      ],
    },
    {
      id: "cricket_terms",
      themeLabel: "Cricket Terms",
      items: [
        { id: "r1", text: "Googly", hogwash: false },
        { id: "r2", text: "Yorker", hogwash: false },
        { id: "r3", text: "Maiden Over", hogwash: false },
        { id: "r4", text: "Doosra", hogwash: false },
        { id: "r5", text: "Silly Mid-On", hogwash: false },
        { id: "r6", text: "Flipper", hogwash: false },
        { id: "r7", text: "Chinaman", hogwash: false },
        { id: "h1", text: "Creston Swing", hogwash: true },
        { id: "h2", text: "Valdoran Yorker", hogwash: true },
        { id: "h3", text: "Nordic Bounce", hogwash: true },
      ],
    },
    {
      id: "olympic_swimming",
      themeLabel: "Olympic Swimming Events",
      items: [
        { id: "r1", text: "50m Freestyle", hogwash: false },
        { id: "r2", text: "200m Butterfly", hogwash: false },
        { id: "r3", text: "400m Individual Medley", hogwash: false },
        { id: "r4", text: "4×100m Medley Relay", hogwash: false },
        { id: "r5", text: "800m Freestyle", hogwash: false },
        { id: "r6", text: "100m Backstroke", hogwash: false },
        { id: "r7", text: "200m Breaststroke", hogwash: false },
        { id: "h1", text: "300m Combination", hogwash: true },
        { id: "h2", text: "150m Sprint Relay", hogwash: true },
        { id: "h3", text: "500m Nordic Medley", hogwash: true },
      ],
    },
    {
      id: "fencing_terms",
      themeLabel: "Fencing Terms",
      items: [
        { id: "r1", text: "Parry", hogwash: false },
        { id: "r2", text: "Riposte", hogwash: false },
        { id: "r3", text: "Lunge", hogwash: false },
        { id: "r4", text: "En Garde", hogwash: false },
        { id: "r5", text: "Fleche", hogwash: false },
        { id: "r6", text: "Corps-à-Corps", hogwash: false },
        { id: "r7", text: "Piste", hogwash: false },
        { id: "h1", text: "Creston Advance", hogwash: true },
        { id: "h2", text: "Valdoran Bind", hogwash: true },
        { id: "h3", text: "Nordic Thrust", hogwash: true },
      ],
    },
    {
      id: "bowling_terms",
      themeLabel: "Bowling Terms",
      items: [
        { id: "r1", text: "Turkey", hogwash: false },
        { id: "r2", text: "Brooklyn", hogwash: false },
        { id: "r3", text: "Hambone", hogwash: false },
        { id: "r4", text: "Sleeper", hogwash: false },
        { id: "r5", text: "Baby Split", hogwash: false },
        { id: "r6", text: "Bedposts", hogwash: false },
        { id: "r7", text: "Spare Leave", hogwash: false },
        { id: "h1", text: "Creston Roll", hogwash: true },
        { id: "h2", text: "Valdoran Strike", hogwash: true },
        { id: "h3", text: "Nordic Split", hogwash: true },
      ],
    },
    {
      id: "darts_terms",
      themeLabel: "Darts Terms",
      items: [
        { id: "r1", text: "Bullseye", hogwash: false },
        { id: "r2", text: "Double Out", hogwash: false },
        { id: "r3", text: "Shanghai", hogwash: false },
        { id: "r4", text: "Bust", hogwash: false },
        { id: "r5", text: "Madhouse", hogwash: false },
        { id: "r6", text: "Maximums", hogwash: false },
        { id: "r7", text: "Leg", hogwash: false },
        { id: "h1", text: "Creston Checkout", hogwash: true },
        { id: "h2", text: "Valdoran Ton", hogwash: true },
        { id: "h3", text: "Nordic Double", hogwash: true },
      ],
    },
    {
      id: "snooker_terms",
      themeLabel: "Snooker Terms",
      items: [
        { id: "r1", text: "Snooker", hogwash: false },
        { id: "r2", text: "Free Ball", hogwash: false },
        { id: "r3", text: "Century Break", hogwash: false },
        { id: "r4", text: "Cannon", hogwash: false },
        { id: "r5", text: "Stun Shot", hogwash: false },
        { id: "r6", text: "Cocked Hat", hogwash: false },
        { id: "r7", text: "Plant", hogwash: false },
        { id: "h1", text: "Creston Safety", hogwash: true },
        { id: "h2", text: "Valdoran Bridge", hogwash: true },
        { id: "h3", text: "Nordic Masse", hogwash: true },
      ],
    },

    // ── MATH & LOGIC ──────────────────────────────────────────────────────────
    {
      id: "roman_numerals",
      themeLabel: "Roman Numeral Rules",
      items: [
        { id: "r1", text: "I = 1", hogwash: false },
        { id: "r2", text: "IV = 4", hogwash: false },
        { id: "r3", text: "IX = 9", hogwash: false },
        { id: "r4", text: "XL = 40", hogwash: false },
        { id: "r5", text: "CD = 400", hogwash: false },
        { id: "r6", text: "CM = 900", hogwash: false },
        { id: "r7", text: "M = 1000", hogwash: false },
        { id: "h1", text: "VX = 5", hogwash: true },
        { id: "h2", text: "IC = 99", hogwash: true },
        { id: "h3", text: "LC = 50", hogwash: true },
      ],
    },
    {
      id: "periodic_groups",
      themeLabel: "Periodic Table Groups",
      items: [
        { id: "r1", text: "Alkali Metals", hogwash: false },
        { id: "r2", text: "Alkaline Earth Metals", hogwash: false },
        { id: "r3", text: "Transition Metals", hogwash: false },
        { id: "r4", text: "Halogens", hogwash: false },
        { id: "r5", text: "Noble Gases", hogwash: false },
        { id: "r6", text: "Lanthanides", hogwash: false },
        { id: "r7", text: "Actinides", hogwash: false },
        { id: "h1", text: "Creston Metals", hogwash: true },
        { id: "h2", text: "Valdoran Series", hogwash: true },
        { id: "h3", text: "Nordic Gases", hogwash: true },
      ],
    },
    {
      id: "math_theorems",
      themeLabel: "Famous Math Theorems",
      items: [
        { id: "r1", text: "Pythagorean Theorem", hogwash: false },
        { id: "r2", text: "Fermat's Last Theorem", hogwash: false },
        { id: "r3", text: "Gödel's Incompleteness", hogwash: false },
        { id: "r4", text: "Bayes' Theorem", hogwash: false },
        { id: "r5", text: "Four Color Theorem", hogwash: false },
        { id: "r6", text: "Euler's Identity", hogwash: false },
        { id: "r7", text: "Cantor's Diagonal", hogwash: false },
        { id: "h1", text: "Creston's Conjecture", hogwash: true },
        { id: "h2", text: "Valdoran Principle", hogwash: true },
        { id: "h3", text: "Nordic Limit Theorem", hogwash: true },
      ],
    },
    {
      id: "logic_symbols",
      themeLabel: "Logic & Set Notation",
      items: [
        { id: "r1", text: "∀ (For All)", hogwash: false },
        { id: "r2", text: "∃ (There Exists)", hogwash: false },
        { id: "r3", text: "∈ (Element Of)", hogwash: false },
        { id: "r4", text: "∪ (Union)", hogwash: false },
        { id: "r5", text: "∩ (Intersection)", hogwash: false },
        { id: "r6", text: "⊆ (Subset)", hogwash: false },
        { id: "r7", text: "¬ (Negation)", hogwash: false },
        { id: "h1", text: "⊗ (Valdoran)", hogwash: true },
        { id: "h2", text: "⊕ (Creston Op)", hogwash: true },
        { id: "h3", text: "⊘ (Nordic Null)", hogwash: true },
      ],
    },
    {
      id: "set_theory",
      themeLabel: "Set Theory Concepts",
      items: [
        { id: "r1", text: "Power Set", hogwash: false },
        { id: "r2", text: "Cardinality", hogwash: false },
        { id: "r3", text: "Complement", hogwash: false },
        { id: "r4", text: "Symmetric Difference", hogwash: false },
        { id: "r5", text: "Cartesian Product", hogwash: false },
        { id: "r6", text: "Empty Set", hogwash: false },
        { id: "r7", text: "Partition", hogwash: false },
        { id: "h1", text: "Creston Set", hogwash: true },
        { id: "h2", text: "Valdoran Class", hogwash: true },
        { id: "h3", text: "Nordic Boundary", hogwash: true },
      ],
    },

    // ── WRITING & LITERATURE ──────────────────────────────────────────────────
    {
      id: "literary_genres",
      themeLabel: "Literary Genres",
      items: [
        { id: "r1", text: "Picaresque", hogwash: false },
        { id: "r2", text: "Bildungsroman", hogwash: false },
        { id: "r3", text: "Epistolary", hogwash: false },
        { id: "r4", text: "Magical Realism", hogwash: false },
        { id: "r5", text: "Cli-Fi", hogwash: false },
        { id: "r6", text: "Solarpunk", hogwash: false },
        { id: "r7", text: "New Weird", hogwash: false },
        { id: "h1", text: "Valdoric Realism", hogwash: true },
        { id: "h2", text: "Creston Drama", hogwash: true },
        { id: "h3", text: "Nordic Fiction", hogwash: true },
      ],
    },
    {
      id: "narrative_structures",
      themeLabel: "Story Structure Frameworks",
      items: [
        { id: "r1", text: "Hero's Journey", hogwash: false },
        { id: "r2", text: "Three-Act Structure", hogwash: false },
        { id: "r3", text: "Kishōtenketsu", hogwash: false },
        { id: "r4", text: "Five-Act Structure", hogwash: false },
        { id: "r5", text: "In Medias Res", hogwash: false },
        { id: "r6", text: "Freytag's Pyramid", hogwash: false },
        { id: "r7", text: "Frame Narrative", hogwash: false },
        { id: "h1", text: "Creston Arc", hogwash: true },
        { id: "h2", text: "Valdoran Spine", hogwash: true },
        { id: "h3", text: "Nordic Thread", hogwash: true },
      ],
    },
    {
      id: "rhetorical_devices2",
      themeLabel: "More Rhetorical Devices",
      items: [
        { id: "r1", text: "Epistrophe", hogwash: false },
        { id: "r2", text: "Asyndeton", hogwash: false },
        { id: "r3", text: "Paralipsis", hogwash: false },
        { id: "r4", text: "Anadiplosis", hogwash: false },
        { id: "r5", text: "Tmesis", hogwash: false },
        { id: "r6", text: "Hendiadys", hogwash: false },
        { id: "r7", text: "Syllepsis", hogwash: false },
        { id: "h1", text: "Crestanesis", hogwash: true },
        { id: "h2", text: "Valdorismus", hogwash: true },
        { id: "h3", text: "Nordiplex", hogwash: true },
      ],
    },
    {
      id: "writing_styles",
      themeLabel: "Writing Styles",
      items: [
        { id: "r1", text: "Gonzo Journalism", hogwash: false },
        { id: "r2", text: "New Journalism", hogwash: false },
        { id: "r3", text: "Lyric Essay", hogwash: false },
        { id: "r4", text: "Flash Fiction", hogwash: false },
        { id: "r5", text: "Creative Nonfiction", hogwash: false },
        { id: "r6", text: "Prose Poetry", hogwash: false },
        { id: "r7", text: "Autofiction", hogwash: false },
        { id: "h1", text: "Creston Realism", hogwash: true },
        { id: "h2", text: "Valdoran Confessional", hogwash: true },
        { id: "h3", text: "Nordic Minimalism", hogwash: true },
      ],
    },
    {
      id: "journalism_terms",
      themeLabel: "Journalism Terms",
      items: [
        { id: "r1", text: "Lede", hogwash: false },
        { id: "r2", text: "Nut Graf", hogwash: false },
        { id: "r3", text: "Dateline", hogwash: false },
        { id: "r4", text: "Morgue", hogwash: false },
        { id: "r5", text: "Kicker", hogwash: false },
        { id: "r6", text: "Sidebar", hogwash: false },
        { id: "r7", text: "Masthead", hogwash: false },
        { id: "h1", text: "Creston Column", hogwash: true },
        { id: "h2", text: "Valdoran Brief", hogwash: true },
        { id: "h3", text: "Nordic Digest", hogwash: true },
      ],
    },

    // ── PLANTS & NATURE ───────────────────────────────────────────────────────
    {
      id: "interior_plants",
      themeLabel: "Popular Houseplants",
      items: [
        { id: "r1", text: "Pothos", hogwash: false },
        { id: "r2", text: "Monstera Deliciosa", hogwash: false },
        { id: "r3", text: "Snake Plant", hogwash: false },
        { id: "r4", text: "Fiddle-Leaf Fig", hogwash: false },
        { id: "r5", text: "ZZ Plant", hogwash: false },
        { id: "r6", text: "Calathea", hogwash: false },
        { id: "r7", text: "Peace Lily", hogwash: false },
        { id: "h1", text: "Creston Vine", hogwash: true },
        { id: "h2", text: "Valdoran Fern", hogwash: true },
        { id: "h3", text: "Nordic Leaf", hogwash: true },
      ],
    },
    {
      id: "succulents",
      themeLabel: "Succulent Types",
      items: [
        { id: "r1", text: "Echeveria", hogwash: false },
        { id: "r2", text: "Haworthia", hogwash: false },
        { id: "r3", text: "Sedum", hogwash: false },
        { id: "r4", text: "Gasteria", hogwash: false },
        { id: "r5", text: "Crassula", hogwash: false },
        { id: "r6", text: "Sempervivum", hogwash: false },
        { id: "r7", text: "Lithops", hogwash: false },
        { id: "h1", text: "Valdorveria", hogwash: true },
        { id: "h2", text: "Crestula", hogwash: true },
        { id: "h3", text: "Nordica", hogwash: true },
      ],
    },
    {
      id: "orchid_types",
      themeLabel: "Orchid Varieties",
      items: [
        { id: "r1", text: "Phalaenopsis", hogwash: false },
        { id: "r2", text: "Cattleya", hogwash: false },
        { id: "r3", text: "Dendrobium", hogwash: false },
        { id: "r4", text: "Oncidium", hogwash: false },
        { id: "r5", text: "Cymbidium", hogwash: false },
        { id: "r6", text: "Miltonia", hogwash: false },
        { id: "r7", text: "Zygopetalum", hogwash: false },
        { id: "h1", text: "Crestanium", hogwash: true },
        { id: "h2", text: "Valdorium", hogwash: true },
        { id: "h3", text: "Nordicum", hogwash: true },
      ],
    },
    {
      id: "bonsai_terms",
      themeLabel: "Bonsai Terms",
      items: [
        { id: "r1", text: "Nebari", hogwash: false },
        { id: "r2", text: "Jin", hogwash: false },
        { id: "r3", text: "Shari", hogwash: false },
        { id: "r4", text: "Apex", hogwash: false },
        { id: "r5", text: "Ramification", hogwash: false },
        { id: "r6", text: "Shohin", hogwash: false },
        { id: "r7", text: "Bunjin", hogwash: false },
        { id: "h1", text: "Creston Form", hogwash: true },
        { id: "h2", text: "Valdoran Trunk", hogwash: true },
        { id: "h3", text: "Nordic Pad", hogwash: true },
      ],
    },
    {
      id: "hydroponics",
      themeLabel: "Hydroponics & Growing Methods",
      items: [
        { id: "r1", text: "Deep Water Culture", hogwash: false },
        { id: "r2", text: "Ebb and Flow", hogwash: false },
        { id: "r3", text: "Nutrient Film Technique", hogwash: false },
        { id: "r4", text: "Aeroponics", hogwash: false },
        { id: "r5", text: "Kratky Method", hogwash: false },
        { id: "r6", text: "Wick System", hogwash: false },
        { id: "r7", text: "Dutch Bucket", hogwash: false },
        { id: "h1", text: "Creston Flow", hogwash: true },
        { id: "h2", text: "Valdoran Channel", hogwash: true },
        { id: "h3", text: "Nordic Root Method", hogwash: true },
      ],
    },

    // ── ANIMALS ───────────────────────────────────────────────────────────────
    {
      id: "dog_commands",
      themeLabel: "Dog Training Commands",
      items: [
        { id: "r1", text: "Heel", hogwash: false },
        { id: "r2", text: "Leave It", hogwash: false },
        { id: "r3", text: "Place", hogwash: false },
        { id: "r4", text: "Watch Me", hogwash: false },
        { id: "r5", text: "Off", hogwash: false },
        { id: "r6", text: "Stand", hogwash: false },
        { id: "r7", text: "Release", hogwash: false },
        { id: "h1", text: "Creston Hold", hogwash: true },
        { id: "h2", text: "Valdoran Rest", hogwash: true },
        { id: "h3", text: "Nordic Freeze", hogwash: true },
      ],
    },
    {
      id: "horse_gaits",
      themeLabel: "Horse Gaits & Movements",
      items: [
        { id: "r1", text: "Walk", hogwash: false },
        { id: "r2", text: "Trot", hogwash: false },
        { id: "r3", text: "Canter", hogwash: false },
        { id: "r4", text: "Gallop", hogwash: false },
        { id: "r5", text: "Piaffe", hogwash: false },
        { id: "r6", text: "Passage", hogwash: false },
        { id: "r7", text: "Levade", hogwash: false },
        { id: "h1", text: "Creston Pace", hogwash: true },
        { id: "h2", text: "Valdoran Stride", hogwash: true },
        { id: "h3", text: "Nordic Rack", hogwash: true },
      ],
    },
    {
      id: "bird_songs",
      themeLabel: "Bird Song Terms",
      items: [
        { id: "r1", text: "Call", hogwash: false },
        { id: "r2", text: "Song", hogwash: false },
        { id: "r3", text: "Duet", hogwash: false },
        { id: "r4", text: "Subsong", hogwash: false },
        { id: "r5", text: "Alarm Call", hogwash: false },
        { id: "r6", text: "Contact Call", hogwash: false },
        { id: "r7", text: "Dawn Chorus", hogwash: false },
        { id: "h1", text: "Creston Trill", hogwash: true },
        { id: "h2", text: "Valdoran Warble", hogwash: true },
        { id: "h3", text: "Nordic Chirp Type", hogwash: true },
      ],
    },
    {
      id: "aquatic_mammals",
      themeLabel: "Aquatic Mammals",
      items: [
        { id: "r1", text: "Dugong", hogwash: false },
        { id: "r2", text: "Narwhal", hogwash: false },
        { id: "r3", text: "Beluga Whale", hogwash: false },
        { id: "r4", text: "Boto", hogwash: false },
        { id: "r5", text: "Sea Otter", hogwash: false },
        { id: "r6", text: "Walrus", hogwash: false },
        { id: "r7", text: "Vaquita", hogwash: false },
        { id: "h1", text: "Creston Seal", hogwash: true },
        { id: "h2", text: "Valdoran Porpoise", hogwash: true },
        { id: "h3", text: "Nordic Manatee", hogwash: true },
      ],
    },
    {
      id: "nocturnal_animals",
      themeLabel: "Nocturnal Animals",
      items: [
        { id: "r1", text: "Binturong", hogwash: false },
        { id: "r2", text: "Fossa", hogwash: false },
        { id: "r3", text: "Kinkajou", hogwash: false },
        { id: "r4", text: "Aardvark", hogwash: false },
        { id: "r5", text: "Tenrec", hogwash: false },
        { id: "r6", text: "Civit", hogwash: false },
        { id: "r7", text: "Pangolin", hogwash: false },
        { id: "h1", text: "Creston Glider", hogwash: true },
        { id: "h2", text: "Valdoran Cat", hogwash: true },
        { id: "h3", text: "Nordic Night Fox", hogwash: true },
      ],
    },

    // ── HISTORY ───────────────────────────────────────────────────────────────
    {
      id: "ancient_tools",
      themeLabel: "Ancient Tools & Inventions",
      items: [
        { id: "r1", text: "Atlatl", hogwash: false },
        { id: "r2", text: "Adze", hogwash: false },
        { id: "r3", text: "Borer", hogwash: false },
        { id: "r4", text: "Burin", hogwash: false },
        { id: "r5", text: "Shaduf", hogwash: false },
        { id: "r6", text: "Quern", hogwash: false },
        { id: "r7", text: "Flint Knapper", hogwash: false },
        { id: "h1", text: "Creston Scraper", hogwash: true },
        { id: "h2", text: "Valdoran Drill", hogwash: true },
        { id: "h3", text: "Nordic Bone Pick", hogwash: true },
      ],
    },
    {
      id: "stone_age_terms",
      themeLabel: "Stone Age Terms",
      items: [
        { id: "r1", text: "Paleolithic", hogwash: false },
        { id: "r2", text: "Mesolithic", hogwash: false },
        { id: "r3", text: "Neolithic", hogwash: false },
        { id: "r4", text: "Megalith", hogwash: false },
        { id: "r5", text: "Microlith", hogwash: false },
        { id: "r6", text: "Midden", hogwash: false },
        { id: "r7", text: "Cairn", hogwash: false },
        { id: "h1", text: "Valdoran Period", hogwash: true },
        { id: "h2", text: "Crestolithic", hogwash: true },
        { id: "h3", text: "Nordic Age", hogwash: true },
      ],
    },
    {
      id: "bronze_age",
      themeLabel: "Bronze Age Civilizations",
      items: [
        { id: "r1", text: "Mycenaean Greece", hogwash: false },
        { id: "r2", text: "Hittite Empire", hogwash: false },
        { id: "r3", text: "Shang Dynasty", hogwash: false },
        { id: "r4", text: "Ugarit", hogwash: false },
        { id: "r5", text: "Elam", hogwash: false },
        { id: "r6", text: "Nuragic Sardinia", hogwash: false },
        { id: "r7", text: "Canaan", hogwash: false },
        { id: "h1", text: "Valdoran Kingdom", hogwash: true },
        { id: "h2", text: "Creston Confederation", hogwash: true },
        { id: "h3", text: "Nordic Union", hogwash: true },
      ],
    },
    {
      id: "iron_age",
      themeLabel: "Iron Age Peoples",
      items: [
        { id: "r1", text: "Celts", hogwash: false },
        { id: "r2", text: "Scythians", hogwash: false },
        { id: "r3", text: "Iberians", hogwash: false },
        { id: "r4", text: "Dacians", hogwash: false },
        { id: "r5", text: "Gauls", hogwash: false },
        { id: "r6", text: "Samnites", hogwash: false },
        { id: "r7", text: "Hallstatt Culture", hogwash: false },
        { id: "h1", text: "Valdorians", hogwash: true },
        { id: "h2", text: "Crestani Tribe", hogwash: true },
        { id: "h3", text: "Nordic Folk", hogwash: true },
      ],
    },
    {
      id: "medieval_terms",
      themeLabel: "Medieval Terms",
      items: [
        { id: "r1", text: "Feudalism", hogwash: false },
        { id: "r2", text: "Tithe", hogwash: false },
        { id: "r3", text: "Trebuchet", hogwash: false },
        { id: "r4", text: "Scutage", hogwash: false },
        { id: "r5", text: "Demesne", hogwash: false },
        { id: "r6", text: "Chivalry", hogwash: false },
        { id: "r7", text: "Guildhall", hogwash: false },
        { id: "h1", text: "Crestanage", hogwash: true },
        { id: "h2", text: "Valdoran Levy", hogwash: true },
        { id: "h3", text: "Nordic Pledge", hogwash: true },
      ],
    },
    {
      id: "renaissance_terms",
      themeLabel: "Renaissance Terms",
      items: [
        { id: "r1", text: "Humanism", hogwash: false },
        { id: "r2", text: "Patronage", hogwash: false },
        { id: "r3", text: "Perspectiva", hogwash: false },
        { id: "r4", text: "Polymath", hogwash: false },
        { id: "r5", text: "Studiolo", hogwash: false },
        { id: "r6", text: "Condottiere", hogwash: false },
        { id: "r7", text: "Sprezzatura", hogwash: false },
        { id: "h1", text: "Crestanismo", hogwash: true },
        { id: "h2", text: "Valdoran Ideal", hogwash: true },
        { id: "h3", text: "Nordic Virtue", hogwash: true },
      ],
    },
    {
      id: "industrial_revolution",
      themeLabel: "Industrial Revolution Terms",
      items: [
        { id: "r1", text: "Spinning Jenny", hogwash: false },
        { id: "r2", text: "Steam Engine", hogwash: false },
        { id: "r3", text: "Enclosure Movement", hogwash: false },
        { id: "r4", text: "Luddite", hogwash: false },
        { id: "r5", text: "Puddling Process", hogwash: false },
        { id: "r6", text: "Flying Shuttle", hogwash: false },
        { id: "r7", text: "Coke Smelting", hogwash: false },
        { id: "h1", text: "Creston Loom", hogwash: true },
        { id: "h2", text: "Valdoran Press", hogwash: true },
        { id: "h3", text: "Nordic Forge", hogwash: true },
      ],
    },
    {
      id: "cold_war_terms",
      themeLabel: "Cold War Terms",
      items: [
        { id: "r1", text: "Détente", hogwash: false },
        { id: "r2", text: "Mutually Assured Destruction", hogwash: false },
        { id: "r3", text: "Iron Curtain", hogwash: false },
        { id: "r4", text: "Domino Theory", hogwash: false },
        { id: "r5", text: "Brinkmanship", hogwash: false },
        { id: "r6", text: "Proxy War", hogwash: false },
        { id: "r7", text: "Glasnost", hogwash: false },
        { id: "h1", text: "Creston Doctrine", hogwash: true },
        { id: "h2", text: "Valdoran Pact", hogwash: true },
        { id: "h3", text: "Nordic Shield Plan", hogwash: true },
      ],
    },
    {
      id: "space_race",
      themeLabel: "Space Race Milestones",
      items: [
        { id: "r1", text: "Sputnik", hogwash: false },
        { id: "r2", text: "Vostok 1", hogwash: false },
        { id: "r3", text: "Apollo 11", hogwash: false },
        { id: "r4", text: "Gemini Program", hogwash: false },
        { id: "r5", text: "Luna 9", hogwash: false },
        { id: "r6", text: "Skylab", hogwash: false },
        { id: "r7", text: "Apollo-Soyuz", hogwash: false },
        { id: "h1", text: "Project Creston", hogwash: true },
        { id: "h2", text: "Valdoran 1", hogwash: true },
        { id: "h3", text: "Nordic Star Mission", hogwash: true },
      ],
    },
    {
      id: "digital_age",
      themeLabel: "Digital Age Milestones",
      items: [
        { id: "r1", text: "World Wide Web", hogwash: false },
        { id: "r2", text: "First iPhone", hogwash: false },
        { id: "r3", text: "ARPANET", hogwash: false },
        { id: "r4", text: "Moore's Law", hogwash: false },
        { id: "r5", text: "Open Source Movement", hogwash: false },
        { id: "r6", text: "Dot-Com Boom", hogwash: false },
        { id: "r7", text: "Social Media Rise", hogwash: false },
        { id: "h1", text: "Creston Protocol", hogwash: true },
        { id: "h2", text: "Valdoran Net", hogwash: true },
        { id: "h3", text: "Nordic Grid Launch", hogwash: true },
      ],
    },

    // ── DRINKS & FOOD ─────────────────────────────────────────────────────────
    {
      id: "cocktail_garnishes",
      themeLabel: "Cocktail Garnishes",
      items: [
        { id: "r1", text: "Maraschino Cherry", hogwash: false },
        { id: "r2", text: "Dehydrated Citrus", hogwash: false },
        { id: "r3", text: "Cocktail Onion", hogwash: false },
        { id: "r4", text: "Edible Flower", hogwash: false },
        { id: "r5", text: "Smoked Salt Rim", hogwash: false },
        { id: "r6", text: "Cucumber Ribbon", hogwash: false },
        { id: "r7", text: "Expressed Peel", hogwash: false },
        { id: "h1", text: "Creston Sprig", hogwash: true },
        { id: "h2", text: "Valdoran Zest", hogwash: true },
        { id: "h3", text: "Nordic Bitters Drop", hogwash: true },
      ],
    },
    {
      id: "mocktail_styles",
      themeLabel: "Non-Alcoholic Cocktail Styles",
      items: [
        { id: "r1", text: "Shrub Soda", hogwash: false },
        { id: "r2", text: "Zero-Proof Spritz", hogwash: false },
        { id: "r3", text: "Adaptogen Tonic", hogwash: false },
        { id: "r4", text: "Drinking Vinegar", hogwash: false },
        { id: "r5", text: "Seedlip Sour", hogwash: false },
        { id: "r6", text: "Botanical Fizz", hogwash: false },
        { id: "r7", text: "Mushroom Latte", hogwash: false },
        { id: "h1", text: "Creston Blend", hogwash: true },
        { id: "h2", text: "Valdoran Free Pour", hogwash: true },
        { id: "h3", text: "Nordic Calm", hogwash: true },
      ],
    },
    {
      id: "tea_ceremonies2",
      themeLabel: "Tea Traditions Around the World",
      items: [
        { id: "r1", text: "Gongfu Cha (China)", hogwash: false },
        { id: "r2", text: "Chanoyu (Japan)", hogwash: false },
        { id: "r3", text: "Chai (India)", hogwash: false },
        { id: "r4", text: "Samovar Tea (Russia)", hogwash: false },
        { id: "r5", text: "Mint Tea (Morocco)", hogwash: false },
        { id: "r6", text: "Butter Tea (Tibet)", hogwash: false },
        { id: "r7", text: "Afternoon Tea (Britain)", hogwash: false },
        { id: "h1", text: "Creston Brew (Valdoria)", hogwash: true },
        { id: "h2", text: "Nordic Steep", hogwash: true },
        { id: "h3", text: "Crestano Ceremony", hogwash: true },
      ],
    },
    {
      id: "coffee_brewing",
      themeLabel: "Coffee Brewing Methods",
      items: [
        { id: "r1", text: "Pour Over", hogwash: false },
        { id: "r2", text: "French Press", hogwash: false },
        { id: "r3", text: "AeroPress", hogwash: false },
        { id: "r4", text: "Moka Pot", hogwash: false },
        { id: "r5", text: "Cold Brew", hogwash: false },
        { id: "r6", text: "Siphon", hogwash: false },
        { id: "r7", text: "Chemex", hogwash: false },
        { id: "h1", text: "Creston Drip", hogwash: true },
        { id: "h2", text: "Valdoran Press", hogwash: true },
        { id: "h3", text: "Nordic Steep", hogwash: true },
      ],
    },
    {
      id: "fermentation2",
      themeLabel: "Fermentation Vessels & Tools",
      items: [
        { id: "r1", text: "Carboy", hogwash: false },
        { id: "r2", text: "Crock", hogwash: false },
        { id: "r3", text: "Airlock", hogwash: false },
        { id: "r4", text: "Brine Weight", hogwash: false },
        { id: "r5", text: "Fermentation Crock", hogwash: false },
        { id: "r6", text: "pH Meter", hogwash: false },
        { id: "r7", text: "Hydrometer", hogwash: false },
        { id: "h1", text: "Creston Vessel", hogwash: true },
        { id: "h2", text: "Valdoran Jar", hogwash: true },
        { id: "h3", text: "Nordic Brine Pot", hogwash: true },
      ],
    },
    {
      id: "sushi_fish",
      themeLabel: "Fish Used in Sushi",
      items: [
        { id: "r1", text: "Bluefin Tuna", hogwash: false },
        { id: "r2", text: "Yellowtail", hogwash: false },
        { id: "r3", text: "Eel", hogwash: false },
        { id: "r4", text: "Sea Bream", hogwash: false },
        { id: "r5", text: "Amberjack", hogwash: false },
        { id: "r6", text: "Mackerel", hogwash: false },
        { id: "r7", text: "Flounder", hogwash: false },
        { id: "h1", text: "Creston Bass", hogwash: true },
        { id: "h2", text: "Valdoran Snapper", hogwash: true },
        { id: "h3", text: "Nordic Tuna", hogwash: true },
      ],
    },
    {
      id: "ramen_types",
      themeLabel: "Ramen Styles",
      items: [
        { id: "r1", text: "Tonkotsu", hogwash: false },
        { id: "r2", text: "Shoyu", hogwash: false },
        { id: "r3", text: "Miso Ramen", hogwash: false },
        { id: "r4", text: "Shio Ramen", hogwash: false },
        { id: "r5", text: "Tsukemen", hogwash: false },
        { id: "r6", text: "Mazemen", hogwash: false },
        { id: "r7", text: "Abura Soba", hogwash: false },
        { id: "h1", text: "Creston Broth", hogwash: true },
        { id: "h2", text: "Valdoran Tan", hogwash: true },
        { id: "h3", text: "Nordic Noodle", hogwash: true },
      ],
    },
    {
      id: "dim_sum",
      themeLabel: "Dim Sum Dishes",
      items: [
        { id: "r1", text: "Har Gow", hogwash: false },
        { id: "r2", text: "Siu Mai", hogwash: false },
        { id: "r3", text: "Cheung Fun", hogwash: false },
        { id: "r4", text: "Lo Mai Gai", hogwash: false },
        { id: "r5", text: "Char Siu Bao", hogwash: false },
        { id: "r6", text: "Egg Tart", hogwash: false },
        { id: "r7", text: "Turnip Cake", hogwash: false },
        { id: "h1", text: "Creston Bun", hogwash: true },
        { id: "h2", text: "Valdoran Dumpling", hogwash: true },
        { id: "h3", text: "Nordic Roll", hogwash: true },
      ],
    },
    {
      id: "tapas_dishes",
      themeLabel: "Spanish Tapas",
      items: [
        { id: "r1", text: "Patatas Bravas", hogwash: false },
        { id: "r2", text: "Gambas al Ajillo", hogwash: false },
        { id: "r3", text: "Croquetas", hogwash: false },
        { id: "r4", text: "Tortilla Española", hogwash: false },
        { id: "r5", text: "Pimientos de Padrón", hogwash: false },
        { id: "r6", text: "Boquerones", hogwash: false },
        { id: "r7", text: "Jamón Ibérico", hogwash: false },
        { id: "h1", text: "Creston Frito", hogwash: true },
        { id: "h2", text: "Valdoran Bocado", hogwash: true },
        { id: "h3", text: "Nordic Pincho", hogwash: true },
      ],
    },
    {
      id: "mezze_dishes",
      themeLabel: "Middle Eastern Mezze",
      items: [
        { id: "r1", text: "Hummus", hogwash: false },
        { id: "r2", text: "Mutabal", hogwash: false },
        { id: "r3", text: "Kibbeh", hogwash: false },
        { id: "r4", text: "Fattoush", hogwash: false },
        { id: "r5", text: "Labneh", hogwash: false },
        { id: "r6", text: "Dolma", hogwash: false },
        { id: "r7", text: "Shanklish", hogwash: false },
        { id: "h1", text: "Creston Dip", hogwash: true },
        { id: "h2", text: "Valdoran Spread", hogwash: true },
        { id: "h3", text: "Nordic Plate", hogwash: true },
      ],
    },

    // ── CRAFTS & TEXTILES ─────────────────────────────────────────────────────
    {
      id: "knitting2",
      themeLabel: "Knitting Stitch Patterns",
      items: [
        { id: "r1", text: "Seed Stitch", hogwash: false },
        { id: "r2", text: "Moss Stitch", hogwash: false },
        { id: "r3", text: "Cable Stitch", hogwash: false },
        { id: "r4", text: "Lace Stitch", hogwash: false },
        { id: "r5", text: "Fair Isle", hogwash: false },
        { id: "r6", text: "Brioche Stitch", hogwash: false },
        { id: "r7", text: "Entrelac", hogwash: false },
        { id: "h1", text: "Creston Cross", hogwash: true },
        { id: "h2", text: "Valdoran Loop", hogwash: true },
        { id: "h3", text: "Nordic Weave Stitch", hogwash: true },
      ],
    },
    {
      id: "embroidery_stitches",
      themeLabel: "Embroidery Stitches",
      items: [
        { id: "r1", text: "Satin Stitch", hogwash: false },
        { id: "r2", text: "French Knot", hogwash: false },
        { id: "r3", text: "Lazy Daisy", hogwash: false },
        { id: "r4", text: "Stem Stitch", hogwash: false },
        { id: "r5", text: "Chain Stitch", hogwash: false },
        { id: "r6", text: "Herringbone Stitch", hogwash: false },
        { id: "r7", text: "Feather Stitch", hogwash: false },
        { id: "h1", text: "Creston Fill", hogwash: true },
        { id: "h2", text: "Valdoran Knot", hogwash: true },
        { id: "h3", text: "Nordic Cross Stitch", hogwash: true },
      ],
    },
    {
      id: "lace_making",
      themeLabel: "Lace Making Styles",
      items: [
        { id: "r1", text: "Bobbin Lace", hogwash: false },
        { id: "r2", text: "Needle Lace", hogwash: false },
        { id: "r3", text: "Tatting", hogwash: false },
        { id: "r4", text: "Knitted Lace", hogwash: false },
        { id: "r5", text: "Bruges Lace", hogwash: false },
        { id: "r6", text: "Venetian Lace", hogwash: false },
        { id: "r7", text: "Torchon Lace", hogwash: false },
        { id: "h1", text: "Creston Weave", hogwash: true },
        { id: "h2", text: "Valdoran Thread", hogwash: true },
        { id: "h3", text: "Nordic Net", hogwash: true },
      ],
    },
    {
      id: "macrame_terms",
      themeLabel: "Macramé Knot Types",
      items: [
        { id: "r1", text: "Square Knot", hogwash: false },
        { id: "r2", text: "Lark's Head", hogwash: false },
        { id: "r3", text: "Spiral Knot", hogwash: false },
        { id: "r4", text: "Half Hitch", hogwash: false },
        { id: "r5", text: "Gathering Knot", hogwash: false },
        { id: "r6", text: "Josephine Knot", hogwash: false },
        { id: "r7", text: "Berry Knot", hogwash: false },
        { id: "h1", text: "Creston Bind", hogwash: true },
        { id: "h2", text: "Valdoran Wrap", hogwash: true },
        { id: "h3", text: "Nordic Loop", hogwash: true },
      ],
    },
    {
      id: "weaving_terms",
      themeLabel: "Weaving Terms",
      items: [
        { id: "r1", text: "Warp", hogwash: false },
        { id: "r2", text: "Weft", hogwash: false },
        { id: "r3", text: "Heddle", hogwash: false },
        { id: "r4", text: "Shuttle", hogwash: false },
        { id: "r5", text: "Selvedge", hogwash: false },
        { id: "r6", text: "Tabby Weave", hogwash: false },
        { id: "r7", text: "Twill Weave", hogwash: false },
        { id: "h1", text: "Creston Loom", hogwash: true },
        { id: "h2", text: "Valdoran Reed", hogwash: true },
        { id: "h3", text: "Nordic Shed", hogwash: true },
      ],
    },

    // ── GLASS & CERAMICS ──────────────────────────────────────────────────────
    {
      id: "stained_glass",
      themeLabel: "Stained Glass Terms",
      items: [
        { id: "r1", text: "Came", hogwash: false },
        { id: "r2", text: "Grozing", hogwash: false },
        { id: "r3", text: "Kiln Firing", hogwash: false },
        { id: "r4", text: "Cartoon", hogwash: false },
        { id: "r5", text: "Flash Glass", hogwash: false },
        { id: "r6", text: "Foiling", hogwash: false },
        { id: "r7", text: "Grisaille", hogwash: false },
        { id: "h1", text: "Creston Lead", hogwash: true },
        { id: "h2", text: "Valdoran Panel", hogwash: true },
        { id: "h3", text: "Nordic Fuse", hogwash: true },
      ],
    },
    {
      id: "mosaic_terms",
      themeLabel: "Mosaic Art Terms",
      items: [
        { id: "r1", text: "Tesserae", hogwash: false },
        { id: "r2", text: "Andamento", hogwash: false },
        { id: "r3", text: "Grout", hogwash: false },
        { id: "r4", text: "Smalti", hogwash: false },
        { id: "r5", text: "Opus Regulatum", hogwash: false },
        { id: "r6", text: "Opus Vermiculatum", hogwash: false },
        { id: "r7", text: "Millefiori", hogwash: false },
        { id: "h1", text: "Creston Tile", hogwash: true },
        { id: "h2", text: "Valdoran Inlay", hogwash: true },
        { id: "h3", text: "Nordic Set", hogwash: true },
      ],
    },
    {
      id: "glass_blowing",
      themeLabel: "Glass Blowing Terms",
      items: [
        { id: "r1", text: "Gather", hogwash: false },
        { id: "r2", text: "Punty", hogwash: false },
        { id: "r3", text: "Marver", hogwash: false },
        { id: "r4", text: "Blowpipe", hogwash: false },
        { id: "r5", text: "Annealing Oven", hogwash: false },
        { id: "r6", text: "Casing", hogwash: false },
        { id: "r7", text: "Parison", hogwash: false },
        { id: "h1", text: "Creston Gather", hogwash: true },
        { id: "h2", text: "Valdoran Bubble", hogwash: true },
        { id: "h3", text: "Nordic Mold", hogwash: true },
      ],
    },
    {
      id: "ceramics2",
      themeLabel: "Ceramic Firing Types",
      items: [
        { id: "r1", text: "Oxidation Firing", hogwash: false },
        { id: "r2", text: "Reduction Firing", hogwash: false },
        { id: "r3", text: "Soda Firing", hogwash: false },
        { id: "r4", text: "Wood Firing", hogwash: false },
        { id: "r5", text: "Salt Glaze", hogwash: false },
        { id: "r6", text: "Pit Firing", hogwash: false },
        { id: "r7", text: "Saggar Firing", hogwash: false },
        { id: "h1", text: "Creston Kiln", hogwash: true },
        { id: "h2", text: "Valdoran Flame", hogwash: true },
        { id: "h3", text: "Nordic Gas Fire", hogwash: true },
      ],
    },
    {
      id: "jewelry_making",
      themeLabel: "Jewelry Making Terms",
      items: [
        { id: "r1", text: "Bezel Setting", hogwash: false },
        { id: "r2", text: "Prong Setting", hogwash: false },
        { id: "r3", text: "Soldering", hogwash: false },
        { id: "r4", text: "Chasing", hogwash: false },
        { id: "r5", text: "Repoussé", hogwash: false },
        { id: "r6", text: "Granulation", hogwash: false },
        { id: "r7", text: "Filigree", hogwash: false },
        { id: "h1", text: "Creston Setting", hogwash: true },
        { id: "h2", text: "Valdoran Mount", hogwash: true },
        { id: "h3", text: "Nordic Inlay", hogwash: true },
      ],
    },

    // ── MEDIA & CULTURE ───────────────────────────────────────────────────────
    {
      id: "podcast_genres",
      themeLabel: "Podcast Genres",
      items: [
        { id: "r1", text: "True Crime", hogwash: false },
        { id: "r2", text: "Narrative Nonfiction", hogwash: false },
        { id: "r3", text: "Interview Format", hogwash: false },
        { id: "r4", text: "Roundtable", hogwash: false },
        { id: "r5", text: "Comedy", hogwash: false },
        { id: "r6", text: "Bite-Sized Daily", hogwash: false },
        { id: "r7", text: "Solo Monologue", hogwash: false },
        { id: "h1", text: "Creston Cast", hogwash: true },
        { id: "h2", text: "Valdoran Series", hogwash: true },
        { id: "h3", text: "Nordic Dispatch", hogwash: true },
      ],
    },
    {
      id: "documentary_styles",
      themeLabel: "Documentary Styles",
      items: [
        { id: "r1", text: "Observational", hogwash: false },
        { id: "r2", text: "Expository", hogwash: false },
        { id: "r3", text: "Participatory", hogwash: false },
        { id: "r4", text: "Reflexive", hogwash: false },
        { id: "r5", text: "Performative", hogwash: false },
        { id: "r6", text: "Poetic", hogwash: false },
        { id: "r7", text: "Mockumentary", hogwash: false },
        { id: "h1", text: "Creston Style", hogwash: true },
        { id: "h2", text: "Valdoran Mode", hogwash: true },
        { id: "h3", text: "Nordic Lens", hogwash: true },
      ],
    },
    {
      id: "podcast_terms",
      themeLabel: "Audio Production Terms",
      items: [
        { id: "r1", text: "Room Tone", hogwash: false },
        { id: "r2", text: "Dynamic Range", hogwash: false },
        { id: "r3", text: "Pop Filter", hogwash: false },
        { id: "r4", text: "Noise Floor", hogwash: false },
        { id: "r5", text: "Gain Staging", hogwash: false },
        { id: "r6", text: "Proximity Effect", hogwash: false },
        { id: "r7", text: "Loudness Normalization", hogwash: false },
        { id: "h1", text: "Creston Level", hogwash: true },
        { id: "h2", text: "Valdoran Mix", hogwash: true },
        { id: "h3", text: "Nordic Floor", hogwash: true },
      ],
    },
    {
      id: "radio_formats",
      themeLabel: "Radio Station Formats",
      items: [
        { id: "r1", text: "Top 40", hogwash: false },
        { id: "r2", text: "Adult Contemporary", hogwash: false },
        { id: "r3", text: "Classic Rock", hogwash: false },
        { id: "r4", text: "News/Talk", hogwash: false },
        { id: "r5", text: "Country", hogwash: false },
        { id: "r6", text: "Urban Contemporary", hogwash: false },
        { id: "r7", text: "Smooth Jazz", hogwash: false },
        { id: "h1", text: "Creston FM", hogwash: true },
        { id: "h2", text: "Valdoran Mix", hogwash: true },
        { id: "h3", text: "Nordic Sound", hogwash: true },
      ],
    },
    {
      id: "broadcast_terms",
      themeLabel: "TV Broadcasting Terms",
      items: [
        { id: "r1", text: "Chyron", hogwash: false },
        { id: "r2", text: "B-Roll", hogwash: false },
        { id: "r3", text: "Stand-Up", hogwash: false },
        { id: "r4", text: "Package", hogwash: false },
        { id: "r5", text: "SOT", hogwash: false },
        { id: "r6", text: "Lower Third", hogwash: false },
        { id: "r7", text: "Crawl", hogwash: false },
        { id: "h1", text: "Creston Banner", hogwash: true },
        { id: "h2", text: "Valdoran Ticker", hogwash: true },
        { id: "h3", text: "Nordic Slate", hogwash: true },
      ],
    },

    // ── PHILOSOPHY ────────────────────────────────────────────────────────────
    {
      id: "philosophy_schools",
      themeLabel: "Schools of Philosophy",
      items: [
        { id: "r1", text: "Stoicism", hogwash: false },
        { id: "r2", text: "Epicureanism", hogwash: false },
        { id: "r3", text: "Cynicism", hogwash: false },
        { id: "r4", text: "Pragmatism", hogwash: false },
        { id: "r5", text: "Existentialism", hogwash: false },
        { id: "r6", text: "Nihilism", hogwash: false },
        { id: "r7", text: "Absurdism", hogwash: false },
        { id: "h1", text: "Valdorism", hogwash: true },
        { id: "h2", text: "Crestanism", hogwash: true },
        { id: "h3", text: "Nordicism", hogwash: true },
      ],
    },
    {
      id: "ethics_theories",
      themeLabel: "Ethical Theories",
      items: [
        { id: "r1", text: "Deontology", hogwash: false },
        { id: "r2", text: "Consequentialism", hogwash: false },
        { id: "r3", text: "Virtue Ethics", hogwash: false },
        { id: "r4", text: "Care Ethics", hogwash: false },
        { id: "r5", text: "Contractarianism", hogwash: false },
        { id: "r6", text: "Divine Command Theory", hogwash: false },
        { id: "r7", text: "Moral Relativism", hogwash: false },
        { id: "h1", text: "Creston Ethics", hogwash: true },
        { id: "h2", text: "Valdoran Moralism", hogwash: true },
        { id: "h3", text: "Nordic Rationalism", hogwash: true },
      ],
    },
    {
      id: "metaphysics_terms",
      themeLabel: "Metaphysics Terms",
      items: [
        { id: "r1", text: "Substance", hogwash: false },
        { id: "r2", text: "Causality", hogwash: false },
        { id: "r3", text: "Free Will", hogwash: false },
        { id: "r4", text: "Determinism", hogwash: false },
        { id: "r5", text: "Modal Logic", hogwash: false },
        { id: "r6", text: "Possible Worlds", hogwash: false },
        { id: "r7", text: "Universals", hogwash: false },
        { id: "h1", text: "Creston Reality", hogwash: true },
        { id: "h2", text: "Valdoran Essence", hogwash: true },
        { id: "h3", text: "Nordic Being", hogwash: true },
      ],
    },
    {
      id: "epistemology2",
      themeLabel: "Epistemology Terms",
      items: [
        { id: "r1", text: "A Priori", hogwash: false },
        { id: "r2", text: "A Posteriori", hogwash: false },
        { id: "r3", text: "Justified True Belief", hogwash: false },
        { id: "r4", text: "Gettier Problem", hogwash: false },
        { id: "r5", text: "Fallibilism", hogwash: false },
        { id: "r6", text: "Coherentism", hogwash: false },
        { id: "r7", text: "Foundationalism", hogwash: false },
        { id: "h1", text: "Creston Belief", hogwash: true },
        { id: "h2", text: "Valdoran Knowing", hogwash: true },
        { id: "h3", text: "Nordic Justification", hogwash: true },
      ],
    },
    {
      id: "aesthetics_terms",
      themeLabel: "Aesthetics Terms",
      items: [
        { id: "r1", text: "The Sublime", hogwash: false },
        { id: "r2", text: "Mimesis", hogwash: false },
        { id: "r3", text: "Catharsis", hogwash: false },
        { id: "r4", text: "Wabi-Sabi", hogwash: false },
        { id: "r5", text: "Kitsch", hogwash: false },
        { id: "r6", text: "Camp", hogwash: false },
        { id: "r7", text: "Uncanny", hogwash: false },
        { id: "h1", text: "Valdoric Beauty", hogwash: true },
        { id: "h2", text: "Creston Form", hogwash: true },
        { id: "h3", text: "Nordic Feeling", hogwash: true },
      ],
    },

    // ── EARTH SCIENCE ─────────────────────────────────────────────────────────
    {
      id: "geology_eras",
      themeLabel: "Geological Time Periods",
      items: [
        { id: "r1", text: "Cambrian", hogwash: false },
        { id: "r2", text: "Devonian", hogwash: false },
        { id: "r3", text: "Permian", hogwash: false },
        { id: "r4", text: "Triassic", hogwash: false },
        { id: "r5", text: "Cretaceous", hogwash: false },
        { id: "r6", text: "Eocene", hogwash: false },
        { id: "r7", text: "Pleistocene", hogwash: false },
        { id: "h1", text: "Valdoran Period", hogwash: true },
        { id: "h2", text: "Crestacian", hogwash: true },
        { id: "h3", text: "Nordic Era", hogwash: true },
      ],
    },
    {
      id: "fossil_types",
      themeLabel: "Types of Fossil",
      items: [
        { id: "r1", text: "Body Fossil", hogwash: false },
        { id: "r2", text: "Trace Fossil", hogwash: false },
        { id: "r3", text: "Mold Fossil", hogwash: false },
        { id: "r4", text: "Cast Fossil", hogwash: false },
        { id: "r5", text: "Amber Fossil", hogwash: false },
        { id: "r6", text: "Coprolite", hogwash: false },
        { id: "r7", text: "Microfossil", hogwash: false },
        { id: "h1", text: "Creston Imprint", hogwash: true },
        { id: "h2", text: "Valdoran Bone", hogwash: true },
        { id: "h3", text: "Nordic Preserve", hogwash: true },
      ],
    },
    {
      id: "paleontology",
      themeLabel: "Paleontology Terms",
      items: [
        { id: "r1", text: "Stratigraphy", hogwash: false },
        { id: "r2", text: "Taphonomy", hogwash: false },
        { id: "r3", text: "Biostratigraphy", hogwash: false },
        { id: "r4", text: "Cladistics", hogwash: false },
        { id: "r5", text: "Fossiliferous", hogwash: false },
        { id: "r6", text: "Excavation Grid", hogwash: false },
        { id: "r7", text: "Type Specimen", hogwash: false },
        { id: "h1", text: "Creston Layer", hogwash: true },
        { id: "h2", text: "Valdoran Index", hogwash: true },
        { id: "h3", text: "Nordic Deposit", hogwash: true },
      ],
    },
    {
      id: "mineralogy2",
      themeLabel: "Mineral Properties",
      items: [
        { id: "r1", text: "Cleavage", hogwash: false },
        { id: "r2", text: "Fracture", hogwash: false },
        { id: "r3", text: "Luster", hogwash: false },
        { id: "r4", text: "Streak", hogwash: false },
        { id: "r5", text: "Specific Gravity", hogwash: false },
        { id: "r6", text: "Crystal Habit", hogwash: false },
        { id: "r7", text: "Tenacity", hogwash: false },
        { id: "h1", text: "Creston Sheen", hogwash: true },
        { id: "h2", text: "Valdoran Grain", hogwash: true },
        { id: "h3", text: "Nordic Density", hogwash: true },
      ],
    },
    {
      id: "crystallography",
      themeLabel: "Crystal Systems",
      items: [
        { id: "r1", text: "Cubic", hogwash: false },
        { id: "r2", text: "Hexagonal", hogwash: false },
        { id: "r3", text: "Trigonal", hogwash: false },
        { id: "r4", text: "Tetragonal", hogwash: false },
        { id: "r5", text: "Orthorhombic", hogwash: false },
        { id: "r6", text: "Monoclinic", hogwash: false },
        { id: "r7", text: "Triclinic", hogwash: false },
        { id: "h1", text: "Valdorhombic", hogwash: true },
        { id: "h2", text: "Crestagonal", hogwash: true },
        { id: "h3", text: "Nordinic", hogwash: true },
      ],
    },

    // ── WEATHER & ENVIRONMENT ─────────────────────────────────────────────────
    {
      id: "weather_fronts",
      themeLabel: "Weather Front Types",
      items: [
        { id: "r1", text: "Cold Front", hogwash: false },
        { id: "r2", text: "Warm Front", hogwash: false },
        { id: "r3", text: "Stationary Front", hogwash: false },
        { id: "r4", text: "Occluded Front", hogwash: false },
        { id: "r5", text: "Dryline", hogwash: false },
        { id: "r6", text: "Squall Line", hogwash: false },
        { id: "r7", text: "Arctic Front", hogwash: false },
        { id: "h1", text: "Creston Front", hogwash: true },
        { id: "h2", text: "Valdoran Surge", hogwash: true },
        { id: "h3", text: "Nordic Boundary", hogwash: true },
      ],
    },
    {
      id: "meteorology2",
      themeLabel: "Meteorology Terms",
      items: [
        { id: "r1", text: "Isobar", hogwash: false },
        { id: "r2", text: "Anticyclone", hogwash: false },
        { id: "r3", text: "Trough", hogwash: false },
        { id: "r4", text: "Inversion", hogwash: false },
        { id: "r5", text: "Dew Point", hogwash: false },
        { id: "r6", text: "Wind Shear", hogwash: false },
        { id: "r7", text: "Mesocyclone", hogwash: false },
        { id: "h1", text: "Crestocyclone", hogwash: true },
        { id: "h2", text: "Valdoran Pressure", hogwash: true },
        { id: "h3", text: "Nordic Shear", hogwash: true },
      ],
    },
    {
      id: "climate_science",
      themeLabel: "Climate Science Terms",
      items: [
        { id: "r1", text: "Carbon Sequestration", hogwash: false },
        { id: "r2", text: "Albedo Effect", hogwash: false },
        { id: "r3", text: "Radiative Forcing", hogwash: false },
        { id: "r4", text: "Permafrost", hogwash: false },
        { id: "r5", text: "Thermohaline Circulation", hogwash: false },
        { id: "r6", text: "El Niño", hogwash: false },
        { id: "r7", text: "Tipping Point", hogwash: false },
        { id: "h1", text: "Creston Feedback", hogwash: true },
        { id: "h2", text: "Valdoran Sink", hogwash: true },
        { id: "h3", text: "Nordic Balance", hogwash: true },
      ],
    },
    {
      id: "oceanography2",
      themeLabel: "Oceanography Terms",
      items: [
        { id: "r1", text: "Upwelling", hogwash: false },
        { id: "r2", text: "Salinity", hogwash: false },
        { id: "r3", text: "Gyres", hogwash: false },
        { id: "r4", text: "Chemosynthesis", hogwash: false },
        { id: "r5", text: "Hadal Zone", hogwash: false },
        { id: "r6", text: "Phytoplankton Bloom", hogwash: false },
        { id: "r7", text: "Tidal Bore", hogwash: false },
        { id: "h1", text: "Creston Drift", hogwash: true },
        { id: "h2", text: "Valdoran Swell", hogwash: true },
        { id: "h3", text: "Nordic Deep Current", hogwash: true },
      ],
    },
    {
      id: "hydrology",
      themeLabel: "Hydrology Terms",
      items: [
        { id: "r1", text: "Watershed", hogwash: false },
        { id: "r2", text: "Aquifer", hogwash: false },
        { id: "r3", text: "Infiltration", hogwash: false },
        { id: "r4", text: "Evapotranspiration", hogwash: false },
        { id: "r5", text: "Base Flow", hogwash: false },
        { id: "r6", text: "Floodplain", hogwash: false },
        { id: "r7", text: "Percolation", hogwash: false },
        { id: "h1", text: "Creston Flow", hogwash: true },
        { id: "h2", text: "Valdoran Basin", hogwash: true },
        { id: "h3", text: "Nordic Recharge", hogwash: true },
      ],
    },

    // ── MEDICINE & BODY ───────────────────────────────────────────────────────
    {
      id: "immune_system",
      themeLabel: "Immune System Terms",
      items: [
        { id: "r1", text: "Antibody", hogwash: false },
        { id: "r2", text: "T Cell", hogwash: false },
        { id: "r3", text: "B Cell", hogwash: false },
        { id: "r4", text: "Cytokine", hogwash: false },
        { id: "r5", text: "Macrophage", hogwash: false },
        { id: "r6", text: "Natural Killer Cell", hogwash: false },
        { id: "r7", text: "Lymph Node", hogwash: false },
        { id: "h1", text: "Creston Cell", hogwash: true },
        { id: "h2", text: "Valdoran Factor", hogwash: true },
        { id: "h3", text: "Nordic Antibody", hogwash: true },
      ],
    },
    {
      id: "cell_types",
      themeLabel: "Types of Human Cell",
      items: [
        { id: "r1", text: "Neuron", hogwash: false },
        { id: "r2", text: "Erythrocyte", hogwash: false },
        { id: "r3", text: "Osteoclast", hogwash: false },
        { id: "r4", text: "Hepatocyte", hogwash: false },
        { id: "r5", text: "Melanocyte", hogwash: false },
        { id: "r6", text: "Adipocyte", hogwash: false },
        { id: "r7", text: "Chondrocyte", hogwash: false },
        { id: "h1", text: "Crestocyte", hogwash: true },
        { id: "h2", text: "Valdoran Cell", hogwash: true },
        { id: "h3", text: "Nordic Blast", hogwash: true },
      ],
    },
    {
      id: "organ_systems",
      themeLabel: "Human Organ Systems",
      items: [
        { id: "r1", text: "Integumentary", hogwash: false },
        { id: "r2", text: "Lymphatic", hogwash: false },
        { id: "r3", text: "Endocrine", hogwash: false },
        { id: "r4", text: "Reproductive", hogwash: false },
        { id: "r5", text: "Urinary", hogwash: false },
        { id: "r6", text: "Respiratory", hogwash: false },
        { id: "r7", text: "Muscular", hogwash: false },
        { id: "h1", text: "Crestonic System", hogwash: true },
        { id: "h2", text: "Valdoran Network", hogwash: true },
        { id: "h3", text: "Nordic System", hogwash: true },
      ],
    },
    {
      id: "endocrine_terms",
      themeLabel: "Endocrine System Terms",
      items: [
        { id: "r1", text: "Cortisol", hogwash: false },
        { id: "r2", text: "Insulin", hogwash: false },
        { id: "r3", text: "Melatonin", hogwash: false },
        { id: "r4", text: "Thyroxine", hogwash: false },
        { id: "r5", text: "Glucagon", hogwash: false },
        { id: "r6", text: "Oxytocin", hogwash: false },
        { id: "r7", text: "Aldosterone", hogwash: false },
        { id: "h1", text: "Valdorin", hogwash: true },
        { id: "h2", text: "Crestamin", hogwash: true },
        { id: "h3", text: "Nordocin", hogwash: true },
      ],
    },
    {
      id: "cardiovascular",
      themeLabel: "Cardiovascular Terms",
      items: [
        { id: "r1", text: "Systole", hogwash: false },
        { id: "r2", text: "Diastole", hogwash: false },
        { id: "r3", text: "Stenosis", hogwash: false },
        { id: "r4", text: "Arrhythmia", hogwash: false },
        { id: "r5", text: "Ejection Fraction", hogwash: false },
        { id: "r6", text: "Pericardium", hogwash: false },
        { id: "r7", text: "Endocardium", hogwash: false },
        { id: "h1", text: "Creston Valve", hogwash: true },
        { id: "h2", text: "Valdoran Rhythm", hogwash: true },
        { id: "h3", text: "Nordic Pulse", hogwash: true },
      ],
    },

    // ── MUSIC ─────────────────────────────────────────────────────────────────
    {
      id: "guitar_techniques",
      themeLabel: "Guitar Playing Techniques",
      items: [
        { id: "r1", text: "Hammer-On", hogwash: false },
        { id: "r2", text: "Pull-Off", hogwash: false },
        { id: "r3", text: "Sweep Picking", hogwash: false },
        { id: "r4", text: "Tapping", hogwash: false },
        { id: "r5", text: "Vibrato", hogwash: false },
        { id: "r6", text: "String Bending", hogwash: false },
        { id: "r7", text: "Tremolo Picking", hogwash: false },
        { id: "h1", text: "Creston Slide", hogwash: true },
        { id: "h2", text: "Valdoran Tap", hogwash: true },
        { id: "h3", text: "Nordic Mute", hogwash: true },
      ],
    },
    {
      id: "piano_terms",
      themeLabel: "Piano Terms",
      items: [
        { id: "r1", text: "Damper Pedal", hogwash: false },
        { id: "r2", text: "Sostenuto Pedal", hogwash: false },
        { id: "r3", text: "Una Corda", hogwash: false },
        { id: "r4", text: "Voicing", hogwash: false },
        { id: "r5", text: "Rubato", hogwash: false },
        { id: "r6", text: "Touch Weight", hogwash: false },
        { id: "r7", text: "Legato", hogwash: false },
        { id: "h1", text: "Creston Tone", hogwash: true },
        { id: "h2", text: "Valdoran Pedal", hogwash: true },
        { id: "h3", text: "Nordic Touch", hogwash: true },
      ],
    },
    {
      id: "drum_rudiments",
      themeLabel: "Drum Rudiments",
      items: [
        { id: "r1", text: "Single Stroke Roll", hogwash: false },
        { id: "r2", text: "Double Stroke Roll", hogwash: false },
        { id: "r3", text: "Paradiddle", hogwash: false },
        { id: "r4", text: "Flam", hogwash: false },
        { id: "r5", text: "Drag", hogwash: false },
        { id: "r6", text: "Ruff", hogwash: false },
        { id: "r7", text: "Ratamacue", hogwash: false },
        { id: "h1", text: "Creston Roll", hogwash: true },
        { id: "h2", text: "Valdoran Beat", hogwash: true },
        { id: "h3", text: "Nordic Tap", hogwash: true },
      ],
    },
    {
      id: "vocal_techniques",
      themeLabel: "Vocal Techniques",
      items: [
        { id: "r1", text: "Belting", hogwash: false },
        { id: "r2", text: "Falsetto", hogwash: false },
        { id: "r3", text: "Head Voice", hogwash: false },
        { id: "r4", text: "Mixed Voice", hogwash: false },
        { id: "r5", text: "Vibrato", hogwash: false },
        { id: "r6", text: "Melisma", hogwash: false },
        { id: "r7", text: "Twang", hogwash: false },
        { id: "h1", text: "Creston Break", hogwash: true },
        { id: "h2", text: "Valdoran Lift", hogwash: true },
        { id: "h3", text: "Nordic Chest Mix", hogwash: true },
      ],
    },
    {
      id: "music_production2",
      themeLabel: "DAW & Music Tech Terms",
      items: [
        { id: "r1", text: "MIDI", hogwash: false },
        { id: "r2", text: "Quantization", hogwash: false },
        { id: "r3", text: "Automation", hogwash: false },
        { id: "r4", text: "Sample Rate", hogwash: false },
        { id: "r5", text: "Bit Depth", hogwash: false },
        { id: "r6", text: "Wet/Dry Mix", hogwash: false },
        { id: "r7", text: "Stem Mixing", hogwash: false },
        { id: "h1", text: "Creston Track", hogwash: true },
        { id: "h2", text: "Valdoran Bus", hogwash: true },
        { id: "h3", text: "Nordic Patch", hogwash: true },
      ],
    },

    // ── MAPPING & GEOGRAPHY ───────────────────────────────────────────────────
    {
      id: "map_symbols",
      themeLabel: "Map Symbols & Legend Terms",
      items: [
        { id: "r1", text: "Contour Line", hogwash: false },
        { id: "r2", text: "Benchmark", hogwash: false },
        { id: "r3", text: "Hachure", hogwash: false },
        { id: "r4", text: "Spot Height", hogwash: false },
        { id: "r5", text: "Saddle", hogwash: false },
        { id: "r6", text: "Escarpment", hogwash: false },
        { id: "r7", text: "Index Contour", hogwash: false },
        { id: "h1", text: "Creston Line", hogwash: true },
        { id: "h2", text: "Valdoran Mark", hogwash: true },
        { id: "h3", text: "Nordic Relief", hogwash: true },
      ],
    },
    {
      id: "cartography",
      themeLabel: "Cartography Terms",
      items: [
        { id: "r1", text: "Graticule", hogwash: false },
        { id: "r2", text: "Scale Bar", hogwash: false },
        { id: "r3", text: "Isoline", hogwash: false },
        { id: "r4", text: "Choropleth", hogwash: false },
        { id: "r5", text: "Toponym", hogwash: false },
        { id: "r6", text: "Datum", hogwash: false },
        { id: "r7", text: "Projection", hogwash: false },
        { id: "h1", text: "Creston Grid", hogwash: true },
        { id: "h2", text: "Valdoran Layer", hogwash: true },
        { id: "h3", text: "Nordic Overlay", hogwash: true },
      ],
    },
    {
      id: "surveying_terms",
      themeLabel: "Land Surveying Terms",
      items: [
        { id: "r1", text: "Theodolite", hogwash: false },
        { id: "r2", text: "Traverse", hogwash: false },
        { id: "r3", text: "Triangulation", hogwash: false },
        { id: "r4", text: "Metes and Bounds", hogwash: false },
        { id: "r5", text: "Benchmark", hogwash: false },
        { id: "r6", text: "Azimuth", hogwash: false },
        { id: "r7", text: "Backsight", hogwash: false },
        { id: "h1", text: "Creston Point", hogwash: true },
        { id: "h2", text: "Valdoran Line", hogwash: true },
        { id: "h3", text: "Nordic Station", hogwash: true },
      ],
    },
    {
      id: "gis_terms",
      themeLabel: "GIS & Remote Sensing Terms",
      items: [
        { id: "r1", text: "Raster", hogwash: false },
        { id: "r2", text: "Vector Layer", hogwash: false },
        { id: "r3", text: "Shapefile", hogwash: false },
        { id: "r4", text: "Spatial Join", hogwash: false },
        { id: "r5", text: "Georeferencing", hogwash: false },
        { id: "r6", text: "DEM", hogwash: false },
        { id: "r7", text: "NDVI", hogwash: false },
        { id: "h1", text: "Creston Index", hogwash: true },
        { id: "h2", text: "Valdoran Band", hogwash: true },
        { id: "h3", text: "Nordic Pixel", hogwash: true },
      ],
    },
    {
      id: "remote_sensing",
      themeLabel: "Satellite & Sensor Types",
      items: [
        { id: "r1", text: "LiDAR", hogwash: false },
        { id: "r2", text: "SAR", hogwash: false },
        { id: "r3", text: "Multispectral", hogwash: false },
        { id: "r4", text: "Hyperspectral", hogwash: false },
        { id: "r5", text: "Thermal Infrared", hogwash: false },
        { id: "r6", text: "Panchromatic", hogwash: false },
        { id: "r7", text: "Passive Sensor", hogwash: false },
        { id: "h1", text: "Creston Array", hogwash: true },
        { id: "h2", text: "Valdoran Scan", hogwash: true },
        { id: "h3", text: "Nordic Pulse Sensor", hogwash: true },
      ],
    },

    // ── ARCHITECTURE & DESIGN ─────────────────────────────────────────────────
    {
      id: "architecture_styles",
      themeLabel: "Architecture Styles",
      items: [
        { id: "r1", text: "Gothic", hogwash: false },
        { id: "r2", text: "Baroque", hogwash: false },
        { id: "r3", text: "Brutalism", hogwash: false },
        { id: "r4", text: "Art Deco", hogwash: false },
        { id: "r5", text: "Modernism", hogwash: false },
        { id: "r6", text: "Romanesque", hogwash: false },
        { id: "r7", text: "Deconstructivism", hogwash: false },
        { id: "h1", text: "Creston Revival", hogwash: true },
        { id: "h2", text: "Valdoran Arch", hogwash: true },
        { id: "h3", text: "Nordic Spire Style", hogwash: true },
      ],
    },
    {
      id: "fashion_terms",
      themeLabel: "Fashion Design Terms",
      items: [
        { id: "r1", text: "Draping", hogwash: false },
        { id: "r2", text: "Toile", hogwash: false },
        { id: "r3", text: "Bias Cut", hogwash: false },
        { id: "r4", text: "Silhouette", hogwash: false },
        { id: "r5", text: "Basting", hogwash: false },
        { id: "r6", text: "Seam Allowance", hogwash: false },
        { id: "r7", text: "Dart", hogwash: false },
        { id: "h1", text: "Creston Tuck", hogwash: true },
        { id: "h2", text: "Valdoran Pleat", hogwash: true },
        { id: "h3", text: "Nordic Baste Line", hogwash: true },
      ],
    },
    {
      id: "interior_design_b5",
      themeLabel: "Interior Design Styles",
      items: [
        { id: "r1", text: "Scandinavian", hogwash: false },
        { id: "r2", text: "Industrial", hogwash: false },
        { id: "r3", text: "Bohemian", hogwash: false },
        { id: "r4", text: "Mid-Century Modern", hogwash: false },
        { id: "r5", text: "Farmhouse", hogwash: false },
        { id: "r6", text: "Minimalist", hogwash: false },
        { id: "r7", text: "Japandi", hogwash: false },
        { id: "h1", text: "Creston Coastal", hogwash: true },
        { id: "h2", text: "Valdoran Lodge", hogwash: true },
        { id: "h3", text: "Nordic Loft Fusion", hogwash: true },
      ],
    },
    {
      id: "photography_terms",
      themeLabel: "Photography Terms",
      items: [
        { id: "r1", text: "Aperture", hogwash: false },
        { id: "r2", text: "Bokeh", hogwash: false },
        { id: "r3", text: "ISO", hogwash: false },
        { id: "r4", text: "Shutter Speed", hogwash: false },
        { id: "r5", text: "Exposure Triangle", hogwash: false },
        { id: "r6", text: "Depth of Field", hogwash: false },
        { id: "r7", text: "White Balance", hogwash: false },
        { id: "h1", text: "Creston Stop", hogwash: true },
        { id: "h2", text: "Valdoran Frame", hogwash: true },
        { id: "h3", text: "Nordic Light Burst", hogwash: true },
      ],
    },
    {
      id: "film_techniques_b5",
      themeLabel: "Film & Cinematography Techniques",
      items: [
        { id: "r1", text: "Dolly Shot", hogwash: false },
        { id: "r2", text: "Dutch Angle", hogwash: false },
        { id: "r3", text: "Rack Focus", hogwash: false },
        { id: "r4", text: "Tracking Shot", hogwash: false },
        { id: "r5", text: "Smash Cut", hogwash: false },
        { id: "r6", text: "Chiaroscuro", hogwash: false },
        { id: "r7", text: "Motivated Lighting", hogwash: false },
        { id: "h1", text: "Creston Whip", hogwash: true },
        { id: "h2", text: "Valdoran Pull", hogwash: true },
        { id: "h3", text: "Nordic Static Frame", hogwash: true },
      ],
    },
    {
      id: "theater_terms_b5",
      themeLabel: "Theater & Stage Terms",
      items: [
        { id: "r1", text: "Proscenium", hogwash: false },
        { id: "r2", text: "Wings", hogwash: false },
        { id: "r3", text: "Blocking", hogwash: false },
        { id: "r4", text: "Upstage", hogwash: false },
        { id: "r5", text: "Fourth Wall", hogwash: false },
        { id: "r6", text: "Cyclorama", hogwash: false },
        { id: "r7", text: "Flies", hogwash: false },
        { id: "h1", text: "Creston Apron", hogwash: true },
        { id: "h2", text: "Valdoran Drop", hogwash: true },
        { id: "h3", text: "Nordic Stage Pit", hogwash: true },
      ],
    },
    {
      id: "dance_styles",
      themeLabel: "Dance Styles",
      items: [
        { id: "r1", text: "Flamenco", hogwash: false },
        { id: "r2", text: "Lindy Hop", hogwash: false },
        { id: "r3", text: "Kathak", hogwash: false },
        { id: "r4", text: "Capoeira", hogwash: false },
        { id: "r5", text: "Vogueing", hogwash: false },
        { id: "r6", text: "Bhangra", hogwash: false },
        { id: "r7", text: "Krump", hogwash: false },
        { id: "h1", text: "Creston Step", hogwash: true },
        { id: "h2", text: "Valdoran Flow", hogwash: true },
        { id: "h3", text: "Nordic Drift Dance", hogwash: true },
      ],
    },
    {
      id: "ballet_terms_b5",
      themeLabel: "Ballet Terms",
      items: [
        { id: "r1", text: "Plié", hogwash: false },
        { id: "r2", text: "Arabesque", hogwash: false },
        { id: "r3", text: "Pirouette", hogwash: false },
        { id: "r4", text: "Grand Jeté", hogwash: false },
        { id: "r5", text: "Relevé", hogwash: false },
        { id: "r6", text: "Tendu", hogwash: false },
        { id: "r7", text: "Pas de Deux", hogwash: false },
        { id: "h1", text: "Creston Élancé", hogwash: true },
        { id: "h2", text: "Valdoran Fouetté", hogwash: true },
        { id: "h3", text: "Nordic Grand Pose", hogwash: true },
      ],
    },
    {
      id: "art_movements_b5",
      themeLabel: "Art Movements",
      items: [
        { id: "r1", text: "Dadaism", hogwash: false },
        { id: "r2", text: "Fauvism", hogwash: false },
        { id: "r3", text: "Surrealism", hogwash: false },
        { id: "r4", text: "Cubism", hogwash: false },
        { id: "r5", text: "Expressionism", hogwash: false },
        { id: "r6", text: "Futurism", hogwash: false },
        { id: "r7", text: "Abstract Expressionism", hogwash: false },
        { id: "h1", text: "Creston Realism", hogwash: true },
        { id: "h2", text: "Valdoranism", hogwash: true },
        { id: "h3", text: "Nordic Light Movement", hogwash: true },
      ],
    },
    {
      id: "painting_styles",
      themeLabel: "Painting Techniques",
      items: [
        { id: "r1", text: "Impasto", hogwash: false },
        { id: "r2", text: "Sfumato", hogwash: false },
        { id: "r3", text: "Chiaroscuro", hogwash: false },
        { id: "r4", text: "Grisaille", hogwash: false },
        { id: "r5", text: "Glazing", hogwash: false },
        { id: "r6", text: "Alla Prima", hogwash: false },
        { id: "r7", text: "Sgraffito", hogwash: false },
        { id: "h1", text: "Creston Wash", hogwash: true },
        { id: "h2", text: "Valdoran Blend", hogwash: true },
        { id: "h3", text: "Nordic Dry Stroke", hogwash: true },
      ],
    },
    {
      id: "printmaking",
      themeLabel: "Printmaking Techniques",
      items: [
        { id: "r1", text: "Lithography", hogwash: false },
        { id: "r2", text: "Etching", hogwash: false },
        { id: "r3", text: "Woodcut", hogwash: false },
        { id: "r4", text: "Screen Printing", hogwash: false },
        { id: "r5", text: "Mezzotint", hogwash: false },
        { id: "r6", text: "Aquatint", hogwash: false },
        { id: "r7", text: "Linocut", hogwash: false },
        { id: "h1", text: "Creston Press", hogwash: true },
        { id: "h2", text: "Valdoran Plate", hogwash: true },
        { id: "h3", text: "Nordic Intaglio Pull", hogwash: true },
      ],
    },
    {
      id: "sculpture_terms",
      themeLabel: "Sculpture Techniques",
      items: [
        { id: "r1", text: "Armature", hogwash: false },
        { id: "r2", text: "Lost-Wax Casting", hogwash: false },
        { id: "r3", text: "Carving", hogwash: false },
        { id: "r4", text: "Modeling", hogwash: false },
        { id: "r5", text: "Relief", hogwash: false },
        { id: "r6", text: "Assemblage", hogwash: false },
        { id: "r7", text: "Kinetic Sculpture", hogwash: false },
        { id: "h1", text: "Creston Cast", hogwash: true },
        { id: "h2", text: "Valdoran Mold", hogwash: true },
        { id: "h3", text: "Nordic Stone Form", hogwash: true },
      ],
    },
    {
      id: "graphic_design",
      themeLabel: "Graphic Design Terms",
      items: [
        { id: "r1", text: "Kerning", hogwash: false },
        { id: "r2", text: "Tracking", hogwash: false },
        { id: "r3", text: "Leading", hogwash: false },
        { id: "r4", text: "Hierarchy", hogwash: false },
        { id: "r5", text: "Bleed", hogwash: false },
        { id: "r6", text: "Vector", hogwash: false },
        { id: "r7", text: "Raster", hogwash: false },
        { id: "h1", text: "Creston Glyph", hogwash: true },
        { id: "h2", text: "Valdoran Slug", hogwash: true },
        { id: "h3", text: "Nordic Trim Zone", hogwash: true },
      ],
    },
    {
      id: "animation_terms",
      themeLabel: "Animation Techniques",
      items: [
        { id: "r1", text: "Squash and Stretch", hogwash: false },
        { id: "r2", text: "Anticipation", hogwash: false },
        { id: "r3", text: "Ease In/Out", hogwash: false },
        { id: "r4", text: "Keyframe", hogwash: false },
        { id: "r5", text: "Cel Animation", hogwash: false },
        { id: "r6", text: "Motion Blur", hogwash: false },
        { id: "r7", text: "Rigging", hogwash: false },
        { id: "h1", text: "Creston Tween", hogwash: true },
        { id: "h2", text: "Valdoran Morph", hogwash: true },
        { id: "h3", text: "Nordic Frame Smear", hogwash: true },
      ],
    },

    // ── GAMES & TECHNOLOGY ────────────────────────────────────────────────────
    {
      id: "chess_terms",
      themeLabel: "Chess Terms",
      items: [
        { id: "r1", text: "En Passant", hogwash: false },
        { id: "r2", text: "Castling", hogwash: false },
        { id: "r3", text: "Fork", hogwash: false },
        { id: "r4", text: "Discovered Check", hogwash: false },
        { id: "r5", text: "Zugzwang", hogwash: false },
        { id: "r6", text: "Fianchetto", hogwash: false },
        { id: "r7", text: "Gambit", hogwash: false },
        { id: "h1", text: "Creston Pin", hogwash: true },
        { id: "h2", text: "Valdoran Skewer", hogwash: true },
        { id: "h3", text: "Nordic Counter Play", hogwash: true },
      ],
    },
    {
      id: "poker_terms",
      themeLabel: "Poker Terms",
      items: [
        { id: "r1", text: "Bluff", hogwash: false },
        { id: "r2", text: "Pot Odds", hogwash: false },
        { id: "r3", text: "River", hogwash: false },
        { id: "r4", text: "Slow Play", hogwash: false },
        { id: "r5", text: "Overcards", hogwash: false },
        { id: "r6", text: "Donk Bet", hogwash: false },
        { id: "r7", text: "Check-Raise", hogwash: false },
        { id: "h1", text: "Creston Float", hogwash: true },
        { id: "h2", text: "Valdoran Squeeze", hogwash: true },
        { id: "h3", text: "Nordic Cold Call", hogwash: true },
      ],
    },
    {
      id: "board_game_mechanics_b5",
      themeLabel: "Board Game Mechanics",
      items: [
        { id: "r1", text: "Worker Placement", hogwash: false },
        { id: "r2", text: "Deck Building", hogwash: false },
        { id: "r3", text: "Area Control", hogwash: false },
        { id: "r4", text: "Engine Building", hogwash: false },
        { id: "r5", text: "Push Your Luck", hogwash: false },
        { id: "r6", text: "Cooperative Play", hogwash: false },
        { id: "r7", text: "Tile Drafting", hogwash: false },
        { id: "h1", text: "Creston Draw Phase", hogwash: true },
        { id: "h2", text: "Valdoran Token Spend", hogwash: true },
        { id: "h3", text: "Nordic Action Loop", hogwash: true },
      ],
    },
    {
      id: "video_game_genres_b5",
      themeLabel: "Video Game Genres",
      items: [
        { id: "r1", text: "Roguelike", hogwash: false },
        { id: "r2", text: "Metroidvania", hogwash: false },
        { id: "r3", text: "Battle Royale", hogwash: false },
        { id: "r4", text: "Soulslike", hogwash: false },
        { id: "r5", text: "MOBA", hogwash: false },
        { id: "r6", text: "4X Strategy", hogwash: false },
        { id: "r7", text: "Immersive Sim", hogwash: false },
        { id: "h1", text: "Creston Crawler", hogwash: true },
        { id: "h2", text: "Valdoran Tactical RPG", hogwash: true },
        { id: "h3", text: "Nordic Runner Plus", hogwash: true },
      ],
    },
    {
      id: "esports_terms",
      themeLabel: "Esports & Gaming Terms",
      items: [
        { id: "r1", text: "Ping", hogwash: false },
        { id: "r2", text: "Tilted", hogwash: false },
        { id: "r3", text: "Meta", hogwash: false },
        { id: "r4", text: "Griefing", hogwash: false },
        { id: "r5", text: "Smurfing", hogwash: false },
        { id: "r6", text: "Respawn", hogwash: false },
        { id: "r7", text: "Cooldown", hogwash: false },
        { id: "h1", text: "Creston Queue", hogwash: true },
        { id: "h2", text: "Valdoran Burst", hogwash: true },
        { id: "h3", text: "Nordic Lag Frame", hogwash: true },
      ],
    },
    {
      id: "coding_concepts",
      themeLabel: "Programming Concepts",
      items: [
        { id: "r1", text: "Recursion", hogwash: false },
        { id: "r2", text: "Polymorphism", hogwash: false },
        { id: "r3", text: "Encapsulation", hogwash: false },
        { id: "r4", text: "Abstraction", hogwash: false },
        { id: "r5", text: "Inheritance", hogwash: false },
        { id: "r6", text: "Memoization", hogwash: false },
        { id: "r7", text: "Dependency Injection", hogwash: false },
        { id: "h1", text: "Creston Pattern", hogwash: true },
        { id: "h2", text: "Valdoran Loop", hogwash: true },
        { id: "h3", text: "Nordic Thread Binding", hogwash: true },
      ],
    },
    {
      id: "database_terms",
      themeLabel: "Database Terms",
      items: [
        { id: "r1", text: "Primary Key", hogwash: false },
        { id: "r2", text: "Foreign Key", hogwash: false },
        { id: "r3", text: "Normalization", hogwash: false },
        { id: "r4", text: "Index", hogwash: false },
        { id: "r5", text: "Transaction", hogwash: false },
        { id: "r6", text: "Sharding", hogwash: false },
        { id: "r7", text: "ACID", hogwash: false },
        { id: "h1", text: "Creston Schema", hogwash: true },
        { id: "h2", text: "Valdoran Tuple", hogwash: true },
        { id: "h3", text: "Nordic Row Lock", hogwash: true },
      ],
    },
    {
      id: "networking2",
      themeLabel: "Computer Networking Terms",
      items: [
        { id: "r1", text: "Subnet Mask", hogwash: false },
        { id: "r2", text: "DNS", hogwash: false },
        { id: "r3", text: "Firewall", hogwash: false },
        { id: "r4", text: "Latency", hogwash: false },
        { id: "r5", text: "Bandwidth", hogwash: false },
        { id: "r6", text: "TCP/IP", hogwash: false },
        { id: "r7", text: "Load Balancer", hogwash: false },
        { id: "h1", text: "Creston Hop", hogwash: true },
        { id: "h2", text: "Valdoran Packet", hogwash: true },
        { id: "h3", text: "Nordic Bridge Node", hogwash: true },
      ],
    },
    {
      id: "cybersecurity",
      themeLabel: "Cybersecurity Terms",
      items: [
        { id: "r1", text: "Phishing", hogwash: false },
        { id: "r2", text: "Zero-Day", hogwash: false },
        { id: "r3", text: "SQL Injection", hogwash: false },
        { id: "r4", text: "Ransomware", hogwash: false },
        { id: "r5", text: "Penetration Testing", hogwash: false },
        { id: "r6", text: "Man-in-the-Middle", hogwash: false },
        { id: "r7", text: "Social Engineering", hogwash: false },
        { id: "h1", text: "Creston Exploit", hogwash: true },
        { id: "h2", text: "Valdoran Payload", hogwash: true },
        { id: "h3", text: "Nordic Null Probe", hogwash: true },
      ],
    },
    {
      id: "cloud_computing_b5",
      themeLabel: "Cloud Computing Terms",
      items: [
        { id: "r1", text: "Serverless", hogwash: false },
        { id: "r2", text: "Containerization", hogwash: false },
        { id: "r3", text: "Autoscaling", hogwash: false },
        { id: "r4", text: "CDN", hogwash: false },
        { id: "r5", text: "Orchestration", hogwash: false },
        { id: "r6", text: "Multi-Cloud", hogwash: false },
        { id: "r7", text: "Infrastructure as Code", hogwash: false },
        { id: "h1", text: "Creston Pod", hogwash: true },
        { id: "h2", text: "Valdoran Stack", hogwash: true },
        { id: "h3", text: "Nordic Burst Cluster", hogwash: true },
      ],
    },
    {
      id: "ux_design",
      themeLabel: "UX & UI Design Terms",
      items: [
        { id: "r1", text: "Wireframe", hogwash: false },
        { id: "r2", text: "Affordance", hogwash: false },
        { id: "r3", text: "Heuristic", hogwash: false },
        { id: "r4", text: "Prototype", hogwash: false },
        { id: "r5", text: "User Journey", hogwash: false },
        { id: "r6", text: "Accessibility", hogwash: false },
        { id: "r7", text: "Gestalt Principle", hogwash: false },
        { id: "h1", text: "Creston Flow Map", hogwash: true },
        { id: "h2", text: "Valdoran Touch Point", hogwash: true },
        { id: "h3", text: "Nordic Usability Lap", hogwash: true },
      ],
    },
    {
      id: "agile_terms",
      themeLabel: "Agile & Scrum Terms",
      items: [
        { id: "r1", text: "Sprint", hogwash: false },
        { id: "r2", text: "Backlog", hogwash: false },
        { id: "r3", text: "Retrospective", hogwash: false },
        { id: "r4", text: "Velocity", hogwash: false },
        { id: "r5", text: "Definition of Done", hogwash: false },
        { id: "r6", text: "Kanban Board", hogwash: false },
        { id: "r7", text: "Story Points", hogwash: false },
        { id: "h1", text: "Creston Stand-Up", hogwash: true },
        { id: "h2", text: "Valdoran Burndown", hogwash: true },
        { id: "h3", text: "Nordic Epic Cycle", hogwash: true },
      ],
    },
    {
      id: "devops_terms",
      themeLabel: "DevOps Terms",
      items: [
        { id: "r1", text: "CI/CD", hogwash: false },
        { id: "r2", text: "Pipeline", hogwash: false },
        { id: "r3", text: "Blue-Green Deployment", hogwash: false },
        { id: "r4", text: "Rollback", hogwash: false },
        { id: "r5", text: "Monitoring", hogwash: false },
        { id: "r6", text: "Feature Flag", hogwash: false },
        { id: "r7", text: "Canary Release", hogwash: false },
        { id: "h1", text: "Creston Gate Check", hogwash: true },
        { id: "h2", text: "Valdoran Deploy Hook", hogwash: true },
        { id: "h3", text: "Nordic Build Tunnel", hogwash: true },
      ],
    },
    {
      id: "ai_terms",
      themeLabel: "AI & Machine Learning Terms",
      items: [
        { id: "r1", text: "Overfitting", hogwash: false },
        { id: "r2", text: "Backpropagation", hogwash: false },
        { id: "r3", text: "Transformer", hogwash: false },
        { id: "r4", text: "Gradient Descent", hogwash: false },
        { id: "r5", text: "Tokenization", hogwash: false },
        { id: "r6", text: "Embedding", hogwash: false },
        { id: "r7", text: "Fine-Tuning", hogwash: false },
        { id: "h1", text: "Creston Neuron Deck", hogwash: true },
        { id: "h2", text: "Valdoran Weight Map", hogwash: true },
        { id: "h3", text: "Nordic Bias Layer", hogwash: true },
      ],
    },

    // ── LAW & BUSINESS ────────────────────────────────────────────────────────
    {
      id: "legal_terms_b5",
      themeLabel: "Legal & Court Terms",
      items: [
        { id: "r1", text: "Tort", hogwash: false },
        { id: "r2", text: "Habeas Corpus", hogwash: false },
        { id: "r3", text: "Deposition", hogwash: false },
        { id: "r4", text: "Voir Dire", hogwash: false },
        { id: "r5", text: "Subpoena", hogwash: false },
        { id: "r6", text: "Injunction", hogwash: false },
        { id: "r7", text: "Affidavit", hogwash: false },
        { id: "h1", text: "Creston Writ", hogwash: true },
        { id: "h2", text: "Valdoran Pleading", hogwash: true },
        { id: "h3", text: "Nordic Court Stay", hogwash: true },
      ],
    },
    {
      id: "economics_terms",
      themeLabel: "Economics Terms",
      items: [
        { id: "r1", text: "Elasticity", hogwash: false },
        { id: "r2", text: "Marginal Cost", hogwash: false },
        { id: "r3", text: "Externality", hogwash: false },
        { id: "r4", text: "Fiscal Policy", hogwash: false },
        { id: "r5", text: "Monetary Policy", hogwash: false },
        { id: "r6", text: "Consumer Surplus", hogwash: false },
        { id: "r7", text: "Opportunity Cost", hogwash: false },
        { id: "h1", text: "Creston Yield Curve", hogwash: true },
        { id: "h2", text: "Valdoran Supply Gap", hogwash: true },
        { id: "h3", text: "Nordic Demand Floor", hogwash: true },
      ],
    },
    {
      id: "stock_market",
      themeLabel: "Stock Market Terms",
      items: [
        { id: "r1", text: "Bull Market", hogwash: false },
        { id: "r2", text: "Short Selling", hogwash: false },
        { id: "r3", text: "Dividend", hogwash: false },
        { id: "r4", text: "P/E Ratio", hogwash: false },
        { id: "r5", text: "Volatility", hogwash: false },
        { id: "r6", text: "Hedge Fund", hogwash: false },
        { id: "r7", text: "Circuit Breaker", hogwash: false },
        { id: "h1", text: "Creston Float", hogwash: true },
        { id: "h2", text: "Valdoran Index Peg", hogwash: true },
        { id: "h3", text: "Nordic Bear Spread", hogwash: true },
      ],
    },
    {
      id: "real_estate",
      themeLabel: "Real Estate Terms",
      items: [
        { id: "r1", text: "Escrow", hogwash: false },
        { id: "r2", text: "Appraisal", hogwash: false },
        { id: "r3", text: "Amortization", hogwash: false },
        { id: "r4", text: "Cap Rate", hogwash: false },
        { id: "r5", text: "Encumbrance", hogwash: false },
        { id: "r6", text: "Title Insurance", hogwash: false },
        { id: "r7", text: "Easement", hogwash: false },
        { id: "h1", text: "Creston Deed Hold", hogwash: true },
        { id: "h2", text: "Valdoran Lien Type", hogwash: true },
        { id: "h3", text: "Nordic Covenant Clause", hogwash: true },
      ],
    },
    {
      id: "accounting_terms",
      themeLabel: "Accounting Terms",
      items: [
        { id: "r1", text: "Accrual", hogwash: false },
        { id: "r2", text: "Depreciation", hogwash: false },
        { id: "r3", text: "Ledger", hogwash: false },
        { id: "r4", text: "Accounts Receivable", hogwash: false },
        { id: "r5", text: "Double-Entry", hogwash: false },
        { id: "r6", text: "Trial Balance", hogwash: false },
        { id: "r7", text: "EBITDA", hogwash: false },
        { id: "h1", text: "Creston Debit Note", hogwash: true },
        { id: "h2", text: "Valdoran Write-Up", hogwash: true },
        { id: "h3", text: "Nordic Contra Charge", hogwash: true },
      ],
    },
    {
      id: "marketing_terms_b5",
      themeLabel: "Marketing Terms",
      items: [
        { id: "r1", text: "Conversion Rate", hogwash: false },
        { id: "r2", text: "Funnel", hogwash: false },
        { id: "r3", text: "Churn Rate", hogwash: false },
        { id: "r4", text: "A/B Testing", hogwash: false },
        { id: "r5", text: "Retargeting", hogwash: false },
        { id: "r6", text: "Brand Equity", hogwash: false },
        { id: "r7", text: "Lifetime Value", hogwash: false },
        { id: "h1", text: "Creston Reach Score", hogwash: true },
        { id: "h2", text: "Valdoran Impression", hogwash: true },
        { id: "h3", text: "Nordic Click Depth", hogwash: true },
      ],
    },
    {
      id: "psychology_terms_b5",
      themeLabel: "Psychology Terms",
      items: [
        { id: "r1", text: "Cognitive Dissonance", hogwash: false },
        { id: "r2", text: "Confirmation Bias", hogwash: false },
        { id: "r3", text: "Operant Conditioning", hogwash: false },
        { id: "r4", text: "Locus of Control", hogwash: false },
        { id: "r5", text: "Attachment Theory", hogwash: false },
        { id: "r6", text: "Gaslighting", hogwash: false },
        { id: "r7", text: "Intrinsic Motivation", hogwash: false },
        { id: "h1", text: "Creston Frame Shift", hogwash: true },
        { id: "h2", text: "Valdoran Anchor Bias", hogwash: true },
        { id: "h3", text: "Nordic Core Response", hogwash: true },
      ],
    },
    {
      id: "therapy_types",
      themeLabel: "Types of Therapy",
      items: [
        { id: "r1", text: "CBT", hogwash: false },
        { id: "r2", text: "DBT", hogwash: false },
        { id: "r3", text: "EMDR", hogwash: false },
        { id: "r4", text: "Somatic Therapy", hogwash: false },
        { id: "r5", text: "Psychoanalysis", hogwash: false },
        { id: "r6", text: "ACT", hogwash: false },
        { id: "r7", text: "Narrative Therapy", hogwash: false },
        { id: "h1", text: "Creston Talk Method", hogwash: true },
        { id: "h2", text: "Valdoran Reflex Arc", hogwash: true },
        { id: "h3", text: "Nordic Mind Trace", hogwash: true },
      ],
    },

    // ── SCIENCE & NATURE ──────────────────────────────────────────────────────
    {
      id: "quantum_physics_b5",
      themeLabel: "Quantum Physics Terms",
      items: [
        { id: "r1", text: "Superposition", hogwash: false },
        { id: "r2", text: "Entanglement", hogwash: false },
        { id: "r3", text: "Wave Function", hogwash: false },
        { id: "r4", text: "Decoherence", hogwash: false },
        { id: "r5", text: "Spin", hogwash: false },
        { id: "r6", text: "Tunneling", hogwash: false },
        { id: "r7", text: "Qubit", hogwash: false },
        { id: "h1", text: "Creston State Field", hogwash: true },
        { id: "h2", text: "Valdoran Flux Bit", hogwash: true },
        { id: "h3", text: "Nordic Collapse Mode", hogwash: true },
      ],
    },
    {
      id: "chemistry_reactions",
      themeLabel: "Chemistry Reaction Types",
      items: [
        { id: "r1", text: "Synthesis", hogwash: false },
        { id: "r2", text: "Decomposition", hogwash: false },
        { id: "r3", text: "Combustion", hogwash: false },
        { id: "r4", text: "Redox", hogwash: false },
        { id: "r5", text: "Precipitation", hogwash: false },
        { id: "r6", text: "Acid-Base", hogwash: false },
        { id: "r7", text: "Hydrolysis", hogwash: false },
        { id: "h1", text: "Creston Exchange", hogwash: true },
        { id: "h2", text: "Valdoran Chain Burst", hogwash: true },
        { id: "h3", text: "Nordic Ion Shift", hogwash: true },
      ],
    },
    {
      id: "genetics_terms",
      themeLabel: "Genetics Terms",
      items: [
        { id: "r1", text: "Allele", hogwash: false },
        { id: "r2", text: "Phenotype", hogwash: false },
        { id: "r3", text: "Genotype", hogwash: false },
        { id: "r4", text: "Mutation", hogwash: false },
        { id: "r5", text: "Dominant", hogwash: false },
        { id: "r6", text: "Epigenetics", hogwash: false },
        { id: "r7", text: "Gene Expression", hogwash: false },
        { id: "h1", text: "Creston Locus", hogwash: true },
        { id: "h2", text: "Valdoran Trait Code", hogwash: true },
        { id: "h3", text: "Nordic Splice Mark", hogwash: true },
      ],
    },
    {
      id: "ecology_terms",
      themeLabel: "Ecology Terms",
      items: [
        { id: "r1", text: "Trophic Level", hogwash: false },
        { id: "r2", text: "Keystone Species", hogwash: false },
        { id: "r3", text: "Carrying Capacity", hogwash: false },
        { id: "r4", text: "Biomass", hogwash: false },
        { id: "r5", text: "Niche", hogwash: false },
        { id: "r6", text: "Succession", hogwash: false },
        { id: "r7", text: "Mutualism", hogwash: false },
        { id: "h1", text: "Creston Habitat Zone", hogwash: true },
        { id: "h2", text: "Valdoran Guild Layer", hogwash: true },
        { id: "h3", text: "Nordic Flux Chain", hogwash: true },
      ],
    },
    {
      id: "deep_sea",
      themeLabel: "Deep Sea Creatures",
      items: [
        { id: "r1", text: "Anglerfish", hogwash: false },
        { id: "r2", text: "Vampire Squid", hogwash: false },
        { id: "r3", text: "Gulper Eel", hogwash: false },
        { id: "r4", text: "Bioluminescent Jellyfish", hogwash: false },
        { id: "r5", text: "Giant Isopod", hogwash: false },
        { id: "r6", text: "Fangtooth Fish", hogwash: false },
        { id: "r7", text: "Dumbo Octopus", hogwash: false },
        { id: "h1", text: "Creston Lantern Ray", hogwash: true },
        { id: "h2", text: "Valdoran Spined Cusk", hogwash: true },
        { id: "h3", text: "Nordic Abyss Shrimp", hogwash: true },
      ],
    },
    {
      id: "rainforest_animals",
      themeLabel: "Rainforest Animals",
      items: [
        { id: "r1", text: "Okapi", hogwash: false },
        { id: "r2", text: "Harpy Eagle", hogwash: false },
        { id: "r3", text: "Poison Dart Frog", hogwash: false },
        { id: "r4", text: "Tapir", hogwash: false },
        { id: "r5", text: "Mandrill", hogwash: false },
        { id: "r6", text: "Glasswing Butterfly", hogwash: false },
        { id: "r7", text: "Pygmy Marmoset", hogwash: false },
        { id: "h1", text: "Creston Tree Viper", hogwash: true },
        { id: "h2", text: "Valdoran Canopy Frog", hogwash: true },
        { id: "h3", text: "Nordic Leaf Lizard", hogwash: true },
      ],
    },
    {
      id: "desert_animals",
      themeLabel: "Desert Animals",
      items: [
        { id: "r1", text: "Fennec Fox", hogwash: false },
        { id: "r2", text: "Gila Monster", hogwash: false },
        { id: "r3", text: "Sidewinder", hogwash: false },
        { id: "r4", text: "Meerkat", hogwash: false },
        { id: "r5", text: "Thorny Devil", hogwash: false },
        { id: "r6", text: "Roadrunner", hogwash: false },
        { id: "r7", text: "Dung Beetle", hogwash: false },
        { id: "h1", text: "Creston Sand Gecko", hogwash: true },
        { id: "h2", text: "Valdoran Sun Scorpion", hogwash: true },
        { id: "h3", text: "Nordic Dune Vole", hogwash: true },
      ],
    },
    {
      id: "insect_types",
      themeLabel: "Insect Orders",
      items: [
        { id: "r1", text: "Hymenoptera", hogwash: false },
        { id: "r2", text: "Coleoptera", hogwash: false },
        { id: "r3", text: "Lepidoptera", hogwash: false },
        { id: "r4", text: "Diptera", hogwash: false },
        { id: "r5", text: "Orthoptera", hogwash: false },
        { id: "r6", text: "Odonata", hogwash: false },
        { id: "r7", text: "Hemiptera", hogwash: false },
        { id: "h1", text: "Creston Apteria", hogwash: true },
        { id: "h2", text: "Valdoran Dorsoptera", hogwash: true },
        { id: "h3", text: "Nordic Spinoptera", hogwash: true },
      ],
    },
    {
      id: "mushroom_types",
      themeLabel: "Mushroom Types",
      items: [
        { id: "r1", text: "Chanterelle", hogwash: false },
        { id: "r2", text: "Morel", hogwash: false },
        { id: "r3", text: "Lion's Mane", hogwash: false },
        { id: "r4", text: "Shiitake", hogwash: false },
        { id: "r5", text: "Porcini", hogwash: false },
        { id: "r6", text: "Oyster Mushroom", hogwash: false },
        { id: "r7", text: "King Trumpet", hogwash: false },
        { id: "h1", text: "Creston Cap", hogwash: true },
        { id: "h2", text: "Valdoran Spore Bloom", hogwash: true },
        { id: "h3", text: "Nordic Forest Tuft", hogwash: true },
      ],
    },

    // ── FOOD & DRINK CONTINUED ────────────────────────────────────────────────
    {
      id: "baking_terms",
      themeLabel: "Baking Terms",
      items: [
        { id: "r1", text: "Lamination", hogwash: false },
        { id: "r2", text: "Proofing", hogwash: false },
        { id: "r3", text: "Blind Baking", hogwash: false },
        { id: "r4", text: "Autolyse", hogwash: false },
        { id: "r5", text: "Crumb Structure", hogwash: false },
        { id: "r6", text: "Scoring", hogwash: false },
        { id: "r7", text: "Bench Rest", hogwash: false },
        { id: "h1", text: "Creston Fold Stage", hogwash: true },
        { id: "h2", text: "Valdoran Oven Bloom", hogwash: true },
        { id: "h3", text: "Nordic Dough Rest", hogwash: true },
      ],
    },
    {
      id: "bbq_techniques",
      themeLabel: "BBQ & Grilling Terms",
      items: [
        { id: "r1", text: "Low and Slow", hogwash: false },
        { id: "r2", text: "Bark", hogwash: false },
        { id: "r3", text: "Stall", hogwash: false },
        { id: "r4", text: "Texas Crutch", hogwash: false },
        { id: "r5", text: "Spatchcock", hogwash: false },
        { id: "r6", text: "Reverse Sear", hogwash: false },
        { id: "r7", text: "Indirect Heat", hogwash: false },
        { id: "h1", text: "Creston Smoke Ring", hogwash: true },
        { id: "h2", text: "Valdoran Baste Point", hogwash: true },
        { id: "h3", text: "Nordic Char Wrap", hogwash: true },
      ],
    },
    {
      id: "wine_regions_b5",
      themeLabel: "Wine Regions",
      items: [
        { id: "r1", text: "Bordeaux", hogwash: false },
        { id: "r2", text: "Barossa Valley", hogwash: false },
        { id: "r3", text: "Napa Valley", hogwash: false },
        { id: "r4", text: "Rioja", hogwash: false },
        { id: "r5", text: "Burgundy", hogwash: false },
        { id: "r6", text: "Tuscany", hogwash: false },
        { id: "r7", text: "Mendoza", hogwash: false },
        { id: "h1", text: "Creston Valley", hogwash: true },
        { id: "h2", text: "Valdoran Coast", hogwash: true },
        { id: "h3", text: "Nordic Reserve Hills", hogwash: true },
      ],
    },
    {
      id: "beer_styles_b5",
      themeLabel: "Beer Styles",
      items: [
        { id: "r1", text: "Hefeweizen", hogwash: false },
        { id: "r2", text: "Saison", hogwash: false },
        { id: "r3", text: "Stout", hogwash: false },
        { id: "r4", text: "Gose", hogwash: false },
        { id: "r5", text: "Pilsner", hogwash: false },
        { id: "r6", text: "Bock", hogwash: false },
        { id: "r7", text: "Lambic", hogwash: false },
        { id: "h1", text: "Creston Pale", hogwash: true },
        { id: "h2", text: "Valdoran Dark Brew", hogwash: true },
        { id: "h3", text: "Nordic Amber Lager", hogwash: true },
      ],
    },
    {
      id: "cheese_types",
      themeLabel: "Cheese Types",
      items: [
        { id: "r1", text: "Gruyère", hogwash: false },
        { id: "r2", text: "Manchego", hogwash: false },
        { id: "r3", text: "Taleggio", hogwash: false },
        { id: "r4", text: "Pecorino", hogwash: false },
        { id: "r5", text: "Époisses", hogwash: false },
        { id: "r6", text: "Halloumi", hogwash: false },
        { id: "r7", text: "Comté", hogwash: false },
        { id: "h1", text: "Creston Rind", hogwash: true },
        { id: "h2", text: "Valdoran Blue", hogwash: true },
        { id: "h3", text: "Nordic Cave Aged", hogwash: true },
      ],
    },
    {
      id: "bread_types",
      themeLabel: "Types of Bread",
      items: [
        { id: "r1", text: "Sourdough", hogwash: false },
        { id: "r2", text: "Ciabatta", hogwash: false },
        { id: "r3", text: "Brioche", hogwash: false },
        { id: "r4", text: "Injera", hogwash: false },
        { id: "r5", text: "Rye", hogwash: false },
        { id: "r6", text: "Focaccia", hogwash: false },
        { id: "r7", text: "Naan", hogwash: false },
        { id: "h1", text: "Creston Loaf", hogwash: true },
        { id: "h2", text: "Valdoran Crust", hogwash: true },
        { id: "h3", text: "Nordic Barley Round", hogwash: true },
      ],
    },
    {
      id: "knife_techniques",
      themeLabel: "Knife Cuts & Kitchen Techniques",
      items: [
        { id: "r1", text: "Julienne", hogwash: false },
        { id: "r2", text: "Brunoise", hogwash: false },
        { id: "r3", text: "Chiffonade", hogwash: false },
        { id: "r4", text: "Tourné", hogwash: false },
        { id: "r5", text: "Batonnet", hogwash: false },
        { id: "r6", text: "Macedoine", hogwash: false },
        { id: "r7", text: "Paysanne", hogwash: false },
        { id: "h1", text: "Creston Slice", hogwash: true },
        { id: "h2", text: "Valdoran Mince", hogwash: true },
        { id: "h3", text: "Nordic Roll Cut", hogwash: true },
      ],
    },

    // ── WELLNESS & SPORTS ─────────────────────────────────────────────────────
    {
      id: "yoga_poses_b5",
      themeLabel: "Yoga Poses",
      items: [
        { id: "r1", text: "Downward Dog", hogwash: false },
        { id: "r2", text: "Warrior II", hogwash: false },
        { id: "r3", text: "Crow Pose", hogwash: false },
        { id: "r4", text: "Child's Pose", hogwash: false },
        { id: "r5", text: "Triangle Pose", hogwash: false },
        { id: "r6", text: "Bridge Pose", hogwash: false },
        { id: "r7", text: "Boat Pose", hogwash: false },
        { id: "h1", text: "Creston Flow Stretch", hogwash: true },
        { id: "h2", text: "Valdoran Spine Arc", hogwash: true },
        { id: "h3", text: "Nordic Ground Bind", hogwash: true },
      ],
    },
    {
      id: "martial_arts_b5",
      themeLabel: "Martial Arts Terms",
      items: [
        { id: "r1", text: "Ippon", hogwash: false },
        { id: "r2", text: "Kata", hogwash: false },
        { id: "r3", text: "Randori", hogwash: false },
        { id: "r4", text: "Kiai", hogwash: false },
        { id: "r5", text: "Waza", hogwash: false },
        { id: "r6", text: "Dojo", hogwash: false },
        { id: "r7", text: "Osoto Gari", hogwash: false },
        { id: "h1", text: "Creston Tachi Stance", hogwash: true },
        { id: "h2", text: "Valdoran Ashi Form", hogwash: true },
        { id: "h3", text: "Nordic Guard Break", hogwash: true },
      ],
    },
    {
      id: "olympic_track",
      themeLabel: "Olympic Track & Field Events",
      items: [
        { id: "r1", text: "Steeplechase", hogwash: false },
        { id: "r2", text: "Heptathlon", hogwash: false },
        { id: "r3", text: "Hammer Throw", hogwash: false },
        { id: "r4", text: "Triple Jump", hogwash: false },
        { id: "r5", text: "Decathlon", hogwash: false },
        { id: "r6", text: "Race Walk", hogwash: false },
        { id: "r7", text: "Pole Vault", hogwash: false },
        { id: "h1", text: "Creston Sprint Relay", hogwash: true },
        { id: "h2", text: "Valdoran Field Dash", hogwash: true },
        { id: "h3", text: "Nordic Long Bound", hogwash: true },
      ],
    },
    {
      id: "soccer_terms_b5",
      themeLabel: "Soccer / Football Terms",
      items: [
        { id: "r1", text: "Offside Trap", hogwash: false },
        { id: "r2", text: "Tiki-Taka", hogwash: false },
        { id: "r3", text: "Nutmeg", hogwash: false },
        { id: "r4", text: "Gegenpressing", hogwash: false },
        { id: "r5", text: "False Nine", hogwash: false },
        { id: "r6", text: "Overlapping Run", hogwash: false },
        { id: "r7", text: "Sweeper-Keeper", hogwash: false },
        { id: "h1", text: "Creston Press Line", hogwash: true },
        { id: "h2", text: "Valdoran High Block", hogwash: true },
        { id: "h3", text: "Nordic Zone Drop", hogwash: true },
      ],
    },
    {
      id: "rugby_terms",
      themeLabel: "Rugby Terms",
      items: [
        { id: "r1", text: "Scrum", hogwash: false },
        { id: "r2", text: "Lineout", hogwash: false },
        { id: "r3", text: "Ruck", hogwash: false },
        { id: "r4", text: "Maul", hogwash: false },
        { id: "r5", text: "Garryowen", hogwash: false },
        { id: "r6", text: "Knock-On", hogwash: false },
        { id: "r7", text: "Grubber Kick", hogwash: false },
        { id: "h1", text: "Creston Bind", hogwash: true },
        { id: "h2", text: "Valdoran Pick-and-Go", hogwash: true },
        { id: "h3", text: "Nordic Driving Maul", hogwash: true },
      ],
    },
    {
      id: "hockey_terms",
      themeLabel: "Ice Hockey Terms",
      items: [
        { id: "r1", text: "Power Play", hogwash: false },
        { id: "r2", text: "Icing", hogwash: false },
        { id: "r3", text: "Penalty Shot", hogwash: false },
        { id: "r4", text: "Breakaway", hogwash: false },
        { id: "r5", text: "Crease", hogwash: false },
        { id: "r6", text: "Slapshot", hogwash: false },
        { id: "r7", text: "Offsides", hogwash: false },
        { id: "h1", text: "Creston Charge", hogwash: true },
        { id: "h2", text: "Valdoran Rush Line", hogwash: true },
        { id: "h3", text: "Nordic Backhand Dig", hogwash: true },
      ],
    },
    {
      id: "volleyball_terms",
      themeLabel: "Volleyball Terms",
      items: [
        { id: "r1", text: "Libero", hogwash: false },
        { id: "r2", text: "Dig", hogwash: false },
        { id: "r3", text: "Float Serve", hogwash: false },
        { id: "r4", text: "Setter Dump", hogwash: false },
        { id: "r5", text: "Rotation", hogwash: false },
        { id: "r6", text: "Pancake", hogwash: false },
        { id: "r7", text: "Overpass", hogwash: false },
        { id: "h1", text: "Creston Back Set", hogwash: true },
        { id: "h2", text: "Valdoran Quick Strike", hogwash: true },
        { id: "h3", text: "Nordic Line Drop", hogwash: true },
      ],
    },
    {
      id: "swimming_strokes_b5",
      themeLabel: "Swimming Strokes & Techniques",
      items: [
        { id: "r1", text: "Freestyle", hogwash: false },
        { id: "r2", text: "Butterfly", hogwash: false },
        { id: "r3", text: "Backstroke", hogwash: false },
        { id: "r4", text: "Breaststroke", hogwash: false },
        { id: "r5", text: "Flip Turn", hogwash: false },
        { id: "r6", text: "Drafting", hogwash: false },
        { id: "r7", text: "Streamline", hogwash: false },
        { id: "h1", text: "Creston Scull", hogwash: true },
        { id: "h2", text: "Valdoran Glide Push", hogwash: true },
        { id: "h3", text: "Nordic Catch Phase", hogwash: true },
      ],
    },
    {
      id: "cycling_terms",
      themeLabel: "Cycling Terms",
      items: [
        { id: "r1", text: "Peloton", hogwash: false },
        { id: "r2", text: "Domestique", hogwash: false },
        { id: "r3", text: "Breakaway", hogwash: false },
        { id: "r4", text: "Cadence", hogwash: false },
        { id: "r5", text: "Drafting", hogwash: false },
        { id: "r6", text: "Grimpeur", hogwash: false },
        { id: "r7", text: "Time Trial", hogwash: false },
        { id: "h1", text: "Creston Flyer", hogwash: true },
        { id: "h2", text: "Valdoran Lead Out", hogwash: true },
        { id: "h3", text: "Nordic Sprint Stage", hogwash: true },
      ],
    },
    {
      id: "gymnastics_terms",
      themeLabel: "Gymnastics Terms",
      items: [
        { id: "r1", text: "Kip", hogwash: false },
        { id: "r2", text: "Round-Off", hogwash: false },
        { id: "r3", text: "Tsukahara", hogwash: false },
        { id: "r4", text: "Yurchenko", hogwash: false },
        { id: "r5", text: "Giant Swing", hogwash: false },
        { id: "r6", text: "Salto", hogwash: false },
        { id: "r7", text: "Pike Position", hogwash: false },
        { id: "h1", text: "Creston Layout", hogwash: true },
        { id: "h2", text: "Valdoran Arch Set", hogwash: true },
        { id: "h3", text: "Nordic Hollow Hold", hogwash: true },
      ],
    },
    {
      id: "winter_sports",
      themeLabel: "Winter Sports",
      items: [
        { id: "r1", text: "Biathlon", hogwash: false },
        { id: "r2", text: "Luge", hogwash: false },
        { id: "r3", text: "Skeleton", hogwash: false },
        { id: "r4", text: "Curling", hogwash: false },
        { id: "r5", text: "Nordic Combined", hogwash: false },
        { id: "r6", text: "Bobsled", hogwash: false },
        { id: "r7", text: "Ski Jumping", hogwash: false },
        { id: "h1", text: "Creston Slalom Run", hogwash: true },
        { id: "h2", text: "Valdoran Ice Cross", hogwash: true },
        { id: "h3", text: "Nordic Downhill Race", hogwash: true },
      ],
    },
    {
      id: "extreme_sports",
      themeLabel: "Extreme Sports",
      items: [
        { id: "r1", text: "Wingsuit Flying", hogwash: false },
        { id: "r2", text: "Free Solo Climbing", hogwash: false },
        { id: "r3", text: "Kitesurfing", hogwash: false },
        { id: "r4", text: "Highlining", hogwash: false },
        { id: "r5", text: "BASE Jumping", hogwash: false },
        { id: "r6", text: "Paragliding", hogwash: false },
        { id: "r7", text: "Speedflying", hogwash: false },
        { id: "h1", text: "Creston Sky Dive", hogwash: true },
        { id: "h2", text: "Valdoran Ridge Leap", hogwash: true },
        { id: "h3", text: "Nordic Air Glide", hogwash: true },
      ],
    },
    {
      id: "water_sports",
      themeLabel: "Water Sports",
      items: [
        { id: "r1", text: "Wakeboarding", hogwash: false },
        { id: "r2", text: "Dragon Boat Racing", hogwash: false },
        { id: "r3", text: "Open Water Swimming", hogwash: false },
        { id: "r4", text: "Freediving", hogwash: false },
        { id: "r5", text: "Canoe Polo", hogwash: false },
        { id: "r6", text: "Outrigger Canoeing", hogwash: false },
        { id: "r7", text: "Artistic Swimming", hogwash: false },
        { id: "h1", text: "Creston Paddle Surf", hogwash: true },
        { id: "h2", text: "Valdoran Drift Race", hogwash: true },
        { id: "h3", text: "Nordic Wave Sprint", hogwash: true },
      ],
    },

    // ── HISTORY, CULTURE & MYTHOLOGY ──────────────────────────────────────────
    {
      id: "greek_mythology_b5",
      themeLabel: "Greek Mythology Figures",
      items: [
        { id: "r1", text: "Persephone", hogwash: false },
        { id: "r2", text: "Hephaestus", hogwash: false },
        { id: "r3", text: "Nemesis", hogwash: false },
        { id: "r4", text: "Morpheus", hogwash: false },
        { id: "r5", text: "Hecate", hogwash: false },
        { id: "r6", text: "Charon", hogwash: false },
        { id: "r7", text: "Tyche", hogwash: false },
        { id: "h1", text: "Creston the Bold", hogwash: true },
        { id: "h2", text: "Valdoran of Olympus", hogwash: true },
        { id: "h3", text: "Nordic the Wanderer", hogwash: true },
      ],
    },
    {
      id: "norse_mythology",
      themeLabel: "Norse Mythology Terms",
      items: [
        { id: "r1", text: "Yggdrasil", hogwash: false },
        { id: "r2", text: "Valhalla", hogwash: false },
        { id: "r3", text: "Fenrir", hogwash: false },
        { id: "r4", text: "Ragnarök", hogwash: false },
        { id: "r5", text: "Mjölnir", hogwash: false },
        { id: "r6", text: "Bifröst", hogwash: false },
        { id: "r7", text: "Jörmungandr", hogwash: false },
        { id: "h1", text: "Creston the Frost", hogwash: true },
        { id: "h2", text: "Valdoran's Forge", hogwash: true },
        { id: "h3", text: "Nordic Root Realm", hogwash: true },
      ],
    },
    {
      id: "world_religions_b5",
      themeLabel: "World Religions",
      items: [
        { id: "r1", text: "Zoroastrianism", hogwash: false },
        { id: "r2", text: "Jainism", hogwash: false },
        { id: "r3", text: "Sikhism", hogwash: false },
        { id: "r4", text: "Bahá'í Faith", hogwash: false },
        { id: "r5", text: "Shinto", hogwash: false },
        { id: "r6", text: "Cao Dai", hogwash: false },
        { id: "r7", text: "Animism", hogwash: false },
        { id: "h1", text: "Creston Faith", hogwash: true },
        { id: "h2", text: "Valdoran Order", hogwash: true },
        { id: "h3", text: "Nordic Sun Path", hogwash: true },
      ],
    },
    {
      id: "ancient_civilizations_b5",
      themeLabel: "Ancient Civilizations",
      items: [
        { id: "r1", text: "Sumerians", hogwash: false },
        { id: "r2", text: "Phoenicians", hogwash: false },
        { id: "r3", text: "Minoans", hogwash: false },
        { id: "r4", text: "Etruscans", hogwash: false },
        { id: "r5", text: "Olmecs", hogwash: false },
        { id: "r6", text: "Kushites", hogwash: false },
        { id: "r7", text: "Nabataeans", hogwash: false },
        { id: "h1", text: "Crestonians", hogwash: true },
        { id: "h2", text: "Valdorans", hogwash: true },
        { id: "h3", text: "Nordic Plainsmen", hogwash: true },
      ],
    },
    {
      id: "constellations2",
      themeLabel: "Famous Constellations",
      items: [
        { id: "r1", text: "Cassiopeia", hogwash: false },
        { id: "r2", text: "Cygnus", hogwash: false },
        { id: "r3", text: "Lyra", hogwash: false },
        { id: "r4", text: "Scorpius", hogwash: false },
        { id: "r5", text: "Perseus", hogwash: false },
        { id: "r6", text: "Aquila", hogwash: false },
        { id: "r7", text: "Auriga", hogwash: false },
        { id: "h1", text: "Creston Major", hogwash: true },
        { id: "h2", text: "Valdoran Minor", hogwash: true },
        { id: "h3", text: "Nordic Spiral", hogwash: true },
      ],
    },

    // ── SPACE & PHYSICS ───────────────────────────────────────────────────────
    {
      id: "solar_system2",
      themeLabel: "Solar System Terms",
      items: [
        { id: "r1", text: "Aphelion", hogwash: false },
        { id: "r2", text: "Perihelion", hogwash: false },
        { id: "r3", text: "Lagrange Point", hogwash: false },
        { id: "r4", text: "Heliosphere", hogwash: false },
        { id: "r5", text: "Kuiper Belt", hogwash: false },
        { id: "r6", text: "Oort Cloud", hogwash: false },
        { id: "r7", text: "Zodiacal Light", hogwash: false },
        { id: "h1", text: "Creston Drift Zone", hogwash: true },
        { id: "h2", text: "Valdoran Periapsis", hogwash: true },
        { id: "h3", text: "Nordic Dust Band", hogwash: true },
      ],
    },
    {
      id: "space_exploration",
      themeLabel: "Space Exploration Terms",
      items: [
        { id: "r1", text: "Orbital Insertion", hogwash: false },
        { id: "r2", text: "Aerobraking", hogwash: false },
        { id: "r3", text: "Delta-V", hogwash: false },
        { id: "r4", text: "Gravity Assist", hogwash: false },
        { id: "r5", text: "Reentry", hogwash: false },
        { id: "r6", text: "Launch Window", hogwash: false },
        { id: "r7", text: "Deep Space Network", hogwash: false },
        { id: "h1", text: "Creston Orbit Path", hogwash: true },
        { id: "h2", text: "Valdoran Boost Stage", hogwash: true },
        { id: "h3", text: "Nordic Entry Burn", hogwash: true },
      ],
    },
    {
      id: "astronomy_terms",
      themeLabel: "Astronomy Terms",
      items: [
        { id: "r1", text: "Redshift", hogwash: false },
        { id: "r2", text: "Parsec", hogwash: false },
        { id: "r3", text: "Accretion Disk", hogwash: false },
        { id: "r4", text: "Magnetar", hogwash: false },
        { id: "r5", text: "Pulsar", hogwash: false },
        { id: "r6", text: "Quasar", hogwash: false },
        { id: "r7", text: "Event Horizon", hogwash: false },
        { id: "h1", text: "Creston Burst Wave", hogwash: true },
        { id: "h2", text: "Valdoran Dark Void", hogwash: true },
        { id: "h3", text: "Nordic Stellar Rim", hogwash: true },
      ],
    },
    {
      id: "physics_terms",
      themeLabel: "Physics Terms",
      items: [
        { id: "r1", text: "Torque", hogwash: false },
        { id: "r2", text: "Entropy", hogwash: false },
        { id: "r3", text: "Inertia", hogwash: false },
        { id: "r4", text: "Resonance", hogwash: false },
        { id: "r5", text: "Refraction", hogwash: false },
        { id: "r6", text: "Doppler Effect", hogwash: false },
        { id: "r7", text: "Electromagnetic Induction", hogwash: false },
        { id: "h1", text: "Creston Waveform", hogwash: true },
        { id: "h2", text: "Valdoran Force Field", hogwash: true },
        { id: "h3", text: "Nordic Charge Plane", hogwash: true },
      ],
    },

    // ── HEALTH & BODY ─────────────────────────────────────────────────────────
    {
      id: "medical_specialties",
      themeLabel: "Medical Specialties",
      items: [
        { id: "r1", text: "Nephrology", hogwash: false },
        { id: "r2", text: "Rheumatology", hogwash: false },
        { id: "r3", text: "Hematology", hogwash: false },
        { id: "r4", text: "Urology", hogwash: false },
        { id: "r5", text: "Palliative Care", hogwash: false },
        { id: "r6", text: "Endoscopy", hogwash: false },
        { id: "r7", text: "Interventional Radiology", hogwash: false },
        { id: "h1", text: "Creston Medicine", hogwash: true },
        { id: "h2", text: "Valdoran Pathology", hogwash: true },
        { id: "h3", text: "Nordic Tissue Study", hogwash: true },
      ],
    },
    {
      id: "surgical_terms",
      themeLabel: "Surgical Terms",
      items: [
        { id: "r1", text: "Anastomosis", hogwash: false },
        { id: "r2", text: "Laparoscopy", hogwash: false },
        { id: "r3", text: "Debridement", hogwash: false },
        { id: "r4", text: "Excision", hogwash: false },
        { id: "r5", text: "Retractor", hogwash: false },
        { id: "r6", text: "Cauterization", hogwash: false },
        { id: "r7", text: "Suture", hogwash: false },
        { id: "h1", text: "Creston Incision Type", hogwash: true },
        { id: "h2", text: "Valdoran Graft Patch", hogwash: true },
        { id: "h3", text: "Nordic Wound Close", hogwash: true },
      ],
    },
    {
      id: "pharmacy_terms",
      themeLabel: "Pharmacy Terms",
      items: [
        { id: "r1", text: "Pharmacokinetics", hogwash: false },
        { id: "r2", text: "Half-Life", hogwash: false },
        { id: "r3", text: "Contraindication", hogwash: false },
        { id: "r4", text: "Bioavailability", hogwash: false },
        { id: "r5", text: "Titration", hogwash: false },
        { id: "r6", text: "Agonist", hogwash: false },
        { id: "r7", text: "Antagonist", hogwash: false },
        { id: "h1", text: "Creston Dose Cap", hogwash: true },
        { id: "h2", text: "Valdoran Binding Rate", hogwash: true },
        { id: "h3", text: "Nordic Active Tier", hogwash: true },
      ],
    },
    {
      id: "nutrition_terms",
      themeLabel: "Nutrition Terms",
      items: [
        { id: "r1", text: "Macronutrient", hogwash: false },
        { id: "r2", text: "Glycemic Index", hogwash: false },
        { id: "r3", text: "Antioxidant", hogwash: false },
        { id: "r4", text: "Fiber", hogwash: false },
        { id: "r5", text: "Electrolyte", hogwash: false },
        { id: "r6", text: "Biotin", hogwash: false },
        { id: "r7", text: "Phytochemical", hogwash: false },
        { id: "h1", text: "Creston Enzyme Boost", hogwash: true },
        { id: "h2", text: "Valdoran Mineral Salt", hogwash: true },
        { id: "h3", text: "Nordic Core Vitamin", hogwash: true },
      ],
    },
    {
      id: "fitness_terms",
      themeLabel: "Fitness & Gym Terms",
      items: [
        { id: "r1", text: "Progressive Overload", hogwash: false },
        { id: "r2", text: "Hypertrophy", hogwash: false },
        { id: "r3", text: "AMRAP", hogwash: false },
        { id: "r4", text: "Superset", hogwash: false },
        { id: "r5", text: "RPE", hogwash: false },
        { id: "r6", text: "Periodization", hogwash: false },
        { id: "r7", text: "VO2 Max", hogwash: false },
        { id: "h1", text: "Creston Pump Cycle", hogwash: true },
        { id: "h2", text: "Valdoran Work Phase", hogwash: true },
        { id: "h3", text: "Nordic Load Phase", hogwash: true },
      ],
    },
    {
      id: "mental_health_terms",
      themeLabel: "Mental Health Terms",
      items: [
        { id: "r1", text: "Dissociation", hogwash: false },
        { id: "r2", text: "Rumination", hogwash: false },
        { id: "r3", text: "Hypervigilance", hogwash: false },
        { id: "r4", text: "Intrusive Thought", hogwash: false },
        { id: "r5", text: "Emotional Regulation", hogwash: false },
        { id: "r6", text: "Avoidance Behavior", hogwash: false },
        { id: "r7", text: "Psychoeducation", hogwash: false },
        { id: "h1", text: "Creston Thought Trap", hogwash: true },
        { id: "h2", text: "Valdoran Mood Shift", hogwash: true },
        { id: "h3", text: "Nordic Core Schema", hogwash: true },
      ],
    },

    // ── LANGUAGE & IDEAS ──────────────────────────────────────────────────────
    {
      id: "linguistics_terms",
      themeLabel: "Linguistics Terms",
      items: [
        { id: "r1", text: "Morpheme", hogwash: false },
        { id: "r2", text: "Phoneme", hogwash: false },
        { id: "r3", text: "Syntax", hogwash: false },
        { id: "r4", text: "Pragmatics", hogwash: false },
        { id: "r5", text: "Creole", hogwash: false },
        { id: "r6", text: "Diglossia", hogwash: false },
        { id: "r7", text: "Code-Switching", hogwash: false },
        { id: "h1", text: "Creston Dialect Mark", hogwash: true },
        { id: "h2", text: "Valdoran Root Form", hogwash: true },
        { id: "h3", text: "Nordic Speech Layer", hogwash: true },
      ],
    },
    {
      id: "grammar_terms_b5",
      themeLabel: "Grammar & Writing Terms",
      items: [
        { id: "r1", text: "Appositive", hogwash: false },
        { id: "r2", text: "Gerund", hogwash: false },
        { id: "r3", text: "Dangling Modifier", hogwash: false },
        { id: "r4", text: "Subjunctive", hogwash: false },
        { id: "r5", text: "Anaphora", hogwash: false },
        { id: "r6", text: "Asyndeton", hogwash: false },
        { id: "r7", text: "Hyperbaton", hogwash: false },
        { id: "h1", text: "Creston Clause Hook", hogwash: true },
        { id: "h2", text: "Valdoran Predicate", hogwash: true },
        { id: "h3", text: "Nordic Phrase Drop", hogwash: true },
      ],
    },
    {
      id: "mythology_creatures",
      themeLabel: "Mythological Creatures",
      items: [
        { id: "r1", text: "Kelpie", hogwash: false },
        { id: "r2", text: "Manticore", hogwash: false },
        { id: "r3", text: "Selkie", hogwash: false },
        { id: "r4", text: "Thunderbird", hogwash: false },
        { id: "r5", text: "Basilisk", hogwash: false },
        { id: "r6", text: "Roc", hogwash: false },
        { id: "r7", text: "Peryton", hogwash: false },
        { id: "h1", text: "Creston Wraith", hogwash: true },
        { id: "h2", text: "Valdoran Shade Beast", hogwash: true },
        { id: "h3", text: "Nordic Frost Drake", hogwash: true },
      ],
    },

    // ── PLANTS & NATURE ───────────────────────────────────────────────────────
    {
      id: "tree_types",
      themeLabel: "Types of Trees",
      items: [
        { id: "r1", text: "Baobab", hogwash: false },
        { id: "r2", text: "Bristlecone Pine", hogwash: false },
        { id: "r3", text: "Dragon Blood Tree", hogwash: false },
        { id: "r4", text: "Kapok", hogwash: false },
        { id: "r5", text: "Larch", hogwash: false },
        { id: "r6", text: "Wollemi Pine", hogwash: false },
        { id: "r7", text: "Monkey Puzzle", hogwash: false },
        { id: "h1", text: "Creston Oak", hogwash: true },
        { id: "h2", text: "Valdoran Elm", hogwash: true },
        { id: "h3", text: "Nordic Spire Tree", hogwash: true },
      ],
    },
    {
      id: "flower_types",
      themeLabel: "Flower Types",
      items: [
        { id: "r1", text: "Hellebore", hogwash: false },
        { id: "r2", text: "Fritillaria", hogwash: false },
        { id: "r3", text: "Echinacea", hogwash: false },
        { id: "r4", text: "Agapanthus", hogwash: false },
        { id: "r5", text: "Allium", hogwash: false },
        { id: "r6", text: "Celosia", hogwash: false },
        { id: "r7", text: "Lisianthus", hogwash: false },
        { id: "h1", text: "Creston Petal", hogwash: true },
        { id: "h2", text: "Valdoran Bloom", hogwash: true },
        { id: "h3", text: "Nordic Frost Flower", hogwash: true },
      ],
    },
    {
      id: "herb_spice",
      themeLabel: "Herbs & Spices",
      items: [
        { id: "r1", text: "Sumac", hogwash: false },
        { id: "r2", text: "Fenugreek", hogwash: false },
        { id: "r3", text: "Asafoetida", hogwash: false },
        { id: "r4", text: "Epazote", hogwash: false },
        { id: "r5", text: "Shiso", hogwash: false },
        { id: "r6", text: "Grains of Selim", hogwash: false },
        { id: "r7", text: "Dried Barberry", hogwash: false },
        { id: "h1", text: "Creston Seed", hogwash: true },
        { id: "h2", text: "Valdoran Root Spice", hogwash: true },
        { id: "h3", text: "Nordic Berry Dust", hogwash: true },
      ],
    },
    {
      id: "vegetable_varieties",
      themeLabel: "Vegetable Varieties",
      items: [
        { id: "r1", text: "Kohlrabi", hogwash: false },
        { id: "r2", text: "Celeriac", hogwash: false },
        { id: "r3", text: "Romanesco", hogwash: false },
        { id: "r4", text: "Salsify", hogwash: false },
        { id: "r5", text: "Purslane", hogwash: false },
        { id: "r6", text: "Fiddlehead", hogwash: false },
        { id: "r7", text: "Cardoon", hogwash: false },
        { id: "h1", text: "Creston Root", hogwash: true },
        { id: "h2", text: "Valdoran Greens", hogwash: true },
        { id: "h3", text: "Nordic Field Bulb", hogwash: true },
      ],
    },
    {
      id: "fruit_varieties",
      themeLabel: "Exotic Fruits",
      items: [
        { id: "r1", text: "Mangosteen", hogwash: false },
        { id: "r2", text: "Cherimoya", hogwash: false },
        { id: "r3", text: "Rambutan", hogwash: false },
        { id: "r4", text: "Longan", hogwash: false },
        { id: "r5", text: "Feijoa", hogwash: false },
        { id: "r6", text: "Jujube", hogwash: false },
        { id: "r7", text: "Salak", hogwash: false },
        { id: "h1", text: "Creston Berry", hogwash: true },
        { id: "h2", text: "Valdoran Stone Fruit", hogwash: true },
        { id: "h3", text: "Nordic Wild Plum", hogwash: true },
      ],
    },
    {
      id: "bird_types",
      themeLabel: "Bird Families",
      items: [
        { id: "r1", text: "Corvidae", hogwash: false },
        { id: "r2", text: "Falconidae", hogwash: false },
        { id: "r3", text: "Psittacidae", hogwash: false },
        { id: "r4", text: "Picidae", hogwash: false },
        { id: "r5", text: "Threskiornithidae", hogwash: false },
        { id: "r6", text: "Anatidae", hogwash: false },
        { id: "r7", text: "Accipitridae", hogwash: false },
        { id: "h1", text: "Crestonidae", hogwash: true },
        { id: "h2", text: "Valdoranidae", hogwash: true },
        { id: "h3", text: "Nordicus Avian", hogwash: true },
      ],
    },

    // ── EARTH & ENVIRONMENT ───────────────────────────────────────────────────
    {
      id: "ocean_zones_b5",
      themeLabel: "Ocean Zones",
      items: [
        { id: "r1", text: "Epipelagic", hogwash: false },
        { id: "r2", text: "Mesopelagic", hogwash: false },
        { id: "r3", text: "Bathypelagic", hogwash: false },
        { id: "r4", text: "Abyssopelagic", hogwash: false },
        { id: "r5", text: "Hadal Zone", hogwash: false },
        { id: "r6", text: "Benthic Zone", hogwash: false },
        { id: "r7", text: "Photic Zone", hogwash: false },
        { id: "h1", text: "Creston Drift Layer", hogwash: true },
        { id: "h2", text: "Valdoran Deep Band", hogwash: true },
        { id: "h3", text: "Nordic Cold Shelf", hogwash: true },
      ],
    },
    {
      id: "weather_phenomena",
      themeLabel: "Weather Phenomena",
      items: [
        { id: "r1", text: "Derecho", hogwash: false },
        { id: "r2", text: "Haboob", hogwash: false },
        { id: "r3", text: "Mammatus Clouds", hogwash: false },
        { id: "r4", text: "Virga", hogwash: false },
        { id: "r5", text: "Microburst", hogwash: false },
        { id: "r6", text: "Waterspout", hogwash: false },
        { id: "r7", text: "Frost Hollow", hogwash: false },
        { id: "h1", text: "Creston Hail Band", hogwash: true },
        { id: "h2", text: "Valdoran Squall Line", hogwash: true },
        { id: "h3", text: "Nordic Cold Burst", hogwash: true },
      ],
    },
    {
      id: "rock_types",
      themeLabel: "Types of Rocks",
      items: [
        { id: "r1", text: "Obsidian", hogwash: false },
        { id: "r2", text: "Pumice", hogwash: false },
        { id: "r3", text: "Gneiss", hogwash: false },
        { id: "r4", text: "Schist", hogwash: false },
        { id: "r5", text: "Chert", hogwash: false },
        { id: "r6", text: "Travertine", hogwash: false },
        { id: "r7", text: "Dolomite", hogwash: false },
        { id: "h1", text: "Creston Shale", hogwash: true },
        { id: "h2", text: "Valdoran Breccia", hogwash: true },
        { id: "h3", text: "Nordic Frost Rock", hogwash: true },
      ],
    },
    {
      id: "biome_types",
      themeLabel: "Earth's Biomes",
      items: [
        { id: "r1", text: "Chaparral", hogwash: false },
        { id: "r2", text: "Taiga", hogwash: false },
        { id: "r3", text: "Savanna", hogwash: false },
        { id: "r4", text: "Mangrove", hogwash: false },
        { id: "r5", text: "Alpine Tundra", hogwash: false },
        { id: "r6", text: "Temperate Rainforest", hogwash: false },
        { id: "r7", text: "Freshwater Wetland", hogwash: false },
        { id: "h1", text: "Creston Shrubland", hogwash: true },
        { id: "h2", text: "Valdoran Grassland", hogwash: true },
        { id: "h3", text: "Nordic Frost Plain", hogwash: true },
      ],
    },
    {
      id: "geology_features",
      themeLabel: "Geological Features",
      items: [
        { id: "r1", text: "Horst", hogwash: false },
        { id: "r2", text: "Graben", hogwash: false },
        { id: "r3", text: "Caldera", hogwash: false },
        { id: "r4", text: "Atoll", hogwash: false },
        { id: "r5", text: "Moraine", hogwash: false },
        { id: "r6", text: "Karst", hogwash: false },
        { id: "r7", text: "Sinkhole", hogwash: false },
        { id: "h1", text: "Creston Basin Edge", hogwash: true },
        { id: "h2", text: "Valdoran Rift Side", hogwash: true },
        { id: "h3", text: "Nordic Fault Ridge", hogwash: true },
      ],
    },
    {
      id: "climate_zones",
      themeLabel: "Climate Zones",
      items: [
        { id: "r1", text: "Humid Continental", hogwash: false },
        { id: "r2", text: "Semi-Arid", hogwash: false },
        { id: "r3", text: "Oceanic", hogwash: false },
        { id: "r4", text: "Subarctic", hogwash: false },
        { id: "r5", text: "Tropical Monsoon", hogwash: false },
        { id: "r6", text: "Mediterranean", hogwash: false },
        { id: "r7", text: "Polar Ice Cap", hogwash: false },
        { id: "h1", text: "Creston Dry Zone", hogwash: true },
        { id: "h2", text: "Valdoran Warm Band", hogwash: true },
        { id: "h3", text: "Nordic Frost Region", hogwash: true },
      ],
    },

    // ── BONUS BATCH 5 EXTRAS ──────────────────────────────────────────────────
    {
      id: "sign_language",
      themeLabel: "Sign Language & Deaf Culture Terms",
      items: [
        { id: "r1", text: "Fingerspelling", hogwash: false },
        { id: "r2", text: "Classifier", hogwash: false },
        { id: "r3", text: "Handshape", hogwash: false },
        { id: "r4", text: "Non-Manual Markers", hogwash: false },
        { id: "r5", text: "Directional Verb", hogwash: false },
        { id: "r6", text: "Initialized Sign", hogwash: false },
        { id: "r7", text: "Visual Phonology", hogwash: false },
        { id: "h1", text: "Creston Hand Code", hogwash: true },
        { id: "h2", text: "Valdoran Palm Sign", hogwash: true },
        { id: "h3", text: "Nordic Gesture Bind", hogwash: true },
      ],
    },
    {
      id: "forensic_science",
      themeLabel: "Forensic Science Terms",
      items: [
        { id: "r1", text: "Luminol", hogwash: false },
        { id: "r2", text: "Ballistics", hogwash: false },
        { id: "r3", text: "Toxicology", hogwash: false },
        { id: "r4", text: "Entomology", hogwash: false },
        { id: "r5", text: "Chain of Custody", hogwash: false },
        { id: "r6", text: "Postmortem Interval", hogwash: false },
        { id: "r7", text: "Trace Evidence", hogwash: false },
        { id: "h1", text: "Creston Fiber Test", hogwash: true },
        { id: "h2", text: "Valdoran Residue Kit", hogwash: true },
        { id: "h3", text: "Nordic Sample Chain", hogwash: true },
      ],
    },
    {
      id: "urban_planning",
      themeLabel: "Urban Planning Terms",
      items: [
        { id: "r1", text: "Zoning", hogwash: false },
        { id: "r2", text: "Setback", hogwash: false },
        { id: "r3", text: "Mixed-Use Development", hogwash: false },
        { id: "r4", text: "Transit-Oriented Development", hogwash: false },
        { id: "r5", text: "Infill", hogwash: false },
        { id: "r6", text: "Green Belt", hogwash: false },
        { id: "r7", text: "Walkability Score", hogwash: false },
        { id: "h1", text: "Creston Density Plan", hogwash: true },
        { id: "h2", text: "Valdoran Growth Zone", hogwash: true },
        { id: "h3", text: "Nordic Block Permit", hogwash: true },
      ],
    },
    {
      id: "diplomacy",
      themeLabel: "Diplomacy & International Relations Terms",
      items: [
        { id: "r1", text: "Envoy", hogwash: false },
        { id: "r2", text: "Détente", hogwash: false },
        { id: "r3", text: "Ratification", hogwash: false },
        { id: "r4", text: "Diplomatic Immunity", hogwash: false },
        { id: "r5", text: "Suzerainty", hogwash: false },
        { id: "r6", text: "Multilateral Treaty", hogwash: false },
        { id: "r7", text: "Persona Non Grata", hogwash: false },
        { id: "h1", text: "Creston Accord", hogwash: true },
        { id: "h2", text: "Valdoran Annex Pact", hogwash: true },
        { id: "h3", text: "Nordic Summit Clause", hogwash: true },
      ],
    },
    {
      id: "cognitive_science",
      themeLabel: "Cognitive Science Terms",
      items: [
        { id: "r1", text: "Working Memory", hogwash: false },
        { id: "r2", text: "Executive Function", hogwash: false },
        { id: "r3", text: "Dual Process Theory", hogwash: false },
        { id: "r4", text: "Schema", hogwash: false },
        { id: "r5", text: "Embodied Cognition", hogwash: false },
        { id: "r6", text: "Metacognition", hogwash: false },
        { id: "r7", text: "Priming", hogwash: false },
        { id: "h1", text: "Creston Trace Loop", hogwash: true },
        { id: "h2", text: "Valdoran Recall Map", hogwash: true },
        { id: "h3", text: "Nordic Thought Frame", hogwash: true },
      ],
    },
  ];
